var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360, _path3361, _path3362, _path3363, _path3364, _path3365, _path3366, _path3367, _path3368, _path3369, _path3370, _path3371, _path3372, _path3373, _path3374, _path3375, _path3376, _path3377, _path3378, _path3379, _path3380, _path3381, _path3382, _path3383, _path3384, _path3385, _path3386, _path3387, _path3388, _path3389, _path3390, _path3391, _path3392, _path3393, _path3394, _path3395, _path3396, _path3397, _path3398, _path3399, _path3400, _path3401, _path3402, _path3403, _path3404, _path3405, _path3406, _path3407, _path3408, _path3409, _path3410, _path3411, _path3412, _path3413, _path3414, _path3415, _path3416, _path3417, _path3418, _path3419, _path3420, _path3421, _path3422, _path3423, _path3424, _path3425, _path3426, _path3427, _path3428, _path3429, _path3430, _path3431, _path3432, _path3433, _path3434, _path3435, _path3436, _path3437, _path3438, _path3439, _path3440, _path3441, _path3442, _path3443, _path3444, _path3445, _path3446, _path3447, _path3448, _path3449, _path3450, _path3451, _path3452, _path3453, _path3454, _path3455, _path3456, _path3457, _path3458, _path3459, _path3460, _path3461, _path3462, _path3463, _path3464, _path3465, _path3466, _path3467, _path3468, _path3469, _path3470, _path3471, _path3472, _path3473, _path3474, _path3475, _path3476, _path3477, _path3478, _path3479, _path3480, _path3481, _path3482, _path3483, _path3484, _path3485, _path3486, _path3487, _path3488, _path3489, _path3490, _path3491, _path3492, _path3493, _path3494, _path3495, _path3496, _path3497, _path3498, _path3499, _path3500, _path3501, _path3502, _path3503, _path3504, _path3505, _path3506, _path3507, _path3508, _path3509, _path3510, _path3511, _path3512, _path3513, _path3514, _path3515, _path3516, _path3517, _path3518, _path3519, _path3520, _path3521, _path3522, _path3523, _path3524, _path3525, _path3526, _path3527, _path3528, _path3529, _path3530, _path3531, _path3532, _path3533, _path3534, _path3535, _path3536, _path3537, _path3538, _path3539, _path3540, _path3541, _path3542, _path3543, _path3544, _path3545, _path3546, _path3547, _path3548, _path3549, _path3550, _path3551, _path3552, _path3553, _path3554, _path3555, _path3556, _path3557, _path3558, _path3559, _path3560, _path3561, _path3562, _path3563, _path3564, _path3565, _path3566, _path3567, _path3568, _path3569, _path3570, _path3571, _path3572, _path3573, _path3574, _path3575, _path3576, _path3577, _path3578, _path3579, _path3580, _path3581, _path3582, _path3583, _path3584, _path3585, _path3586, _path3587, _path3588, _path3589, _path3590, _path3591, _path3592, _path3593, _path3594, _path3595, _path3596, _path3597, _path3598, _path3599, _path3600, _path3601, _path3602, _path3603, _path3604, _path3605, _path3606, _path3607, _path3608, _path3609, _path3610, _path3611, _path3612, _path3613, _path3614, _path3615, _path3616, _path3617, _path3618, _path3619, _path3620, _path3621, _path3622, _path3623, _path3624, _path3625, _path3626, _path3627, _path3628, _path3629, _path3630, _path3631, _path3632, _path3633, _path3634, _path3635, _path3636, _path3637, _path3638, _path3639, _path3640, _path3641, _path3642, _path3643, _path3644, _path3645, _path3646, _path3647, _path3648, _path3649, _path3650, _path3651, _path3652, _path3653, _path3654, _path3655, _path3656, _path3657, _path3658, _path3659, _path3660, _path3661, _path3662, _path3663, _path3664, _path3665, _path3666, _path3667, _path3668, _path3669, _path3670, _path3671, _path3672, _path3673, _path3674, _path3675, _path3676, _path3677, _path3678, _path3679, _path3680, _path3681, _path3682, _path3683, _path3684, _path3685, _path3686, _path3687, _path3688, _path3689, _path3690, _path3691, _path3692, _path3693, _path3694, _path3695, _path3696, _path3697, _path3698, _path3699, _path3700, _path3701, _path3702, _path3703, _path3704, _path3705, _path3706, _path3707, _path3708, _path3709, _path3710, _path3711, _path3712, _path3713, _path3714, _path3715, _path3716, _path3717, _path3718, _path3719, _path3720, _path3721, _path3722, _path3723, _path3724, _path3725, _path3726, _path3727, _path3728, _path3729, _path3730, _path3731, _path3732, _path3733, _path3734, _path3735, _path3736, _path3737, _path3738, _path3739, _path3740, _path3741, _path3742, _path3743, _path3744, _path3745, _path3746, _path3747, _path3748, _path3749, _path3750, _path3751, _path3752, _path3753, _path3754, _path3755, _path3756, _path3757, _path3758, _path3759, _path3760, _path3761, _path3762, _path3763, _path3764, _path3765, _path3766, _path3767, _path3768, _path3769, _path3770, _path3771, _path3772, _path3773, _path3774, _path3775, _path3776, _path3777, _path3778, _path3779, _path3780, _path3781, _path3782, _path3783, _path3784, _path3785, _path3786, _path3787, _path3788, _path3789, _path3790, _path3791, _path3792, _path3793, _path3794, _path3795, _path3796, _path3797, _path3798, _path3799, _path3800, _path3801, _path3802, _path3803, _path3804, _path3805, _path3806, _path3807, _path3808, _path3809, _path3810, _path3811, _path3812, _path3813, _path3814, _path3815, _path3816, _path3817, _path3818, _path3819, _path3820, _path3821, _path3822, _path3823, _path3824, _path3825, _path3826, _path3827, _path3828, _path3829, _path3830, _path3831, _path3832, _path3833, _path3834, _path3835, _path3836, _path3837, _path3838, _path3839, _path3840, _path3841, _path3842, _path3843, _path3844, _path3845, _path3846, _path3847, _path3848, _path3849, _path3850, _path3851, _path3852, _path3853, _path3854, _path3855, _path3856, _path3857, _path3858, _path3859, _path3860, _path3861, _path3862, _path3863, _path3864, _path3865, _path3866, _path3867, _path3868, _path3869, _path3870, _path3871, _path3872, _path3873, _path3874, _path3875, _path3876, _path3877, _path3878, _path3879, _path3880, _path3881, _path3882, _path3883, _path3884, _path3885, _path3886, _path3887, _path3888, _path3889, _path3890, _path3891, _path3892, _path3893, _path3894, _path3895, _path3896, _path3897, _path3898, _path3899, _path3900, _path3901, _path3902, _path3903, _path3904, _path3905, _path3906, _path3907, _path3908, _path3909, _path3910, _path3911, _path3912, _path3913, _path3914, _path3915, _path3916, _path3917, _path3918, _path3919, _path3920, _path3921, _path3922, _path3923, _path3924, _path3925, _path3926, _path3927, _path3928, _path3929, _path3930, _path3931, _path3932, _path3933, _path3934, _path3935, _path3936, _path3937, _path3938, _path3939, _path3940, _path3941, _path3942, _path3943, _path3944, _path3945, _path3946, _path3947, _path3948, _path3949, _path3950, _path3951, _path3952, _path3953, _path3954, _path3955, _path3956, _path3957, _path3958, _path3959, _path3960, _path3961, _path3962, _path3963, _path3964, _path3965, _path3966, _path3967, _path3968, _path3969, _path3970, _path3971, _path3972, _path3973, _path3974, _path3975, _path3976, _path3977, _path3978, _path3979, _path3980, _path3981, _path3982, _path3983, _path3984, _path3985, _path3986, _path3987, _path3988, _path3989, _path3990, _path3991, _path3992, _path3993, _path3994, _path3995, _path3996, _path3997, _path3998, _path3999, _path4000, _path4001, _path4002, _path4003, _path4004, _path4005, _path4006, _path4007, _path4008, _path4009, _path4010, _path4011, _path4012, _path4013, _path4014, _path4015, _path4016, _path4017, _path4018, _path4019, _path4020, _path4021, _path4022, _path4023, _path4024, _path4025, _path4026, _path4027, _path4028, _path4029, _path4030, _path4031, _path4032, _path4033, _path4034, _path4035, _path4036, _path4037, _path4038, _path4039, _path4040, _path4041, _path4042, _path4043, _path4044, _path4045, _path4046, _path4047, _path4048, _path4049, _path4050, _path4051, _path4052, _path4053, _path4054, _path4055, _path4056, _path4057, _path4058, _path4059, _path4060, _path4061, _path4062, _path4063, _path4064, _path4065, _path4066, _path4067, _path4068, _path4069, _path4070, _path4071, _path4072, _path4073, _path4074, _path4075, _path4076, _path4077, _path4078, _path4079, _path4080, _path4081, _path4082, _path4083, _path4084, _path4085, _path4086, _path4087, _path4088, _path4089, _path4090, _path4091, _path4092, _path4093, _path4094, _path4095, _path4096, _path4097, _path4098, _path4099, _path4100, _path4101, _path4102, _path4103, _path4104, _path4105, _path4106, _path4107, _path4108, _path4109, _path4110, _path4111, _path4112, _path4113, _path4114, _path4115, _path4116, _path4117, _path4118, _path4119, _path4120, _path4121, _path4122, _path4123, _path4124, _path4125, _path4126, _path4127, _path4128, _path4129, _path4130, _path4131, _path4132, _path4133, _path4134, _path4135, _path4136, _path4137, _path4138, _path4139, _path4140, _path4141, _path4142, _path4143, _path4144, _path4145, _path4146, _path4147, _path4148, _path4149, _path4150, _path4151, _path4152, _path4153, _path4154, _path4155, _path4156, _path4157, _path4158, _path4159, _path4160, _path4161, _path4162, _path4163, _path4164, _path4165, _path4166, _path4167, _path4168, _path4169, _path4170, _path4171, _path4172, _path4173, _path4174, _path4175, _path4176, _path4177, _path4178, _path4179, _path4180, _path4181, _path4182, _path4183, _path4184, _path4185, _path4186, _path4187, _path4188, _path4189, _path4190, _path4191, _path4192, _path4193, _path4194, _path4195, _path4196, _path4197, _path4198, _path4199, _path4200, _path4201, _path4202, _path4203, _path4204, _path4205, _path4206, _path4207, _path4208, _path4209, _path4210, _path4211, _path4212, _path4213, _path4214, _path4215, _path4216, _path4217, _path4218, _path4219, _path4220, _path4221, _path4222, _path4223, _path4224, _path4225, _path4226, _path4227, _path4228, _path4229, _path4230, _path4231, _path4232, _path4233, _path4234, _path4235, _path4236, _path4237, _path4238, _path4239, _path4240, _path4241, _path4242, _path4243, _path4244, _path4245, _path4246, _path4247, _path4248, _path4249, _path4250, _path4251, _path4252, _path4253, _path4254, _path4255, _path4256, _path4257, _path4258, _path4259, _path4260, _path4261, _path4262, _path4263, _path4264, _path4265, _path4266, _path4267, _path4268, _path4269, _path4270, _path4271, _path4272, _path4273, _path4274, _path4275, _path4276, _path4277, _path4278, _path4279, _path4280, _path4281, _path4282, _path4283, _path4284, _path4285, _path4286, _path4287, _path4288, _path4289, _path4290, _path4291, _path4292, _path4293, _path4294, _path4295, _path4296, _path4297, _path4298, _path4299, _path4300, _path4301, _path4302, _path4303, _path4304, _path4305, _path4306, _path4307, _path4308, _path4309, _path4310, _path4311, _path4312, _path4313, _path4314, _path4315, _path4316, _path4317, _path4318, _path4319, _path4320, _path4321, _path4322, _path4323, _path4324, _path4325, _path4326, _path4327, _path4328, _path4329, _path4330, _path4331, _path4332, _path4333, _path4334, _path4335, _path4336, _path4337, _path4338, _path4339, _path4340, _path4341, _path4342, _path4343, _path4344, _path4345, _path4346, _path4347, _path4348, _path4349, _path4350, _path4351, _path4352, _path4353, _path4354, _path4355, _path4356, _path4357, _path4358, _path4359, _path4360, _path4361, _path4362, _path4363, _path4364, _path4365, _path4366, _path4367, _path4368, _path4369, _path4370, _path4371, _path4372, _path4373, _path4374, _path4375, _path4376, _path4377, _path4378, _path4379, _path4380, _path4381, _path4382, _path4383, _path4384, _path4385, _path4386, _path4387, _path4388, _path4389, _path4390, _path4391, _path4392, _path4393, _path4394, _path4395, _path4396, _path4397, _path4398, _path4399, _path4400, _path4401, _path4402, _path4403, _path4404, _path4405, _path4406, _path4407, _path4408, _path4409, _path4410, _path4411, _path4412, _path4413, _path4414, _path4415, _path4416, _path4417, _path4418, _path4419, _path4420, _path4421, _path4422, _path4423, _path4424, _path4425, _path4426, _path4427, _path4428, _path4429, _path4430, _path4431, _path4432, _path4433, _path4434, _path4435, _path4436, _path4437, _path4438, _path4439, _path4440, _path4441, _path4442, _path4443, _path4444, _path4445, _path4446, _path4447, _path4448, _path4449, _path4450, _path4451, _path4452, _path4453, _path4454, _path4455, _path4456, _path4457, _path4458, _path4459, _path4460, _path4461, _path4462, _path4463, _path4464, _path4465, _path4466, _path4467, _path4468, _path4469, _path4470, _path4471, _path4472, _path4473, _path4474, _path4475, _path4476, _path4477, _path4478, _path4479, _path4480, _path4481, _path4482, _path4483, _path4484, _path4485, _path4486, _path4487, _path4488, _path4489, _path4490, _path4491, _path4492, _path4493, _path4494, _path4495, _path4496, _path4497, _path4498, _path4499, _path4500, _path4501, _path4502, _path4503, _path4504, _path4505, _path4506, _path4507, _path4508, _path4509, _path4510, _path4511, _path4512, _path4513, _path4514, _path4515, _path4516, _path4517, _path4518, _path4519, _path4520, _path4521, _path4522, _path4523, _path4524, _path4525, _path4526, _path4527, _path4528, _path4529, _path4530, _path4531, _path4532, _path4533, _path4534, _path4535, _path4536, _path4537, _path4538, _path4539, _path4540, _path4541, _path4542, _path4543, _path4544, _path4545, _path4546, _path4547, _path4548, _path4549, _path4550, _path4551, _path4552, _path4553, _path4554, _path4555, _path4556, _path4557, _path4558, _path4559, _path4560, _path4561, _path4562, _path4563, _path4564, _path4565, _path4566, _path4567, _path4568, _path4569, _path4570, _path4571, _path4572, _path4573, _path4574, _path4575, _path4576, _path4577, _path4578, _path4579, _path4580, _path4581, _path4582, _path4583, _path4584, _path4585, _path4586, _path4587, _path4588, _path4589, _path4590, _path4591, _path4592, _path4593, _path4594, _path4595, _path4596, _path4597, _path4598, _path4599, _path4600, _path4601, _path4602, _path4603, _path4604, _path4605, _path4606, _path4607, _path4608, _path4609, _path4610, _path4611, _path4612, _path4613, _path4614, _path4615, _path4616, _path4617, _path4618, _path4619, _path4620, _path4621, _path4622, _path4623, _path4624, _path4625, _path4626, _path4627, _path4628, _path4629, _path4630, _path4631, _path4632, _path4633, _path4634, _path4635, _path4636, _path4637, _path4638, _path4639, _path4640, _path4641, _path4642, _path4643, _path4644, _path4645, _path4646, _path4647, _path4648, _path4649, _path4650, _path4651, _path4652, _path4653, _path4654, _path4655, _path4656, _path4657, _path4658, _path4659, _path4660, _path4661, _path4662, _path4663, _path4664, _path4665, _path4666, _path4667, _path4668, _path4669, _path4670, _path4671, _path4672, _path4673, _path4674, _path4675, _path4676, _path4677, _path4678, _path4679, _path4680, _path4681, _path4682, _path4683, _path4684, _path4685, _path4686, _path4687, _path4688, _path4689, _path4690, _path4691, _path4692, _path4693, _path4694, _path4695, _path4696, _path4697, _path4698, _path4699, _path4700, _path4701, _path4702, _path4703, _path4704, _path4705, _path4706, _path4707, _path4708, _path4709, _path4710, _path4711, _path4712, _path4713, _path4714, _path4715, _path4716, _path4717, _path4718, _path4719, _path4720, _path4721, _path4722, _path4723, _path4724, _path4725, _path4726, _path4727, _path4728, _path4729, _path4730, _path4731, _path4732, _path4733, _path4734, _path4735, _path4736, _path4737, _path4738, _path4739, _path4740, _path4741, _path4742, _path4743, _path4744, _path4745, _path4746, _path4747, _path4748, _path4749, _path4750, _path4751, _path4752, _path4753, _path4754, _path4755, _path4756, _path4757, _path4758, _path4759, _path4760, _path4761, _path4762, _path4763, _path4764, _path4765, _path4766, _path4767, _path4768, _path4769, _path4770, _path4771, _path4772, _path4773, _path4774, _path4775, _path4776, _path4777, _path4778, _path4779, _path4780, _path4781, _path4782, _path4783, _path4784, _path4785, _path4786, _path4787, _path4788, _path4789, _path4790, _path4791, _path4792, _path4793, _path4794, _path4795, _path4796, _path4797, _path4798, _path4799, _path4800, _path4801, _path4802, _path4803, _path4804, _path4805, _path4806, _path4807, _path4808, _path4809, _path4810, _path4811, _path4812, _path4813, _path4814, _path4815, _path4816, _path4817, _path4818, _path4819, _path4820, _path4821, _path4822, _path4823, _path4824, _path4825, _path4826, _path4827, _path4828, _path4829, _path4830, _path4831, _path4832, _path4833, _path4834, _path4835, _path4836, _path4837, _path4838, _path4839, _path4840, _path4841, _path4842, _path4843, _path4844, _path4845, _path4846, _path4847, _path4848, _path4849, _path4850, _path4851, _path4852, _path4853, _path4854, _path4855, _path4856, _path4857, _path4858, _path4859, _path4860, _path4861, _path4862, _path4863, _path4864, _path4865, _path4866, _path4867, _path4868, _path4869, _path4870, _path4871, _path4872, _path4873, _path4874, _path4875, _path4876, _path4877, _path4878, _path4879, _path4880, _path4881, _path4882, _path4883, _path4884, _path4885, _path4886, _path4887, _path4888, _path4889, _path4890, _path4891, _path4892, _path4893, _path4894, _path4895, _path4896, _path4897, _path4898, _path4899, _path4900, _path4901, _path4902, _path4903, _path4904, _path4905, _path4906, _path4907, _path4908, _path4909, _path4910, _path4911, _path4912, _path4913, _path4914, _path4915, _path4916, _path4917, _path4918, _path4919, _path4920, _path4921, _path4922, _path4923, _path4924, _path4925, _path4926, _path4927, _path4928, _path4929, _path4930, _path4931, _path4932, _path4933, _path4934, _path4935, _path4936, _path4937, _path4938, _path4939, _path4940, _path4941, _path4942, _path4943, _path4944, _path4945, _path4946, _path4947, _path4948, _path4949, _path4950, _path4951, _path4952, _path4953, _path4954, _path4955, _path4956, _path4957, _path4958, _path4959, _path4960, _path4961, _path4962, _path4963, _path4964, _path4965, _path4966, _path4967, _path4968, _path4969, _path4970, _path4971, _path4972, _path4973, _path4974, _path4975, _path4976, _path4977, _path4978, _path4979, _path4980, _path4981, _path4982, _path4983, _path4984, _path4985, _path4986, _path4987, _path4988, _path4989, _path4990, _path4991, _path4992, _path4993, _path4994, _path4995, _path4996, _path4997, _path4998, _path4999, _path5000, _path5001, _path5002, _path5003, _path5004, _path5005;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCellphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 128,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h-1v-1h5v2h1v1h-2v-1zm-4-3v-2h3v1h2v-1h1v2h-4zm13 5v1h1v3h-2v-3h-2v-1h2zm-3 0h-1v-1h1zm2 4v1h-1v-1zm-2 2h-1v-1h1zm0 1v-1h1v1z",
    fill: "#9faac6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 117v1h2v1h-7v-1h4v-1zm11 2v-1h6v1zm-18-2v1h-3v-1zm27 1h-3v-1h3zm-40-2h2v1h-2zm52 1v1h-2v-1h1zm-24 1h2v1h-2zm-19-1h-1v-1h1zm33 1h-1v-1h1zm7-1v1h-1v-1zm-26 3h-1v-1h1zm7-1h1v1h-1z",
    fill: "#2f354b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 121h-2v-1h4v3h-2zm25-1v-1h7v1h-4zm-39 1h-1v-1h2v-1h-1v-1h2v3zm-2-3v1h-3v-1zm33 3v-1h3v1zm-20 0h-2v-1h2zm-13-2h1v1h-1zm12 4h-1v-1h1z",
    fill: "#2c3346"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 66v1h3v2h-2v-1h-2v-1h-2v1h-3v-1h-2v-1h3zm3 5h-1v-1h2v1h1v1h-2zm-12-3v-1h1v1z",
    fill: "#626e98"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65 77v1h-3v-1H50v-1h19v1z",
    fill: "#d3d9d6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76 115h3v1h-5v1h-8v-1h7v-1zm-22 1h-3v-1h3zm9 1v-1h-1v-1h2v2zm-2-2v1h-1v-1zm27 0v1h-1v-1z",
    fill: "#33384c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44 15v1h-3v1h5v3h-1v-1h-3v-1h-2v-2h-1v1h-1v-2zm-6 3h-1v-1h1z",
    fill: "#9da8c6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59v9h-1v-9zm0-16v1h-1v-4h1zm-1 12h1v3h-1zm1-8h-1v-2h1v1zm-1 7v-1h1v1zm1 15v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.063
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120h1v1h1v1h-4v-1h2zm-28 3v-2h1v1h2v1zm38-3h2v1h-1v1h-1zm-43 0v1h-1v-2h1zm-3-2h1v1h-1zm53 3v-1h1v1zm-48 1v-1h1v1zm48 0h-1v-1h1zm-47 0h1v1h-1z",
    fill: "#2d3245"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122v-2h1v1h5v2h-4v-1zm26-1v1h1v1h-4v-2zm-32-3h1v1h-1z",
    fill: "#2c3345"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103h-3v-1h-6v-1h7v1h2zm-11-2v-1h2v1h-1zm20 3h2v1h-2zm11 1v1h-2v-1h1zm-37-6h1v1h-1zm24 4h1v1h-1z",
    fill: "#414862"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v-1h2v1h-1v1h-2zm6 4v1h-1v1h-1v-2zm-2 2v1h-3v-1zm15-13v1h-1v-1zm-4 2h-1v-1h1zm-3 1v1h-1v-1zm-3 1h1v1h-1zm-2 2v-1h1v1zm27 3h1v1h-1zm-27 1v1h-1v-1z",
    fill: "#808aa5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M85 9h2v6h-1v-3h-1v-1zM60 83v1h-3v-1zM84 8v1h-1V8zM58 82v-1h1v1zm-5 1v-1h1v1zm8 2h-1v-1h1z",
    fill: "#535f87"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54 65v-3h6v2h-1v-1h-2v1h-2v1zm10 2h1v2h-2v-1h1zm-11-3v1h-1v-1zm10 1h-1v-1h1z",
    fill: "#66729a"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11V8h1v1h1v1h1v1h-1v1h-1v-1zm2 1h1v1h2v3h-2v-1h1v-1h-2zm-3-3h-1V8h1z",
    fill: "#a1acca"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v2h-3v-1h2v-3h1zm-7-5v-3h1v3zm-9-4v-1h1v2h-1zm6 0h-2v-1h2zm2 0h-1v-1h1zm6 6h1v1h-1z",
    fill: "#a0abc7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M46 21v-1h1v3h-1v1h-2v-4h-2v-1h3v2zm1-2v-1h1v2h-1z",
    fill: "#9da8c4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8h1V7h1v1h1v1h1v3h-2v-1h-1v-1h-1V9zM45 71h1v1h-1z",
    fill: "#5d6991"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69v-2h2v1h3v-1h2v1h-1v1zm-2-2h1v1h-1zm0 1v1h-1v-1zm10 1v-1h1v1zm3 1h-1v-1h1z",
    fill: "#616d97"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57 117v1h-6v-1zm4 1h1v1h-2v-2h1zm-15-2v1h-1v-1zm33 1v-1h1v1zm-7 0h1v1h-1zm3 1h-1v-1h1zm-10 1v-1h1v1z",
    fill: "#30364c"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h-1v-1h2v1zm2 1v1h-1v-2h1zM48 63v1h-2v-1h1zM69 4v1h-1V4zm-8 5v1h-1V9zm1 2h-1v-1h1zm3 2h-1v-1h1zm5 5h1v1h-1zM44 65v1h-1v-1zm-5 1v1h-1v-1z",
    fill: "#6c7699"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v3h-3v-4h1v1zm-6-1v-1h3v1z",
    fill: "#9ca7c3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68 101v-1h5v1zm0-1h-2v-1h1v-1h1zm5 1h3v1h-3zm-23-6v1h-1v-1zm11 4h1v1h-1z",
    fill: "#454f6a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69 100h-1v-1h1v-1h1v1h1v-1h1v2h-1zm-5-1h-2v-1h2zm9 1h2v1h-2zm5 2h-2v-1h2zm-27-7h1v1h-1z",
    fill: "#46506b"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55 71v1h-1v-2h5v1h1v1h-2v-1zM73 7h1v1h-2V6h1zM50 70h-1v-1h1z",
    fill: "#5f6b95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-3h2v-1h1v4zM45 7h-1V6h1z",
    fill: "#a2aec8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h3v1h-1zm-2 0h-1v-1h2v1zm20-6v-1h1v1zm-9 3h-1v-1h1zm-1 1h-1v-1h1zm-11 5v1h-1v-1zm1 1v-1h1v1zm3 1h-1v-1h1z",
    fill: "#858fa8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M57 101v1h-3v-1zm17 4v-1h3v1h-1zm-31-6v1h-2v-1h1zm5 1h1v1h-2v-1zm16 2v1h-1v-1z",
    fill: "#424963"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M89 121h-5v-1h5zm-8-1h1v1h-2v-1zm-38-5v1h-1v-1zm-3 5v-1h1v1zm1 0h1v1h-1zm1 3h-1v-1h1z",
    fill: "#2c3245"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-2h1v1zM43 67h1v1h-2v-1zM67 9h-1V8h1zm5 8h-1v-1h1zm3 3h-1v-1h1zm1 1h-1v-1h1zm1 2v-1h1v1zM39 69v-1h1v1z",
    fill: "#677194"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13h1v2h-3v-3h2zm-2 3v1h-1v-2h1z",
    fill: "#9ea9c7"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h3v1h-1v2h-1v-2h-1zm14-1v-1h1v1zm-13 4v1h-1v-1zm-4 3h1v1h-1zm26 2h-1v-1h1zm0 6v1h-1v-1z",
    fill: "#7883a1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47 56h2v1h-2zm4-3v1h-1v-1zm-2 2v-1h1v1zm22 2h-1v-1h1zm-26 1v-1h1v1zm2 0v1h-1v-1zm25 1h-1v-1h1zm-1 5v-1h1v1zm-1 8h-1v-1h1z",
    fill: "#7782a0"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M46 57h2v1h-2zm-1 2v-1h1v2h-1zm26 1h1v2h-1v-1zm-1-2v-1h1v1zm-21 0v1h-1v-1zm-5 2v1h-1v-1zm27 5h-1v-1h1z",
    fill: "#76819f"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103h-4v-1h4zm-8-1v-1h3v1zm-9-2h-2v-1h2zm2-1v1h-1v-1z",
    fill: "#444e69"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M49 125v-1h4v1h-2zm37-1v1h-2v-1h1zM40 3v1h-1V3zm23 4h1v1h-1zM47 125v-1h1v1z",
    fill: "#1c2026"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h2v2h-1zm3 3h2v2h-1v-1h-1zm-7-8V9h1v1zm2 0v1h-1v-1zm4 8v-1h1v1z",
    fill: "#636c93"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18v5h-1v-1h-1v-2h1v-2zm-2-1h1v1h-1zm-1 6h1v1h-1z",
    fill: "#9ea9c5"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34 53h-1v-6h1zm0-9v1h-1v-1zm-1 10h1v1h-1zm1 5h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.059
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M62 64h-2v-2h1v1h1zm-10 0v-1h2v1h-1zm12 2v2h-1v-2zm3 3v1h-1v-2h1z",
    fill: "#67739b"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74v1h-6v-1zm4 1h-1v-1h1zm10 0h-1v-1h1zm2 0h-1v-1h1z",
    fill: "#d1dad9"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77h4v1h-4zm16-2v1h-3v-1h1zm-2 2v1h-1v-1zm-14 35v-1h1v1z",
    fill: "#d3dad4"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M47 78v-1h3v1zm3 1v-1h3v1zm10-1v1h-3v-1z",
    fill: "#d4dad6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99h1v1h-5v-1zm-4 0h-3v-1h2v-1h1z",
    fill: "#434d68"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114v-2h1v2zm12 2h-1v-1h2v1zm13 0v1h-2v-1h1zm3 0v1h-2v-1h1zm-8 0h1v1h-1z",
    fill: "#32374b"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70 117v1h-6v-1zm-18-1v1h-1v-1zm27 0v1h-1v-1zm7 1v-1h1v1z",
    fill: "#31364c"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h2v1h-1zm10 8h1v2h-1v-1zM60 8h1v1h-1zm4 4v-1h1v1zm8 8h1v1h-1zM44 65h1v1h-1z",
    fill: "#6b7598"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M60 73v1h-7v-1h2zM57 9h1v1h-1z",
    fill: "#75809c"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1zm-1 32h1v1h-1zm9 3v1h-1v-1zm-21 2h1v1h-1zm26 4v1h-1v-1zm-28 3h-1v-1h1zm31 4h-1v-1h1zm6 6v-1h1v1z",
    fill: "#7d86a3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h1v2h1v1h-2v-2h-1v-1h-1v-1h2zm1 5v-1h1v1z",
    fill: "#5f688f"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40v-1h6v1zm-7 0h-1v-1h1zm34 34h-1v-1h1z",
    fill: "#9099aa"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M41 45v-1h-1v-1h4v2zm4-1v-1h1v1z",
    fill: "#8a95a7"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M44 52v-1h1v2h-1zm-4 4v-1h2v1h-1zm15-12h-1v-1h1zm-5 2v-1h1v1zm11-1h1v1h-1zm-17 8v1h-1v-1z",
    fill: "#818ba6"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-4v-1h4zm-15 4v1h-1v-1zm4 0v1h-1v-1zm26 4h1v1h-1zm-28 2v-1h1v1z",
    fill: "#7f89a5"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h-1v-1h2v1zm-5 1v1h-2v-1h1zm0 4h-2v-1h2zm7-7v1h-1v-1zm-5 2h1v1h-1z",
    fill: "#838da7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1zm-5 2v-1h1v1zm0 0v1h-1v-1zm-3 1h1v1h-1zm3 1v1h-1v-1zm-3 4h1v1h-1zm-4 2h1v1h-1zm35 3h-1v-1h1z",
    fill: "#7e87a4"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1zm-15 2v-1h1v1zm15 0v-1h1v1zm-17 5h-1v-1h1zm-1 1h-1v-1h1zm25 1h1v1h-1zm2 9h-1v-1h1zm-3 7h-1v-1h1z",
    fill: "#7b86a2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M55 53h-1v-2h1v1zm2 0v1h-2v-1h1zm0-1h-1v-1h1zm12 6h-1v-1h1zm-20 2h-1v-1h1zm21 4h-1v-1h1z",
    fill: "#747f9f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57 63h2v2h-2zm5 1v2h-1v-2zm1 3v1h-1v-1zm3 2v1h-1v-1z",
    fill: "#65719a"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M60 69v2h-1v-1h-6v-1z",
    fill: "#606c95"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M65 78v1h-4v-1h1zm-10 1h-2v-1h2zm1 0v-1h1v1zm12 0v-1h1v1z",
    fill: "#d4dad5"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v1h1v1h-2v-1h-1v-1h1zm-19-3h1v1h-2v-1zm-6-1v1h-1v-1zm22 3h1v1h-1z",
    fill: "#404761"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M76 118h1v1h-2v-1zm-34-1h-1v-1h1zm-4 0v1h-1v-1zm1 0h1v1h-1zm6 1v-1h1v1zm22 2v-1h1v1zm-6 0v1h-1v-1z",
    fill: "#2e344a"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M88 121v1h-5v-1h1zm-44 1h-2v-1h2zm2-2v1h-1v-1z",
    fill: "#2c3144"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39 63v-1h-1v-1h3v1h-1v1zM57 6v1h-1V6zm12 57h-1v-1h1zm11 3v1h-1v-1z",
    fill: "#747d9c"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v2h-1v-2zm-3-5v1h-1V6zm19 1v1h-1V7zm-9 13h1v1h-1zm2 1h1v1h-1zM40 67h-1v-1h1z",
    fill: "#6c7698"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h1v1h-1zm0 2h-1V7h1zm-1 2h1v1h-1zm4 6v-1h1v1zm5 5h-1v-1h1zm1 0v1h-1v-1zM41 67h1v1h-1z",
    fill: "#687295"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M79 13h1v1h-2v-4h1zm-2-6v1h-1V7zm1 2h-1V8h1z",
    fill: "#5c6890"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M36 81v3h-1v-3zm0-3v2h-1v-2zm0-70v1h-1V8zm-1 68h1v1h-1z",
    fill: "#20232b"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v2h-1v-1zM38 8v1h-1V8zm3 0h1v1h-1zm2 0h1v1h-1zm5 0v1h-1V8zm-4 2V9h1v1z",
    fill: "#a2adca"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40 10h-3V9h2V8h1v1h1v1zm13 7v1h-1v-1zm0 4v-1h1v1z",
    fill: "#a1acc8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14h2v1h-1v1h-1zm-5-6v2h-1V8zm4 6v-2h1v2z",
    fill: "#a0abc9"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M84 9h1v3h-1zm1 4v-1h1v2h-1zm1 3v-1h1v1zM59 82v-1h1v1z",
    fill: "#546088"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M44 67h-1v-1h2v1zm-6 1v-1h2v1h-1zm28-57h1v1h-1zm5 6h-1v-1h1zm0 1v-1h1v1z",
    fill: "#697396"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1zm2 1h-1v-1h1zm0 33v-1h1v1zm-9 1h-1v-1h1zm-4 3h1v1h-1zm-4 4h1v1h-1zm26 1v-1h1v1z",
    fill: "#7984a2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1zm0 0h1v1h-1zM45 63h-1v-1h1zm22 0v-1h1v1zm-25 0h1v1h-1zm-3 1h1v1h-1zm29 3v-1h1v1z",
    fill: "#707b9b"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M39 23h-1v-3h1v1zm2 2h-1v-1h-1v-1h2zm49 10h-1v-1h1z",
    fill: "#99a4c0"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53v-2h1v2zm0 4v-2h1v2zm1-31h-1v-1h1zm-1 2v-1h1v1zm0 30h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1zm-6 0h1v1h-1zm9 1h-1v-1h1zm2 1h-1v-1h1zm-19 2h1v1h-1zm2 4v-1h1v1zm-3 2h1v1h-1z",
    fill: "#7f88a5"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1zm7 2h1v1h-1zm-23 3v1h-1v-1zm29 3h-1v-1h1zm-33 3v1h-1v-1zm35 2h1v1h-1zm3 9v1h-1v-1z",
    fill: "#7f89a4"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M70 58h1v2h-1v-1zm-23 3h-1v-2h1v1zm24 2h-1v-1h2v1zm-27-1h-1v-1h1z",
    fill: "#75809e"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M64 67v-2h1v1h1v1zm-13-3v-2h1v2zm3-2v-1h1v1zm6 0h-1v-1h1z",
    fill: "#68749b"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M57 66v-1h2v1h-1zm-6 1h-2v-1h2zm10 0h-2v-1h2zm2 2v1h-1v-1z",
    fill: "#636f99"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69h-2v-1h2zm6-1h2v1h-2zm4 4h-1v-2h1v1zm-13-3h1v1h-1z",
    fill: "#606c96"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75v-1h3v1h-1zm-6 0h-1v-1h2v1zm10-1h1v1h-1zm5 6h-1v-1h1z",
    fill: "#d1d9d8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75v1h-7v-1h3z",
    fill: "#d3dbd5"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M50 80v-1h3v1h-1zm8 0v-1h3v1h-1zm-2-1v1h-1v-1z",
    fill: "#d0d8d4"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M73 99h2v1h-2zm4 1h1v1h-2v-1zm-39-6h-1v-1h1zm44 8v-1h1v1zm3 1v-1h1v1z",
    fill: "#48526d"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M60 101h-5v-1h5zm-12-2v1h-1v-1zm24 4h1v1h-1z",
    fill: "#424b66"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117h-2v-1h2zm-10 1h-2v-1h2zm-20-5h1v1h-1zm7 5v-1h1v1zm14 0v-1h1v1z",
    fill: "#30374c"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M70 123h-1v-1h4v1zm-11-8h1v1h-2v-1zm4 4v-1h1v1z",
    fill: "#2d3247"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M90 117h-3v-1h3zm-14-1h2v1h-2zm-24 1v-1h1v1zm38 1v-1h1v1z",
    fill: "#31374c"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M85 118h2v1h-2zm-46-1v1h-1v-1zm2 1h-1v-1h1zm47 0h1v1h-1zm-10 1v1h-1v-1zm-18 3h-1v-1h1z",
    fill: "#2e3449"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M43 119h1v1h-2v-1zm33 1h-1v-1h2v1zm-33-3h1v1h-1zm-6 1h1v1h-1zm17 3v-1h1v1z",
    fill: "#2d3447"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121v1h-1v1h-1v-2zm-31-1v-1h1v1zm35 1h-1v-1h1zm-31 1h1v1h-1zm30 1v-1h1v1z",
    fill: "#2d3246"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123h1v1h-4v-1zm37-1h1v1h-1zm-42 1h1v1h-1zm27 1h-1v-1h1z",
    fill: "#2f3244"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M49 5h-1V4h1zm20 16v1h-1v-1zm-3 25v1h-1v-1zm8 21h-1v-1h1zm9-1v1h-1v-1zm2 3h-1v-1h1z",
    fill: "#7f89a3"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61v-1h2v1h-1zM57 6h-1V5h1zM41 60h1v1h-1zm0 2v1h-1v-1zm40 7v-1h1v1z",
    fill: "#757e9d"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5h1v1h-1zm-6 53v1h-1v-1zm-6 4h-1v-1h1zm-3 0h1v1h-1zm22 3h-1v-1h1zm0 4v-1h1v1z",
    fill: "#6f799c"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M69 6v1h-1V6zm-3 4V9h1v1zm5 4v1h-1v-1zm3 4v1h-1v-1zM45 68h-1v-1h1zm-7 1v-1h1v1z",
    fill: "#677195"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M41 9h1v1h-1zm2 0h1v1h-1zm3 1v1h-1v-1zm1 1v1h-1v-1zm2 1h1v1h-1zm3 4v1h-1v-1z",
    fill: "#a1acc9"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9h2v1h-1v1h-1zm2 5h-1v-3h1z",
    fill: "#56628a"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h-1V9h1z",
    fill: "#4e5a82"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38 15h-1v-3h1zm10 0h-1v-1h1zm-3 1h-1v-1h1zm0 1v-1h1v1z",
    fill: "#9faac8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v-2h1v2zm-1-52v1h-1v-1zm6 6v1h-1v-1zM48 62h1v1h-1zm-6 3h1v1h-1z",
    fill: "#6d779a"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1zm2 2h-1v-1h1zm1 1h-1v-1h1zm8 5v1h-1v-1zM37 63h1v1h-1zm32 9v1h-1v-1z",
    fill: "#707b9a"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h-1v-3h1v1zm-4-4h-1v-1h1zm4 4h1v1h-1zM42 70h1v1h-1z",
    fill: "#626b92"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M57 53h-2v-1h2zm10-35v1h-1v-1zM52 55h-1v-1h1zm-3 2h1v1h-1zm-1 3h-1v-1h1z",
    fill: "#75809f"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M40 20v2h1v1h-2v-3zm-1-1v1h-1v-1zm-1 2h-1v-1h1z",
    fill: "#9aa5c1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24v-1h3v1zm-1-2v-2h1v2zm0-3v1h-1v-1z",
    fill: "#9ba6c2"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M95 38h-1v-6h1v1z",
    fill: "#fff",
    fillOpacity: 0.043
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M34 73h-1v-3h1zm-1-34h1v1h-1zm0 30v-1h1v1zm7 58h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.067
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1zm-9 2h1v1h-1zm11 0h1v1h-1zm-23 4h1v1h-1zm4 5h1v1h-1zm-4 2v1h-1v-1z",
    fill: "#838da6"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1zm-8 4h1v1h-1zm-5 4v1h-1v-1zm1 0h1v1h-1zm2 2v-1h1v1zm-1 0h1v1h-1z",
    fill: "#848ea7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61h-1v-3h1zm-25-7h1v1h-1zm-4 4v1h-1v-1zm27 15h-1v-1h1z",
    fill: "#78839f"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M50 70v-1h3v1zm0 0v1h-1v-1zm4 1h-1v-1h1zm9 1v1h-1v-1z",
    fill: "#5f6b94"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M55 72v-1h3v1zm-4-1v1h-2v-1h1zm-3 0v1h-1v-1z",
    fill: "#5e6a94"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M53 73v-1h6v1h-1z",
    fill: "#5b6791"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M48 100v-1h3v1h-1zm22 2h2v1h-2zm-9-2v1h-1v-1z",
    fill: "#424c67"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M41 102v-1h3v1zm-2 0h-1v-1h1zm12 2h-1v-1h1zm22 2v-1h1v1z",
    fill: "#3f465f"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M51 105v-1h2v1h-1zm-12-4h1v1h-1zm10 3v-1h1v1zm14 1h-1v-1h1zm0 0h1v1h-1z",
    fill: "#3f4660"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M70 120v-1h4v1h-2zm-13-5v1h-1v-1zm12 0h1v1h-1z",
    fill: "#2f3449"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M53 120v-1h2v1h-1zm14 0h2v1h-2zm-10 0v-1h1v1zm2 1v-1h1v1z",
    fill: "#2e3549"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125v-1h2v1h-1zm-8 0h-1v-1h1zm19 0h-1v-1h1zm2-1v1h-1v-1zm3 0h1v1h-1z",
    fill: "#1d2027"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-2v-1h1zM47 5h1v1h-1zm-7 7h1v1h-1zm8 4h-1v-1h1z",
    fill: "#9faac7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M59 6h1v1h-1zm0 4V9h1v1zm3 1v1h-1v-1zM40 66v-1h1v1zm-3 1v-1h1v1z",
    fill: "#6d7898"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h-1V7h1zm11 15h-1v-1h1zM42 69h-1v-1h1zm-3 1h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#667093"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M69 8h-1V7h1zm2 7h1v1h-1zm7 7h-1v-1h1zM44 68v1h-1v-1zm-5 1h1v1h-1z",
    fill: "#656f93"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M95 41h-1v-3h1zM33 9V8h1v1zm60 113v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.039
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M69 9v2h-1V9zm2 6v-1h1v1zm4 3h-1v-1h1zm2 3h-1v-1h1z",
    fill: "#656f94"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M82 11h1v2h-1v-1h-1V9h1z",
    fill: "#57638b"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16h2v1h-2zm-5-5v-1h1v1zm2 1h-1v-1h1zm0 1h1v1h-1z",
    fill: "#646d94"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1zm1 29v-1h1v1zm-11 0v1h-1v-1zm6 0h1v1h-1zm34 23h-1v-1h1z",
    fill: "#8f98a7"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1zm6 5h1v1h-1zm7 31h1v1h-1zm5 18v1h-1v-1zm14 3h1v1h-1z",
    fill: "#828da3"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M73 66v2h-1v-2zM54 14h-1v-1h1zm28 54v-1h1v1zm6 2v1h-1v-1z",
    fill: "#7c86a1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M69 70v1h-1v-2h1zm-5-57v1h-1v-1zm6 6v1h-1v-1zM43 64v1h-1v-1z",
    fill: "#6e789a"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1zm6 1v1h-1v-1zm7 30h1v1h-1zm9 13v1h-1v-1zm8 7h1v1h-1z",
    fill: "#848fa3"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1zm9 32v1h-1v-1zm18 22h-1v-1h1zm2 0v1h-1v-1zm-11 3h1v1h-1z",
    fill: "#838ea3"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1zm8 48h-1v-1h1zm-27 1v-1h1v1zm-3 0h1v1h-1zm29 6h1v1h-1z",
    fill: "#727d9c"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1zm1 2v-1h1v1zm2 0v1h-1v-1zm1 1v1h-1v-1zm5 4v1h-1v-1z",
    fill: "#6e799a"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1zm2 3v-1h1v1zm2 1h-1v-1h1zm1 2h-1v-1h1zM37 70v-1h1v1z",
    fill: "#667094"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M46 17h1v3h-1zm-5 2v-1h1v1zm5 1v1h-1v-1z",
    fill: "#9da8c5"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v2h-1v-2zM63 23h-1v-1h1zm-6 18h1v1h-1zm9 3v1h-1v-1z",
    fill: "#8691a5"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M33 93v-1h1v2h-1zm0-67v-1h1v1zm1 4h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#f3f3ff",
    fillOpacity: 0.086
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1zm-1 37v-1h1v1zm0 5h1v1h-1zm1 2v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.071
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42v-1h4v1h-1zm6 0v-1h1v1z",
    fill: "#8d95a8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-3v-1h1zm-6-2v1h-1v-1zm9 1h1v1h-1z",
    fill: "#8994aa"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44v-1h2v1h-1zm-9 0v-1h1v1zm3 2h-1v-1h1zm3-1h1v1h-1z",
    fill: "#8994a9"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1zm-2 2v-1h1v1zm-8 3h1v1h-1zm-1 6v1h-1v-1zm-2 2h-1v-1h1z",
    fill: "#828ca6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v-1h2v2h-1v-1zm27-1v1h-1v-1zm-19 2h-1v-1h1z",
    fill: "#8893a9"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v2h-1v-1zm0 12v-2h1v2zm0-9h1v1h-1z",
    fill: "#6b6c70",
    fillOpacity: 0.863
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45h1v3h-1zm40 17h-1v-1h1zm8 6v-1h1v1z",
    fill: "#828ca3"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h2v1h-1zm-21 3h-2v-1h2zm2 3h1v1h-1z",
    fill: "#838da8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v4h-1v-4zm-1 5h1v1h-1z",
    fill: "#767864"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-2v-1zm-3 1h1v1h-1zm-1 2h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#7883a2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h3v1zm-3-1h2v1h-2z",
    fill: "#7883a3"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50v2h-1v-2zm-3 6v1h-1v-2h1zm18 2v-1h1v1z",
    fill: "#7580a0"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1zm2 2h-1v-1h1zm-3 0h1v1h-1zm0 2h-1v-1h1zm-2 2v-1h1v1z",
    fill: "#747fa0"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55h1v1h-1zm12 0v1h-1v-1zm-13 1v1h-1v-1zm-2 2v-1h1v1zm-1 1v-1h1v1z",
    fill: "#717b9e"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M55 57h1v1h-1zm-3 1h1v1h-1zm7 1v-1h1v1zm-7 1h-1v-1h1zm-2 1v-1h1v1z",
    fill: "#6f799d"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M54 61h-1v-1h1zm-4 0h1v1h-1zm16 4h1v1h-1zm2 2v1h-1v-1zm0 5h-1v-1h1z",
    fill: "#6b779a"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M34 70v-3h1v3zm0-5h1v1h-1zm1 7h-1v-1h1z",
    fill: "#6d6e71",
    fillOpacity: 0.871
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M55 66v-1h2v1h-1zm-7 3h-1v-1h1zm16 1v1h-1v-1zm0 1h1v1h-1z",
    fill: "#626e97"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M53 77v1h-3v-1h1zm9 1h-1v-1h1zm4 0h-1v-1h1z",
    fill: "#d3d9d5"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M57 78v-1h4v1h-1zm10 0v-1h1v1z",
    fill: "#d3d9d4"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h3v1h-3zm-3 1h-1v-1h1zm14 1h1v1h-1z",
    fill: "#515b7e"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M76 99h2v1h-2zm8 3v-1h2v1h-1zM52 92h1v1h-1z",
    fill: "#4a546f"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v-1h1v1zm3 0v1h-1v-1zm2 1v1h-1v-1zm15 3v1h-1v-1zm12 3v-1h1v1z",
    fill: "#454f69"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96h-1v-1h1zm0 1h1v1h-1zm20 3h-1v-1h1zm3 1h-1v-1h1zm4 0h1v1h-1z",
    fill: "#47516c"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M41 100h2v1h-2zm16 3h2v1h-2zm-7-1v1h-1v-1z",
    fill: "#40485f"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M49 101v-1h2v1h-1zm10 1h-1v-1h2v1zm1 0h1v1h-1z",
    fill: "#424965"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M65 106h1v1h-2v-1zm-23-4h1v1h-1zm0 1v1h-1v-1zm11 3h-1v-1h1z",
    fill: "#3e455e"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M36 112v3h-1v-3zm-1-3h1v2h-1v-1z",
    fill: "#191b20"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M52 118h1v1h-2v-1zm-10-1v-1h1v1zm27 2h-1v-1h1zm-3 0h1v1h-1z",
    fill: "#2e354b"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M58 123h1v1h-2v-1zm-4 1v-1h1v1zm9 0h-1v-1h1zm12 0v-1h1v1z",
    fill: "#2f3246"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M54 5v1h-1V5zm19 20h1v1h-1zm10 40h-1v-1h1zm-11 6h1v1h-1z",
    fill: "#818ba1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6V5h1v1zm2 10h-1v-1h1zm0 0h1v1h-1zm4 4h1v1h-1z",
    fill: "#6a7498"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-2h1v1zM69 6h-1V5h1zm1 10h-1v-1h1z",
    fill: "#697397"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5v1h-1V5zM48 67v1h-1v-1zm-1 1v1h-1v-1zm17 3v-1h1v1z",
    fill: "#626e96"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6V5h1v1zm-2 10v-1h1v1zM63 85v-1h1v1zm2 1h-1v-1h1z",
    fill: "#586188"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7V6h1v1zm27 61h1v1h-1zm4 2v1h-1v-1zm1 1v1h-1v-1z",
    fill: "#7a839f"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M48 7v1h-1V7zm4 8h1v1h-1zm3 3h-1v-1h1zm0 0h1v1h-1z",
    fill: "#a4afcd"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7h1v1h-1zm19 39v1h-1v-1zm1 1v1h-1v-1zm-7 55v-1h1v1z",
    fill: "#8992a3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8h1v1h-1zm11 47h-1v-1h1zm4 12v-1h1v1zm12 4v-1h1v1z",
    fill: "#79829f"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8v3h-1V8zm0 3h1v1h-1z",
    fill: "#5f6b93"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9v1h-1V9zm-2 7h1v1h-1zM38 59v-1h1v1zm51 13h-1v-1h1z",
    fill: "#7b85a0"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M80 9h1v3h-1zm1 5v-1h1v1z",
    fill: "#59658d"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M88 9h1v3h-1zm2 7h-1v-1h1z",
    fill: "#4f5b83"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M92 9h1v2h-1v-1zm0 62h1v2h-1v-1z",
    fill: "#36373a"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1zm18 36v-1h1v1zm1 0h1v1h-1zm6 12h-1v-1h1z",
    fill: "#8b94a3"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h1v3h-1zm2 3v1h-1v-1z",
    fill: "#5b678f"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22v2h-1v-2zm-6-11h1v1h-1zm2 1v1h-1v-1z",
    fill: "#9fabc6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h3v1h-3zm-4-10h-1v-1h1z",
    fill: "#a1acc7"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h2v1h-2zm0-29v-1h1v1zm32 60h-1v-1h1z",
    fill: "#8792a7"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1zm15 36h-1v-1h1zm4 21v-1h1v1zm4 1v1h-1v-1z",
    fill: "#838ea1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1zM47 54h1v1h-1zm27 8h-1v-1h1zm-2 2h1v1h-1z",
    fill: "#7a85a1"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h4v1h-2z",
    fill: "#9fabc5"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1zm16 43v-1h1v1zm9 10h1v1h-1zm-9 4v-1h1v1z",
    fill: "#808aa3"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1zm-6 46h-1v-1h1zm4-1v1h-1v-1zm-18 6h1v1h-1z",
    fill: "#6d7799"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-2h1zm-5-3v-1h1v1zm3 0h1v1h-1z",
    fill: "#636c94"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M76 16v-1h1v1zm3 0v1h-1v-1zm1 3v1h-1v-1zM42 71v1h-1v-1z",
    fill: "#616a91"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v1h-1v-2h1zM37 80v-1h1v1zm25 5v-1h1v1z",
    fill: "#576087"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h4v1z",
    fill: "#9da8c7"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h-2v-1h2zm38-56v1h-1v-1zM66 85h-1v-1h1z",
    fill: "#5c668b"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1zm3 1v1h-1v-1zM38 82h-1v-1h1zm26 5v1h-1v-1z",
    fill: "#555f83"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1zm7 4v1h-1v-1zm10 44v-1h1v1zm7-1h1v1h-1z",
    fill: "#8a96a6"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58v3h-1v-3zm-8-40v1h-1v-1z",
    fill: "#7b85a2"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19v-1h1v2h-1zm2 3h-1v-1h2v1z",
    fill: "#5d678a"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1zm6 5h-1v-1h1zm11 42h-1v-1h1zm3 2h-1v-1h1z",
    fill: "#818ca3"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1zm-4 25h1v1h-1zm-17 8v1h-1v-1zm29 12h-1v-1h1z",
    fill: "#7d88a3"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1zM57 51h1v1h-1zm6 3h1v1h-1zm6 15v-1h1v1z",
    fill: "#737d9d"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1zm-5 35h-1v-1h1zm-21 8h-1v-1h1zm-4 0h1v1h-1z",
    fill: "#6f7a9a"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53v2h-1v-2zm0-24h-1v-1h1zm-1 21v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.02
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M33 82h1v3h-1zm0-43v-1h1v1z",
    fill: "azure",
    fillOpacity: 0.071
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1zm2-1h1v1h-1zm46 41h1v1h-1zm-22 7v1h-1v-1z",
    fill: "#939caa"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-3v-1zm-5 0h1v1h-1z",
    fill: "#939cab"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1zm3 0v-1h1v1zm8 2h-1v-1h1zm15 21v1h-1v-1z",
    fill: "#8f98a8"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40h1v1h-2v-1zm12 0h-1v-1h1zm-14 1h-1v-1h1z",
    fill: "#8e97a7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h-1v-3h1zm0-6h-1v-1h1z",
    fill: "#272930"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1zm-6 4h-1v-1h1zm2 0h-1v-1h1zm29 18h1v1h-1z",
    fill: "#8994a7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1zm1 0v-1h1v1zm3-1v1h-1v-1zm20 1v1h-1v-1z",
    fill: "#8c95a8"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M50 43h-1v-1h2v1zm26 23v-2h1v2z",
    fill: "#8893a7"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M77 66h1v1h-2v-1zM51 43v-1h1v1zm11 15h-1v-1h1z",
    fill: "#8691a7"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1zm6 3v-1h1v1zm-19 2v1h-1v-1zm-6 1v1h-1v-1z",
    fill: "#818ba5"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1zm2 2h-1v-1h1zm9 16h-1v-1h1zm3 3v-1h1v1z",
    fill: "#8b94a4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1zm5 1h-1v-1h1zm0 1v-1h1v1zm20 21v1h-1v-1z",
    fill: "#818ba4"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M40 47h-1v-1h2v1zm-1-1h-1v-1h1zm5 1h-1v-1h1z",
    fill: "#8792a9"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h2v1h-2zm10 1h1v1h-1zm2 2h-1v-1h1z",
    fill: "#7d87a3"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1zm-3 1h1v1h-1zm-1 2h-1v-1h1zm-1 3h-1v-1h1z",
    fill: "#8089a5"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1zm7 1v-1h1v1zm-11 2v1h-1v-1zm0 3v1h-1v-1z",
    fill: "#7d86a4"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-2v-1h2zm-5 0v-1h1v1zm10 1v-1h1v1z",
    fill: "#7984a3"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1zm-17 8h-1v-1h1zm25 0h-1v-1h1zm0 1h1v1h-1z",
    fill: "#7a85a2"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h1v1h-2v-1zm4-1v1h-1v-1zm-5 3h1v1h-1z",
    fill: "#7782a2"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1zm-1 5h-1v-1h1zm-1 1v1h-1v-1zm-4 3v-1h1v1z",
    fill: "#7984a1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M52 55h1v2h-1v-1zm3-1v1h-1v-1zm13 5v-1h1v1z",
    fill: "#737da0"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M75 65h-1v-2h1v1zm-6-10h-1v-1h1zm5 2v1h-1v-1z",
    fill: "#7c87a3"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58v-1h1v-1h1v2zm3-3h1v1h-1z",
    fill: "#707a9d"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M34 62h1v3h-1zm1-1h-1v-1h1z",
    fill: "#6b6b6f",
    fillOpacity: 0.871
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M71 69h-1v-3h1zm-31-8v-1h1v1z",
    fill: "#767f9e"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M59 60h1v1h-1zm-5 1v1h-1v-1zm7 0v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#69759b"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M52 64v1h-1v1h-1v-2zm12 5h1v1h-1z",
    fill: "#657199"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M60 65v-1h1v2h-2v-1zm2 1h1v1h-1z",
    fill: "#65719b"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M83 67h1v1h-1zm-10 2v1h-1v-1zm7 0v1h-1v-1zm7 1h-1v-1h1z",
    fill: "#7f89a2"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M49 74v-1h2v1h-1zm4 0h-1v-1h1zm8 0h-1v-1h1z",
    fill: "#76819d"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M78 74h1v1h-1zm4 1v1h-1v-1zm1 1v1h-1v-1zm-1 2h-1v-1h1z",
    fill: "#d5ddd8"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M61 75h1v1h-1zm5 1h-1v-1h1zm0 3h-1v-1h1zm2-1v1h-1v-1z",
    fill: "#d4dad4"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77v-1h1v1zm21 0h-1v-1h1zm-9 1v1h-1v-1zm15 1h1v1h-1z",
    fill: "#d4dad7"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78v1h-3v-1zm5 1v-1h1v1z",
    fill: "#d7ddd7"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81v1h-2v-1h1zm-3 3v-1h1v1zm3 0v-1h1v1z",
    fill: "#515d86"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v-4h1v4z",
    fill: "#1f222a"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92h-1v-3h1zm0 26v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.082
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M36 90v3h-1v-3zm17 34h1v1h-1z",
    fill: "#1e2028"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M50 93v-1h1v1zm3 1v1h-1v-1zm8 0h1v1h-1zm3 2h-1v-1h1z",
    fill: "#4a5371"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M93 99h1v2h-1v-1zm1-2h-1v-1h1zm-1 5h1v1h-1z",
    fill: "#a1a1aa",
    fillOpacity: 0.447
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99v1h-2v-1h1zm-8-1v-1h1v1zm5 0h1v1h-1z",
    fill: "#4d5673"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M74 99v-1h3v1zm5 0h1v1h-1z",
    fill: "#4b5470"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M46 100h-1v-1h2v1zm29 4v-1h1v1zm14 4h-1v-1h1z",
    fill: "#414b66"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M37 102h1v1h-1zm3 1v-1h1v1zm23 2v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#3e455f"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M60 103h-1v-1h1zm8 2h-1v-1h1zm5-1v1h-1v-1zm7 1h-1v-1h1z",
    fill: "#424964"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M75 114v1h-1v-2h1zm-23-1v1h-1v-1zm11 2v-1h1v1z",
    fill: "#34394f"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M66 116h-2v-1h2zm13-2v1h-1v-1zm-18 1h1v1h-1z",
    fill: "#34394d"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M41 116v-1h1v1zm2 2v1h-1v-1zm9 2h-1v-1h1zm9 3v-1h1v1z",
    fill: "#2d3348"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M56 115v1h-1v-1zm16 1v-1h1v1zm-34 5h-1v-1h1zm52 1h-1v-1h1z",
    fill: "#2e3347"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M47 116h1v1h-1zm12 2h-1v-1h1zm0 1h1v1h-1zm11 0v1h-1v-1z",
    fill: "#2f354a"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M54 116v1h-1v-1zm1 0h1v1h-1zm20 1h-1v-1h1zm-12 0h1v1h-1z",
    fill: "#32374d"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M81 118h-1v-1h1zm-31 0h1v1h-1zm27 1v-1h1v1zm13-1v1h-1v-1z",
    fill: "#2e354a"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M72 120v1h-2v-1h1zm-34 0h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#2e3346"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M76 123h2v1h-2zm7-1v1h-1v-1zm-10 2v-1h1v1z",
    fill: "#2e3245"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M87 122v1h-4v-1h1z",
    fill: "#2d3144"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M87 124h-4v-1h4z",
    fill: "#2e3142"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M76 125h-1v-1h2v1zm-31 0v-1h1v1zm16 0h-1v-1h1z",
    fill: "#1d2128"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M54 125v-1h3v1zm19-1v1h-1v-1z",
    fill: "#1e1f27"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M48 127v-1h2v1h-1zm3 0v-1h2v1h-1z",
    fill: "#a0a0ac",
    fillOpacity: 0.243
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M69 127v-1h4v1h-1z",
    fill: "#9f9fa4",
    fillOpacity: 0.231
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M63 2V1h3v1z",
    fill: "#98989f",
    fillOpacity: 0.263
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M73 1h1v1h-2V1zm3 1V1h1v1z",
    fill: "#9999a1",
    fillOpacity: 0.247
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M81 2h2v1h-2zm5 1h-1V2h1z",
    fill: "#3d3f47"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M74 4V3h3v1h-1z",
    fill: "#2a303e"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M61 4v1h-1V4zm8 57v1h-1v-1zm0 11h-1v-1h1z",
    fill: "#727c9c"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5V4h1v1zm13 2v1h-1V7zM62 61v-1h1v1z",
    fill: "#707a9b"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M68 4v1h-1V4zm7 19h-1v-1h1zM42 66h-1v-1h1z",
    fill: "#6e7899"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M71 4h1v1h-1zM47 66v-1h1v1zm-1 1h-1v-1h1z",
    fill: "#667297"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4v1h-1V4zm1 1h1v1h-1zM43 73h-1v-1h1z",
    fill: "#5c678b"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M55 7h-1V5h1v1zm2 4h-1v-1h1z",
    fill: "#7e88a1"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M56 5v1h-1V5zM42 59h-1v-1h1zm-4 1h-1v-1h1z",
    fill: "#7a83a0"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5h2v1h-2zM44 64v-1h1v1z",
    fill: "#6e7999"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M67 6h-1V5h1zm2 12v1h-1v-1zM48 62v1h-1v-1z",
    fill: "#6e789b"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M84 6V5h1v1zM38 71v-1h1v1zm29 11h1v1h-1z",
    fill: "#636d90"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M50 7V6h1v1zm10 12v-1h1v1zm30 56v1h-1v-1z",
    fill: "#8f9aa9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6v1h-1V6zm18 40v-1h1v1zm7 12v-1h1v1z",
    fill: "#8c95a4"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M59 7v1h-1V6h1zm1 3v1h-1v-1z",
    fill: "#6e7998"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M67 7h-1V6h1zm2 11h1v1h-1zM53 61h-1v-1h1z",
    fill: "#6c769a"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M89 6v1h-1V6zm-3 14h-1v-1h1zm0 1v-1h1v1z",
    fill: "#5a6487"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M33 7h1v1h-1zm62 17v1h-1v-1zm-7 102h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.008
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h-1V7h1zm-6 1h-1V8h1zm13 8v-1h1v1z",
    fill: "#a2adc9"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v2h-1zm-4-8v1h-1V7z",
    fill: "#a2adcb"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M73 61v2h-1v-2zM49 8V7h1v1z",
    fill: "#77829e"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9V8h1v1zm5 2v-1h1v1zm15 40h1v1h-1z",
    fill: "#7f8aa0"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8v2h-1V8zm11 16v-1h1v1z",
    fill: "#677193"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M68 8h1v1h-1zm6 8v1h-1v-1zm4 5h1v1h-1z",
    fill: "#656e94"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M70 9h-1V8h1zm8 12h-1v-1h1zm1 0h1v1h-1z",
    fill: "#636d93"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M72 8h1v2h-1V9zm2 3v1h-1v-1z",
    fill: "#606c94"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42v1h-2v-1h1zm3-33v1h-1V9z",
    fill: "#8b95a8"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v2h-1V9zm4 6h-1v-1h1z",
    fill: "#687297"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M88 9v3h-1V9z",
    fill: "#515d85"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M90 10V9h1v1zM50 82h-1v-1h1zm1 0v-1h1v1z",
    fill: "#505c84"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M92 10h-1V9h1zm0 3h-1v-1h1zm-6 103v-1h1v1z",
    fill: "#32394c"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M63 10h1v1h-1zm7 7v1h-1v-1zM48 63h1v1h-1z",
    fill: "#6b7599"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h2v1h-1zm0-2h-1v-1h1z",
    fill: "#626c95"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h1v2h-1v-1zM48 67h1v1h-1z",
    fill: "#616d95"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M51 70h2v1h-2zm24-60v1h-1v-1z",
    fill: "#5e6a92"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M84 12h1v2h-1v-1zm-1-2h1v1h-1z",
    fill: "#556189"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1zm9 8h-1v-1h1zm8 42v1h-1v-1z",
    fill: "#7c88a2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12h-1v-1h1zm4 6v-1h1v1zM42 67v-1h1v1z",
    fill: "#6a7497"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1zm16 48h1v1h-1zm0 4v1h-1v-1z",
    fill: "#7c87a2"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1zm1 0v1h-1v-1zM41 65v-1h1v1z",
    fill: "#6f799b"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M87 13h1v2h-1v-1zM52 83v-1h1v1z",
    fill: "#525e84"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M89 14v1h-1v-2h1zM45 81h1v1h-1z",
    fill: "#505c82"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M93 13v1h-1v-1zm-1 3v-1h1v1zm0 5v-1h1v1z",
    fill: "#343539"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M37 17h-1v-3h1z",
    fill: "#99a4be"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1zm5 3h-1v-1h1zm1 6v1h-1v-1z",
    fill: "#9ea9c6"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1zm5 4v-1h1v1zm-5 1h-1v-1h1z",
    fill: "#7f8aa2"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1zm0 1v-1h1v1zm14 11v1h-1v-1z",
    fill: "#7d89a3"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16v-1h1v1zm6 5v1h-1v-1zM42 71h-1v-1h1z",
    fill: "#636c92"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M82 15h1v1h-1zM63 83h1v1h-1zm1 2v-1h1v1z",
    fill: "#5a638a"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1zm1 2h-1v-1h1zM62 83h1v1h-1z",
    fill: "#596289"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18h-2v-1h1v-1h1z",
    fill: "#9ca7c5"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1zM44 58h-1v-1h1zm29 6v-1h1v1z",
    fill: "#7984a0"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1zm1 6h1v1h-1zM38 58h-1v-1h1z",
    fill: "#7f8aa3"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1zm6 43h-1v-1h1zm-1 11v1h-1v-1z",
    fill: "#747f9d"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v2h-1zm1 1h1v1h-1z",
    fill: "#606990"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1zm1 0v1h-1v-1zM67 85v1h-1v-1z",
    fill: "#5b6589"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18v1h-2v-2h1v1z",
    fill: "#545e82"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v3h-1z",
    fill: "#9eaac5"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v1h-1v-1zm2 0h1v1h-1zm4 5v1h-1v-1z",
    fill: "#9ba7c2"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v1h-1v-2h1zM64 19v1h-1v-1z",
    fill: "#8893a5"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1zm7 30h1v1h-1zm4 19v-1h1v1z",
    fill: "#838ea4"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1zM38 57h-1v-1h1zm37 8v-1h1v1z",
    fill: "#808ba4"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M44 60v-1h1v2h-1zm23-41h1v1h-1z",
    fill: "#76829f"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1zM47 62h-1v-1h1zm-6 1h1v1h-1z",
    fill: "#717c9c"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1zm2 3v-1h1v1zM66 84h1v1h-1z",
    fill: "#5e688b"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v-2h1v2zm2 0h1v1h-1z",
    fill: "#5c6689"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-2v-1h2zm-2-1h-1v-1h1z",
    fill: "#576184"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1zm2 1v1h-1v-1zM66 84v-1h1v1z",
    fill: "#5e688c"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1zm17 43v1h-1v-1zm-7 4h1v1h-1z",
    fill: "#838ea5"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1zM43 58h-1v-1h1zm30 10v1h-1v-1z",
    fill: "#7b85a1"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1zm7 46h-1v-1h1zm-1 1h-1v-1h1z",
    fill: "#8792a4"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1zM43 69v1h-1v-1zm-3 1v1h-1v-1z",
    fill: "#646e91"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M39 71h2v1h-2zm43-48h-1v-1h1z",
    fill: "#626c90"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1zM38 73v-1h1v1zm28 9h1v1h-1z",
    fill: "#606a8d"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M60 23v1h-1v1h-1v-2z",
    fill: "#a4b0c7"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1zm-1 29v-1h1v1zm1 17h1v1h-1z",
    fill: "#7e89a1"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1zm-2 32v-1h1v1zm-31 3h1v1h-1z",
    fill: "#7b84a1"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1zm3 0v1h-1v-1zm0 1h1v1h-1z",
    fill: "#687393"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M34 96v1h-1v-2h1zm0-71h-1v-1h1z",
    fill: "#f4f4ff",
    fillOpacity: 0.094
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1zM43 74h-1v-1h1zm8 0v-1h1v1z",
    fill: "#76809d"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M87 27v-1h3v1h-1z",
    fill: "#626c87"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1zm-7 20v-1h1v1zm5 2v1h-1v-1z",
    fill: "#8590a3"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1zm-1 2v1h-1v-1zm5 64h-1v-1h1z",
    fill: "#646e89"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M61 30v-1h3v1h-1z",
    fill: "#cdc77b"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1zM65 80h1v1h-1zm14 6h1v1h-1z",
    fill: "#737d95"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1zm0 20h-1v-1h1zm-61 69h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.035
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1zm3 0h-1v-1h1zm17 9h-1v-1h1z",
    fill: "#a8ada5"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1zm0 42v-1h1v1zm0 7h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.075
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1zm10 4h1v1h-1zm19 17v-1h1v1z",
    fill: "#9ea6a5"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M80 38h2v1h-2zm-1-1v1h-1v-1z",
    fill: "#ccca98"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1zm2 1v-1h1v1zm12 0v-1h1v1z",
    fill: "#939ba9"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1zm14 0h-1v-1h1zm13 4h-1v-1h1z",
    fill: "#939ba8"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M39 39h2v1h-2zm40 24h1v1h-1z",
    fill: "#919aaa"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v-1h3v1z",
    fill: "#919aab"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1zm-12 1v1h-1v-1zm4 1v-1h1v1z",
    fill: "#8f98a9"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h2v1h-2zm-6 1h-1v-1h1z",
    fill: "#8e97a9"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1zm5 0h-1v-1h1zm31 33h-1v-1h1z",
    fill: "#8b94a6"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1zm-13 0v1h-1v-1zm24 2v-1h1v1z",
    fill: "#8c94a7"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1zm7 0v-1h1v1zm31 33v1h-1v-1z",
    fill: "#8b94a5"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57v-1h1v2h-1zM62 41v-1h1v1z",
    fill: "#9099a5"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1zm-2 1h-1v-1h1zm15 30h1v1h-1z",
    fill: "#8590a6"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1zm-8 2h1v1h-1zm-3 2h1v1h-1z",
    fill: "#8792a8"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1zm-5 0h1v1h-1zm27 28h1v1h-1z",
    fill: "#848fa6"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1zm0 11v1h-1v-1zm-1 8h1v1h-1z",
    fill: "#323436"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v2h-1v-2zm0 11v1h-1v-1z",
    fill: "#27292f"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1zm3 0v1h-1v-1zm3 1v-1h1v1z",
    fill: "#8b95a7"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1zm21 26h-1v-1h1zm2 1h-1v-1h1z",
    fill: "#838da5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1zm0 16v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#6c6c6f",
    fillOpacity: 0.867
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1zM38 56v-1h1v1zm38 8h-1v-1h1z",
    fill: "#828ca5"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49v1h-2v-1h1zm14-5h-1v-1h1z",
    fill: "#808aa6"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1zm-18 6v1h-1v-1zm34 7v1h-1v-1z",
    fill: "#808aa4"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1zm4 3v-1h1v1zm16 19h-1v-1h1z",
    fill: "#8590a2"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h1v1h-2v-1zm-5-2h-1v-1h1z",
    fill: "#abb0a3"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-2v-1h2zm2-1h-1v-1h1z",
    fill: "#8691a8"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1zm-5 1v-1h1v1zm-6 6v1h-1v-1z",
    fill: "#7d87a4"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h3v1z",
    fill: "#7b86a3"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47h1v1h-2v-1zm-1 1v1h-1v-1z",
    fill: "#7a85a3"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1zm2 2v-1h1v1zm15 17v1h-1v-1z",
    fill: "#838ea2"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1zm1 2h-1v-1h1zm-1 7v-1h1v1z",
    fill: "#26282f"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1zm18 18h1v1h-1zm0 3h-1v-1h1z",
    fill: "#79839e"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1zm6 10h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#8e98a4"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1zm32 4v1h-1v-1zm-34 4h-1v-1h1z",
    fill: "#7e88a3"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1zm15 1v-1h1v1zm-23 8h-1v-1h1z",
    fill: "#7a83a2"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1zm0 1v1h-1v-1zm-4 5v-1h1v1z",
    fill: "#7681a1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1zm20 21h1v1h-1zm4 2v-1h1v1z",
    fill: "#7b859f"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50v1h-1v-1zm1 2h-1v-1h1zm2 8v-1h1v1z",
    fill: "#828da2"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h-1v-2h1v1zm-1-6h1v1h-1z",
    fill: "#26292e"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v2h-1zm0 2h1v1h-1z",
    fill: "#313335"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M51 54v-1h1v1zm-1 0h1v1h-1zm0 2h-1v-1h1z",
    fill: "#7681a0"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M54 54h-1v-1h2v1zm-2 3h-1v-1h1z",
    fill: "#747ea0"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M72 54h-1v-1h1zm-30 3v-1h1v1zm-3 0h1v1h-1z",
    fill: "#7e88a4"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M55 55v1h-2v-1h1zm-3 3h-1v-1h1z",
    fill: "#727c9f"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55h1v1h-1zm6 0v1h-1v-1zm3 6v-1h1v1z",
    fill: "#717b9d"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M60 57h-1v-1h1zm-15 6v-1h1v1zm23 0v1h-1v-1z",
    fill: "#6f7a9b"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56h1v2h-1v-1zm1 8v-1h1v1z",
    fill: "#727c9d"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1zm2 2v1h-1v-1zm3 2h-1v-1h1z",
    fill: "#8d97a3"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M78 72v-2h1v2zm-3-14v-1h1v1z",
    fill: "#848fa2"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M47 59v-1h1v1zm25 0v1h-1v-1zm1 4v1h-1v-1z",
    fill: "#77829f"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M51 58v1h-1v-1zm17 1h-1v-1h1zm-19 1v-1h1v1z",
    fill: "#727c9e"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1zm2 1v-1h1v1zM72 80h1v1h-1z",
    fill: "#848d9c"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M54 59v1h-1v-1zm-5 3v-1h1v1zm-3 2h-1v-1h1z",
    fill: "#6d789b"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M42 61v-1h1v2h-1zm28 1v1h-1v-1z",
    fill: "#757f9e"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M61 61h-1v-1h1zm3 1h1v1h-1zm2 2h-1v-1h1z",
    fill: "#6a779a"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M37 62v-1h1v1zm33 3v1h-1v-1zm9 4h-1v-1h1z",
    fill: "#757e9e"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M69 68v-2h1v2zm-27-7v1h-1v-1z",
    fill: "#747e9d"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M45 61h1v1h-1zm26 0v1h-1v-1zm-29 2v-1h1v1z",
    fill: "#737e9d"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h1v1h-2v-1zm3 0h-1v-1h1z",
    fill: "#68749c"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1zm11 6h-1v-1h1zm0 1v-1h1v1z",
    fill: "#8b95a5"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M63 64h1v2h-1v-1zm-1 0v-1h1v1z",
    fill: "#67739a"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v-1h2v1h-1zm8 4h1v1h-1z",
    fill: "#647098"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65v1h-1v-1zm1 0h1v1h-1zm15 6h-1v-1h1z",
    fill: "#647099"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M55 65v1h-3v-1z",
    fill: "#636f98"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M75 66v-1h1v1zm12 4v-1h1v1zm-3 2v-1h1v1z",
    fill: "#808ba3"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67v3h-1v-3z",
    fill: "#23252d"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70h1v3h-1v-1z",
    fill: "#22242c"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M50 72h1v1h-2v-1zm3 1h-1v-1h1z",
    fill: "#5b6790"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73v1h-1v-1zm0 10h-1v-1h1zm-1 1h1v1h-1z",
    fill: "#6e6f72",
    fillOpacity: 0.878
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M93 74h-1v-1h1zm-1 9v-1h1v1zm0 2v-1h1v1z",
    fill: "#37383b"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M34 76h-1v-2h1v1zm0 1v1h-1v-1z",
    fill: "#f1f1ff",
    fillOpacity: 0.075
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M65 76h-3v-1h3z",
    fill: "#d4dad3"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M49 77h-2v-1h2zm28 3v-1h1v1z",
    fill: "#d4dad8"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M68 77h1v1h-1zm6 2v1h-1v-1zm12 0v1h-1v-1z",
    fill: "#d3dad5"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M69 78v-1h1v2h-1zm-13 1h-1v-1h1z",
    fill: "#d5dbd6"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79h-2v-1h2zm23 0v-1h1v1z",
    fill: "#d6ddd6"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M74 79h2v1h-2zm-2 0v1h-1v-1z",
    fill: "#d3dad7"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M84 83h-1v-1h2v1zm-14-3h1v1h-1z",
    fill: "#80899b"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M82 82v-1h1v1zm1 3h1v1h-1zm-4 6h-1v-1h1z",
    fill: "#7f8799"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M38 83v-1h2v1h-1zm4-1h1v1h-1z",
    fill: "#525c7f"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M45 83h-1v-1h2v1zm-4 0h-1v-1h1z",
    fill: "#525c80"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82v1h-3v-1h1z",
    fill: "#536087"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84v-1h2v1h-1zm5-1v1h-1v-1z",
    fill: "#515c7d"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84v-1h1v1zm9 0v-1h1v1zm15 6v-1h1v1z",
    fill: "#515b7f"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86v-1h-1v-1h2v2z",
    fill: "#505980"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M63 88h2v1h-2zm-1 0v-1h1v1z",
    fill: "#535d81"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h1v2h-1v-1zm0-5h1v1h-1z",
    fill: "#a3a3aa",
    fillOpacity: 0.447
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90h-1v-1h1zm44 8h1v1h-1zm7 3v1h-1v-1z",
    fill: "#4d5773"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90v1h-1v-1zm-24 2h-1v-1h1zm13 1v1h-1v-1z",
    fill: "#4a5373"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M93 92h-1v-2h1v1zm-1 3v-1h1v1z",
    fill: "#3b3c3d"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91h3v1h-3z",
    fill: "#c5cbc7"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95h-1v-1h1zm12 3v-1h1v1zm16 3h-1v-1h1z",
    fill: "#48516e"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v-3h1v3z",
    fill: "#1e2026"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M79 102h-1v-1h2v1zm-28-7v1h-1v-1z",
    fill: "#464f6b"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h-1v-1h1zm13-1h1v1h-1zm3 2v-1h1v1z",
    fill: "#505977"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95h1v1h-1zm1 2v-1h1v1zm17 4v-1h1v1z",
    fill: "#49526f"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M74 96h-1v-1h1zm3 0v1h-1v-1zm8 3h1v1h-1z",
    fill: "#4f5875"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h-1v-3h1z",
    fill: "#393a3b"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95h1v1h-1zm0 2h1v1h-1zm1 6v1h-1v-1z",
    fill: "#a3a1aa",
    fillOpacity: 0.447
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96v1h-2v-1h1zm-3 1h-1v-1h1z",
    fill: "#464d68"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M59 99v-1h2v1h-1zm-10-2v-1h1v1z",
    fill: "#434e69"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M52 97h-1v-1h1zm-4 0h1v1h-1zm18 4v-1h1v1z",
    fill: "#444e67"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M76 97v1h-2v-2h1v1z",
    fill: "#4c5572"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M75 97v-1h1v1zm4 0v1h-1v-1zm5 2h1v1h-1z",
    fill: "#4e5774"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h-1v-1h1zm6 1v-1h1v1zm14 3h-1v-1h1z",
    fill: "#434d67"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M50 97h1v1h-1zm11 4v-1h1v1zm24 4h-1v-1h1z",
    fill: "#444e68"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M61 97v1h-3v-1z",
    fill: "#515873"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M53 101h-2v-1h2zm-13-3h1v1h-1z",
    fill: "#434a65"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99v-1h1v1zm10 2h-1v-1h1zm21 3h-1v-1h1z",
    fill: "#414a65"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M77 103h1v1h-2v-1zm-22-4v-1h1v1z",
    fill: "#424c66"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M56 99v-1h1v1zm12 2h1v1h-1zm5 1v1h-1v-1z",
    fill: "#444d69"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99h-1v-1h1zm6 2h-1v-1h1zm3 1h-1v-1h1z",
    fill: "#4c5671"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v1h-1v-1zm27 5h1v1h-1zm6 0v1h-1v-1z",
    fill: "#414863"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101h-1v-1h1zm30 4h-1v-1h1zm6 2v-1h1v1z",
    fill: "#404762"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M52 103h-1v-1h2v1zm-8-2v-1h1v1z",
    fill: "#414961"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M51 103h2v1h-2zm-6-1h-1v-1h1z",
    fill: "#404760"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102h1v1h-1zm20 4h-1v-1h1zm-4 0h1v1h-1z",
    fill: "#3d445b"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M38 103v-1h2v1h-1zm16 2v1h-1v-1z",
    fill: "#3e445e"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M93 102v3h-1v-3z",
    fill: "#3a3b3e"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M93 110v-2h1v2zm0-6h1v1h-1z",
    fill: "#a2a2ab",
    fillOpacity: 0.443
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M52 105v1h-1v-1zm12 2v1h-1v-1zm13 1v1h-1v-1z",
    fill: "#3d455d"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M35 109v-3h1v3z",
    fill: "#1a1c21"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h1v3h-1z",
    fill: "#3b3d3d"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110v1h-1v-1zm10 1v-1h1v1zm28 3h1v1h-1z",
    fill: "#33394e"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M51 110v1h-1v-1zm13 3h-1v-1h1zm27 1v1h-1v-1z",
    fill: "#373d53"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M38 114h-1v-1h1zm42 2h-1v-1h1zm-20 0h1v1h-1z",
    fill: "#32384c"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M52 115v-1h1v1zm11-1v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#343a4f"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M56 120h-1v-1h2v1zm-16-5h1v1h-1z",
    fill: "#2f3549"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M46 115h1v1h-1zm-3 3h-1v-1h1zm25 3v1h-1v-1z",
    fill: "#2e3447"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M55 117h-1v-1h1zm2 0v-1h1v1zm5 0h1v1h-1z",
    fill: "#32374c"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M56 116h1v1h-1zm20 1h-1v-1h1zm-11 2h1v1h-1z",
    fill: "#32384d"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M37 118h-1v-1h1zm4 1v-1h1v1zm19 3v1h-1v-1z",
    fill: "#2d3347"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M45 117v1h-1v-1zm29 2h1v1h-1zm16 0v1h-1v-1z",
    fill: "#2d3448"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M47 117v1h-1v-1zm3 2h-1v-1h1zm34 0v-1h1v1z",
    fill: "#2d3449"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v-1h1v1zm40 0h1v1h-1zm-35 1h1v1h-1z",
    fill: "#2d3349"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119h-1v-1h1zm-19 0v1h-1v-1zm-1 3v1h-1v-1z",
    fill: "#2e3349"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119v1h-1v-1zm2 1v-1h1v1zm-4 1h1v1h-1z",
    fill: "#2b3245"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M43 123h2v1h-2zm39 1h-1v-1h1z",
    fill: "#2e3244"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124v-1h1v1zm3 0h-1v-1h1zm7 0h-1v-1h1z",
    fill: "#2f3345"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M46 124h1v1h-1zm23 0v1h-1v-1zm10 0h1v1h-1z",
    fill: "#1c2027"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M48 125h1v1h-1zm27 1h-1v-1h1zm1-1h1v1h-1z",
    fill: "#414349",
    fillOpacity: 0.996
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M81 127h-3v-1h3z",
    fill: "#9d9daa",
    fillOpacity: 0.247
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2V1h2v1h-1z",
    fill: "#9e9ea8",
    fillOpacity: 0.29
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M63 1v1h-1V1zm4 0v1h-1V1z",
    fill: "#94949f",
    fillOpacity: 0.263
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M77 2V1h1v1zm5 124v1h-1v-1z",
    fill: "#9b9ba3",
    fillOpacity: 0.251
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M89 1v1h-1V1zm6 57h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3h-1V2h1zm5-1h1v1h-1z",
    fill: "#403f45"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M52 2h1v1h-1zM36 7h-1V6h1z",
    fill: "#3d3f43"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M53 2h1v1h-1zm5 1h-1V2h1z",
    fill: "#494c51"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3V2h1v1zm5-1v1h-1V2z",
    fill: "#4a4e53"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M66 2h2v1h-2z",
    fill: "#4d4d53"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M81 3h-1V2h1zm4-1v1h-1V2z",
    fill: "#3d3e46"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4V3h1v1zm34 101v-1h1v1z",
    fill: "#313642"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M67 4V3h2v1h-1z",
    fill: "#2e3441"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M71 3h1v1h-2V3z",
    fill: "#2d333f"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M81 4h-1V3h1zm2 0h-1V3h1z",
    fill: "#282f3b"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M83 3h2v1h-2z",
    fill: "#272e3a"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M87 3h1v1h-1zm5 116v1h-1v-1z",
    fill: "#1d212a"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4v1h-2V4h1z",
    fill: "#a7b4cf"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M53 4h1v1h-1zm19 21h-1v-1h1z",
    fill: "#848ea2"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5h-1V4h1zm4-1h1v1h-1z",
    fill: "#757e9c"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M59 4v1h-1V4zM39 63h1v1h-1z",
    fill: "#737d9c"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M61 5V4h1v1zm8 60h-1v-1h1z",
    fill: "#727a9d"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M66 5h-1V4h1zM37 63v-1h1v1z",
    fill: "#727c9b"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M76 4v1h-1V4zm-5 5h-1V8h1z",
    fill: "#636d94"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M87 4v1h-1V4zm-1 14h-1v-1h1z",
    fill: "#586286"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M48 6V5h1v1zm1 46v-1h1v1z",
    fill: "#7a84a2"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M50 5h1v1h-1zm30 58v-1h1v1z",
    fill: "#919aa7"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M58 5v1h-1V5zM39 63h-1v-1h1z",
    fill: "#717b9a"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6h-1V5h1zm-5 118h1v1h-1z",
    fill: "#1d2028"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M72 6V5h1v1zM48 69v1h-1v-1z",
    fill: "#606d96"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5h1v1h-1zM67 71v-1h1v1z",
    fill: "#697499"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6h1v1h-1zm9 7h1v1h-1z",
    fill: "#8089a3"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M52 7V6h1v1zm22 46v-1h1v1z",
    fill: "#8790a1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6v1h-1V6zm5 67v-1h1v1z",
    fill: "#6c789a"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M71 7V6h1v2h-1z",
    fill: "#616d94"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M76 6v1h-1V6zM47 71v1h-1v-1z",
    fill: "#5d6992"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6v1h-1V6zM46 54h-1v-1h1z",
    fill: "#7f8aa6"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h-1V7h1zm25 116h1v1h-1z",
    fill: "#1f2129"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8V7h1v1zm17 17h-1v-1h1z",
    fill: "#a4b0c8"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7v1h-1V7zm19 17v1h-1v-1z",
    fill: "#a5b0cb"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M45 7h1v1h-1zm6 6h-1v-1h1z",
    fill: "#a2adcc"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7h1v1h-1zm10 85v-1h1v1z",
    fill: "#8c98a6"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8V7h1v1zm22 20v-1h1v1z",
    fill: "#828da0"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M56 8V7h1v1zM44 74v-1h1v1z",
    fill: "#77809c"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M59 8V7h1v1zm3 4v-1h1v1z",
    fill: "#6c7797"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M81 8h-1V7h1zM57 49h1v1h-1z",
    fill: "#7680a2"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M82 8h-1V7h1zm-4 17v-1h1v1z",
    fill: "#6a7594"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7h1v1h-1zM40 66h1v1h-1z",
    fill: "#6c7796"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M87 8h-1V7h1zm-28 2h-1V9h1z",
    fill: "#6f7a97"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M88 7v1h-1V7zM38 48v1h-1v-1z",
    fill: "#848ea8"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M56 9h-1V8h1zm31 64v-1h1v1z",
    fill: "#7c869e"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M60 9h-1V8h1zm7 7h1v1h-1z",
    fill: "#6c7798"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M62 8v1h-1V8zm13 15v-1h1v1z",
    fill: "#6a7596"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8v1h-1V8zm20 23v-1h1v1z",
    fill: "#666f8c"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8h1v1h-1zm12 14v1h-1v-1z",
    fill: "#697395"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8v1h-1V8zm5 0v1h-1V8z",
    fill: "#525d86"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10h-1V9h1zm-1 24h1v1h-1z",
    fill: "#f2f2ff",
    fillOpacity: 0.078
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M37 9v1h-1V9zm6 16v1h-1v-1z",
    fill: "#9ba4be"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1zm4 3h-1v-1h1z",
    fill: "#a1accb"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1zm6 7h-1v-1h1z",
    fill: "#a3aeca"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M71 9v1h-1V9zm8 11v1h-1v-1z",
    fill: "#636b93"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M80 10h-1V9h1zm0 3v-1h1v1z",
    fill: "#5a668e"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1zm25 61v1h-1v-1z",
    fill: "#848d9f"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1zM39 66v-1h1v1z",
    fill: "#6d7899"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M91 10v1h-1v-1zM52 83h1v1h-1z",
    fill: "#515c84"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11v-1h1v2h-1z",
    fill: "#33394c"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v-1h1v1zm0 8h1v1h-1z",
    fill: "#272931"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1zm17 55h1v1h-1z",
    fill: "#808aa2"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-1v-1h1zm9 59v-1h1v1z",
    fill: "#737e9b"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1zm1 1h1v1h-1z",
    fill: "#666f96"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M91 11v1h-1v-1zm-4 2v-1h1v1z",
    fill: "#515d84"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M37 12v2h-1v-2z",
    fill: "#9aa5bf"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1zm24 58v-1h1v1z",
    fill: "#8692a3"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1zm22 52v1h-1v-1z",
    fill: "#7a83a1"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1zm-4 42v-1h1v1z",
    fill: "#737e9e"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1zm0 3v-1h1v1z",
    fill: "#6a7598"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1zm0 1v-1h1v1z",
    fill: "#667197"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M76 13h-1v-1h2v1z",
    fill: "#5f6992"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M82 13h-1v-1h1zm0 0h1v1h-1z",
    fill: "#58648c"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M91 13h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#505d84"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M92 13v-1h1v1zm0 87v-1h1v1z",
    fill: "#393a3e"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13v1h-1v-1zm0 2v1h-1v-1z",
    fill: "#28292f"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1zM48 61h-1v-1h1z",
    fill: "#727d9d"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1zM49 63v-1h1v1z",
    fill: "#6a7699"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1zm-1 59h1v1h-1z",
    fill: "#677598"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1zm3 4h-1v-1h1z",
    fill: "#667095"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13h2v1h-2z",
    fill: "#636c95"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M77 13v1h-2v-1h1z",
    fill: "#616a93"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M90 14v-1h1v1zm0 1h1v1h-1z",
    fill: "#515e85"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14h1v1h-1zm0 6v-1h1v1z",
    fill: "#e5eef6",
    fillOpacity: 0.118
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1zm13 10v1h-1v-1z",
    fill: "#9faac9"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1zm6 59v1h-1v-1z",
    fill: "#7d88a2"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1zm0 46h1v1h-1z",
    fill: "#6c7799"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h2v1z",
    fill: "#697498"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1zm2 1h1v1h-1z",
    fill: "#626b93"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M78 14v1h-1v-1zM44 71v1h-1v-1z",
    fill: "#5f6990"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M91 16v-2h1v2z",
    fill: "#323a4c"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1zM38 43h-1v-1h1z",
    fill: "#8b94a9"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1zm25 58h-1v-1h1z",
    fill: "#8d96a6"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1zm15 47v-1h1v1z",
    fill: "#808ca2"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1zm8 40h-1v-1h1z",
    fill: "#7983a1"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1zm11 9v-1h1v1z",
    fill: "#737e9c"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1zm2 4v-1h1v1z",
    fill: "#646d93"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16v-1h1v1zM65 84h-1v-1h1z",
    fill: "#5b648b"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1zM52 82v1h-1v-1z",
    fill: "#515d83"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18h-1v-2h1v1z",
    fill: "#282931"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1zm4 2v1h-1v-1z",
    fill: "#a0abc8"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1zm36 15h-1v-1h1z",
    fill: "#939ebb"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1zm23 49h-1v-1h1z",
    fill: "#8e98aa"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1zm2 0v1h-1v-1z",
    fill: "#808ca3"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1zM66 86h-1v-1h1z",
    fill: "#5b648a"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h1v1h-1zm1 2v1h-1v-1z",
    fill: "#333439"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1zm2 3v1h-1v-1z",
    fill: "#a2adc8"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1zm-2 24h1v1h-1z",
    fill: "#8490a4"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1zm8 48h1v1h-1z",
    fill: "#7b86a1"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1zm1 2v-1h1v1z",
    fill: "#687296"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1zM64 83v-1h1v1z",
    fill: "#5d668d"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-1v-1h1zm-16 95h1v1h-1z",
    fill: "#343b4e"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M38 18v1h-1v-1zm6 7v-1h1v1z",
    fill: "#9da9c5"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1zm-1 6v-1h1v1z",
    fill: "#a1adc8"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1zm2 2h-1v-1h1z",
    fill: "#8d98b4"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1zm13 51v-1h1v1z",
    fill: "#8692a4"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1zm0 1h1v1h-1z",
    fill: "#5d678b"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1zM39 76h-1v-1h1z",
    fill: "#596387"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1zm-40 93v1h-1v-1z",
    fill: "#353b4e"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1zm-1 3h1v1h-1z",
    fill: "#a4b0ca"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1zM44 69v-1h1v1z",
    fill: "#646e93"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M92 20v1h-1v-2h1z",
    fill: "#353c4f"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M34 20v1h-1v-1zm0 81v1h-1v-1z",
    fill: "#ececf5",
    fillOpacity: 0.11
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1zm9 31v-1h1v1z",
    fill: "#7f8a9f"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1zm-2 21v1h-1v-1z",
    fill: "#8a92a6"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1zM42 72v-1h1v1z",
    fill: "#616991"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#596386"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22v-1h1v1zm1 77v1h-1v-1z",
    fill: "#ececf5",
    fillOpacity: 0.106
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M38 21v1h-1v-1zm44 10h1v1h-1z",
    fill: "#99a5c1"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M56 21h1v2h-1v-1z",
    fill: "#a3afc9"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1zm0 1v-1h1v1z",
    fill: "#a4afc9"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1zm29 55h-1v-1h1z",
    fill: "#97a1ad"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1zm9 50h1v1h-1z",
    fill: "#8691a4"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1zM36 76v-1h1v1z",
    fill: "#5b6586"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1zm0 39h1v1h-1z",
    fill: "#343538"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1zm7 31v1h-1v-1z",
    fill: "#808aa7"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h2v1h-1z",
    fill: "#96a0ab"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1zM42 69v1h-1v-1z",
    fill: "#656f92"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1zM39 72h1v1h-1z",
    fill: "#606a8e"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1zm-2 8v-1h1v1z",
    fill: "#5d6786"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1zm0 48v1h-1v-1z",
    fill: "#353538"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h2v1h-1z",
    fill: "#a1adc7"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1zm8 28v-1h1v1z",
    fill: "#808ba1"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1zm20 55v-1h1v1z",
    fill: "#8e97a6"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1zM39 59h1v1h-1z",
    fill: "#77809e"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1zM37 72v-1h1v1z",
    fill: "#626c8f"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1zM39 71v1h-1v-1z",
    fill: "#616b8e"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1zm0 25v1h-1v-1z",
    fill: "#353638"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h2v1h-2z",
    fill: "#9aa7c1"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1zm36 7v1h-1v-1z",
    fill: "#9fabc4"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h-1v-1h2v1z",
    fill: "#a4adc6"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M61 25h-1v-1h2v1z",
    fill: "#a3b0c9"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1zm7 49h-1v-1h1z",
    fill: "#969eab"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1zm-30 3v-1h1v1z",
    fill: "#929ba9"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1zM50 41v-1h1v1z",
    fill: "#8d97a6"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1zM37 70h1v1h-1z",
    fill: "#636e91"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1zm5 49v-1h1v1z",
    fill: "#949cac"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1zm14 48h1v1h-1z",
    fill: "#7c879f"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27v-1h1v1zm0 5h1v1h-1z",
    fill: "#f3f3f3",
    fillOpacity: 0.086
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1zm20 50v1h-1v-1z",
    fill: "#8e98a6"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1zM58 40v1h-1v-1z",
    fill: "#8792a5"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1zm-5 57v-1h1v1z",
    fill: "#727d96"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1zm-8 57v-1h1v1z",
    fill: "#6f7a95"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1zm-23 75v1h-1v-1z",
    fill: "#636d89"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1zm-62 94h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1zm3 58h-1v-1h1z",
    fill: "#768195"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1zM57 80v1h-1v-1z",
    fill: "#6d7692"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1zm-7 60v-1h1v1z",
    fill: "#6a758f"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M85 28h-1v-1h1zm1 1h1v1h-1z",
    fill: "#67718b"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-2v-1h1z",
    fill: "#636d88"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h-2v-1h2z",
    fill: "#c7be7a"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h2v1h-2z",
    fill: "#c9c478"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1zM61 57h-1v-1h1z",
    fill: "#78849e"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1zM37 56h-1v-1h1z",
    fill: "#7f8a9e"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1zm-8 54h1v1h-1z",
    fill: "#747f98"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M35 29v2h-1v-2z",
    fill: "#696a70",
    fillOpacity: 0.898
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1zm7-1h1v1h-1z",
    fill: "#ccc67b"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1zm-5 54v1h-1v-1z",
    fill: "#737d94"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1zm-5 55v1h-1v-1z",
    fill: "#727c96"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1zM52 81v-1h1v1z",
    fill: "#6c7591"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M33 31v-1h1v1zm1 57v1h-1v-1z",
    fill: "#f2ffff",
    fillOpacity: 0.082
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1zm12 1v-1h1v1z",
    fill: "#ccc67f"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1zm7 0v1h-1v-1z",
    fill: "#cdc77d"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1zm9 1v1h-1v-1z",
    fill: "#cec77c"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1zm-6 25v1h-1v-1z",
    fill: "#7e89a4"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1zm0 11h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.027
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1zm20 3h-1v-1h1z",
    fill: "#c8c487"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M66 31h2v1h-2z",
    fill: "#cfc880"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1zm8 2v-1h1v1z",
    fill: "#9ca9c0"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h2v1z",
    fill: "#919cb7"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M92 33v-2h1v2z",
    fill: "#303233"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M38 32h1v1h-2v-1z",
    fill: "#aca989"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-2v-1h1z",
    fill: "#b1ae8f"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32h2v1h-2z",
    fill: "#cfc985"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-2v-1h1z",
    fill: "#cec882"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h2v1z",
    fill: "#adad97"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-2v-1h2z",
    fill: "#aeaf9d"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1zm6 2v-1h1v1z",
    fill: "#b1b49e"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1zm6 1v1h-1v-1z",
    fill: "#b3b69c"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1zm9 1v1h-1v-1z",
    fill: "#cec98a"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1zm2 12h1v1h-1z",
    fill: "#b8bba3"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#9ea8c0"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1zm-1 2v-1h1v1z",
    fill: "#303236"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1zm35 14v-1h1v1z",
    fill: "#a5aba2"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34v1h-2v-1h1z",
    fill: "#a5aaa5"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1zm30 15v-1h1v1z",
    fill: "#aab0a4"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1zm11 1h-1v-1h1z",
    fill: "#cdc98f"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1zm7 0h1v1h-1z",
    fill: "#cdc88d"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h2v1h-2z",
    fill: "#cec989"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h2v1h-1z",
    fill: "#9ba7c0"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v1h-1v-2h1z",
    fill: "#6b6e75"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1zm14 2h-1v-1h1z",
    fill: "#9fa7a5"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h2v1h-2z",
    fill: "#9ca5a8"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1zm7 1v-1h1v1z",
    fill: "#9da5a8"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1zm30 17h-1v-1h1z",
    fill: "#a9aea3"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1zm16 4h1v1h-1z",
    fill: "#cac894"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1zm12 3v-1h1v1z",
    fill: "#ccc992"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35v1h-2v-1h1z",
    fill: "#cdca90"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1zm-16 79v1h-1v-1z",
    fill: "#a8adb2"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1zm5 2h1v1h-1z",
    fill: "#adb2a5"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1zm23 13h1v1h-1z",
    fill: "#afb3a2"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1zm48 53h1v1h-1z",
    fill: "#98a0a9"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1zm2 0v-1h1v1z",
    fill: "#959fa9"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1zm46 31h-1v-1h1z",
    fill: "#96a0aa"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1zm36 53v-1h1v1z",
    fill: "#969eaa"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1zm36 39v1h-1v-1z",
    fill: "#969fa9"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-2v-1h1z",
    fill: "#97a0a6"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1zm22 11v1h-1v-1z",
    fill: "#a7ada4"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1zm13 7v1h-1v-1z",
    fill: "#b5b8a2"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1zm3 0v1h-1v-1z",
    fill: "#ccca93"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1zm35 35v-1h1v1z",
    fill: "#939dab"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1zm-8 1h1v1h-1z",
    fill: "#929bab"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1zm5 58v-1h1v1z",
    fill: "#939bac"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1zm12 4v1h-1v-1z",
    fill: "#939ba7"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1zm24 25v-1h1v1z",
    fill: "#939ca7"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1zm11 6v1h-1v-1z",
    fill: "#b0b4a3"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M71 38h1v1h-1zm17 8v1h-1v-1z",
    fill: "#c0c2a2"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1zm15 6v1h-1v-1z",
    fill: "#c4c4a1"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-2v-1z",
    fill: "#c7c497"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1zm47 57h1v1h-1z",
    fill: "#8e96a5"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1zm6 0h-1v-1h1z",
    fill: "#929bac"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1zm3 0v1h-1v-1z",
    fill: "#8d97a5"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1zm22 22v-1h1v1z",
    fill: "#8f98a6"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1zm7 4h-1v-1h1z",
    fill: "#c4c5a6"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1zm2 1h1v1h-1z",
    fill: "#c6c6a6"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1zm29 2v1h-1v-1z",
    fill: "#8d97a8"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1zm38 23h1v1h-1z",
    fill: "#8e97a8"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1zm35 29v1h-1v-1z",
    fill: "#8a93a5"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1zm2 1h-1v-1h1z",
    fill: "#c2c2a7"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1zm2 2h1v1h-1z",
    fill: "#c4c4a7"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1zm23 0h1v1h-1z",
    fill: "#8c95a6"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-2v-1h1z",
    fill: "#8e95a8"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1zm35 24v-1h1v1z",
    fill: "#8b96a8"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1zm20 30v1h-1v-1z",
    fill: "#8a94a4"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1zm23 34v-1h1v1z",
    fill: "#9099a7"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M72 42h-1v-1h1zm0 1v-1h1v1z",
    fill: "#a4a9a5"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1zm35 6v-1h1v1z",
    fill: "#8690a3"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1zm33 20v1h-1v-1z",
    fill: "#8c96a8"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1zm-7 3h1v1h-1z",
    fill: "#858fa7"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1zm7 3h-1v-1h1z",
    fill: "#848fa7"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43v-1h2v1h-1z",
    fill: "#cac89e"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1zm47 20v1h-1v-1z",
    fill: "#848fa4"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1zm-6 1v1h-1v-1z",
    fill: "#8a95a8"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1zm7 2v1h-1v-1z",
    fill: "#838da4"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1zm-2 14h-1v-1h1z",
    fill: "#8b95a9"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1zm9 4h1v1h-1z",
    fill: "#a7aca5"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1zm9 15v1h-1v-1z",
    fill: "#8892a3"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M72 44v1h-1v-1zm6 8h1v1h-1z",
    fill: "#939ca4"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1zm13 8h-1v-1h1z",
    fill: "#b2b6a1"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1zm8 4v-1h1v1z",
    fill: "#b5b9a3"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-2v-1h1z",
    fill: "#c6c59f"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1zm0 4v1h-1v-1z",
    fill: "#777864"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-2h1v2z",
    fill: "#333536"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1zm0 3v1h-1v-1z",
    fill: "#a8a8b2",
    fillOpacity: 0.682
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1zm0 7v1h-1v-1z",
    fill: "#8791ab"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1zm7 0v1h-1v-1z",
    fill: "#7e88a5"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1zm-7 3h-1v-1h1z",
    fill: "#7e89a5"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1zm-16 5h1v1h-1z",
    fill: "#7f88a4"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v1h-1v-1zm4 7h-1v-1h1z",
    fill: "#8d96a2"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45h1v1h-1zm4 5h-1v-1h1z",
    fill: "#929ba4"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#a1a8a3"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1zm6 3h1v1h-1z",
    fill: "#aeb2a2"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-2v-1z",
    fill: "#b4b8a1"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M43 46v1h-2v-1h1z",
    fill: "#8892a9"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1zm15 10v-1h1v1z",
    fill: "#7c86a3"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1zm-11 5h-1v-1h1z",
    fill: "#7c85a3"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1zm-1 13v-1h1v1z",
    fill: "#7f88a6"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M81 46h1v1h-2v-1z",
    fill: "#b1b4a2"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-2h1z",
    fill: "#343536"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1zm4 0v1h-1v-1z",
    fill: "#858fa9"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1zm-2 3v1h-1v-1z",
    fill: "#828ca7"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1zm23 9h-1v-1h1z",
    fill: "#7d88a4"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1zm-3 2v-1h1v1z",
    fill: "#7c87a4"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1zm2 1v-1h1v1z",
    fill: "#7a85a4"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1zm6 7v-1h1v1z",
    fill: "#7682a2"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1zm5 1v1h-1v-1z",
    fill: "#a6aca4"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1zm1 10h-1v-1h1z",
    fill: "#262830"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1zm14 7h1v1h-1z",
    fill: "#7681a2"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M69 49h1v1h-1zm7 18h-1v-1h1z",
    fill: "#818ba3"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1zm2 4v-1h1v1z",
    fill: "#959ea2"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1zm4 3h-1v-1h1z",
    fill: "#9aa2a4"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1zm36 20v-1h1v1z",
    fill: "#7c85a2"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M55 50h2v1h-2z",
    fill: "#747ea1"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1zm4 1v1h-1v-1z",
    fill: "#979fa2"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1zm-1 13v-1h1v1z",
    fill: "#323335"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1zm1 6v-1h1v1z",
    fill: "#8892a1"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1zm11 5v1h-1v-1z",
    fill: "#919aa0"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#97a0a2"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1zm10 7h-1v-1h1z",
    fill: "#9aa2a3"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M41 52v1h-2v-1h1z",
    fill: "#8690a9"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M77 53v-1h1v2h-1z",
    fill: "#9099a1"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53h-1v-1h2v1z",
    fill: "#939ca1"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1zm41 19v1h-1v-1z",
    fill: "#848da1"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M70 53v1h-1v-1zm-31 7h-1v-1h1z",
    fill: "#77809d"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1zm10 27v1h-1v-1z",
    fill: "#8e96a0"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54h1v1h-1zm7 3h1v1h-1z",
    fill: "#737d9f"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1zm-1 19v-1h1v1z",
    fill: "#858da1"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1zm12 34v1h-1v-1z",
    fill: "#8c94a0"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M67 56v-1h1v1zm1 4v-1h1v1z",
    fill: "#727da1"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1zm2 4v-1h1v1z",
    fill: "#909aa4"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#8f96a0"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1zm49 28h-1v-1h1z",
    fill: "#7d889c"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M44 57v-1h1v1zm34 11v1h-1v-1z",
    fill: "#7b84a2"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M56 56v1h-1v-1zm-6 3h1v1h-1z",
    fill: "#707a9e"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57v-1h1v1zm10 10h1v1h-1z",
    fill: "#707a9c"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M66 56v1h-1v-1zm-4 4h-1v-1h1z",
    fill: "#909ab0"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1zm3 24v1h-1v-1z",
    fill: "#8992a2"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56h1v2h-1v-1z",
    fill: "#8f99a5"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1zm0 5v1h-1v-1z",
    fill: "#9199a6"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M48 57h1v1h-1zm-5 3v-1h1v1z",
    fill: "#76819e"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M50 57h1v1h-1zm19 8v-1h1v1z",
    fill: "#747e9f"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v1h-1v-2h1z",
    fill: "#8d97a4"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1zm-1 39h-1v-1h1z",
    fill: "#878f9d"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1zm2 3v-1h1v1z",
    fill: "#89919d"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58h1v1h-1zm47 11h-1v-1h1z",
    fill: "#7d87a2"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M42 58h1v1h-1zm29 7h1v1h-1z",
    fill: "#7983a0"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M49 58h1v1h-1zm-8 4h1v1h-1z",
    fill: "#747f9e"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M55 58h1v1h-1zm-3 3h-1v-1h1z",
    fill: "#6e789c"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1zm0 3v-1h1v1z",
    fill: "#919ba5"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59v2h-1v-2z",
    fill: "#25272f"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60h-1v-1h1zm4 9v-1h1v1z",
    fill: "#77819e"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h-1v-1h1zm0 2h-1v-1h1z",
    fill: "#717b9c"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1zm5 3h1v1h-1z",
    fill: "#8a93a4"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#828b9c"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M38 60v1h-1v-1zm33 6h-1v-1h1z",
    fill: "#77809f"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M58 60h1v1h-1zm8 7v-1h1v1z",
    fill: "#69769b"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M61 60h1v1h-1zm-23 6v-1h1v1z",
    fill: "#6d799a"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M67 60v1h-1v-1zm14 8v1h-1v-1z",
    fill: "#727b9a"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1zm-3 11h-1v-1h1z",
    fill: "#828ca2"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1zm5 23v1h-1v-1z",
    fill: "#7f889a"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M53 62h-1v-1h1zm14 8v-1h1v1z",
    fill: "#6a759b"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h1v1h-2v-1z",
    fill: "#68759a"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61h1v1h-1zm1 1h1v1h-1z",
    fill: "#6b789b"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1zm4 21v1h-1v-1z",
    fill: "#80899a"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1zm1 21v1h-1v-1z",
    fill: "#818a9c"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M35 63v-1h1v1zm0 3v-1h1v1z",
    fill: "#24252e"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h1v1h-1zm41 23v-1h1v1z",
    fill: "#707996"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M73 62h1v1h-1zM63 74h-1v-1h1z",
    fill: "#79849f"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h-1v-2h1v1z",
    fill: "#6e7794"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64h-1v-1h1zm1 0v1h-1v-1z",
    fill: "#69769a"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v1h-1v-1zm5 11v-1h1v1z",
    fill: "#919aa9"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1zM53 88v-1h1v1z",
    fill: "#8b93a6"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1zm2 1h1v1h-1z",
    fill: "#9ca6b0"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64h1v1h-1zm3 59h1v1h-1z",
    fill: "#23252e"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M53 64h1v1h-1zm13 5h-1v-1h1z",
    fill: "#667299"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M59 64h1v1h-1zm4 1v1h-1v-1z",
    fill: "#66729b"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M79 64v1h-1v-1zm5 9h-1v-1h1z",
    fill: "#8e98a7"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M80 65v1h-1v-1zm-9 7v-1h1v1z",
    fill: "#7d88a0"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66v1h-1v-1zm-1 1v1h-1v-1z",
    fill: "#647096"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M47 67v-1h1v1zm-2 2v-1h1v1z",
    fill: "#636f96"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67h-1v-1h1zm-3 5h1v1h-1z",
    fill: "#8d96a7"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69h-1v-1h1zm28 13v1h-1v-1z",
    fill: "#667193"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#616b91"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M45 70v-1h2v1h-1z",
    fill: "#606d94"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M72 69v1h-1v-1zm16 2v1h-1v-1z",
    fill: "#7a849f"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M47 71h-2v-1h2z",
    fill: "#5e6b93"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h-1v-1h2v1z",
    fill: "#5e6b95"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M50 71v-1h1v1zm12 1v1h-1v-1z",
    fill: "#5e6a93"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M81 70v1h-1v-1zm-6 1h1v1h-1z",
    fill: "#8893a6"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M89 71h-1v-1h1zm0 1v-1h1v1z",
    fill: "#7f89a1"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M48 71h1v1h-1zm5 0h1v1h-1z",
    fill: "#5e6a95"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M52 71v1h-1v-1zm8 1h1v1h-1z",
    fill: "#5d6993"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M47 72v1h-2v-1h1z",
    fill: "#5b668d"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v1h-2v-1h1z",
    fill: "#606d93"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74v-1h1v1zm0 2v-1h1v1z",
    fill: "#21242c"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M45 73h2v1h-2z",
    fill: "#77819b"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M49 73v1h-2v-1h1z",
    fill: "#77819c"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M34 74h1v2h-1v-1z",
    fill: "#6e6f73",
    fillOpacity: 0.886
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74h1v1h-1zm5 1v-1h1v1z",
    fill: "#d1dad8"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M61 74v1h-2v-1h1z",
    fill: "#d0d9d8"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M64 74h1v1h-1zm4 5v1h-1v-1z",
    fill: "#d0d8d7"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#d2dad9"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74h1v1h-1zm-31 5h-1v-1h1z",
    fill: "#d5dbd7"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M82 75v-1h1v1zm-11 1h1v1h-1z",
    fill: "#d5dbd8"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M84 75h-1v-1h1zm-10 2h-1v-1h1z",
    fill: "#d4ddd8"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v1h-1v-1zm-40 1v1h-1v-1z",
    fill: "#d8ded8"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M49 75v1h-2v-1h1z",
    fill: "#d5dad6"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M51 76v-1h1v1zm2 0v-1h1v1z",
    fill: "#d3dbd4"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M52 75h1v1h-1zm21 17v1h-1v-1z",
    fill: "#d3dad3"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M69 76v-1h2v1h-1z",
    fill: "#d4dbd5"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M74 76v-1h1v1zm2 2h1v1h-1z",
    fill: "#d7ded5"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v1h-1v-2h1z",
    fill: "#363839"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77h-1v-1h1zm34 2v1h-1v-1z",
    fill: "#d4dbda"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77v-1h1v1zm12 3h-1v-1h1z",
    fill: "#d5dad7"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77h-1v-1h1zm-1 0v1h-1v-1z",
    fill: "#d5dcd7"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M72 78h-1v-1h1zm-27 0h1v1h-1z",
    fill: "#d6dcd6"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77h1v1h-1zm10 2h-1v-1h1z",
    fill: "#d6ddd7"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M76 78v-1h1v1zm7 0v1h-1v-1z",
    fill: "#d8ddd6"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M91 77v1h-1v-1zM72 96v1h-1v-1z",
    fill: "#97a0ac"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M93 77v1h-1v-1zm-1 7v-1h1v1z",
    fill: "#37393b"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78v1h-1v-1zm21 4v1h-1v-1z",
    fill: "#546086"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M48 79v-1h1v1zm23 0h-1v-1h1z",
    fill: "#d5dcd5"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78v1h-1v-1zm-9 14h1v1h-1z",
    fill: "#bfc5c8"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79h1v1h-1zm2 0h1v1h-1z",
    fill: "#d1d9d6"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M53 80v-1h2v1h-1z",
    fill: "#cfd7d3"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80v-1h2v1h-1z",
    fill: "#d0d8d5"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M65 79h2v1h-2z",
    fill: "#d0d8d6"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M80 79h1v1h-2v-1z",
    fill: "#d5dad9"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80v-1h1v1zm-12 7v1h-1v-1z",
    fill: "#bdc4c8"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80h-1v-1h1zm-8 13v1h-1v-1z",
    fill: "#9097a1"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M92 80v-1h1v2h-1z",
    fill: "#37383c"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81h-1v-1h1zm26 4v1h-1v-1z",
    fill: "#6b748e"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M47 81v-1h2v1h-1z",
    fill: "#6b748d"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M58 80h1v1h-1zm2 0h1v1h-1z",
    fill: "#6e7793"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M63 80h2v1h-2z",
    fill: "#737c95"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M69 81h-1v-1h1zm15 4v-1h1v1z",
    fill: "#7a8499"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80h1v1h-1zm-4 16v1h-1v-1z",
    fill: "#89919f"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M76 81v-1h1v1zm-7 16h-1v-1h1z",
    fill: "#8a91a1"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M79 81v-1h1v1zm-9 16v-1h1v1z",
    fill: "#8b94a1"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v-1h1v1zm1 1v-1h1v1z",
    fill: "#8a91a3"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81h1v1h-1zm8 2h-1v-1h1z",
    fill: "#535d82"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M44 81v1h-1v-1zm6 4h-1v-1h1z",
    fill: "#505b7f"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M51 81v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#505d85"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81v1h-1v-1zm1 2v1h-1v-1z",
    fill: "#525e87"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81h1v2h-1v-1z",
    fill: "#717c98"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M74 82h-1v-1h1zm4-1v1h-1v-1z",
    fill: "#747e98"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M77 81v2h-1v-2z",
    fill: "#77819a"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M58 82h1v1h-2v-1z",
    fill: "#546087"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83v-1h1v1zm2 0v1h-1v-1z",
    fill: "#768196"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82h1v1h-1zm9 2v1h-1v-1z",
    fill: "#798498"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M78 83h-1v-1h1zm1 1h-1v-1h1z",
    fill: "#747e99"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M60 84v-1h1v1zm0 1h-1v-1h1z",
    fill: "#535f86"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M93 85v-2h1v2z",
    fill: "#a19faa",
    fillOpacity: 0.451
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M39 85h-2v-1h2z",
    fill: "#515c7c"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85h-1v-1h2v1z",
    fill: "#4e5b7d"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M56 84h1v1h-2v-1z",
    fill: "#525b83"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M58 84v1h-1v-1zm5 2v1h-1v-1z",
    fill: "#525d83"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85v-1h1v1zm4 0v-1h1v1z",
    fill: "#747f95"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v-1h1v1zm9 0v1h-1v-1z",
    fill: "#4e5a7a"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86h-1v-1h2v1z",
    fill: "#4f5a7d"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v1h-1v-1zm8 4v1h-1v-1z",
    fill: "#636e89"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M77 85v1h-1v-1zm2 0v1h-1v-1z",
    fill: "#6f7994"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v-1h1v1zm-7 5h1v1h-1z",
    fill: "#798193"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M87 85h2v1h-2z",
    fill: "#7b8698"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M94 87h-1v-2h1v1z",
    fill: "#9f9fa8",
    fillOpacity: 0.451
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M55 86v1h-1v-1zm10 15v1h-1v-1z",
    fill: "#878ea1"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M92 87v-1h1v1zm0 13h1v1h-1z",
    fill: "#393a3d"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M85 87v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#cbd4d4"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M93 87v1h-1v-1zm0 12h-1v-1h1z",
    fill: "#393a3c"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88v2h-1v-2z",
    fill: "#727275",
    fillOpacity: 0.894
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v-1h1v1zm46 11h-1v-1h1z",
    fill: "#4c5672"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h-1v-1h1zm22 6h1v1h-1z",
    fill: "#515a77"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88h1v1h-1zm-16 9v-1h1v1z",
    fill: "#8b92a2"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v-1h1v2h-1z",
    fill: "#393b3c"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90v1h-1v-1zm53 15h-1v-1h1z",
    fill: "#4a536e"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M38 91v-1h1v1zm27 3v-1h1v1z",
    fill: "#4c5471"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M51 91v-1h1v2h-1z",
    fill: "#4b5376"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M78 90v1h-1v-1zm11 4v1h-1v-1z",
    fill: "#5c6681"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M51 92h-1v-1h1zm15 4h-1v-1h1z",
    fill: "#4b5574"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M76 92h-1v-1h1zm-19 3h1v1h-1z",
    fill: "#5d6680"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h-1v-1h1zm-6 2v-1h1v1z",
    fill: "#c9d1cc"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M89 91v1h-1v-1zm2 5h-1v-1h1z",
    fill: "#606a85"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93v-1h1v1zm14 4v-1h1v1z",
    fill: "#5a647e"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92h2v1h-2z",
    fill: "#c6ccc7"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M89 94h-1v-2h1v1z",
    fill: "#5e6882"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v-1h1v1zm3-1v1h-1v-1z",
    fill: "#48516b"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h1v1h-1zm13 5h-1v-1h1z",
    fill: "#47506d"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93h1v1h-1zm11 2h1v1h-1z",
    fill: "#5a647d"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M39 95h-1v-1h1zm0 0h1v1h-1z",
    fill: "#484f69"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M39 94h1v1h-1zm51 12v1h-1v-1z",
    fill: "#494f6a"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M51 95v-1h1v1zm14 1v1h-1v-1z",
    fill: "#495270"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M64 95h-2v-1h2z",
    fill: "#4b5473"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M76 94v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#545d7a"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M84 94v1h-2v-1h1z",
    fill: "#a9b0b5"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M34 97v-2h1v2z",
    fill: "#707376",
    fillOpacity: 0.906
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h1v1h-1zm15 4h-1v-1h1z",
    fill: "#49546e"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M69 95h1v1h-1zm17 4h-1v-1h1z",
    fill: "#505974"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M76 96v-1h2v1h-1z",
    fill: "#525b78"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96v-1h1v1zm2 2h-1v-1h1z",
    fill: "#555e77"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M84 96h-2v-1h2z",
    fill: "#5c6479"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M48 96v1h-1v-1zm15 6v-1h1v1z",
    fill: "#424a65"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M37 97h2v1h-2z",
    fill: "#454c66"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97h2v1h-2z",
    fill: "#4e576b"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99v1h-1v-2h1z",
    fill: "#1d1f27"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v1h-1v-1zm5 2h-1v-1h1z",
    fill: "#434a64"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M44 99h-2v-1h2z",
    fill: "#434965"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98v1h-2v-1h1z",
    fill: "#414d67"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M48 98h1v1h-1zm32 6v-1h1v1z",
    fill: "#434c67"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M53 99h-1v-1h1zm-1 0v1h-1v-1z",
    fill: "#434c68"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M54 99h-1v-1h1zm4 1v-1h1v1z",
    fill: "#434e68"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M61 99v-1h1v1zm2 1v-1h1v1z",
    fill: "#444e6a"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M66 98v1h-2v-1h1z",
    fill: "#45506a"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M67 99h-1v-1h1zm1 0v-1h1v1z",
    fill: "#46506a"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M77 98h1v1h-1zm7 3h-1v-1h1z",
    fill: "#4b5570"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99h-1v-1h1zm8 4v-1h1v1z",
    fill: "#4c5571"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M84 99h-1v-1h2v1z",
    fill: "#4e5874"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M93 98h1v1h-1zm0 4v-1h1v1z",
    fill: "#a19eaa",
    fillOpacity: 0.447
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M57 99h1v1h-1zm24 4h1v1h-1z",
    fill: "#424e68"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M66 99v1h-1v-1zm13 3h1v1h-1z",
    fill: "#454e69"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M75 100v-1h1v1zm9 1v1h-1v-1z",
    fill: "#49536e"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M79 99v1h-1v-1zm2 1h1v1h-1z",
    fill: "#4a5370"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M81 99v1h-1v-1zm2 1v1h-1v-1z",
    fill: "#4a5470"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M87 100v-1h1v1zm2 0h1v1h-1z",
    fill: "#525c77"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M35 100v2h-1v-2z",
    fill: "#707376",
    fillOpacity: 0.918
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M38 101v-1h1v1zm13 2h-1v-1h1z",
    fill: "#404860"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M55 101h-1v-1h1zm18 2h1v1h-1z",
    fill: "#414b65"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M41 101v1h-1v-1zm24 2v1h-1v-1z",
    fill: "#3f4661"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M33 103v-1h1v2h-1z",
    fill: "#ededf6",
    fillOpacity: 0.114
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v2h-1v-2z",
    fill: "#1b1e24"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v-1h1v1zm15 2h-1v-1h1z",
    fill: "#3d4660"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M47 103h-1v-1h1zm14 3v-1h1v1z",
    fill: "#3f4560"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M48 102v1h-1v-1zm42 8v1h-1v-1z",
    fill: "#3f4760"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M49 102v1h-1v-1zm41 9h1v1h-1z",
    fill: "#40475d"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103v-1h1v1zm6 1h-1v-1h1z",
    fill: "#414861"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M83 103h-1v-1h1zm5 2h-1v-1h1z",
    fill: "#45516a"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M88 103h-2v-1h2z",
    fill: "#4a546e"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M37 103v1h-1v-1zm27 6v1h-1v-1z",
    fill: "#3b4359"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M37 104v-1h1v1zm23 2v-1h1v1z",
    fill: "#3d435d"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M41 103v1h-1v-1zm3 0v1h-1v-1z",
    fill: "#3e445d"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M44 103h1v1h-1zm33 6v-1h1v1z",
    fill: "#3b465c"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103v1h-1v-1zm16 3h1v1h-1z",
    fill: "#3d445f"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h1v1h-1zm29 4h1v1h-1z",
    fill: "#3c4560"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M54 104h-1v-1h2v1z",
    fill: "#40485e"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M55 104v-1h2v1h-1z",
    fill: "#3f485f"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h1v1h-1zm4 0v1h-1v-1z",
    fill: "#424b65"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M70 103h1v1h-2v-1z",
    fill: "#414a64"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104h-1v-1h2v1z",
    fill: "#474f69"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105v-1h1v1zm47 6v1h-1v-1z",
    fill: "#3c435c"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M50 104v1h-1v-1zm25 2v1h-1v-1z",
    fill: "#3d445e"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M53 104h2v1h-2z",
    fill: "#3e4660"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104h1v1h-2v-1z",
    fill: "#3e475f"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M61 104h1v1h-1zm16 2v1h-1v-1z",
    fill: "#3f475f"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M39 105h1v1h-2v-1z",
    fill: "#3a4155"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M47 105v1h-1v-1zm30 7h-1v-1h1z",
    fill: "#384055"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M51 106v1h-1v-1zm12 3v-1h1v1z",
    fill: "#3c445b"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107v-1h1v1zm1 4h-1v-1h1z",
    fill: "#3b3c3e"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M94 107v1h-1v-2h1z",
    fill: "#a3a3aa",
    fillOpacity: 0.439
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M33 108v-1h1v2h-1z",
    fill: "#eeeef6",
    fillOpacity: 0.122
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M34 107h1v2h-1v-1z",
    fill: "#75777b",
    fillOpacity: 0.929
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M50 107v1h-1v-1zm1 2h-1v-1h1z",
    fill: "#3a4057"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v1h-1v-2h1z",
    fill: "#373c51"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h1v1h-1zm3 2v1h-1v-1z",
    fill: "#343c52"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111h-1v-1h1zm1 3v-1h1v1z",
    fill: "#343b51"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M94 111v1h-1v-2h1z",
    fill: "#a1a3aa",
    fillOpacity: 0.447
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112h-1v-1h1zm39 3v-1h1v1z",
    fill: "#33394b"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112h-1v-1h1zm-12 0v1h-1v-1z",
    fill: "#32384e"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M76 111v1h-1v-1zm-14 1h1v1h-1z",
    fill: "#32394f"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M34 113h-1v-1h1zm0 1v1h-1v-1z",
    fill: "#efeff7",
    fillOpacity: 0.129
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M77 113h-1v-1h2v1z",
    fill: "#353d53"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v-2h1v2z",
    fill: "#3b3d40"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M93 114v-2h1v2z",
    fill: "#a4a4ac",
    fillOpacity: 0.451
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114h-1v-1h1zm14 2v-1h1v1z",
    fill: "#303549"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M64 114h-1v-1h2v1z",
    fill: "#363c52"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115h-1v-1h1zm30 1h-1v-1h1z",
    fill: "#30364a"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114h1v1h-1zm39 1h1v1h-1z",
    fill: "#34394c"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h1v1h-1zm24 1v-1h1v1z",
    fill: "#33394d"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114v1h-1v-1zm-18 2h-1v-1h1z",
    fill: "#31384b"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115h-1v-1h1zm0 1v-1h1v1z",
    fill: "#363c50"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h-1v-2h1v1z",
    fill: "#3c3d40"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M37 116h-1v-1h1zm43 7v-1h1v1z",
    fill: "#2f3547"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M48 116h-1v-1h1zm42 2h1v1h-1z",
    fill: "#31374b"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M68 116v-1h1v1zm-21 2h1v1h-1z",
    fill: "#2c3246"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M72 115v1h-1v-1zm-5 7h1v1h-1z",
    fill: "#2e3348"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M82 116v-1h1v1zm3-1v1h-1v-1z",
    fill: "#37374d"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M38 117h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#2e344b"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116v1h-1v-1zm43 1h1v1h-1z",
    fill: "#2f354c"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M44 117v-1h1v1zm39-1h1v1h-1z",
    fill: "#30364d"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M50 116h1v1h-2v-1z",
    fill: "#30364b"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v1h-1v-1zm-4 2v-1h1v1z",
    fill: "#2d354a"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M83 118h-1v-1h2v1z",
    fill: "#2f344b"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M82 119h-1v-1h1zm-22 2h1v1h-1z",
    fill: "#2d344a"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M84 119h-2v-1h2z",
    fill: "#2c3449"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M40 121h-1v-1h1zm-2 0h1v1h-1z",
    fill: "#2d3344"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M40 120h1v1h-1zm11 2v1h-1v-1z",
    fill: "#2c3344"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v1h-1v-1zm32 2v-1h1v1z",
    fill: "#2c3143"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121v1h-1v-1zm31 0h1v1h-1z",
    fill: "#5f6571"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122v1h-1v-1zm9 1h-1v-1h1z",
    fill: "#2f3543"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M39 122h1v1h-1zm42 1v-1h1v1z",
    fill: "#2d3244"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M51 123v-1h1v1zm12 0h-1v-1h1z",
    fill: "#2d3345"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M87 122h1v1h-1zm-8 1h1v1h-1z",
    fill: "#2e3144"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M43 123v1h-2v-1h1z",
    fill: "#2e3243"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M46 123v1h-1v-1zm6 0h1v1h-1z",
    fill: "#2f3245"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M60 123v1h-1v-1zm2 1h-1v-1h1z",
    fill: "#303247"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M69 124h-2v-1h2z",
    fill: "#2e3345"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M44 124h1v1h-1zm20 0v1h-1v-1z",
    fill: "#202129"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M63 124v1h-1v-1zm1 1v-1h1v1z",
    fill: "#1f2028"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M74 124h1v1h-1zm4 1v-1h1v1z",
    fill: "#1c2127"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126v-1h1v1zm2 0v-1h1v1z",
    fill: "#414246",
    fillOpacity: 0.992
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M68 125v1h-1v-1zm3 1v-1h1v1z",
    fill: "#404146",
    fillOpacity: 0.992
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M70 125h1v1h-1zm2 0h1v1h-1z",
    fill: "#414247",
    fillOpacity: 0.992
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M79 126h-1v-1h1zm3-1v1h-1v-1z",
    fill: "#3f4147"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M81 125v1h-2v-1h1z",
    fill: "#404248"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M47 127v-1h1v1zm4 0h-1v-1h1z",
    fill: "#a4a4b0",
    fillOpacity: 0.243
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v1h-1v-1zm20 1v-1h1v1z",
    fill: "#9e9eab",
    fillOpacity: 0.239
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M56 126h1v1h-1zm18 1h-1v-1h1z",
    fill: "#a1a1aa",
    fillOpacity: 0.235
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M60 126v1h-2v-1h1z",
    fill: "#9f9ba8",
    fillOpacity: 0.231
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126h1v1h-1zm7 0h1v1h-1z",
    fill: "#9e9ea7",
    fillOpacity: 0.227
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M40 1v1h-1V1z",
    fill: "#e2e2f0",
    fillOpacity: 0.071
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M41 1v1h-1V1z",
    fill: "#b6b6bc",
    fillOpacity: 0.165
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M42 2h-1V1h1z",
    fill: "#aaaab2",
    fillOpacity: 0.247
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M42 1h1v1h-1z",
    fill: "#a7a3ae",
    fillOpacity: 0.275
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M44 1v1h-1V1z",
    fill: "#a5a5af",
    fillOpacity: 0.278
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M45 1v1h-1V1z",
    fill: "#a5a5af",
    fillOpacity: 0.29
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2V1h1v1z",
    fill: "#a3a3ad",
    fillOpacity: 0.294
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M47 1v1h-1V1z",
    fill: "#a1a1ae",
    fillOpacity: 0.298
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M47 2V1h1v1z",
    fill: "#9e9ea8",
    fillOpacity: 0.302
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M48 2V1h1v1z",
    fill: "#9d9da7",
    fillOpacity: 0.298
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M50 1v1h-1V1z",
    fill: "#a1a1ab",
    fillOpacity: 0.298
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M50 2V1h1v1z",
    fill: "#9f9fad",
    fillOpacity: 0.294
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M52 1v1h-1V1z",
    fill: "#9f9faa",
    fillOpacity: 0.294
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M55 2h-1V1h1z",
    fill: "#9b9ba5",
    fillOpacity: 0.29
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M55 1h1v1h-1z",
    fill: "#bfbfc9",
    fillOpacity: 0.282
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M57 1v1h-1V1z",
    fill: "#bdbdc8",
    fillOpacity: 0.275
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M57 2V1h1v1z",
    fill: "#93939e",
    fillOpacity: 0.278
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M58 1h1v1h-1z",
    fill: "#9595a0",
    fillOpacity: 0.275
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M60 2h-1V1h1z",
    fill: "#9797a2",
    fillOpacity: 0.271
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1v1h-1V1z",
    fill: "#9999a5",
    fillOpacity: 0.267
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M61 1h1v1h-1z",
    fill: "#9696a1",
    fillOpacity: 0.267
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M67 1h1v1h-1z",
    fill: "#9a96a2",
    fillOpacity: 0.259
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M69 1v1h-1V1z",
    fill: "#9999a4",
    fillOpacity: 0.255
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1v1h-1V1z",
    fill: "#9696a2",
    fillOpacity: 0.259
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M70 1h1v1h-1z",
    fill: "#99959c",
    fillOpacity: 0.255
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M71 1h1v1h-1z",
    fill: "#97979f",
    fillOpacity: 0.251
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2V1h1v1z",
    fill: "#9c98a0",
    fillOpacity: 0.243
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M76 1v1h-1V1z",
    fill: "#9c9ca4",
    fillOpacity: 0.243
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M79 1v1h-1V1z",
    fill: "#9c99a4",
    fillOpacity: 0.255
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M79 2V1h1v1z",
    fill: "#9e9aa6",
    fillOpacity: 0.259
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M81 1v1h-1V1z",
    fill: "#9f9ca7",
    fillOpacity: 0.263
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M81 1h1v1h-1z",
    fill: "#9f9fa7",
    fillOpacity: 0.263
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M82 1h1v1h-1z",
    fill: "#9f9fab",
    fillOpacity: 0.263
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M84 2h-1V1h1z",
    fill: "#a29eaa",
    fillOpacity: 0.259
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M84 1h1v1h-1z",
    fill: "#a09ca8",
    fillOpacity: 0.255
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M86 1v1h-1V1z",
    fill: "#a09ca8",
    fillOpacity: 0.243
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M87 2h-1V1h1z",
    fill: "#a4aaaa",
    fillOpacity: 0.188
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M87 1h1v1h-1z",
    fill: "#c8c8c8",
    fillOpacity: 0.11
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M37 2h1v1h-1z",
    fill: "#aca8b0",
    fillOpacity: 0.255
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M39 3h-1V2h1z",
    fill: "#7f7f84",
    fillOpacity: 0.651
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M39 2h1v1h-1z",
    fill: "#5b5d62",
    fillOpacity: 0.871
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3h-1V2h1z",
    fill: "#46484e",
    fillOpacity: 0.957
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3V2h1v1z",
    fill: "#3f3e44"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M43 2h1v1h-1z",
    fill: "#3e3d43"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M44 3V2h1v1z",
    fill: "#3e3d44"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3h-1V2h1z",
    fill: "#3e3d46"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M47 3h-1V2h1z",
    fill: "#3e3d45"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h-1V2h1z",
    fill: "#3e3d42"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3V2h1v1z",
    fill: "#3d3e43"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2v1h-1V2z",
    fill: "#3a3c42"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M51 2h1v1h-1z",
    fill: "#3b3d42"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M54 3V2h1v1z",
    fill: "#4e5157"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M55 3V2h1v1z",
    fill: "#5f6268"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3V2h1v1z",
    fill: "#5b5f64"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M59 3h-1V2h1z",
    fill: "#4a4d52"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3V2h1v1z",
    fill: "#4b4e54"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M62 3h-1V2h1z",
    fill: "#4b4e53"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M62 2h1v1h-1z",
    fill: "#4a4d53"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2v1h-1V2z",
    fill: "#494d52"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M65 2h1v1h-1z",
    fill: "#4a4b51"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h-1V2h1z",
    fill: "#4e4e54"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M69 2h1v1h-1z",
    fill: "#4e4e55"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M71 2v1h-1V2z",
    fill: "#4e4f56"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M72 2v1h-1V2z",
    fill: "#4d4d55"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M73 2v1h-1V2z",
    fill: "#4c4c54"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3h-1V2h1z",
    fill: "#494952"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M74 2h1v1h-1z",
    fill: "#42434b"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M75 2h1v1h-1z",
    fill: "#3a3c44"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M76 2h1v1h-1z",
    fill: "#393a43"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M77 3V2h1v1z",
    fill: "#3b3c45"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3V2h1v1z",
    fill: "#3b3d45"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M80 2v1h-1V2z",
    fill: "#3c3d45"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M83 3V2h1v1z",
    fill: "#3c3e45"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M86 2h1v1h-1z",
    fill: "#40434b",
    fillOpacity: 0.973
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M88 3h-1V2h1z",
    fill: "#4e5156",
    fillOpacity: 0.918
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M88 3V2h1v1z",
    fill: "#6c6e72",
    fillOpacity: 0.757
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M90 2v1h-1V2z",
    fill: "#94979b",
    fillOpacity: 0.424
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M91 3h-1V2h1z",
    fill: "#ddd",
    fillOpacity: 0.059
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M36 3v1h-1V3z",
    fill: "#dadaff",
    fillOpacity: 0.027
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M36 4V3h1v1z",
    fill: "#a2a0a5",
    fillOpacity: 0.549
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M37 3h1v1h-1z",
    fill: "#5f5e66",
    fillOpacity: 0.98
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4V3h1v1z",
    fill: "#222329"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M41 3v1h-1V3z",
    fill: "#323740"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M42 3v1h-1V3z",
    fill: "#3f444f"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3v1h-1V3z",
    fill: "#434753"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M43 3h1v1h-1z",
    fill: "#444853"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4h-1V3h1z",
    fill: "#424753"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3v1h-1V3z",
    fill: "#434755"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M46 3h1v1h-1z",
    fill: "#444755"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M48 3v1h-1V3z",
    fill: "#393d48"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3v1h-1V3z",
    fill: "#373c45"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M49 3h1v1h-1z",
    fill: "#3c4145"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4V3h1v1z",
    fill: "#3b3f43"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4h-1V3h1z",
    fill: "#3a3d44"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M52 4V3h1v1z",
    fill: "#383b44"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M53 3h1v1h-1z",
    fill: "#373b44"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h-1V3h1z",
    fill: "#363a44"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3v1h-1V3z",
    fill: "#323741"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M56 3h1v1h-1z",
    fill: "#30343f"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3h1v1h-1z",
    fill: "#323643"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M60 3v1h-1V3z",
    fill: "#313542"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M60 4V3h1v1z",
    fill: "#313543"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4h-1V3h1z",
    fill: "#323644"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3v1h-1V3z",
    fill: "#333845"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M63 3h1v1h-1z",
    fill: "#323845"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4h-1V3h1z",
    fill: "#313643"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M65 4V3h1v1z",
    fill: "#2f3542"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M66 3h1v1h-1z",
    fill: "#303643"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M69 3h1v1h-1z",
    fill: "#2d3340"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M73 3v1h-1V3z",
    fill: "#2b313d"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M74 3v1h-1V3z",
    fill: "#2a303d"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M78 3v1h-1V3z",
    fill: "#292f3d"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M79 3v1h-1V3z",
    fill: "#29303c"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M79 4V3h1v1z",
    fill: "#292f3c"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M82 3v1h-1V3z",
    fill: "#282e3a"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M86 3v1h-1V3z",
    fill: "#262d39"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M86 4V3h1v1z",
    fill: "#262a39"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M89 3v1h-1V3z",
    fill: "#1b1f22"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M90 4h-1V3h1z",
    fill: "#424547"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M91 3v1h-1V3z",
    fill: "#84838a",
    fillOpacity: 0.792
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M92 3v1h-1V3z",
    fill: "#b1b1b7",
    fillOpacity: 0.169
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M36 5h-1V4h1z",
    fill: "#a5a5af",
    fillOpacity: 0.525
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M37 4v1h-1V4z",
    fill: "#5d5d62"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M38 4v1h-1V4z",
    fill: "#18191e"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5V4h1v1z",
    fill: "#5c6270"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h-1V4h1z",
    fill: "#959fb4"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M41 5h-1V4h1z",
    fill: "#a5b0c8"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M41 4h1v1h-1z",
    fill: "#a6b2cf"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5h-1V4h1z",
    fill: "#a5b2cf"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5V4h1v1z",
    fill: "#a6b4cf"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M47 4v1h-1V4z",
    fill: "#a9b5d0"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M47 5V4h1v1z",
    fill: "#949eb9"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4v1h-1V4z",
    fill: "#979eb0"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M50 4h1v1h-1z",
    fill: "#949ca8"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M51 4h1v1h-1z",
    fill: "#8e95a6"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M53 5h-1V4h1z",
    fill: "#8890a2"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M55 5h-1V4h1z",
    fill: "#828ba2"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4h1v1h-1z",
    fill: "#7e86a0"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M57 4v1h-1V4z",
    fill: "#78809d"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M59 5V4h1v1z",
    fill: "#737c9c"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M63 4h1v1h-1z",
    fill: "#6d7891"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h-1V4h1z",
    fill: "#727b96"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5h-1V4h1z",
    fill: "#6a7597"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M70 4h1v1h-1z",
    fill: "#687397"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M72 5V4h1v1z",
    fill: "#646f97"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M74 5h-1V4h1z",
    fill: "#646e97"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M74 4h1v1h-1z",
    fill: "#636e95"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M76 5V4h1v1z",
    fill: "#616c92"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M77 5V4h1v1z",
    fill: "#606b91"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M78 5V4h1v1z",
    fill: "#5e6991"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M80 5h-1V4h1z",
    fill: "#5f6a92"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M80 4h1v1h-1z",
    fill: "#5e6990"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M82 4h1v1h-1z",
    fill: "#5a658a"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M83 5V4h1v1z",
    fill: "#59648a"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M85 4v1h-1V4z",
    fill: "#586389"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5h-1V4h1z",
    fill: "#576288"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M88 4v1h-1V4z",
    fill: "#545e7c"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M88 5V4h1v1z",
    fill: "#454c64"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M90 4v1h-1V4z",
    fill: "#20232f"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M90 5V4h1v1z",
    fill: "#2f2f38"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M91 5V4h1v1z",
    fill: "#81818a",
    fillOpacity: 0.847
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M93 5h-1V4h1z",
    fill: "#b2b2b2",
    fillOpacity: 0.118
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M34 6V5h1v1z",
    fill: "#c7c7c7",
    fillOpacity: 0.18
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M35 5h1v1h-1z",
    fill: "#77787e",
    fillOpacity: 0.961
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M37 5v1h-1V5z",
    fill: "#161921"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M37 6V5h1v1z",
    fill: "#767d8f"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M38 5h1v1h-1z",
    fill: "#abb5cd"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M39 5h1v1h-1z",
    fill: "#a7b3cf"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M40 5h1v1h-1z",
    fill: "#a6b2cc"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M41 6V5h1v1z",
    fill: "#a4b2c9"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M42 6V5h1v1z",
    fill: "#a6b4cc"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M43 6V5h1v1z",
    fill: "#a4b1cb"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M45 5v1h-1V5z",
    fill: "#a2b0ca"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M46 5v1h-1V5z",
    fill: "#a1b0ca"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M47 6h-1V5h1z",
    fill: "#a3b0cc"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M49 6V5h1v1z",
    fill: "#8e95ac"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M52 6h-1V5h1z",
    fill: "#8a94a3"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M52 5h1v1h-1z",
    fill: "#858ea0"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M60 6V5h1v1z",
    fill: "#6d789a"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M62 6V5h1v1z",
    fill: "#50566b"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6V5h1v1z",
    fill: "#2b3340"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M65 5h1v1h-1z",
    fill: "#68738f"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M70 5v1h-1V5z",
    fill: "#667195"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6h-1V5h1z",
    fill: "#647095"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h-1V5h1z",
    fill: "#5f6b97"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M75 5v1h-1V5z",
    fill: "#5e6a97"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M75 6V5h1v1z",
    fill: "#5d6a93"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M77 5v1h-1V5z",
    fill: "#5d698f"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M77 6V5h1v1z",
    fill: "#626e92"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6V5h1v1z",
    fill: "#5d688f"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M81 6h-1V5h1z",
    fill: "#5a658d"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h-1V5h1z",
    fill: "#5e6a8f"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6V5h1v1z",
    fill: "#646e94"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M86 5v1h-1V5z",
    fill: "#616c8e"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M87 5h1v1h-1z",
    fill: "#5b658a"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M89 5v1h-1V5z",
    fill: "#58608a"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M89 6V5h1v1z",
    fill: "#53597c"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M91 6h-1V5h1z",
    fill: "#212433"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M91 6V5h1v1z",
    fill: "#3e4046"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M92 6V5h1v1z",
    fill: "#96989a",
    fillOpacity: 0.584
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M35 7h-1V6h1z",
    fill: "#a7a7a9",
    fillOpacity: 0.537
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M36 7V6h1v1z",
    fill: "#464d5b"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M38 6v1h-1V6z",
    fill: "#a9b4ce"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M39 6v1h-1V6z",
    fill: "#9fadc7"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M39 7V6h1v1z",
    fill: "#a8b6cc"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M41 7h-1V6h1z",
    fill: "#b4c0d2"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7h-1V6h1z",
    fill: "#aebacc"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M42 7V6h1v1z",
    fill: "#b6c2d8"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M44 7h-1V6h1z",
    fill: "#aab6cf"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M46 7h-1V6h1z",
    fill: "#a2afca"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7h-1V6h1z",
    fill: "#a2afcb"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M47 7V6h1v1z",
    fill: "#a5b0ce"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M49 7h-1V6h1z",
    fill: "#8691b0"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M53 6h1v1h-1z",
    fill: "#828ca1"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7V6h1v1z",
    fill: "#707b99"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M63 6v1h-1V6z",
    fill: "#2b3141"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M64 6v1h-1V6z",
    fill: "#151311"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M65 7h-1V6h1z",
    fill: "#0f1318"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M66 7h-1V6h1z",
    fill: "#535e78"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M70 7h-1V6h1z",
    fill: "#657093"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M71 6v1h-1V6z",
    fill: "#626f94"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6v1h-1V6z",
    fill: "#5f6a95"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M74 6h1v1h-1z",
    fill: "#5d6895"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7h-1V6h1z",
    fill: "#5a678d"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M77 6h1v1h-1z",
    fill: "#6f7b9d"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M79 6v1h-1V6z",
    fill: "#96a2ba"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M80 7h-1V6h1z",
    fill: "#707b97"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M81 7V6h1v1z",
    fill: "#8894ae"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M82 6h1v1h-1z",
    fill: "#818ca6"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M84 7h-1V6h1z",
    fill: "#8c97af"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7h-1V6h1z",
    fill: "#98a4b9"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M86 7h-1V6h1z",
    fill: "#98a4b8"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M86 6h1v1h-1z",
    fill: "#7d89a1"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M87 6h1v1h-1z",
    fill: "#9da8c1"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M90 7h-1V6h1z",
    fill: "#505d83"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M90 6h1v1h-1z",
    fill: "#49516a"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M91 6h1v1h-1z",
    fill: "#171c22"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M92 6h1v1h-1z",
    fill: "#737477",
    fillOpacity: 0.89
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M93 7V6h1v1z",
    fill: "#d8d8e5",
    fillOpacity: 0.078
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M34 7h1v1h-1z",
    fill: "#8e8d92",
    fillOpacity: 0.765
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M37 7v1h-1V7z",
    fill: "#80879e"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7v1h-1V7z",
    fill: "#a7b0cf"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M38 7h1v1h-1z",
    fill: "#a0adc7"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M40 8h-1V7h1z",
    fill: "#a4b1c9"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M40 7h1v1h-1z",
    fill: "#a9b4cb"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M42 8V7h1v1z",
    fill: "#abb7d1"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M48 8V7h1v1z",
    fill: "#9aa5c3"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M51 7v1h-1V7z",
    fill: "#8a97a6"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M54 8V7h1v1z",
    fill: "#7e899e"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M55 8V7h1v1z",
    fill: "#7c869f"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M57 7h1v1h-1z",
    fill: "#707b98"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M61 7v1h-1V7z",
    fill: "#6b7698"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8V7h1v1z",
    fill: "#6c779b"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M62 7h1v1h-1z",
    fill: "#4c5469"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M64 7h1v1h-1z",
    fill: "#2c313f"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M65 8V7h1v1z",
    fill: "#656e8b"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M70 8h-1V7h1z",
    fill: "#646f93"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h-1V7h1z",
    fill: "#616e93"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M74 8V7h1v1z",
    fill: "#5e6994"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M77 7h1v1h-1z",
    fill: "#5c688c"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M83 7v1h-1V7z",
    fill: "#677291"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M85 7v1h-1V7z",
    fill: "#667190"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M86 8h-1V7h1z",
    fill: "#6a7494"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8h-1V7h1z",
    fill: "#586082"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M90 7v1h-1V7z",
    fill: "#4e5a83"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M91 8h-1V7h1z",
    fill: "#525c82"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M92 7v1h-1V7z",
    fill: "#232933"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M92 7h1v1h-1z",
    fill: "#515157",
    fillOpacity: 0.988
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M93 7h1v1h-1z",
    fill: "#b5b5be",
    fillOpacity: 0.231
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9h-1V8h1z",
    fill: "#76767b",
    fillOpacity: 0.835
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M36 8h1v1h-1z",
    fill: "#969eb9"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M41 8v1h-1V8z",
    fill: "#a1abc8"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8h1v1h-1z",
    fill: "#a1accc"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8v1h-1V8z",
    fill: "#a4afcb"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M50 8v1h-1V8z",
    fill: "#848eac"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M51 8h1v1h-1z",
    fill: "#8f99a9"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8v1h-1V8z",
    fill: "#8a93a2"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M53 8h1v1h-1z",
    fill: "#858d9f"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M55 9h-1V8h1z",
    fill: "#818a9e"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9V8h1v1z",
    fill: "#727c9a"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M58 9V8h1v1z",
    fill: "#6e7a98"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M62 9V8h1v1z",
    fill: "#6c7695"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9V8h1v1z",
    fill: "#697291"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M71 8h1v1h-1z",
    fill: "#626d94"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9h-1V8h1z",
    fill: "#5a668f"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M79 9V8h1v1z",
    fill: "#59648d"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M80 8h1v1h-1z",
    fill: "#57628b"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M82 9h-1V8h1z",
    fill: "#566189"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M83 8v1h-1V8z",
    fill: "#556088"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M84 9V8h1v1z",
    fill: "#525e86"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M86 9V8h1v1z",
    fill: "#505c83"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M87 8h1v1h-1z",
    fill: "#4e5980"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8v1h-1V8z",
    fill: "#515b83"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M89 8h1v1h-1z",
    fill: "#4f5a84"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M92 8v1h-1V8z",
    fill: "#2f3546"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M93 8v1h-1V8z",
    fill: "#3d3e42"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M94 9h-1V8h1z",
    fill: "#a9a6ae",
    fillOpacity: 0.337
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M35 9v1h-1V9z",
    fill: "#6c6e70",
    fillOpacity: 0.886
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10V9h1v1z",
    fill: "#24272e"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#9ba5c4"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#78829d"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10V9h1v1z",
    fill: "#8e97a5"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10h-1V9h1z",
    fill: "#8790a0"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#838b9f"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#7d879f"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#6a7599"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#697398"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M72 10h-1V9h1z",
    fill: "#626c94"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M79 10h-1V9h1z",
    fill: "#5b688f"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M93 9h1v1h-1z",
    fill: "#9f9da6",
    fillOpacity: 0.42
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10v1h-1v-1z",
    fill: "#ebebf5",
    fillOpacity: 0.102
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11v-1h1v1z",
    fill: "#6d6f72",
    fillOpacity: 0.91
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M36 10v1h-1v-1z",
    fill: "#272a31"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11v-1h1v1z",
    fill: "#9ba5bf"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1z",
    fill: "#a2adcd"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#8791b1"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#7d87a0"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#8f9aaa"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#7a85a0"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#747f9b"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M63 11h-1v-1h1z",
    fill: "#6c7599"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1z",
    fill: "#6a7399"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11v-1h1v1z",
    fill: "#a09da6",
    fillOpacity: 0.443
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M34 12h-1v-1h1z",
    fill: "#e5eeee",
    fillOpacity: 0.118
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12h-1v-1h1z",
    fill: "#6f7074",
    fillOpacity: 0.922
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12v-1h1v1z",
    fill: "#9ba5be"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#a1adca"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1z",
    fill: "#9ea9ca"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#7a84a3"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12h-1v-1h1z",
    fill: "#8993a3"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#6f7a99"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#677095"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1z",
    fill: "#636d95"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M75 11h1v1h-1z",
    fill: "#5d6a91"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11v1h-1v-1z",
    fill: "#38393b"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M93 11h1v1h-1z",
    fill: "#a7a7ad",
    fillOpacity: 0.467
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h-1v-1h1z",
    fill: "#e7e7f7",
    fillOpacity: 0.129
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12v1h-1v-1z",
    fill: "#73747b",
    fillOpacity: 0.933
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M36 13h-1v-1h1z",
    fill: "#26272f"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#929cbc"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#77819d"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#8d98aa"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#8d98a8"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#687497"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#677296"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#657097"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1z",
    fill: "#646d95"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M75 12v1h-1v-1z",
    fill: "#616b94"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M77 12h1v1h-1z",
    fill: "#5e6891"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M88 12h1v1h-1z",
    fill: "#4f5b82"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M94 12v1h-1v-1z",
    fill: "#b4b2bc",
    fillOpacity: 0.494
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14v-1h1v1z",
    fill: "#e4edf6",
    fillOpacity: 0.114
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M34 13h1v1h-1z",
    fill: "#6e7078",
    fillOpacity: 0.922
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#a3aecc"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#838ead"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#8f9bab"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#8b98a3"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#8691a3"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#838ca3"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#677497"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#667398"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M78 13v1h-1v-1z",
    fill: "#5f6991"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M91 14v-1h1v1z",
    fill: "#333b4d"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M93 14v-1h1v1z",
    fill: "#9694a1",
    fillOpacity: 0.471
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15h-1v-1h1z",
    fill: "#6f7179",
    fillOpacity: 0.925
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M35 15v-1h1v1z",
    fill: "#292a30"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#7d87a6"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#909ca6"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#8d96a5"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#8790a4"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M77 14v1h-1v-1z",
    fill: "#616a92"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M79 14v1h-1v-1z",
    fill: "#5e688f"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M80 14v1h-1v-1z",
    fill: "#5d678f"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M81 15h-1v-1h1z",
    fill: "#5c668e"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M81 14h1v1h-1z",
    fill: "#5a648c"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M82 14h1v1h-1z",
    fill: "#59638b"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15h-1v-1h1z",
    fill: "#576189"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v-1h1v1z",
    fill: "#566088"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M86 15h-1v-1h1z",
    fill: "#566087"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M92 14h1v1h-1z",
    fill: "#333438"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M94 14v1h-1v-1z",
    fill: "#9896a0",
    fillOpacity: 0.478
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M34 15v1h-1v-1z",
    fill: "#dfe7ef",
    fillOpacity: 0.125
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16v-1h1v1z",
    fill: "#6e7078",
    fillOpacity: 0.929
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#99a4c2"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#7a859f"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#939aab"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#8793a3"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M77 15h1v1h-1z",
    fill: "#616a90"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M81 16h-1v-1h1z",
    fill: "#5e678e"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#535f85"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h-1v-1h1z",
    fill: "#9997a1",
    fillOpacity: 0.482
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17v-1h1v1z",
    fill: "#e7e7ef",
    fillOpacity: 0.129
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M34 16h1v1h-1z",
    fill: "#6f7178",
    fillOpacity: 0.933
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#929da9"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#8e99a5"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#8995a3"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#8491a3"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#747f9c"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1z",
    fill: "#5c658c"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#5c658b"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#555f86"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#545e85"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#535d83"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#515b82"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#525d84"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1z",
    fill: "#343b4d"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M93 16h1v1h-1z",
    fill: "#9996a1",
    fillOpacity: 0.49
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M33 17h1v1h-1z",
    fill: "#e6eef6",
    fillOpacity: 0.122
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M34 18v-1h1v1z",
    fill: "#6e7077",
    fillOpacity: 0.929
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M36 18v-1h1v1z",
    fill: "#98a4bd"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#8e9ab6"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#7c889e"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#909baa"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#939daa"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#8e9aa6"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#8995a4"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#626b94"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#5a6488"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#576085"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#535c81"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1z",
    fill: "#545e84"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1z",
    fill: "#33343a"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M94 17v1h-1v-1z",
    fill: "#9896a0",
    fillOpacity: 0.498
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M33 19v-1h1v1z",
    fill: "#e6e6ee",
    fillOpacity: 0.122
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19h-1v-1h1z",
    fill: "#6e7077",
    fillOpacity: 0.925
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19h-1v-1h1z",
    fill: "#292933"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M36 19v-1h1v1z",
    fill: "#98a3bd"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#7e89a0"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#909bad"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#939fad"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#576185"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1z",
    fill: "#566084"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1z",
    fill: "#555f85"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M93 19v-1h1v1z",
    fill: "#9896a0",
    fillOpacity: 0.506
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19v1h-1v-1z",
    fill: "#6c6e76",
    fillOpacity: 0.925
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M35 20v-1h1v1z",
    fill: "#282833"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20v-1h1v1z",
    fill: "#96a1bc"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#a3aec9"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#919cac"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#969fab"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#929da8"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#8e99a7"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#5f688e"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#586285"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M89 20h-1v-1h1z",
    fill: "#566083"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20v-1h1v1z",
    fill: "#566086"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19h1v1h-1z",
    fill: "#34343a"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M94 19v1h-1v-1z",
    fill: "#9997a1",
    fillOpacity: 0.522
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21h-1v-1h1z",
    fill: "#6b6e74",
    fillOpacity: 0.918
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M36 20h1v1h-1z",
    fill: "#95a0bb"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#a3afc8"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#a5b0ca"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#909ab4"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#919baa"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#97a2ab"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#949ea8"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#8f97a8"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#858fa4"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#7a84a1"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#5b6588"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#596286"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M94 20v1h-1v-1z",
    fill: "#999aa3",
    fillOpacity: 0.549
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M35 21v1h-1v-1z",
    fill: "#6b6c72",
    fillOpacity: 0.918
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M36 22h-1v-1h1z",
    fill: "#25292f"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M36 21h1v1h-1z",
    fill: "#95a0b9"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#a6afcc"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#959ebc"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#7e88a2"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#8d97aa"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#959eaa"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#9299a9"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#8c95a7"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#75819e"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#717c9b"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1z",
    fill: "#6a7496"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#606a90"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#5f698e"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#5b6488"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#586284"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#363d50"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M94 22h-1v-1h1z",
    fill: "#99a0a7",
    fillOpacity: 0.58
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M33 22h1v1h-1z",
    fill: "#ebf5ff",
    fillOpacity: 0.102
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M34 23v-1h1v1z",
    fill: "#6c6d71",
    fillOpacity: 0.914
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M35 22h1v1h-1z",
    fill: "#262a30"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v-1h1v1z",
    fill: "#939fb8"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M38 23h-1v-1h1z",
    fill: "#98a3c0"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#a4afc8"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#a6b1cc"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#9aa5c2"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#919ca9"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#8d99a7"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#818ca1"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#7d88a1"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#7a84a0"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#76809e"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#5e688a"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#5d6889"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#5c6788"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#5b6685"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#5a6583"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#383f4f"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#9ba2a8",
    fillOpacity: 0.604
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M34 24h-1v-1h1z",
    fill: "#eaf4f4",
    fillOpacity: 0.098
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24h-1v-1h1z",
    fill: "#6c6d72",
    fillOpacity: 0.91
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M36 23v1h-1v-1z",
    fill: "#272b31"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M36 24v-1h1v1z",
    fill: "#939eb8"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24h-1v-1h1z",
    fill: "#97a2be"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v-1h1v1z",
    fill: "#97a3bf"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#a4b0c9"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#a5b1ca"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#a0acc6"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#8791ac"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#939dad"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#98a2ae"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#949faa"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#919ba8"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#8791a2"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#828ea2"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#6f7a98"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#6a7695"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#687294"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#656f91"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#646e8f"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#616c8d"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#606b8b"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#5e6a89"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#5e6988"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#5d6885"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#5c6784"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#606a87"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#3a4150"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#a0a5ab",
    fillOpacity: 0.612
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M34 25v-1h1v1z",
    fill: "#6d6d72",
    fillOpacity: 0.906
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h-1v-1h1z",
    fill: "#282a31"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25h-1v-1h1z",
    fill: "#939eb7"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M38 24v1h-1v-1z",
    fill: "#98a3bc"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v-1h1v1z",
    fill: "#98a2bd"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M40 24v1h-1v-1z",
    fill: "#98a2bf"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#9da9c6"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#9eaac6"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1z",
    fill: "#9eaac4"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#a0abc3"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#a1adc3"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#a1acc3"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#a2acc3"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#a4aec6"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#a5b0c9"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#a3b0c7"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#949ebb"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#8892a5"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#979fae"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#8994a4"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#7c87a0"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#737d9b"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#707a98"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#6e7897"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#677192"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#657091"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#626d90"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#626d8d"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#636d8c"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#626c8a"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#606a88"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#606a86"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#5f6986"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#626d89"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#3b424f"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#343437"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#9fa3ac",
    fillOpacity: 0.702
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M35 25v1h-1v-1z",
    fill: "#6d6c70",
    fillOpacity: 0.898
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25v1h-1v-1z",
    fill: "#282a32"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M36 25h1v1h-1z",
    fill: "#929db9"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M38 25v1h-1v-1z",
    fill: "#95a3bf"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26h-1v-1h1z",
    fill: "#95a2be"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M39 25h1v1h-1z",
    fill: "#96a2bf"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#99a4c1"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#9aa4c1"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#9ca3b7"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#9ca3b2"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#9da2a8"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M47 26h-1v-1h1z",
    fill: "#9da2a3"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#9da29d"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#9da29a"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#9fa494"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#a2a693"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1z",
    fill: "#a3a692"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#a6a894"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#a7a997"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#a9ab97"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#abad98"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#aaaf9a"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#a9b0a2"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#a9afab"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#a9afb2"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#a9aeb9"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#a8afbe"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#a7afc3"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#a7b1ca"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#8794b3"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#7d89a4"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#8c94ab"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#939aaa"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#9097a8"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#8b93a4"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#8790a2"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#78829c"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#757e9a"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#727b98"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#6e7996"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#6b7695"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#677292"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#647192"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#646f90"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#626e8c"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#636d8a"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#646c89"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#626b88"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#626b87"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#616a87"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#646f89"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#3b434d"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#353438"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#a1a4af",
    fillOpacity: 0.784
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h-1v-1h1z",
    fill: "#6a6c6d",
    fillOpacity: 0.898
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27v-1h1v1z",
    fill: "#262a2f"
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M36 27v-1h1v1z",
    fill: "#929dba"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M38 26v1h-1v-1z",
    fill: "#95a2bd"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M39 26v1h-1v-1z",
    fill: "#939eb3"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#8f969e"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#8e9492"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#8e948a"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#919481"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1z",
    fill: "#96967c"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#9b9879"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#a09c77"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#a3a076"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#a7a375"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#aaa575"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#aba776"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#b0aa79"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#b2ac7a"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#b3b07a"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#b6b279"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#b8b379"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#b8b47b"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#b7b679"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#b8b67b"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#b8b781"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#b7b685"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#b6b587"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#b4b58c"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#b1b49b"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#afb4aa"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#adb4b5"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#9fa7b3"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#8b90a6"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#8189a2"
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#8792a6"
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#8f9aa4"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#8b96a3"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#818d9f"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#7e899d"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#7a849c"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#768099"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#6c7794"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#697391"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#66728f"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#65708d"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#646e8b"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#646e8a"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#69738a"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#4b525a"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#343336"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#a6abb5",
    fillOpacity: 0.765
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27h1v1h-1z",
    fill: "#e8e8f3",
    fillOpacity: 0.09
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v-1h1v1z",
    fill: "#68696e",
    fillOpacity: 0.902
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M35 27h1v1h-1z",
    fill: "#262728"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v-1h1v1z",
    fill: "#898e9a"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M37 28v-1h1v1z",
    fill: "#898c90"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M38 27h1v1h-1z",
    fill: "#868984"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27v1h-1v-1z",
    fill: "#89897c"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M40 27h1v1h-1z",
    fill: "#8c8c78"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#919174"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#979675"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#9d9a75"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#a29f76"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#a6a375"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#a9a675"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#aca974"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#b0ac75"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#b2af74"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#b4b075"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#b7b276"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#bab579"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#bcb979"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#c0bb78"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#c3bd78"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#c2bd78"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#c4bd7b"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1z",
    fill: "#c6bd7c"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#c5be7b"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#c5bf79"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#c5be7a"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#c5bd7c"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#c4bd7e"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#c1bc7e"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#c0bb84"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#beba8f"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#b9b99c"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#a5aaa0"
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#8c949c"
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#7f869d"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#7f88a1"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#8390a4"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#8593a3"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#7f8a9d"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#7b8699"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#737e94"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1z",
    fill: "#6f7993"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#69738e"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h-1v-1h1z",
    fill: "#676f8a"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#636c86"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1z",
    fill: "#6e778c"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#575d63"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M92 28v-1h1v1z",
    fill: "#333233"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#a6acb4",
    fillOpacity: 0.788
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28v1h-1v-1z",
    fill: "#e8e8ff",
    fillOpacity: 0.09
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M34 28h1v1h-1z",
    fill: "#696972",
    fillOpacity: 0.902
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M36 28v1h-1v-1z",
    fill: "#242322"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v-1h1v1z",
    fill: "#818279"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M38 28v1h-1v-1z",
    fill: "#898a77"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M38 29v-1h1v1z",
    fill: "#8e8e76"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M39 28h1v1h-1z",
    fill: "#959475"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28v1h-1v-1z",
    fill: "#999774"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#9f9b77"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#a4a076"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#a6a372"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#aba771"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#adaa72"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#afac73"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#b3af76"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#b6b177"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#b7b377"
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#bab678"
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#bcb779"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#bfba7b"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#c0bb7c"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#c3bc7b"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#c7bf79"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#c8c179"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#c8c279"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#cac379"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#cac47b"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#cac37d"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#c9c17a"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#c7c175"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#c6c176"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#c5c07f"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#c1c089"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#b2b591"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#9a9d95"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#848995"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#788097"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#7e899a"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#7b8697"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#778298"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#717c94"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h1v1h-1z",
    fill: "#6f7990"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#6d768f"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1z",
    fill: "#6b738d"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#69708a"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#677089"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#666f87"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#656e86"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#636c84"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#6d778b"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#555c60"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#323333"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29v-1h1v1z",
    fill: "#a8adb4",
    fillOpacity: 0.796
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M36 29v1h-1v-1z",
    fill: "#262725"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M37 29v1h-1v-1z",
    fill: "#8d8c75"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30h-1v-1h1z",
    fill: "#969777"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30h-1v-1h1z",
    fill: "#999976"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M39 30v-1h1v1z",
    fill: "#9f9c75"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30v-1h1v1z",
    fill: "#a29f75"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#a6a376"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#aaa777"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#aca874"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#b1ac75"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#b4ae78"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#b6b07a"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1z",
    fill: "#b8b37c"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#b9b47c"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#bab67b"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#bcb97c"
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#bebb7c"
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29h1v1h-1z",
    fill: "#bfbb7c"
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#c1bc7d"
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#c4be7d"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#c6c07c"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#c8c07d"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#c7c17c"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#c8c47b"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#cbc57c"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#ccc77b"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#cdc77a"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#ccc679"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#cbc47b"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#cac37a"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#c9c47e"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#c8c584"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#c1bf8d"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#afae93"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#939896"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#7f879c"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#737f99"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#717d98"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#737e97"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#707a93"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#6e7791"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#6a738e"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#666f89"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#656e88"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#616a85"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#6a738c"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#535a60"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#323435"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#a9abb1",
    fillOpacity: 0.804
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.024
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31h-1v-1h1z",
    fill: "#272822"
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31v-1h1v1z",
    fill: "#979777"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M38 30v1h-1v-1z",
    fill: "#a0a177"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31h-1v-1h1z",
    fill: "#a1a176"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31h-1v-1h1z",
    fill: "#a5a479"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M40 30h1v1h-1z",
    fill: "#a8a67a"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#aba97a"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#aeac7b"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#b0ae7d"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#b2b07e"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#b5b17f"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#b7b381"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#b9b583"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#bbb784"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#bbb984"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#bcba85"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#bdbb85"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#bdbb84"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#bebc84"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#c1be84"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#c3bf82"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#c5c084"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#c6c182"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#c7c280"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#c9c47f"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#ccc67e"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#cec67b"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#cec77b"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#cdc77c"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#cec87d"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#cdc77f"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#cec681"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#cdc57c"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#cbc47a"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#cbc383"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#c7c18c"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#bbbc96"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1z",
    fill: "#aab0a5"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#979fb3"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#8994b1"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#76809c"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#707999"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#6c7595"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#687190"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#626b8a"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#616a89"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#5f6887"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#6a7390"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31v-1h1v1z",
    fill: "#545963"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#323336"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#aaacb2",
    fillOpacity: 0.812
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31h1v1h-1z",
    fill: "#6a6c71",
    fillOpacity: 0.898
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32v-1h1v1z",
    fill: "#292a21"
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M37 32h-1v-1h1z",
    fill: "#9e9f7b"
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M38 31v1h-1v-1z",
    fill: "#a8a77e"
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M39 31v1h-1v-1z",
    fill: "#a9a77f"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M40 31v1h-1v-1z",
    fill: "#aaa881"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32h-1v-1h1z",
    fill: "#aba982"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#afac83"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#b1af86"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#b2b188"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#b2b288"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#b4b387"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#b6b588"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#b8b68b"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#bab88d"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#bbb890"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#bab790"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#bab88f"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#bbb98f"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#bcba8f"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#bdbc8d"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#bfbd8b"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#c1be8d"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#c2bf8c"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#c3c08a"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#c5c289"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#c9c685"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#cbc684"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#cdc783"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#cfc782"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#cfc781"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#cec77f"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#cdc87e"
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#ccc97e"
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#cdc97e"
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#c8c57e"
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#c8c484"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#c7c38a"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#c2c198"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#b2b9ac"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#a7aeb9"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#a0aac3"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#96a1bd"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#939eb9"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#909bb7"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#929db8"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M91 32h-1v-1h1z",
    fill: "#9fa9c3"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#696f77"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#abafb5",
    fillOpacity: 0.827
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33v-1h1v1z",
    fill: "#696971",
    fillOpacity: 0.898
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M35 32h1v1h-1z",
    fill: "#292a23"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h-1v-1h1z",
    fill: "#a2a384"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M40 33h-1v-1h1z",
    fill: "#aeab8b"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M41 32v1h-1v-1z",
    fill: "#aeac8c"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#b1b090"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#b1b191"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#b2b393"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#b3b395"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#b4b497"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#b5b598"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#b6b598"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#b6b597"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#b6b696"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#b7b796"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#b8b997"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#b9b994"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#bcbb93"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#bdbc93"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#bdbd94"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#bfbe94"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#c0bf91"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32h1v1h-1z",
    fill: "#c2c18f"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#c5c38c"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#c7c48b"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#cac68a"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#cdc788"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#cfc887"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#d0c985"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#cfc983"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#cfc984"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#d0c982"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#d0c880"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#cec682"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#cbc582"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#cac486"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#c8c28b"
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#bfbc98"
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#afb4ab"
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#a3abbb"
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#9faac1"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#9eabc2"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#a1abc4"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#9faac3"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#9eaac2"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#9da9c1"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#a4afc5"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#6a7075"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#acafb6",
    fillOpacity: 0.839
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#f2f2ff",
    fillOpacity: 0.082
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#6a6b72",
    fillOpacity: 0.894
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#2a2b27"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#a3a490"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#adaa93"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#acab93"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#acac95"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#abad96"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#adaf9a"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#aeb09c"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#adaf9e"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M49 33v1h-1v-1z",
    fill: "#adb0a0"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#aeb19f"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#afb29e"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#b1b49d"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#b1b59c"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#b7b89c"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#b7b99b"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#b6b999"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M59 34h-1v-1h1z",
    fill: "#b7b999"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#b9ba98"
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#bbbc94"
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#bfbe93"
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#c2bf93"
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#c6c291"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#c9c58f"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#ccc78e"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#ccc88b"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#cdc88b"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#cfc98b"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#cdca88"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fill: "#ceca86"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#d0c987"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#d0c887"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#d1c885"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#cfc885"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#cdc785"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#ccc686"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#cdc588"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#c3c391"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#a9afb1"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1z",
    fill: "#9ca8c0"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#9ca7bf"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#9ba7be"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#9aa6bf"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#99a6bf"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#a1aec2"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#6b6f75"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#abadb7",
    fillOpacity: 0.839
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#6a6b72",
    fillOpacity: 0.89
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#2b2c2b"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#a3a597"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#a8ac9c"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#a7ac9c"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#a7ab9c"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#a8ac9d"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#a8ac9f"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#a7aca0"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#a6aba1"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#a5aba5"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#a6aca7"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#a8ada7"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#a9aea7"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#aaafa6"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#acb1a5"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#aeb1a4"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#b0b2a3"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#b0b3a2"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#b0b39f"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#b5b899"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#b9ba9b"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#bcbb9a"
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#bfbd98"
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#c2c097"
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#c6c395"
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#c8c694"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#cbc791"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#ceca8d"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#cec98b"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35v-1h1v1z",
    fill: "#ceca8b"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#cdc98c"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#cfc989"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#cec88a"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#ccc78a"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#c9c686"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#c5c488"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#c2c197"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#b2b5a9"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#a1a9b7"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#9aa6bb"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#9aa5bc"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#a0adc2"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#303136"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#abafb7",
    fillOpacity: 0.839
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#f2f2f2",
    fillOpacity: 0.078
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#6c6c73",
    fillOpacity: 0.886
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#2a2c2e"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#a0a59d"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#a1aba0"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#a0aa9f"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#a1a89f"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#a2a8a0"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#a1a9a4"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#9da6a7"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#9ea6a8"
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#9fa6a8"
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#a1a8aa"
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#a1a9a8"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#a1aaa7"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#a2aba6"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#a3aca6"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#a6aca6"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#a8aea4"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#acb0a0"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#aeb3a0"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#b1b5a0"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#b5b89f"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#b7b99c"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#bbbc9a"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#bdbf9a"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#c2c39a"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#c6c698"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#cdc992"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36h-1v-1h1z",
    fill: "#ccc991"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#c9c891"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#cac892"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#ccca90"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#cdca8d"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#ceca8c"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#ccc58c"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#c7c48c"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1z",
    fill: "#c5c292"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#bbbe9f"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#9ca5bc"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#9ba4bf"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#9aa4be"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#98a4bc"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#9facc0"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#adb0b8",
    fillOpacity: 0.839
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#6c6c72",
    fillOpacity: 0.882
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#292b2e"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#9aa1a0"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#9ca6a5"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#9ba4a4"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#9ca4a5"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#9ca3a5"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#9ba4a6"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#9aa3a7"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#99a2a9"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#99a2aa"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#98a0ad"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#98a0ac"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#9aa1ad"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#9ba1ac"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#9ba3ac"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#9aa3ac"
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#9ba4ab"
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#9ba4a9"
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#9ca6a8"
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#9fa6a7"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#9ea6a6"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#a1a8a4"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#a3aaa2"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#a6ada3"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#a9afa4"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#b2b5a0"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#b4b89f"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#b9bc9f"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#bdbe9d"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#c4c39d"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#c9c69c"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#cbc799"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M72 36v1h-1v-1z",
    fill: "#cbc896"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#cac896"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#c9c897"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#cac997"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#cbca97"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#cdca96"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#cdca95"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#ceca93"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#cccb91"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#cdcb8d"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#cdc991"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#c9c890"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#c9c58e"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1z",
    fill: "#c7c390"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#c2c29b"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#acb3a5"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#9ca5b2"
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#98a4bf"
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#95a4bb"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#9eabbe"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#6a6d74"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#303137"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#adb0b9",
    fillOpacity: 0.839
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#6b6d72",
    fillOpacity: 0.882
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#2a2a29"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#989ca1"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#9aa2ab"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#97a0a8"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#969fa8"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#96a0a9"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#959eac"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#959ead"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#969eae"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#969fae"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#979eac"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#979eab"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#979fa9"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#98a1a9"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#98a1a8"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#97a1a5"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#9ba4a5"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#a1a9a5"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#a5aca5"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#abb0a4"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#adb3a4"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#b0b5a2"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#b9bba0"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#bfbfa0"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#c4c39e"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M72 37v1h-1v-1z",
    fill: "#c7c79d"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#c8c79d"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#c7c69e"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#c6c79e"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#c9c89d"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#cac89c"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#cbc99a"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#cccb94"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#cdcb93"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#cbc892"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#c8c492"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#c7c492"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#c3c397"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#b3b9a7"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#9ba6b1"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#95a2bc"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#9eaabe"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#696d74"
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#313136"
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#acafb8",
    fillOpacity: 0.839
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#6b6c70",
    fillOpacity: 0.878
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#2a2a2c"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#9499a4"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#969dab"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#949bac"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#949baa"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#929aa6"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#919aa6"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#919aa5"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#949da5"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#979fa6"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#99a2a5"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#9da5a5"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#9fa6a5"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#a3a9a5"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#a5ada6"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#a8b1a6"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#b5b8a3"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#bbbda2"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#c2c3a0"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#c4c3a1"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#c6c6a2"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#c7c6a2"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#c9c8a1"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#cbca9d"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#cbca9a"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#cdcb94"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#cac993"
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#c9c793"
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#bdbda3"
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#a0a8af"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#9ca8bb"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#676d74"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#303231"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#aeb0b8",
    fillOpacity: 0.831
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#6a6b70",
    fillOpacity: 0.875
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#28292e"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#8c97a7"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#8d97a7"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#929ba6"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#969ea7"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#98a0a6"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#9ca3a7"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#a0a8a9"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#a1aaa9"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#a5aca8"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#a9afa8"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#acb2a7"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#aeb4a5"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40v-1h1v1z",
    fill: "#b4b8a5"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#bbbda4"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#c0c1a3"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#c1c3a3"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#c2c4a5"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#c8c8a2"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#c9caa0"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#caca9e"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#ccca9f"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#cdcb9a"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#cccb98"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#cbca96"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#c9c697"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#cbc397"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#c9c49c"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#bec19d"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#aab1ad"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#686b73"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#303135"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#adaeba",
    fillOpacity: 0.831
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#6b6b71",
    fillOpacity: 0.871
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#282a2f"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#8a93a3"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#8f97a9"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#8c95a5"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#8894a5"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#8893a4"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#959ea7"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#969fa6"
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#9aa1a7"
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#9da3a7"
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#a1a7a9"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#a3a9a9"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#a4aba8"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#a4aca6"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M71 40h1v1h-1z",
    fill: "#aaafa5"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#b3b6a5"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#bbbea4"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#bec1a2"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#bec1a4"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#c5c6a4"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#c7c8a3"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#c8c9a2"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#cbc9a3"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#cdc9a2"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#ccc89e"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#cbc89b"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#cbc899"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#c9c898"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M87 41v-1h1v1z",
    fill: "#c9c798"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#c9c598"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#c8c598"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#c5c8a7"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#71716d"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#323235"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#acadb8",
    fillOpacity: 0.831
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#6d6b72",
    fillOpacity: 0.871
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#8891a2"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#8c94a8"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#8d95a6"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#8e96a9"
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#8993a7"
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#8691a6"
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#8793a6"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#949da9"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#98a0a8"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#9aa1a9"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#9ca2a7"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#9ca2a6"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#abb0a6"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#b3b8a2"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#b9bca1"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#bcbea4"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#bfc0a6"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#c3c4a5"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#c7c7a5"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#c9c8a6"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#c9c9a7"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#c8c7a2"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#c9c79e"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#cbc89d"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#cbc89a"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#cac89a"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#c9c799"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#c8c599"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#cbcba4"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#787969"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#a7a8b1",
    fillOpacity: 0.784
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#6b6b70",
    fillOpacity: 0.871
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1z",
    fill: "#8a94a7"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#8a94a6"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#828ca4"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#8790a3"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#8e96a8"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#9099a9"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#939aa5"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#969da6"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#99a2a4"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43v-1h1v1z",
    fill: "#9ea5a4"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#adb2a3"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#b4b6a4"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#b7baa5"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#b9bba2"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#bcbfa2"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#bfc1a2"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#c2c3a4"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#c6c5a8"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#c4c5a2"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#c7c6a1"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#c8c7a0"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#cac79e"
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#c9c79c"
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#cbcca6"
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#787968"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#333535"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#a8a9b0",
    fillOpacity: 0.678
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#8994a8"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#8a96a8"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#8690a7"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#818aa5"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#818aa6"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#858fa5"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#8790a7"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#8993a8"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#8e96a4"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#929aa7"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#949ea4"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M71 43h1v1h-1z",
    fill: "#979fa3"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#9da3a5"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#aeb1a6"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#b1b5a4"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#b4b8a2"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#b6baa0"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#babea3"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#bdc0a6"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#c0c2a8"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#c0c1a7"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#bec0a4"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#c1c2a4"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#c3c3a3"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#c5c4a3"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#c7c5a1"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#c8c6a0"
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#c9c79f"
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#c8c69e"
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#cccca5"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#757664"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#333635"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#a7a8b1",
    fillOpacity: 0.682
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#6c6e6f",
    fillOpacity: 0.863
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#282a30"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#848da5"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#8893ab"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#8994a6"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#8792aa"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#7f89a6"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#8791a9"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#8c97a4"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M71 44v1h-1v-1z",
    fill: "#8e99a3"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M72 45v-1h1v1z",
    fill: "#989fa6"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#9ea6a3"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#afb3a1"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#b9bca6"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#bbbea6"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1z",
    fill: "#b9bca3"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#b9bba3"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#bbbda3"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#bdbea3"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#c1c1a3"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#c4c3a3"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#c5c4a2"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#cdcea4"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#8089a6"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#8792a3"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#8a95a5"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#98a1a3"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#a5aba3"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#aaafa2"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#b3b7a2"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#babda4"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#bdbea4"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#bfc1a4"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#c2c3a3"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#c6c4a0"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#cdcea6"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#a6a6b0",
    fillOpacity: 0.678
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#8690aa"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#8691a9"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#8691a2"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M73 46v1h-1v-1z",
    fill: "#8e97a2"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#949da3"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#9ba4a1"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#a5aaa3"
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#a8aca3"
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#abafa3"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#aeb3a2"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#b2b5a2"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#b6b9a4"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#b8bba1"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#babda0"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#bdc0a2"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#c3c3a1"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#c5c4a0"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#cdcea7"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#a7a7b0",
    fillOpacity: 0.686
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#6a6b6f",
    fillOpacity: 0.863
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#7c86a5"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#808ba2"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#9099a3"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#96a0a2"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#9ba3a3"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#9fa5a4"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#a3a8a4"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#a5aaa4"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#a8aea3"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#acb0a4"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#b0b5a4"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#b3b7a0"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#b7bba0"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#babda2"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#bcbfa1"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#c0c1a1"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#c4c4a2"
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#cccda7"
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#a6a6b0",
    fillOpacity: 0.686
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#808aa1"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#7d86a5"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#7782a3"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#7581a2"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#7e89a3"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#818ba2"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#828da1"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M73 48v1h-1v-1z",
    fill: "#8992a4"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#8c96a4"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#919ba4"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#959ea4"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#9aa1a2"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#9da4a3"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#9fa6a4"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#a2a9a2"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#b1b6a2"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#b8bba2"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#bbbca1"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#c1c0a3"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#cccca7"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#6b6b71",
    fillOpacity: 0.863
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#7f88a0"
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#818ca7"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#7c85a5"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#7b85a3"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#757fa2"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#757fa3"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#7282a0"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#747e9c"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#767e9b"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#74829e"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#7483a3"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#7982a3"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#77859f"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#7b86a0"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#7f86a3"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#8088a4"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#8993a2"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#97a1a2"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#9da5a2"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#a1a7a2"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#a1a7a3"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#a1a7a1"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#a4aaa3"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#acb0a3"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#b0b4a1"
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#b3b6a2"
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#b7b9a1"
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#bdbda1"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#cacba6"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#333435"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#a4a6b0",
    fillOpacity: 0.765
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#6a6b70",
    fillOpacity: 0.863
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#7e889e"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#808ba5"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M45 51v-1h1v1z",
    fill: "#7e87a3"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#717fa1"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#767f99"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#999587"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#b1a976"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#a49e7b"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#828598"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#7680a4"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#79839f"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M67 51v-1h1v1z",
    fill: "#7d84a0"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50h1v1h-1z",
    fill: "#8088a1"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M71 51h-1v-1h1z",
    fill: "#808ba0"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M72 50h1v1h-1z",
    fill: "#838fa1"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#8691a1"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#8b95a2"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#8f98a3"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#939ca2"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#949ea1"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#9aa3a2"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#9da4a2"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50h1v1h-1z",
    fill: "#9ea4a2"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#9ca3a2"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#a0a6a5"
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#a3a8a5"
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#abb0a1"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#b3b6a0"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#b8ba9f"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#c8caa6"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#a5a8b2",
    fillOpacity: 0.82
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#6b6e70",
    fillOpacity: 0.863
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#838da1"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M49 52h-1v-1h1z",
    fill: "#7b84a3"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#9a9484"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#d6be5b"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#e2c245"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#dec053"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#aca37c"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fill: "#757f99"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51v1h-1v-1z",
    fill: "#959fb7"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M65 51h1v1h-1z",
    fill: "#a4acc1"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M67 52h-1v-1h1z",
    fill: "#9099ab"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M68 51v1h-1v-1z",
    fill: "#a6adc0"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M68 52v-1h1v1z",
    fill: "#9ba5b3"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M69 51h1v1h-1z",
    fill: "#a6b2c0"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#858fa1"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#9199a1"
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#949ea3"
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#99a1a4"
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#9da4a4"
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#a0a7a3"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#a4aaa1"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#afb2a1"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#b5b9a1"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#c6c8a7"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#757865"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#aaadb6",
    fillOpacity: 0.784
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#6c6d6f",
    fillOpacity: 0.859
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#26292d"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#848ea1"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#8691aa"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52v1h-1v-1z",
    fill: "#828ba7"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52h1v1h-1z",
    fill: "#7c84a4"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M51 52h1v1h-1z",
    fill: "#7782a1"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h1v1h-1z",
    fill: "#757f98"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52h1v1h-1z",
    fill: "#b2a674"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v1h-1v-1z",
    fill: "#e5c34c"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M61 53h-1v-1h1z",
    fill: "#e4bf47"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M61 52h1v1h-1z",
    fill: "#e7c149"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M63 53h-1v-1h1z",
    fill: "#c3b26b"
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M63 52h1v1h-1z",
    fill: "#7c8095"
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M65 52v1h-1v-1z",
    fill: "#7e89a2"
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M66 53h-1v-1h1z",
    fill: "#a9b3c1"
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M66 52h1v1h-1z",
    fill: "#9098a5"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v-1h1v1z",
    fill: "#9fa6b7"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M69 52v1h-1v-1z",
    fill: "#939cad"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M70 52v1h-1v-1z",
    fill: "#909bae"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#838da3"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#8b93a2"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#8e97a1"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#969ea2"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#969ea0"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#9ca5a1"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#a0a6a2"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#a3a9a2"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#a8ad9f"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#c3c7a7"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#747766"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#a7abb4",
    fillOpacity: 0.792
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#6a6b6e",
    fillOpacity: 0.867
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#8891a8"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#878fa7"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#868ea8"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#868da7"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54h-1v-1h1z",
    fill: "#717e9a"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M58 53h1v1h-1z",
    fill: "#a1997f"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M59 53h1v1h-1z",
    fill: "#dec057"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M60 53h1v1h-1z",
    fill: "#e6c444"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M62 53v1h-1v-1z",
    fill: "#e2c350"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M62 54v-1h1v1z",
    fill: "#b1a876"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M64 53v1h-1v-1z",
    fill: "#787f97"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54h-1v-1h1z",
    fill: "#8e96b0"
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M65 53h1v1h-1z",
    fill: "#9fa9b8"
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53v1h-1v-1z",
    fill: "#9098a9"
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M67 53h1v1h-1z",
    fill: "#98a0b5"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M69 53v1h-1v-1z",
    fill: "#868fa8"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M71 54h-1v-1h1z",
    fill: "#7d86a2"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#828ba4"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#868fa1"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#8b93a1"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#919aa2"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#939ca3"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#959da4"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#969da4"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#91999e"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#8f979d"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#929a9f"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#969ea1"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#99a1a1"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#9da5a3"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#a5aaa2"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#afb1a3"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#c0c3a9"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#737664"
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#a8abb4",
    fillOpacity: 0.8
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#6c6e71",
    fillOpacity: 0.863
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#26292f"
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#818ba0"
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#868fa7"
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#868ea6"
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#858ca6"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#848ba6"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M53 54v1h-1v-1z",
    fill: "#737f9f"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M56 54v1h-1v-1z",
    fill: "#737ea0"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M58 54v1h-1v-1z",
    fill: "#6f7da0"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55v-1h1v1z",
    fill: "#7c8192"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54v1h-1v-1z",
    fill: "#a69f7b"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54h1v1h-1z",
    fill: "#beb46b"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55h-1v-1h1z",
    fill: "#b2a774"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M63 54v1h-1v-1z",
    fill: "#85878c"
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M65 54v1h-1v-1z",
    fill: "#868fa9"
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M66 55h-1v-1h1z",
    fill: "#8e9ab2"
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M70 55h-1v-1h1z",
    fill: "#7781a1"
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#8992a1"
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#8d96a1"
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#8f98a1"
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#919ba3"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#949ca5"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#949ba4"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#90979e"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#8e959d"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#90979f"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#9299a0"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#949da1"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#97a2a2"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#9fa7a0"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#aab0a2"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#bdc0a9"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#727564"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#a8abb1",
    fillOpacity: 0.8
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M45 56v-1h1v1z",
    fill: "#7b86a4"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M48 55h1v1h-1z",
    fill: "#7883a0"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M57 56v-1h1v1z",
    fill: "#717b9f"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M60 56h-1v-1h1z",
    fill: "#727e94"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M61 55v1h-1v-1z",
    fill: "#797f94"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M62 55v1h-1v-1z",
    fill: "#767b95"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M63 55v1h-1v-1z",
    fill: "#71799d"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M65 55h1v1h-1z",
    fill: "#6d799b"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M68 55h1v1h-1z",
    fill: "#7381a1"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#838da2"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#8690a0"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#8a93a0"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#8c95a1"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#8d97a1"
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#929ba5"
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#939ba5"
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#8c939c"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#8d949d"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#919aa3"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#939ea2"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#99a49f"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#a5ad9f"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#b9bdaa"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#707265"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#313236"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#a7a9b0",
    fillOpacity: 0.792
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M56 57v-1h1v1z",
    fill: "#6f789d"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M58 56v1h-1v-1z",
    fill: "#6f799e"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M61 57v-1h1v1z",
    fill: "#949fb2"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M63 57h-1v-1h1z",
    fill: "#8d96ac"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M63 56h1v1h-1z",
    fill: "#919cb1"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M65 56v1h-1v-1z",
    fill: "#8e9ab0"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v-1h1v1z",
    fill: "#8590aa"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M68 56h1v1h-1z",
    fill: "#74809f"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#818ca4"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#8590a1"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#8b95a3"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#8e949f"
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#8a909b"
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#8a919c"
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#8d949f"
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#9097a0"
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#96a09f"
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#a2aaa2"
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#b7bbac"
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#6c6f65"
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#323237"
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#a9a9b1",
    fillOpacity: 0.784
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#6b6c6f",
    fillOpacity: 0.867
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#7d869e"
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M41 57h1v1h-1z",
    fill: "#7c86a2"
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h-1v-1h1z",
    fill: "#6e799b"
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M58 58h-1v-1h1z",
    fill: "#6d7a9a"
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M58 57h1v1h-1z",
    fill: "#6e799d"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M59 58v-1h1v1z",
    fill: "#6f78a1"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v-1h1v1z",
    fill: "#8c97ac"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M65 57v1h-1v-1z",
    fill: "#919cb2"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57v1h-1v-1z",
    fill: "#8e96ad"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58h-1v-1h1z",
    fill: "#8790ad"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#919ba6"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#8c949f"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#868e9b"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#8c949d"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h-1v-1h1z",
    fill: "#8f979f"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#949ba0"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#b4b8af"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#6a6c66"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#2f3235"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#a8a9af",
    fillOpacity: 0.784
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#696a6d",
    fillOpacity: 0.867
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#7b849d"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58v1h-1v-1z",
    fill: "#77839f"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M53 58h1v1h-1z",
    fill: "#6f789c"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M57 58h1v1h-1z",
    fill: "#6c799a"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59h-1v-1h1z",
    fill: "#6d799d"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M63 58v1h-1v-1z",
    fill: "#7e86a1"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58v1h-1v-1z",
    fill: "#7a819e"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M65 59h-1v-1h1z",
    fill: "#7c82a0"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M65 58h1v1h-1z",
    fill: "#79809e"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M67 58v1h-1v-1z",
    fill: "#717a98"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M69 59v-1h1v1z",
    fill: "#737fa0"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#8892a2"
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#8f99a4"
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#8b95a0"
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#848d9d"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#86909d"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#89929c"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#8c949e"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#91989f"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#b0b5af"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#676a67"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#303234"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#a3a4aa",
    fillOpacity: 0.753
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h1v1h-1z",
    fill: "#78819b"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M40 59h1v1h-1z",
    fill: "#78819f"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M41 59h1v1h-1z",
    fill: "#7881a0"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M42 60v-1h1v1z",
    fill: "#77819f"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M52 59h1v1h-1z",
    fill: "#6d779b"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M54 60v-1h1v1z",
    fill: "#6c779c"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M55 59h1v1h-1z",
    fill: "#6b769d"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60v-1h1v1z",
    fill: "#6a769a"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59v1h-1v-1z",
    fill: "#6b779c"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M58 59h1v1h-1z",
    fill: "#6b779d"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M60 60h-1v-1h1z",
    fill: "#6c789c"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M61 59v1h-1v-1z",
    fill: "#6b7697"
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M63 60h-1v-1h1z",
    fill: "#a7afc0"
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M64 59v1h-1v-1z",
    fill: "#a4acbd"
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v-1h1v1z",
    fill: "#a2a9ba"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M65 60v-1h1v1z",
    fill: "#a6adc3"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60h-1v-1h1z",
    fill: "#737fa1"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#8c95a3"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#8e98a3"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#8b95a1"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#828b9b"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#88909c"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#8f97a0"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#98a0a3"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#adb3b0"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#656a68"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#333537"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#a0a0a5",
    fillOpacity: 0.561
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M36 60h1v1h-1z",
    fill: "#757e98"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M46 61h-1v-1h1z",
    fill: "#75809d"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M48 60h1v1h-1z",
    fill: "#707b9d"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M49 60h1v1h-1z",
    fill: "#70799d"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M55 60v1h-1v-1z",
    fill: "#6a769c"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M55 61v-1h1v1z",
    fill: "#6a769e"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M56 60h1v1h-1z",
    fill: "#69759d"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M58 61h-1v-1h1z",
    fill: "#68769b"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M64 60v1h-1v-1z",
    fill: "#717b9b"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M64 61v-1h1v1z",
    fill: "#727a9a"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M66 61h-1v-1h1z",
    fill: "#7b83a1"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M68 60h1v1h-1z",
    fill: "#717c9e"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M70 60v1h-1v-1z",
    fill: "#727e9e"
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#8892a4"
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#8c96a3"
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#909aa5"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#818a9a"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#878e9d"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#8c93a1"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#959ca7"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#9fa7ab"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#afb5b5"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#656969"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#9f9fa2",
    fillOpacity: 0.553
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62h-1v-1h1z",
    fill: "#25262f"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M36 61h1v1h-1z",
    fill: "#737c98"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M44 61h1v1h-1z",
    fill: "#737f9d"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M47 61h1v1h-1z",
    fill: "#6f7a9c"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M52 62h-1v-1h1z",
    fill: "#6a759a"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M56 62v-1h1v1z",
    fill: "#68749d"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M61 62v-1h1v1z",
    fill: "#68759b"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v-1h1v1z",
    fill: "#69769c"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M63 61h1v1h-1z",
    fill: "#6b789c"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62v-1h1v1z",
    fill: "#707a9a"
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#8d95a5"
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#8f97a5"
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#929ba7"
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#8891a1"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#939aa8"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#9ca4b0"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#a2a9b3"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#a5acb2"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#aeb3b7"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#65686a"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#9d9da1",
    fillOpacity: 0.565
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v-1h1v1z",
    fill: "#697699"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62v1h-1v-1z",
    fill: "#69749c"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M63 63v-1h1v1z",
    fill: "#6a769b"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M66 62h1v1h-1z",
    fill: "#6f799a"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M78 63h-1v-1h1z",
    fill: "#8c96a7"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62h1v1h-1z",
    fill: "#8e96a7"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#9098a7"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#939cac"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#9aa4b0"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#9fa8b3"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#a1a9b3"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#a3abb4"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#a4abb3"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#adb1b7"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#64676a"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#9d9da0",
    fillOpacity: 0.553
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M35 64v-1h1v1z",
    fill: "#24262f"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64v-1h1v1z",
    fill: "#717c9a"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M50 63v1h-1v-1z",
    fill: "#687499"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M51 63v1h-1v-1z",
    fill: "#68749a"
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M64 64h-1v-1h1z",
    fill: "#67749a"
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M70 63h1v1h-1z",
    fill: "#75819f"
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63v1h-1v-1z",
    fill: "#848da0"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#98a1b0"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#9da7b1"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#a0a9b2"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#a1abb3"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#a3acb4"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#acb1b9"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#62666b"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#323538"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#9d9da1",
    fillOpacity: 0.533
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v-1h1v1z",
    fill: "#707c9c"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M38 64h1v1h-1z",
    fill: "#707c9b"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M44 65v-1h1v1z",
    fill: "#6d7798"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M45 64h1v1h-1z",
    fill: "#6a7698"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M46 64h1v1h-1z",
    fill: "#697598"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64v1h-1v-1z",
    fill: "#687498"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M48 64h1v1h-1z",
    fill: "#677498"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M50 65h-1v-1h1z",
    fill: "#67729a"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M65 64v1h-1v-1z",
    fill: "#69749b"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M81 64v1h-1v-1z",
    fill: "#868fa6"
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M82 64v1h-1v-1z",
    fill: "#8089a2"
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h1v1h-1z",
    fill: "#96a2ae"
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M86 65v-1h1v1z",
    fill: "#9ba6af"
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M87 65v-1h1v1z",
    fill: "#9ea8b1"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h-1v-1h1z",
    fill: "#a0aab2"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65v-1h1v1z",
    fill: "#a2abb4"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M90 64h1v1h-1z",
    fill: "#a9b1b9"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M91 65v-1h1v1z",
    fill: "#60666b"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M92 65v-1h1v1z",
    fill: "#323639"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64v1h-1v-1z",
    fill: "#9b9b9f",
    fillOpacity: 0.514
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65v1h-1v-1z",
    fill: "#6d7693"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M37 65h1v1h-1z",
    fill: "#6f7b9b"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M45 66v-1h1v1z",
    fill: "#687597"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M47 66h-1v-1h1z",
    fill: "#677397"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M48 65h1v1h-1z",
    fill: "#657198"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M66 65v1h-1v-1z",
    fill: "#69759a"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M67 65h1v1h-1z",
    fill: "#6e799c"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M69 65v1h-1v-1z",
    fill: "#717a9c"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M78 66h-1v-1h1z",
    fill: "#8d98a9"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M81 65h1v1h-1z",
    fill: "#7e88a6"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M86 66v-1h1v1z",
    fill: "#96a2ad"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h-1v-1h1z",
    fill: "#9ea7b1"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M89 65h1v1h-1z",
    fill: "#a0a8b3"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M91 66h-1v-1h1z",
    fill: "#a6afb8"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h-1v-1h1z",
    fill: "#60666a"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65v1h-1v-1z",
    fill: "#323439"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M93 65h1v1h-1z",
    fill: "#9b9ba1",
    fillOpacity: 0.502
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M34 66h1v1h-1z",
    fill: "#6e6f71",
    fillOpacity: 0.871
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M35 66h1v1h-1z",
    fill: "#22242d"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M37 66v1h-1v-1z",
    fill: "#6b7491"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M42 66v1h-1v-1z",
    fill: "#6c7697"
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M48 67v-1h1v1z",
    fill: "#636f97"
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M62 67h-1v-1h1z",
    fill: "#636f9a"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M68 66v1h-1v-1z",
    fill: "#6c789b"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M75 67h-1v-1h1z",
    fill: "#828ba5"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v-1h1v1z",
    fill: "#77829a"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67h-1v-1h1z",
    fill: "#7881a2"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66v1h-1v-1z",
    fill: "#97a0ad"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M88 66h1v1h-1z",
    fill: "#9ca5af"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M89 66h1v1h-1z",
    fill: "#9ea6b1"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M91 67h-1v-1h1z",
    fill: "#a5adb5"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66v1h-1v-1z",
    fill: "#606569"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M92 66h1v1h-1z",
    fill: "#34353b"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M94 66v1h-1v-1z",
    fill: "#9b9ba1",
    fillOpacity: 0.494
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M36 67h1v1h-1z",
    fill: "#69728f"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M38 67v1h-1v-1z",
    fill: "#697495"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M40 68v-1h1v1z",
    fill: "#687394"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M46 67h1v1h-1z",
    fill: "#636f95"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M65 68v-1h1v1z",
    fill: "#68739b"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M66 67h1v1h-1z",
    fill: "#69759c"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M72 67v1h-1v-1z",
    fill: "#78829e"
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67v1h-1v-1z",
    fill: "#737c9a"
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M78 67h1v1h-1z",
    fill: "#70799b"
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68h-1v-1h1z",
    fill: "#737b9e"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M81 67v1h-1v-1z",
    fill: "#767f9f"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M87 67v1h-1v-1z",
    fill: "#858fa3"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M88 67h1v1h-1z",
    fill: "#97a0ab"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M90 67v1h-1v-1z",
    fill: "#9da6ae"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h-1v-1h1z",
    fill: "#a4acb5"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68v-1h1v1z",
    fill: "#5f6468"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M93 67v1h-1v-1z",
    fill: "#34363a"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M93 68v-1h1v1z",
    fill: "#9b9da1",
    fillOpacity: 0.49
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M37 69h-1v-1h1z",
    fill: "#67708e"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M38 68v1h-1v-1z",
    fill: "#677295"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M42 69v-1h1v1z",
    fill: "#666f93"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M62 68h1v1h-1z",
    fill: "#64709a"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M68 69h-1v-1h1z",
    fill: "#6b769b"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M80 68v1h-1v-1z",
    fill: "#717a9a"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M91 69h-1v-1h1z",
    fill: "#a2aab3"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M91 68h1v1h-1z",
    fill: "#5c6166"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M93 69h-1v-1h1z",
    fill: "#333539"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M94 69h-1v-1h1z",
    fill: "#989a9e",
    fillOpacity: 0.486
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70v-1h1v1z",
    fill: "#666e8d"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M43 69h1v1h-1z",
    fill: "#636c91"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M60 70v-1h1v1z",
    fill: "#616d96"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M71 70h-1v-1h1z",
    fill: "#757f9d"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M73 69h1v1h-1z",
    fill: "#848ea5"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M75 70v-1h1v1z",
    fill: "#8995a5"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M82 69v1h-1v-1z",
    fill: "#767e9e"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70h-1v-1h1z",
    fill: "#777f9d"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M83 69h1v1h-1z",
    fill: "#7a82a0"
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M85 69h1v1h-1z",
    fill: "#7e87a2"
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M88 69h1v1h-1z",
    fill: "#848ea3"
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M90 70v-1h1v1z",
    fill: "#9ba4b0"
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v-1h1v1z",
    fill: "#5a6065"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M92 70v-1h1v1z",
    fill: "#333538"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M93 70v-1h1v1z",
    fill: "#99979d",
    fillOpacity: 0.482
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M35 70v1h-1v-1z",
    fill: "#6d6e72",
    fillOpacity: 0.871
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M36 70h1v1h-1z",
    fill: "#636b8c"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M41 71h-1v-1h1z",
    fill: "#636d91"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M45 71h-1v-1h1z",
    fill: "#5e6b90"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M67 71h-1v-1h1z",
    fill: "#66739b"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70h1v1h-1z",
    fill: "#78849f"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M74 70v1h-1v-1z",
    fill: "#868fa4"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70v1h-1v-1z",
    fill: "#8994a5"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M76 70h1v1h-1z",
    fill: "#8692a2"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M83 70v1h-1v-1z",
    fill: "#7d87a1"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M85 70v1h-1v-1z",
    fill: "#7981a0"
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M87 71h-1v-1h1z",
    fill: "#7c85a1"
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M91 70v1h-1v-1z",
    fill: "#8e99a9"
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M91 71v-1h1v1z",
    fill: "#565c64"
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M93 71v-1h1v1z",
    fill: "#9997a2",
    fillOpacity: 0.475
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M37 71v1h-1v-1z",
    fill: "#626a8a"
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M44 72v-1h1v1z",
    fill: "#5f698f"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M53 71v1h-1v-1z",
    fill: "#5d6994"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M62 72h-1v-1h1z",
    fill: "#616d98"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72v-1h1v1z",
    fill: "#647097"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M66 72v-1h1v1z",
    fill: "#677399"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72h-1v-1h1z",
    fill: "#858ea3"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M79 72v-1h1v1z",
    fill: "#8692a1"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72v-1h1v1z",
    fill: "#8894a2"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M81 71h1v1h-1z",
    fill: "#8b97a6"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M82 71h1v1h-1z",
    fill: "#8b96a9"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72h-1v-1h1z",
    fill: "#8791a5"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M92 71v1h-1v-1z",
    fill: "#50565f"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M94 72h-1v-1h1z",
    fill: "#99969f",
    fillOpacity: 0.471
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M35 73h-1v-1h1z",
    fill: "#6f7074",
    fillOpacity: 0.871
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M36 72h1v1h-1z",
    fill: "#606888"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M37 72h1v1h-1z",
    fill: "#606b8e"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73v-1h1v1z",
    fill: "#606a8f"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M41 72h1v1h-1z",
    fill: "#5d698d"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M47 73v-1h1v1z",
    fill: "#5b668e"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M49 72v1h-1v-1z",
    fill: "#5c6790"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M52 73h-1v-1h1z",
    fill: "#5a678f"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M59 72h1v1h-1z",
    fill: "#5c6892"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M65 72h1v1h-1z",
    fill: "#637095"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M72 72v1h-1v-1z",
    fill: "#7b859e"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M72 73v-1h1v1z",
    fill: "#7d889e"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M74 72v1h-1v-1z",
    fill: "#838ba1"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M76 72v1h-1v-1z",
    fill: "#8891a3"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M77 73v-1h1v1z",
    fill: "#818aa0"
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M79 73v-1h1v1z",
    fill: "#868f9f"
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M80 72h1v1h-1z",
    fill: "#88929f"
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72v1h-1v-1z",
    fill: "#8992a6"
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M86 72h1v1h-1z",
    fill: "#818ca2"
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M88 73v-1h1v1z",
    fill: "#79849c"
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M91 72v1h-1v-1z",
    fill: "#828ba6"
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M92 72v1h-1v-1z",
    fill: "#4d525f"
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M93 72h1v1h-1z",
    fill: "#9997a2",
    fillOpacity: 0.463
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M36 73h1v1h-1z",
    fill: "#5e6686"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M38 73v1h-1v-1z",
    fill: "#5f6a8b"
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M39 73v1h-1v-1z",
    fill: "#5f698c"
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74v-1h1v1z",
    fill: "#5f688d"
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M40 73h1v1h-1z",
    fill: "#5c6587"
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M42 73v1h-1v-1z",
    fill: "#65728e"
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M44 74h-1v-1h1z",
    fill: "#78809b"
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M62 73v1h-1v-1z",
    fill: "#78839e"
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M64 73v1h-1v-1z",
    fill: "#79859f"
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M65 74h-1v-1h1z",
    fill: "#7a869f"
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M67 74h-1v-1h1z",
    fill: "#808ca4"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M68 74h-1v-1h1z",
    fill: "#828da5"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M69 73h1v1h-1z",
    fill: "#8993a9"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M70 73h1v1h-1z",
    fill: "#8a94a8"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v-1h1v1z",
    fill: "#8d96a8"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M75 73h1v1h-1z",
    fill: "#969faa"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h-1v-1h1z",
    fill: "#939ca9"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v-1h1v1z",
    fill: "#929aab"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M80 73v1h-1v-1z",
    fill: "#95a0a9"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M80 74v-1h1v1z",
    fill: "#97a1aa"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M82 73v1h-1v-1z",
    fill: "#9aa2ad"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M83 73v1h-1v-1z",
    fill: "#9ca4af"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M84 73v1h-1v-1z",
    fill: "#9ea5af"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74h-1v-1h1z",
    fill: "#9fa5af"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M85 74v-1h1v1z",
    fill: "#9aa3ae"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74v-1h1v1z",
    fill: "#848ea4"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74h-1v-1h1z",
    fill: "#8088a3"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74v-1h1v1z",
    fill: "#4b505e"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M94 74h-1v-1h1z",
    fill: "#9a98a3",
    fillOpacity: 0.459
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M35 74h1v1h-1z",
    fill: "#21252c"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75v-1h1v1z",
    fill: "#5c6786"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M38 75h-1v-1h1z",
    fill: "#5d688a"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M39 75h-1v-1h1z",
    fill: "#5d668b"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M39 74h1v1h-1z",
    fill: "#5b6387"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M41 74v1h-1v-1z",
    fill: "#8b93a7"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M42 74v1h-1v-1z",
    fill: "#cad4d3"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74v1h-1v-1z",
    fill: "#d9dfdd"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M43 74h1v1h-1z",
    fill: "#d4ddd7"
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M45 75h-1v-1h1z",
    fill: "#d3dbd7"
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M45 74h1v1h-1z",
    fill: "#d3dbdb"
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M46 74h1v1h-1z",
    fill: "#d2dada"
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M57 74h1v1h-1z",
    fill: "#d1d9d9"
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M71 74v1h-1v-1z",
    fill: "#d3dad8"
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M72 74v1h-1v-1z",
    fill: "#d2dbd8"
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75h-1v-1h1z",
    fill: "#d2dcd9"
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M73 75v-1h1v1z",
    fill: "#d3dcda"
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v-1h1v1z",
    fill: "#d5dcda"
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M75 75v-1h1v1z",
    fill: "#d3dcd7"
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74v1h-1v-1z",
    fill: "#d2dcd8"
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M77 74h1v1h-1z",
    fill: "#d2dcda"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M79 75v-1h1v1z",
    fill: "#d6dcd7"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M81 74v1h-1v-1z",
    fill: "#d4dddc"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M86 75h-1v-1h1z",
    fill: "#d5dbda"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M87 74v1h-1v-1z",
    fill: "#c3c9cf"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75h-1v-1h1z",
    fill: "#99a1a9"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M88 74h1v1h-1z",
    fill: "#8f99aa"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M89 75v-1h1v1z",
    fill: "#8a97a7"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75h-1v-1h1z",
    fill: "#4d525e"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M92 75v-1h1v1z",
    fill: "#36383a"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M94 75h-1v-1h1z",
    fill: "#9898a1",
    fillOpacity: 0.459
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M37 75h1v1h-1z",
    fill: "#5c678c"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M40 75v1h-1v-1z",
    fill: "#778098"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76v-1h1v1z",
    fill: "#d3dcde"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M41 76v-1h1v1z",
    fill: "#daccc3"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M43 76h-1v-1h1z",
    fill: "#c9a7a0"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M43 75h1v1h-1z",
    fill: "#d5d0c6"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M46 76h-1v-1h1z",
    fill: "#d7dcd9"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M47 76h-1v-1h1z",
    fill: "#d6dbd7"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M50 75v1h-1v-1z",
    fill: "#d4dbd4"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M51 75v1h-1v-1z",
    fill: "#d3dbd3"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M72 76h-1v-1h1z",
    fill: "#d5ddd6"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M73 76h-1v-1h1z",
    fill: "#d4ded7"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M74 75v1h-1v-1z",
    fill: "#d5ded6"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M75 76v-1h1v1z",
    fill: "#d6ded6"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M76 76v-1h1v1z",
    fill: "#d5ded7"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M78 75v1h-1v-1z",
    fill: "#cfdbda"
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M79 76h-1v-1h1z",
    fill: "#c4d3d9"
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76h-1v-1h1z",
    fill: "#dadcd9"
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h-1v-1h1z",
    fill: "#d8ded9"
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M83 75v1h-1v-1z",
    fill: "#d7dcd7"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76v-1h1v1z",
    fill: "#d1dddc"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M85 76h-1v-1h1z",
    fill: "#c7d4d4"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M86 76h-1v-1h1z",
    fill: "#d8dcd5"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M87 76h-1v-1h1z",
    fill: "#dce2dd"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M88 75v1h-1v-1z",
    fill: "#c1caca"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M91 76h-1v-1h1z",
    fill: "#97a0b0"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M91 75h1v1h-1z",
    fill: "#565b66"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M93 76v-1h1v1z",
    fill: "#9a9aa1",
    fillOpacity: 0.459
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M33 76h1v1h-1z",
    fill: "#f1ffff",
    fillOpacity: 0.075
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M35 76v1h-1v-1z",
    fill: "#6e6f74",
    fillOpacity: 0.886
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v-1h1v1z",
    fill: "#596384"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v-1h1v1z",
    fill: "#5b658b"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M39 77h-1v-1h1z",
    fill: "#566082"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M39 76h1v1h-1z",
    fill: "#9ba4b6"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M40 76h1v1h-1z",
    fill: "#dee2d7"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M41 77v-1h1v1z",
    fill: "#c9af91"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v-1h1v1z",
    fill: "#c1aba6"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M44 76v1h-1v-1z",
    fill: "#b4bcc8"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M45 76h1v1h-1z",
    fill: "#d7dbd8"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M46 77v-1h1v1z",
    fill: "#d5dad8"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M72 77v-1h1v1z",
    fill: "#d5dcd9"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M75 77v-1h1v1z",
    fill: "#d6dcd9"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76v1h-1v-1z",
    fill: "#d8ddd9"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M77 76h1v1h-1z",
    fill: "#c3cdd3"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h-1v-1h1z",
    fill: "#96a9c6"
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M80 76v1h-1v-1z",
    fill: "#d6dedb"
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M80 77v-1h1v1z",
    fill: "#d8ddd2"
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M81 76h1v1h-1z",
    fill: "#d7dcd8"
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M83 76h1v1h-1z",
    fill: "#bfc7d7"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v-1h1v1z",
    fill: "#a9b9cc"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M85 77v-1h1v1z",
    fill: "#ced5ca"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M86 77v-1h1v1z",
    fill: "#d9dfd3"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M88 77h-1v-1h1z",
    fill: "#d2dbd7"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M88 76h1v1h-1z",
    fill: "#98a0ab"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M92 76v1h-1v-1z",
    fill: "#585d66"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M94 77h-1v-1h1z",
    fill: "#9a9aa3",
    fillOpacity: 0.459
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78h-1v-1h1z",
    fill: "#6d6e73",
    fillOpacity: 0.886
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M36 77v1h-1v-1z",
    fill: "#20242c"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M37 77v1h-1v-1z",
    fill: "#576182"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M38 77v1h-1v-1z",
    fill: "#5a6388"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v-1h1v1z",
    fill: "#555f81"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M40 77v1h-1v-1z",
    fill: "#97a0b3"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M40 78v-1h1v1z",
    fill: "#dce2d4"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77v1h-1v-1z",
    fill: "#bec693"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M42 77h1v1h-1z",
    fill: "#a8c3b0"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M43 77h1v1h-1z",
    fill: "#8fa9bc"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M45 77v1h-1v-1z",
    fill: "#d0dadd"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v-1h1v1z",
    fill: "#d5dad5"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M47 77v1h-1v-1z",
    fill: "#d4dbd7"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M70 77h1v1h-1z",
    fill: "#d6dbd5"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M74 78v-1h1v1z",
    fill: "#d5dcd8"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M76 77v1h-1v-1z",
    fill: "#d6dcd8"
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M77 77h1v1h-1z",
    fill: "#c6cdc5"
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77v1h-1v-1z",
    fill: "#acb1b0"
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M79 77h1v1h-1z",
    fill: "#d4d8d2"
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77v1h-1v-1z",
    fill: "#d6ded8"
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M83 78h-1v-1h1z",
    fill: "#d7dcd6"
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M84 77v1h-1v-1z",
    fill: "#c7c7c7"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78v-1h1v1z",
    fill: "#b6bfc1"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78h-1v-1h1z",
    fill: "#ced3c7"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M86 78v-1h1v1z",
    fill: "#dadfd4"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M87 78v-1h1v1z",
    fill: "#d2dad7"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M90 78h-1v-1h1z",
    fill: "#8f98a5"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78v-1h1v1z",
    fill: "#575c64"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78v-1h1v1z",
    fill: "#a0a0a7",
    fillOpacity: 0.455
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M35 78v1h-1v-1z",
    fill: "#6f6f74",
    fillOpacity: 0.886
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M37 79h-1v-1h1z",
    fill: "#576180"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M38 78v1h-1v-1z",
    fill: "#596287"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M39 78h1v1h-1z",
    fill: "#717c92"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M40 79v-1h1v1z",
    fill: "#d2dbdb"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M41 78h1v1h-1z",
    fill: "#cbdbcb"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78v1h-1v-1z",
    fill: "#b3caae"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M43 78h1v1h-1z",
    fill: "#c7d4cc"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M45 78v1h-1v-1z",
    fill: "#d9dbdb"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M66 79v-1h1v1z",
    fill: "#d4dbd3"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M75 78h1v1h-1z",
    fill: "#d7ddd6"
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M78 78v1h-1v-1z",
    fill: "#d6dcd2"
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M79 79h-1v-1h1z",
    fill: "#d4d7ca"
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78v1h-1v-1z",
    fill: "#d9ddd5"
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M83 79v-1h1v1z",
    fill: "#d4d4cb"
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M84 78h1v1h-1z",
    fill: "#d7d7cc"
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M86 79h-1v-1h1z",
    fill: "#d7ddd2"
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M87 79h-1v-1h1z",
    fill: "#dce3da"
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M88 78h1v1h-1z",
    fill: "#8d95a1"
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M90 79v-1h1v1z",
    fill: "#949dac"
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M91 78h1v1h-1z",
    fill: "#565b63"
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h-1v-1h1z",
    fill: "#38393c"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M93 78h1v1h-1z",
    fill: "#a2a0ad",
    fillOpacity: 0.455
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M34 80v-1h1v1z",
    fill: "#707075",
    fillOpacity: 0.878
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M36 80v-1h1v1z",
    fill: "#555f7f"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M38 79h1v1h-1z",
    fill: "#555f88"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M39 79h1v1h-1z",
    fill: "#545d7e"
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79v1h-1v-1z",
    fill: "#828a9d"
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M41 79h1v1h-1z",
    fill: "#c4cdd4"
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M43 79v1h-1v-1z",
    fill: "#d4dcd7"
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M43 80v-1h1v1z",
    fill: "#d4d9d8"
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M45 79v1h-1v-1z",
    fill: "#d2d8d5"
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M47 80h-1v-1h1z",
    fill: "#d1d8d5"
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M49 79v1h-1v-1z",
    fill: "#d1d8d6"
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M49 80v-1h1v1z",
    fill: "#d1d9d5"
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M57 80h-1v-1h1z",
    fill: "#cfd8d3"
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M58 79v1h-1v-1z",
    fill: "#cfd8d4"
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80h-1v-1h1z",
    fill: "#cfd7d4"
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M63 79v1h-1v-1z",
    fill: "#cfd7d5"
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h-1v-1h1z",
    fill: "#d0d7d7"
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h-1v-1h1z",
    fill: "#d2d9d8"
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M73 79v1h-1v-1z",
    fill: "#d3dad6"
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M82 80v-1h1v1z",
    fill: "#d4dbd8"
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79v1h-1v-1z",
    fill: "#d7dad7"
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79h1v1h-1z",
    fill: "#d8dcd7"
  })), _path3361 || (_path3361 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h-1v-1h1z",
    fill: "#8a91a0"
  })), _path3362 || (_path3362 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80v-1h1v1z",
    fill: "#8d95a4"
  })), _path3363 || (_path3363 = /*#__PURE__*/React.createElement("path", {
    d: "M92 79v1h-1v-1z",
    fill: "#555a61"
  })), _path3364 || (_path3364 = /*#__PURE__*/React.createElement("path", {
    d: "M93 79h1v1h-1z",
    fill: "#a2a0ab",
    fillOpacity: 0.455
  })), _path3365 || (_path3365 = /*#__PURE__*/React.createElement("path", {
    d: "M34 81h-1v-1h1z",
    fill: "#fff0ff",
    fillOpacity: 0.071
  })), _path3366 || (_path3366 = /*#__PURE__*/React.createElement("path", {
    d: "M35 80v1h-1v-1z",
    fill: "#6f6f72",
    fillOpacity: 0.878
  })), _path3367 || (_path3367 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v-1h1v1z",
    fill: "#20232a"
  })), _path3368 || (_path3368 = /*#__PURE__*/React.createElement("path", {
    d: "M37 81h-1v-1h1z",
    fill: "#545e7e"
  })), _path3369 || (_path3369 = /*#__PURE__*/React.createElement("path", {
    d: "M38 80v1h-1v-1z",
    fill: "#555f84"
  })), _path3370 || (_path3370 = /*#__PURE__*/React.createElement("path", {
    d: "M38 81v-1h1v1z",
    fill: "#555e85"
  })), _path3371 || (_path3371 = /*#__PURE__*/React.createElement("path", {
    d: "M40 80v1h-1v-1z",
    fill: "#555e84"
  })), _path3372 || (_path3372 = /*#__PURE__*/React.createElement("path", {
    d: "M40 81v-1h1v1z",
    fill: "#515a7c"
  })), _path3373 || (_path3373 = /*#__PURE__*/React.createElement("path", {
    d: "M41 81v-1h1v1z",
    fill: "#5a6480"
  })), _path3374 || (_path3374 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81h-1v-1h1z",
    fill: "#6a728b"
  })), _path3375 || (_path3375 = /*#__PURE__*/React.createElement("path", {
    d: "M43 81v-1h1v1z",
    fill: "#6b738e"
  })), _path3376 || (_path3376 = /*#__PURE__*/React.createElement("path", {
    d: "M45 80v1h-1v-1z",
    fill: "#697390"
  })), _path3377 || (_path3377 = /*#__PURE__*/React.createElement("path", {
    d: "M45 81v-1h1v1z",
    fill: "#6a748e"
  })), _path3378 || (_path3378 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81h-1v-1h1z",
    fill: "#6b738f"
  })), _path3379 || (_path3379 = /*#__PURE__*/React.createElement("path", {
    d: "M50 81v-1h1v1z",
    fill: "#6b7490"
  })), _path3380 || (_path3380 = /*#__PURE__*/React.createElement("path", {
    d: "M52 81h-1v-1h1z",
    fill: "#6c7490"
  })), _path3381 || (_path3381 = /*#__PURE__*/React.createElement("path", {
    d: "M54 81h-1v-1h1z",
    fill: "#6c7590"
  })), _path3382 || (_path3382 = /*#__PURE__*/React.createElement("path", {
    d: "M54 80h1v1h-1z",
    fill: "#6b748f"
  })), _path3383 || (_path3383 = /*#__PURE__*/React.createElement("path", {
    d: "M56 81h-1v-1h1z",
    fill: "#6d7591"
  })), _path3384 || (_path3384 = /*#__PURE__*/React.createElement("path", {
    d: "M57 81v-1h1v1z",
    fill: "#6e7693"
  })), _path3385 || (_path3385 = /*#__PURE__*/React.createElement("path", {
    d: "M60 81h-1v-1h1z",
    fill: "#6e7692"
  })), _path3386 || (_path3386 = /*#__PURE__*/React.createElement("path", {
    d: "M62 80v1h-1v-1z",
    fill: "#707993"
  })), _path3387 || (_path3387 = /*#__PURE__*/React.createElement("path", {
    d: "M63 81h-1v-1h1z",
    fill: "#717a94"
  })), _path3388 || (_path3388 = /*#__PURE__*/React.createElement("path", {
    d: "M67 80v1h-1v-1z",
    fill: "#778096"
  })), _path3389 || (_path3389 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81v-1h1v1z",
    fill: "#798298"
  })), _path3390 || (_path3390 = /*#__PURE__*/React.createElement("path", {
    d: "M69 80h1v1h-1z",
    fill: "#7d869a"
  })), _path3391 || (_path3391 = /*#__PURE__*/React.createElement("path", {
    d: "M71 80h1v1h-1z",
    fill: "#828a9b"
  })), _path3392 || (_path3392 = /*#__PURE__*/React.createElement("path", {
    d: "M74 80v1h-1v-1z",
    fill: "#87909d"
  })), _path3393 || (_path3393 = /*#__PURE__*/React.createElement("path", {
    d: "M76 80v1h-1v-1z",
    fill: "#8b92a1"
  })), _path3394 || (_path3394 = /*#__PURE__*/React.createElement("path", {
    d: "M77 80h1v1h-1z",
    fill: "#878e9f"
  })), _path3395 || (_path3395 = /*#__PURE__*/React.createElement("path", {
    d: "M81 80v1h-1v-1z",
    fill: "#8d94a0"
  })), _path3396 || (_path3396 = /*#__PURE__*/React.createElement("path", {
    d: "M82 81h-1v-1h1z",
    fill: "#8f95a1"
  })), _path3397 || (_path3397 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81h-1v-1h1z",
    fill: "#8f97a3"
  })), _path3398 || (_path3398 = /*#__PURE__*/React.createElement("path", {
    d: "M83 81v-1h1v1z",
    fill: "#9198a5"
  })), _path3399 || (_path3399 = /*#__PURE__*/React.createElement("path", {
    d: "M84 80h1v1h-1z",
    fill: "#9299a5"
  })), _path3400 || (_path3400 = /*#__PURE__*/React.createElement("path", {
    d: "M86 80h1v1h-1z",
    fill: "#868e9c"
  })), _path3401 || (_path3401 = /*#__PURE__*/React.createElement("path", {
    d: "M88 80v1h-1v-1z",
    fill: "#8991a1"
  })), _path3402 || (_path3402 = /*#__PURE__*/React.createElement("path", {
    d: "M89 80h1v1h-1z",
    fill: "#8a92a2"
  })), _path3403 || (_path3403 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80v1h-1v-1z",
    fill: "#9199a8"
  })), _path3404 || (_path3404 = /*#__PURE__*/React.createElement("path", {
    d: "M91 80h1v1h-1z",
    fill: "#545960"
  })), _path3405 || (_path3405 = /*#__PURE__*/React.createElement("path", {
    d: "M94 81h-1v-1h1z",
    fill: "#a09ea9",
    fillOpacity: 0.455
  })), _path3406 || (_path3406 = /*#__PURE__*/React.createElement("path", {
    d: "M35 81v1h-1v-1z",
    fill: "#6f6f73",
    fillOpacity: 0.882
  })), _path3407 || (_path3407 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h-1v-1h1z",
    fill: "#545e7f"
  })), _path3408 || (_path3408 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82h-1v-1h1z",
    fill: "#545e81"
  })), _path3409 || (_path3409 = /*#__PURE__*/React.createElement("path", {
    d: "M39 82v-1h1v1z",
    fill: "#535d80"
  })), _path3410 || (_path3410 = /*#__PURE__*/React.createElement("path", {
    d: "M41 82v-1h1v1z",
    fill: "#535b83"
  })), _path3411 || (_path3411 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v-1h1v1z",
    fill: "#505a81"
  })), _path3412 || (_path3412 = /*#__PURE__*/React.createElement("path", {
    d: "M44 82v-1h1v1z",
    fill: "#525981"
  })), _path3413 || (_path3413 = /*#__PURE__*/React.createElement("path", {
    d: "M46 82v-1h1v1z",
    fill: "#4f5c82"
  })), _path3414 || (_path3414 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h-1v-1h1z",
    fill: "#4f5c83"
  })), _path3415 || (_path3415 = /*#__PURE__*/React.createElement("path", {
    d: "M48 81h1v1h-1z",
    fill: "#4f5d83"
  })), _path3416 || (_path3416 = /*#__PURE__*/React.createElement("path", {
    d: "M57 82h-1v-1h1z",
    fill: "#515e86"
  })), _path3417 || (_path3417 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81v1h-1v-1z",
    fill: "#525f87"
  })), _path3418 || (_path3418 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82v-1h1v1z",
    fill: "#546188"
  })), _path3419 || (_path3419 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h-1v-1h1z",
    fill: "#566289"
  })), _path3420 || (_path3420 = /*#__PURE__*/React.createElement("path", {
    d: "M63 82h-1v-1h1z",
    fill: "#59658c"
  })), _path3421 || (_path3421 = /*#__PURE__*/React.createElement("path", {
    d: "M64 82h-1v-1h1z",
    fill: "#59668d"
  })), _path3422 || (_path3422 = /*#__PURE__*/React.createElement("path", {
    d: "M65 81v1h-1v-1z",
    fill: "#5a678e"
  })), _path3423 || (_path3423 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81v1h-1v-1z",
    fill: "#5b688d"
  })), _path3424 || (_path3424 = /*#__PURE__*/React.createElement("path", {
    d: "M67 82h-1v-1h1z",
    fill: "#5e6b8e"
  })), _path3425 || (_path3425 = /*#__PURE__*/React.createElement("path", {
    d: "M67 81h1v1h-1z",
    fill: "#616e90"
  })), _path3426 || (_path3426 = /*#__PURE__*/React.createElement("path", {
    d: "M68 82v-1h1v1z",
    fill: "#647293"
  })), _path3427 || (_path3427 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82h-1v-1h1z",
    fill: "#677493"
  })), _path3428 || (_path3428 = /*#__PURE__*/React.createElement("path", {
    d: "M70 82v-1h1v1z",
    fill: "#6b7792"
  })), _path3429 || (_path3429 = /*#__PURE__*/React.createElement("path", {
    d: "M72 81v1h-1v-1z",
    fill: "#6e7995"
  })), _path3430 || (_path3430 = /*#__PURE__*/React.createElement("path", {
    d: "M75 81v1h-1v-1z",
    fill: "#768197"
  })), _path3431 || (_path3431 = /*#__PURE__*/React.createElement("path", {
    d: "M75 82v-1h1v1z",
    fill: "#79839a"
  })), _path3432 || (_path3432 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h-1v-1h1z",
    fill: "#778299"
  })), _path3433 || (_path3433 = /*#__PURE__*/React.createElement("path", {
    d: "M80 81v1h-1v-1z",
    fill: "#788597"
  })), _path3434 || (_path3434 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h-1v-1h1z",
    fill: "#7a8697"
  })), _path3435 || (_path3435 = /*#__PURE__*/React.createElement("path", {
    d: "M81 81h1v1h-1z",
    fill: "#7c8799"
  })), _path3436 || (_path3436 = /*#__PURE__*/React.createElement("path", {
    d: "M84 82h-1v-1h1z",
    fill: "#81899c"
  })), _path3437 || (_path3437 = /*#__PURE__*/React.createElement("path", {
    d: "M85 81v1h-1v-1z",
    fill: "#828b9d"
  })), _path3438 || (_path3438 = /*#__PURE__*/React.createElement("path", {
    d: "M85 82v-1h1v1z",
    fill: "#838c9c"
  })), _path3439 || (_path3439 = /*#__PURE__*/React.createElement("path", {
    d: "M87 82h-1v-1h1z",
    fill: "#868ea0"
  })), _path3440 || (_path3440 = /*#__PURE__*/React.createElement("path", {
    d: "M88 81v1h-1v-1z",
    fill: "#878fa0"
  })), _path3441 || (_path3441 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h-1v-1h1z",
    fill: "#8991a2"
  })), _path3442 || (_path3442 = /*#__PURE__*/React.createElement("path", {
    d: "M90 81h1v1h-1z",
    fill: "#9098a8"
  })), _path3443 || (_path3443 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v-1h1v1z",
    fill: "#52575e"
  })), _path3444 || (_path3444 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v-1h1v1z",
    fill: "#38383c"
  })), _path3445 || (_path3445 = /*#__PURE__*/React.createElement("path", {
    d: "M93 81h1v1h-1z",
    fill: "#a09eab",
    fillOpacity: 0.455
  })), _path3446 || (_path3446 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82v1h-1v-1z",
    fill: "#535d7c"
  })), _path3447 || (_path3447 = /*#__PURE__*/React.createElement("path", {
    d: "M37 82h1v1h-1z",
    fill: "#535e7f"
  })), _path3448 || (_path3448 = /*#__PURE__*/React.createElement("path", {
    d: "M42 82v1h-1v-1z",
    fill: "#525d7e"
  })), _path3449 || (_path3449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 83h-1v-1h1z",
    fill: "#525d7f"
  })), _path3450 || (_path3450 = /*#__PURE__*/React.createElement("path", {
    d: "M47 83h-1v-1h1z",
    fill: "#545c81"
  })), _path3451 || (_path3451 = /*#__PURE__*/React.createElement("path", {
    d: "M48 82h1v1h-1z",
    fill: "#515e83"
  })), _path3452 || (_path3452 = /*#__PURE__*/React.createElement("path", {
    d: "M50 82v1h-1v-1z",
    fill: "#515f82"
  })), _path3453 || (_path3453 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83v-1h1v1z",
    fill: "#525f84"
  })), _path3454 || (_path3454 = /*#__PURE__*/React.createElement("path", {
    d: "M60 82h1v1h-1z",
    fill: "#546185"
  })), _path3455 || (_path3455 = /*#__PURE__*/React.createElement("path", {
    d: "M61 82h1v1h-1z",
    fill: "#576287"
  })), _path3456 || (_path3456 = /*#__PURE__*/React.createElement("path", {
    d: "M62 82h1v1h-1z",
    fill: "#5a638b"
  })), _path3457 || (_path3457 = /*#__PURE__*/React.createElement("path", {
    d: "M63 83v-1h1v1z",
    fill: "#5b658c"
  })), _path3458 || (_path3458 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83h-1v-1h1z",
    fill: "#5e678d"
  })), _path3459 || (_path3459 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83v-1h1v1z",
    fill: "#687494"
  })), _path3460 || (_path3460 = /*#__PURE__*/React.createElement("path", {
    d: "M70 83v-1h1v1z",
    fill: "#6a7794"
  })), _path3461 || (_path3461 = /*#__PURE__*/React.createElement("path", {
    d: "M72 83h-1v-1h1z",
    fill: "#6e7a96"
  })), _path3462 || (_path3462 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82v1h-1v-1z",
    fill: "#76809b"
  })), _path3463 || (_path3463 = /*#__PURE__*/React.createElement("path", {
    d: "M79 82h1v1h-1z",
    fill: "#788399"
  })), _path3464 || (_path3464 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h-1v-1h1z",
    fill: "#7a8599"
  })), _path3465 || (_path3465 = /*#__PURE__*/React.createElement("path", {
    d: "M81 82h1v1h-1z",
    fill: "#7c8699"
  })), _path3466 || (_path3466 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83h-1v-1h1z",
    fill: "#7f879a"
  })), _path3467 || (_path3467 = /*#__PURE__*/React.createElement("path", {
    d: "M86 83v-1h1v1z",
    fill: "#848b9d"
  })), _path3468 || (_path3468 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h-1v-1h1z",
    fill: "#858d9e"
  })), _path3469 || (_path3469 = /*#__PURE__*/React.createElement("path", {
    d: "M89 83h-1v-1h1z",
    fill: "#868e9f"
  })), _path3470 || (_path3470 = /*#__PURE__*/React.createElement("path", {
    d: "M89 82h1v1h-1z",
    fill: "#878fa1"
  })), _path3471 || (_path3471 = /*#__PURE__*/React.createElement("path", {
    d: "M91 82v1h-1v-1z",
    fill: "#8c94a5"
  })), _path3472 || (_path3472 = /*#__PURE__*/React.createElement("path", {
    d: "M92 82v1h-1v-1z",
    fill: "#50565d"
  })), _path3473 || (_path3473 = /*#__PURE__*/React.createElement("path", {
    d: "M93 83v-1h1v1z",
    fill: "#9e9ea9",
    fillOpacity: 0.455
  })), _path3474 || (_path3474 = /*#__PURE__*/React.createElement("path", {
    d: "M35 84h-1v-1h1z",
    fill: "#6d6e72",
    fillOpacity: 0.878
  })), _path3475 || (_path3475 = /*#__PURE__*/React.createElement("path", {
    d: "M37 84h-1v-1h1z",
    fill: "#515c7b"
  })), _path3476 || (_path3476 = /*#__PURE__*/React.createElement("path", {
    d: "M42 83h1v1h-1z",
    fill: "#515c7e"
  })), _path3477 || (_path3477 = /*#__PURE__*/React.createElement("path", {
    d: "M44 84h-1v-1h1z",
    fill: "#515b7d"
  })), _path3478 || (_path3478 = /*#__PURE__*/React.createElement("path", {
    d: "M47 84v-1h1v1z",
    fill: "#525b7f"
  })), _path3479 || (_path3479 = /*#__PURE__*/React.createElement("path", {
    d: "M49 83h1v1h-1z",
    fill: "#4f5c7f"
  })), _path3480 || (_path3480 = /*#__PURE__*/React.createElement("path", {
    d: "M50 83h1v1h-1z",
    fill: "#505c81"
  })), _path3481 || (_path3481 = /*#__PURE__*/React.createElement("path", {
    d: "M51 83h1v1h-1z",
    fill: "#505b82"
  })), _path3482 || (_path3482 = /*#__PURE__*/React.createElement("path", {
    d: "M55 84v-1h1v1z",
    fill: "#535f88"
  })), _path3483 || (_path3483 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84h-1v-1h1z",
    fill: "#556087"
  })), _path3484 || (_path3484 = /*#__PURE__*/React.createElement("path", {
    d: "M66 83v1h-1v-1z",
    fill: "#5d668c"
  })), _path3485 || (_path3485 = /*#__PURE__*/React.createElement("path", {
    d: "M68 83v1h-1v-1z",
    fill: "#616b8d"
  })), _path3486 || (_path3486 = /*#__PURE__*/React.createElement("path", {
    d: "M69 84h-1v-1h1z",
    fill: "#65708f"
  })), _path3487 || (_path3487 = /*#__PURE__*/React.createElement("path", {
    d: "M69 83h1v1h-1z",
    fill: "#677290"
  })), _path3488 || (_path3488 = /*#__PURE__*/React.createElement("path", {
    d: "M71 83v1h-1v-1z",
    fill: "#6a7591"
  })), _path3489 || (_path3489 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84v-1h1v1z",
    fill: "#6d7893"
  })), _path3490 || (_path3490 = /*#__PURE__*/React.createElement("path", {
    d: "M74 83h1v1h-1z",
    fill: "#757f95"
  })), _path3491 || (_path3491 = /*#__PURE__*/React.createElement("path", {
    d: "M76 84v-1h1v1z",
    fill: "#747e97"
  })), _path3492 || (_path3492 = /*#__PURE__*/React.createElement("path", {
    d: "M77 84v-1h1v1z",
    fill: "#727b97"
  })), _path3493 || (_path3493 = /*#__PURE__*/React.createElement("path", {
    d: "M79 83h1v1h-1z",
    fill: "#768198"
  })), _path3494 || (_path3494 = /*#__PURE__*/React.createElement("path", {
    d: "M80 84v-1h1v1z",
    fill: "#788396"
  })), _path3495 || (_path3495 = /*#__PURE__*/React.createElement("path", {
    d: "M81 83h1v1h-1z",
    fill: "#7a8597"
  })), _path3496 || (_path3496 = /*#__PURE__*/React.createElement("path", {
    d: "M83 83v1h-1v-1z",
    fill: "#7c869a"
  })), _path3497 || (_path3497 = /*#__PURE__*/React.createElement("path", {
    d: "M84 84h-1v-1h1z",
    fill: "#7c879b"
  })), _path3498 || (_path3498 = /*#__PURE__*/React.createElement("path", {
    d: "M86 84h-1v-1h1z",
    fill: "#7d889b"
  })), _path3499 || (_path3499 = /*#__PURE__*/React.createElement("path", {
    d: "M87 84v-1h1v1z",
    fill: "#828a9c"
  })), _path3500 || (_path3500 = /*#__PURE__*/React.createElement("path", {
    d: "M88 83h1v1h-1z",
    fill: "#838c9d"
  })), _path3501 || (_path3501 = /*#__PURE__*/React.createElement("path", {
    d: "M90 83v1h-1v-1z",
    fill: "#848d9e"
  })), _path3502 || (_path3502 = /*#__PURE__*/React.createElement("path", {
    d: "M90 84v-1h1v1z",
    fill: "#8991a3"
  })), _path3503 || (_path3503 = /*#__PURE__*/React.createElement("path", {
    d: "M91 83h1v1h-1z",
    fill: "#4f555c"
  })), _path3504 || (_path3504 = /*#__PURE__*/React.createElement("path", {
    d: "M36 85v-1h1v1z",
    fill: "#505b7a"
  })), _path3505 || (_path3505 = /*#__PURE__*/React.createElement("path", {
    d: "M39 84h1v1h-1z",
    fill: "#515b7c"
  })), _path3506 || (_path3506 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84v1h-1v-1z",
    fill: "#515a7d"
  })), _path3507 || (_path3507 = /*#__PURE__*/React.createElement("path", {
    d: "M41 84h1v1h-1z",
    fill: "#51597f"
  })), _path3508 || (_path3508 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84v1h-1v-1z",
    fill: "#4f597e"
  })), _path3509 || (_path3509 = /*#__PURE__*/React.createElement("path", {
    d: "M43 84h1v1h-1z",
    fill: "#4c5b7e"
  })), _path3510 || (_path3510 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85h-1v-1h1z",
    fill: "#4b5d7e"
  })), _path3511 || (_path3511 = /*#__PURE__*/React.createElement("path", {
    d: "M48 84v1h-1v-1z",
    fill: "#4d5c7e"
  })), _path3512 || (_path3512 = /*#__PURE__*/React.createElement("path", {
    d: "M48 85v-1h1v1z",
    fill: "#4e5c7f"
  })), _path3513 || (_path3513 = /*#__PURE__*/React.createElement("path", {
    d: "M53 85h-1v-1h1z",
    fill: "#505a82"
  })), _path3514 || (_path3514 = /*#__PURE__*/React.createElement("path", {
    d: "M53 84h1v1h-1z",
    fill: "#515a82"
  })), _path3515 || (_path3515 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85v-1h1v1z",
    fill: "#535c84"
  })), _path3516 || (_path3516 = /*#__PURE__*/React.createElement("path", {
    d: "M59 85h-1v-1h1z",
    fill: "#525e85"
  })), _path3517 || (_path3517 = /*#__PURE__*/React.createElement("path", {
    d: "M62 84v1h-1v-1z",
    fill: "#555f87"
  })), _path3518 || (_path3518 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85v-1h1v1z",
    fill: "#606a8c"
  })), _path3519 || (_path3519 = /*#__PURE__*/React.createElement("path", {
    d: "M68 84h1v1h-1z",
    fill: "#626d8b"
  })), _path3520 || (_path3520 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85v-1h1v1z",
    fill: "#646f8b"
  })), _path3521 || (_path3521 = /*#__PURE__*/React.createElement("path", {
    d: "M71 85h-1v-1h1z",
    fill: "#66728b"
  })), _path3522 || (_path3522 = /*#__PURE__*/React.createElement("path", {
    d: "M71 84h1v1h-1z",
    fill: "#6a7590"
  })), _path3523 || (_path3523 = /*#__PURE__*/React.createElement("path", {
    d: "M72 85v-1h1v1z",
    fill: "#6e7893"
  })), _path3524 || (_path3524 = /*#__PURE__*/React.createElement("path", {
    d: "M73 84h1v1h-1z",
    fill: "#707a95"
  })), _path3525 || (_path3525 = /*#__PURE__*/React.createElement("path", {
    d: "M79 84v1h-1v-1z",
    fill: "#717b96"
  })), _path3526 || (_path3526 = /*#__PURE__*/React.createElement("path", {
    d: "M81 85v-1h1v1z",
    fill: "#778294"
  })), _path3527 || (_path3527 = /*#__PURE__*/React.createElement("path", {
    d: "M82 85v-1h1v1z",
    fill: "#788397"
  })), _path3528 || (_path3528 = /*#__PURE__*/React.createElement("path", {
    d: "M85 84h1v1h-1z",
    fill: "#7b869a"
  })), _path3529 || (_path3529 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85v-1h1v1z",
    fill: "#7e8799"
  })), _path3530 || (_path3530 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85h-1v-1h1z",
    fill: "#7e879a"
  })), _path3531 || (_path3531 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85h-1v-1h1z",
    fill: "#80889b"
  })), _path3532 || (_path3532 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84v1h-1v-1z",
    fill: "#868ea1"
  })), _path3533 || (_path3533 = /*#__PURE__*/React.createElement("path", {
    d: "M91 84h1v1h-1z",
    fill: "#4e535c"
  })), _path3534 || (_path3534 = /*#__PURE__*/React.createElement("path", {
    d: "M35 86h-1v-1h1z",
    fill: "#6d6f72",
    fillOpacity: 0.882
  })), _path3535 || (_path3535 = /*#__PURE__*/React.createElement("path", {
    d: "M37 86h-1v-1h1z",
    fill: "#4f5a78"
  })), _path3536 || (_path3536 = /*#__PURE__*/React.createElement("path", {
    d: "M38 85v1h-1v-1z",
    fill: "#4f5b7a"
  })), _path3537 || (_path3537 = /*#__PURE__*/React.createElement("path", {
    d: "M38 86v-1h1v1z",
    fill: "#4f5979"
  })), _path3538 || (_path3538 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86h-1v-1h1z",
    fill: "#4e597a"
  })), _path3539 || (_path3539 = /*#__PURE__*/React.createElement("path", {
    d: "M41 85h1v1h-1z",
    fill: "#4f5a7a"
  })), _path3540 || (_path3540 = /*#__PURE__*/React.createElement("path", {
    d: "M43 86h-1v-1h1z",
    fill: "#585678"
  })), _path3541 || (_path3541 = /*#__PURE__*/React.createElement("path", {
    d: "M44 86h-1v-1h1z",
    fill: "#5f5377"
  })), _path3542 || (_path3542 = /*#__PURE__*/React.createElement("path", {
    d: "M45 85v1h-1v-1z",
    fill: "#615276"
  })), _path3543 || (_path3543 = /*#__PURE__*/React.createElement("path", {
    d: "M46 85v1h-1v-1z",
    fill: "#5d5378"
  })), _path3544 || (_path3544 = /*#__PURE__*/React.createElement("path", {
    d: "M47 86h-1v-1h1z",
    fill: "#54587b"
  })), _path3545 || (_path3545 = /*#__PURE__*/React.createElement("path", {
    d: "M50 85v1h-1v-1z",
    fill: "#505a7e"
  })), _path3546 || (_path3546 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h-1v-1h1z",
    fill: "#50597f"
  })), _path3547 || (_path3547 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86v-1h1v1z",
    fill: "#505982"
  })), _path3548 || (_path3548 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86h-1v-1h1z",
    fill: "#4f5a7e"
  })), _path3549 || (_path3549 = /*#__PURE__*/React.createElement("path", {
    d: "M54 85h1v1h-1z",
    fill: "#4d577a"
  })), _path3550 || (_path3550 = /*#__PURE__*/React.createElement("path", {
    d: "M57 85v1h-1v-1z",
    fill: "#586283"
  })), _path3551 || (_path3551 = /*#__PURE__*/React.createElement("path", {
    d: "M57 86v-1h1v1z",
    fill: "#596484"
  })), _path3552 || (_path3552 = /*#__PURE__*/React.createElement("path", {
    d: "M58 85h1v1h-1z",
    fill: "#556082"
  })), _path3553 || (_path3553 = /*#__PURE__*/React.createElement("path", {
    d: "M59 86v-1h1v1z",
    fill: "#505c7d"
  })), _path3554 || (_path3554 = /*#__PURE__*/React.createElement("path", {
    d: "M61 86h-1v-1h1z",
    fill: "#505d82"
  })), _path3555 || (_path3555 = /*#__PURE__*/React.createElement("path", {
    d: "M62 86h-1v-1h1z",
    fill: "#535e85"
  })), _path3556 || (_path3556 = /*#__PURE__*/React.createElement("path", {
    d: "M62 85h1v1h-1z",
    fill: "#555d85"
  })), _path3557 || (_path3557 = /*#__PURE__*/React.createElement("path", {
    d: "M64 85v1h-1v-1z",
    fill: "#565f86"
  })), _path3558 || (_path3558 = /*#__PURE__*/React.createElement("path", {
    d: "M67 85h1v1h-1z",
    fill: "#5a6685"
  })), _path3559 || (_path3559 = /*#__PURE__*/React.createElement("path", {
    d: "M69 85h1v1h-1z",
    fill: "#6c768f"
  })), _path3560 || (_path3560 = /*#__PURE__*/React.createElement("path", {
    d: "M70 85h1v1h-1z",
    fill: "#6e7890"
  })), _path3561 || (_path3561 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v-1h1v1z",
    fill: "#6d778f"
  })), _path3562 || (_path3562 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v-1h1v1z",
    fill: "#6e7591"
  })), _path3563 || (_path3563 = /*#__PURE__*/React.createElement("path", {
    d: "M74 85h1v1h-1z",
    fill: "#6f7a92"
  })), _path3564 || (_path3564 = /*#__PURE__*/React.createElement("path", {
    d: "M75 85h1v1h-1z",
    fill: "#717c93"
  })), _path3565 || (_path3565 = /*#__PURE__*/React.createElement("path", {
    d: "M78 86h-1v-1h1z",
    fill: "#6e7795"
  })), _path3566 || (_path3566 = /*#__PURE__*/React.createElement("path", {
    d: "M79 85h1v1h-1z",
    fill: "#707a92"
  })), _path3567 || (_path3567 = /*#__PURE__*/React.createElement("path", {
    d: "M80 85h1v1h-1z",
    fill: "#707c8d"
  })), _path3568 || (_path3568 = /*#__PURE__*/React.createElement("path", {
    d: "M81 86v-1h1v1z",
    fill: "#778192"
  })), _path3569 || (_path3569 = /*#__PURE__*/React.createElement("path", {
    d: "M83 86h-1v-1h1z",
    fill: "#7e8697"
  })), _path3570 || (_path3570 = /*#__PURE__*/React.createElement("path", {
    d: "M84 85h1v1h-1z",
    fill: "#7e8698"
  })), _path3571 || (_path3571 = /*#__PURE__*/React.createElement("path", {
    d: "M86 85h1v1h-1z",
    fill: "#7a8496"
  })), _path3572 || (_path3572 = /*#__PURE__*/React.createElement("path", {
    d: "M90 85v1h-1v-1z",
    fill: "#7c8698"
  })), _path3573 || (_path3573 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86v-1h1v1z",
    fill: "#828a9e"
  })), _path3574 || (_path3574 = /*#__PURE__*/React.createElement("path", {
    d: "M91 85h1v1h-1z",
    fill: "#4b505a"
  })), _path3575 || (_path3575 = /*#__PURE__*/React.createElement("path", {
    d: "M93 86h-1v-1h1z",
    fill: "#383a3b"
  })), _path3576 || (_path3576 = /*#__PURE__*/React.createElement("path", {
    d: "M34 87v-1h1v1z",
    fill: "#707073",
    fillOpacity: 0.882
  })), _path3577 || (_path3577 = /*#__PURE__*/React.createElement("path", {
    d: "M36 87v-1h1v1z",
    fill: "#4e5875"
  })), _path3578 || (_path3578 = /*#__PURE__*/React.createElement("path", {
    d: "M38 87h-1v-1h1z",
    fill: "#4d5b79"
  })), _path3579 || (_path3579 = /*#__PURE__*/React.createElement("path", {
    d: "M39 87h-1v-1h1z",
    fill: "#4e5878"
  })), _path3580 || (_path3580 = /*#__PURE__*/React.createElement("path", {
    d: "M40 86v1h-1v-1z",
    fill: "#4f587b"
  })), _path3581 || (_path3581 = /*#__PURE__*/React.createElement("path", {
    d: "M41 86v1h-1v-1z",
    fill: "#565575"
  })), _path3582 || (_path3582 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v-1h1v1z",
    fill: "#813f69"
  })), _path3583 || (_path3583 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v-1h1v1z",
    fill: "#a62561"
  })), _path3584 || (_path3584 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v-1h1v1z",
    fill: "#b11a5a"
  })), _path3585 || (_path3585 = /*#__PURE__*/React.createElement("path", {
    d: "M44 87v-1h1v1z",
    fill: "#b21756"
  })), _path3586 || (_path3586 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v-1h1v1z",
    fill: "#b11d5c"
  })), _path3587 || (_path3587 = /*#__PURE__*/React.createElement("path", {
    d: "M46 87v-1h1v1z",
    fill: "#973166"
  })), _path3588 || (_path3588 = /*#__PURE__*/React.createElement("path", {
    d: "M48 86v1h-1v-1z",
    fill: "#694c72"
  })), _path3589 || (_path3589 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87h-1v-1h1z",
    fill: "#4c5b7c"
  })), _path3590 || (_path3590 = /*#__PURE__*/React.createElement("path", {
    d: "M50 86h1v1h-1z",
    fill: "#4f597b"
  })), _path3591 || (_path3591 = /*#__PURE__*/React.createElement("path", {
    d: "M51 86h1v1h-1z",
    fill: "#4f587c"
  })), _path3592 || (_path3592 = /*#__PURE__*/React.createElement("path", {
    d: "M52 86h1v1h-1z",
    fill: "#4e587e"
  })), _path3593 || (_path3593 = /*#__PURE__*/React.createElement("path", {
    d: "M54 86v1h-1v-1z",
    fill: "#4f5a7c"
  })), _path3594 || (_path3594 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87v-1h1v1z",
    fill: "#bcc2ce"
  })), _path3595 || (_path3595 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87h-1v-1h1z",
    fill: "#c9d1d5"
  })), _path3596 || (_path3596 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86v1h-1v-1z",
    fill: "#c9d3d5"
  })), _path3597 || (_path3597 = /*#__PURE__*/React.createElement("path", {
    d: "M58 86h1v1h-1z",
    fill: "#c3ccd1"
  })), _path3598 || (_path3598 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87v-1h1v1z",
    fill: "#a3adb9"
  })), _path3599 || (_path3599 = /*#__PURE__*/React.createElement("path", {
    d: "M60 87v-1h1v1z",
    fill: "#636c8c"
  })), _path3600 || (_path3600 = /*#__PURE__*/React.createElement("path", {
    d: "M62 87h-1v-1h1z",
    fill: "#4f5a82"
  })), _path3601 || (_path3601 = /*#__PURE__*/React.createElement("path", {
    d: "M63 87v-1h1v1z",
    fill: "#565f85"
  })), _path3602 || (_path3602 = /*#__PURE__*/React.createElement("path", {
    d: "M65 86v1h-1v-1z",
    fill: "#586087"
  })), _path3603 || (_path3603 = /*#__PURE__*/React.createElement("path", {
    d: "M65 87v-1h1v1z",
    fill: "#596186"
  })), _path3604 || (_path3604 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h-1v-1h1z",
    fill: "#5f6886"
  })), _path3605 || (_path3605 = /*#__PURE__*/React.createElement("path", {
    d: "M68 87v-1h1v1z",
    fill: "#b6bcc1"
  })), _path3606 || (_path3606 = /*#__PURE__*/React.createElement("path", {
    d: "M70 86v1h-1v-1z",
    fill: "#bfc3cb"
  })), _path3607 || (_path3607 = /*#__PURE__*/React.createElement("path", {
    d: "M71 86v1h-1v-1z",
    fill: "#c0c6ca"
  })), _path3608 || (_path3608 = /*#__PURE__*/React.createElement("path", {
    d: "M72 86v1h-1v-1z",
    fill: "#bac1c4"
  })), _path3609 || (_path3609 = /*#__PURE__*/React.createElement("path", {
    d: "M73 86v1h-1v-1z",
    fill: "#aab0bc"
  })), _path3610 || (_path3610 = /*#__PURE__*/React.createElement("path", {
    d: "M74 87h-1v-1h1z",
    fill: "#7d8397"
  })), _path3611 || (_path3611 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87h-1v-1h1z",
    fill: "#6b758d"
  })), _path3612 || (_path3612 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87v-1h1v1z",
    fill: "#6d7992"
  })), _path3613 || (_path3613 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87v-1h1v1z",
    fill: "#6c7790"
  })), _path3614 || (_path3614 = /*#__PURE__*/React.createElement("path", {
    d: "M77 86h1v1h-1z",
    fill: "#6b7492"
  })), _path3615 || (_path3615 = /*#__PURE__*/React.createElement("path", {
    d: "M79 87h-1v-1h1z",
    fill: "#6d7492"
  })), _path3616 || (_path3616 = /*#__PURE__*/React.createElement("path", {
    d: "M80 86h1v1h-1z",
    fill: "#99a9b3"
  })), _path3617 || (_path3617 = /*#__PURE__*/React.createElement("path", {
    d: "M82 86v1h-1v-1z",
    fill: "#b9c2ce"
  })), _path3618 || (_path3618 = /*#__PURE__*/React.createElement("path", {
    d: "M83 87h-1v-1h1z",
    fill: "#c2c7cd"
  })), _path3619 || (_path3619 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87h-1v-1h1z",
    fill: "#c1c8c9"
  })), _path3620 || (_path3620 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86v1h-1v-1z",
    fill: "#bec4c5"
  })), _path3621 || (_path3621 = /*#__PURE__*/React.createElement("path", {
    d: "M85 86h1v1h-1z",
    fill: "#b0b5b9"
  })), _path3622 || (_path3622 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h-1v-1h1z",
    fill: "#848a9a"
  })), _path3623 || (_path3623 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87v-1h1v1z",
    fill: "#778094"
  })), _path3624 || (_path3624 = /*#__PURE__*/React.createElement("path", {
    d: "M88 86h1v1h-1z",
    fill: "#778296"
  })), _path3625 || (_path3625 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v-1h1v1z",
    fill: "#768193"
  })), _path3626 || (_path3626 = /*#__PURE__*/React.createElement("path", {
    d: "M90 86h1v1h-1z",
    fill: "#7c8399"
  })), _path3627 || (_path3627 = /*#__PURE__*/React.createElement("path", {
    d: "M91 86h1v1h-1z",
    fill: "#474c59"
  })), _path3628 || (_path3628 = /*#__PURE__*/React.createElement("path", {
    d: "M33 88v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.078
  })), _path3629 || (_path3629 = /*#__PURE__*/React.createElement("path", {
    d: "M35 88h-1v-1h1z",
    fill: "#717174",
    fillOpacity: 0.89
  })), _path3630 || (_path3630 = /*#__PURE__*/React.createElement("path", {
    d: "M36 88v-1h1v1z",
    fill: "#4d5774"
  })), _path3631 || (_path3631 = /*#__PURE__*/React.createElement("path", {
    d: "M37 87h1v1h-1z",
    fill: "#505978"
  })), _path3632 || (_path3632 = /*#__PURE__*/React.createElement("path", {
    d: "M38 88v-1h1v1z",
    fill: "#4e5778"
  })), _path3633 || (_path3633 = /*#__PURE__*/React.createElement("path", {
    d: "M40 88h-1v-1h1z",
    fill: "#4f5776"
  })), _path3634 || (_path3634 = /*#__PURE__*/React.createElement("path", {
    d: "M41 87v1h-1v-1z",
    fill: "#843c69"
  })), _path3635 || (_path3635 = /*#__PURE__*/React.createElement("path", {
    d: "M42 87v1h-1v-1z",
    fill: "#c51358"
  })), _path3636 || (_path3636 = /*#__PURE__*/React.createElement("path", {
    d: "M43 87v1h-1v-1z",
    fill: "#c70b50"
  })), _path3637 || (_path3637 = /*#__PURE__*/React.createElement("path", {
    d: "M43 88v-1h1v1z",
    fill: "#d2356c"
  })), _path3638 || (_path3638 = /*#__PURE__*/React.createElement("path", {
    d: "M45 87v1h-1v-1z",
    fill: "#d85a83"
  })), _path3639 || (_path3639 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88v-1h1v1z",
    fill: "#cc1b55"
  })), _path3640 || (_path3640 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h-1v-1h1z",
    fill: "#d21854"
  })), _path3641 || (_path3641 = /*#__PURE__*/React.createElement("path", {
    d: "M48 88h-1v-1h1z",
    fill: "#ac305e"
  })), _path3642 || (_path3642 = /*#__PURE__*/React.createElement("path", {
    d: "M49 88h-1v-1h1z",
    fill: "#5c5272"
  })), _path3643 || (_path3643 = /*#__PURE__*/React.createElement("path", {
    d: "M50 87v1h-1v-1z",
    fill: "#4b597c"
  })), _path3644 || (_path3644 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88v-1h1v1z",
    fill: "#4e587b"
  })), _path3645 || (_path3645 = /*#__PURE__*/React.createElement("path", {
    d: "M51 87h1v1h-1z",
    fill: "#4e577a"
  })), _path3646 || (_path3646 = /*#__PURE__*/React.createElement("path", {
    d: "M53 87v1h-1v-1z",
    fill: "#4a5475"
  })), _path3647 || (_path3647 = /*#__PURE__*/React.createElement("path", {
    d: "M55 88h-1v-1h1z",
    fill: "#e3e8e7"
  })), _path3648 || (_path3648 = /*#__PURE__*/React.createElement("path", {
    d: "M55 87h1v1h-1z",
    fill: "#d1dfcb"
  })), _path3649 || (_path3649 = /*#__PURE__*/React.createElement("path", {
    d: "M57 87v1h-1v-1z",
    fill: "#d6e7cd"
  })), _path3650 || (_path3650 = /*#__PURE__*/React.createElement("path", {
    d: "M57 88v-1h1v1z",
    fill: "#e4e8e3"
  })), _path3651 || (_path3651 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88h-1v-1h1z",
    fill: "#e0e7df"
  })), _path3652 || (_path3652 = /*#__PURE__*/React.createElement("path", {
    d: "M59 87h1v1h-1z",
    fill: "#e4ebe4"
  })), _path3653 || (_path3653 = /*#__PURE__*/React.createElement("path", {
    d: "M60 88v-1h1v1z",
    fill: "#c1c6d0"
  })), _path3654 || (_path3654 = /*#__PURE__*/React.createElement("path", {
    d: "M61 87h1v1h-1z",
    fill: "#596380"
  })), _path3655 || (_path3655 = /*#__PURE__*/React.createElement("path", {
    d: "M64 88v-1h1v1z",
    fill: "#566085"
  })), _path3656 || (_path3656 = /*#__PURE__*/React.createElement("path", {
    d: "M65 88v-1h1v1z",
    fill: "#565f82"
  })), _path3657 || (_path3657 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87v1h-1v-1z",
    fill: "#9da2ac"
  })), _path3658 || (_path3658 = /*#__PURE__*/React.createElement("path", {
    d: "M67 87h1v1h-1z",
    fill: "#d0ccc8"
  })), _path3659 || (_path3659 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87v1h-1v-1z",
    fill: "#ceced0"
  })), _path3660 || (_path3660 = /*#__PURE__*/React.createElement("path", {
    d: "M69 87h1v1h-1z",
    fill: "#c6ccc5"
  })), _path3661 || (_path3661 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87v1h-1v-1z",
    fill: "#cbccc0"
  })), _path3662 || (_path3662 = /*#__PURE__*/React.createElement("path", {
    d: "M71 87h1v1h-1z",
    fill: "#d0d3c6"
  })), _path3663 || (_path3663 = /*#__PURE__*/React.createElement("path", {
    d: "M72 87h1v1h-1z",
    fill: "#c4cac2"
  })), _path3664 || (_path3664 = /*#__PURE__*/React.createElement("path", {
    d: "M74 88v-1h1v1z",
    fill: "#727a8f"
  })), _path3665 || (_path3665 = /*#__PURE__*/React.createElement("path", {
    d: "M76 87h1v1h-1z",
    fill: "#68748d"
  })), _path3666 || (_path3666 = /*#__PURE__*/React.createElement("path", {
    d: "M78 88h-1v-1h1z",
    fill: "#677190"
  })), _path3667 || (_path3667 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h-1v-1h1z",
    fill: "#6b758c"
  })), _path3668 || (_path3668 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88v-1h1v1z",
    fill: "#9ca9b9"
  })), _path3669 || (_path3669 = /*#__PURE__*/React.createElement("path", {
    d: "M80 87h1v1h-1z",
    fill: "#8c9fbc"
  })), _path3670 || (_path3670 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h-1v-1h1z",
    fill: "#96a6bd"
  })), _path3671 || (_path3671 = /*#__PURE__*/React.createElement("path", {
    d: "M83 88h-1v-1h1z",
    fill: "#cfd6d7"
  })), _path3672 || (_path3672 = /*#__PURE__*/React.createElement("path", {
    d: "M84 87v1h-1v-1z",
    fill: "#d1d6d1"
  })), _path3673 || (_path3673 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88h-1v-1h1z",
    fill: "#bfced8"
  })), _path3674 || (_path3674 = /*#__PURE__*/React.createElement("path", {
    d: "M86 88v-1h1v1z",
    fill: "#bac3cb"
  })), _path3675 || (_path3675 = /*#__PURE__*/React.createElement("path", {
    d: "M87 87h1v1h-1z",
    fill: "#798190"
  })), _path3676 || (_path3676 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87v1h-1v-1z",
    fill: "#707b8f"
  })), _path3677 || (_path3677 = /*#__PURE__*/React.createElement("path", {
    d: "M89 87h1v1h-1z",
    fill: "#717b8f"
  })), _path3678 || (_path3678 = /*#__PURE__*/React.createElement("path", {
    d: "M91 87v1h-1v-1z",
    fill: "#777f95"
  })), _path3679 || (_path3679 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88v-1h1v1z",
    fill: "#454a58"
  })), _path3680 || (_path3680 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89h-1v-1h1z",
    fill: "#1f212a"
  })), _path3681 || (_path3681 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v-1h1v1z",
    fill: "#505675"
  })), _path3682 || (_path3682 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88v1h-1v-1z",
    fill: "#4d5775"
  })), _path3683 || (_path3683 = /*#__PURE__*/React.createElement("path", {
    d: "M39 88h1v1h-1z",
    fill: "#56536f"
  })), _path3684 || (_path3684 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h-1v-1h1z",
    fill: "#a82d5d"
  })), _path3685 || (_path3685 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89h-1v-1h1z",
    fill: "#ce1751"
  })), _path3686 || (_path3686 = /*#__PURE__*/React.createElement("path", {
    d: "M42 89v-1h1v1z",
    fill: "#c53663"
  })), _path3687 || (_path3687 = /*#__PURE__*/React.createElement("path", {
    d: "M44 88v1h-1v-1z",
    fill: "#e19eb2"
  })), _path3688 || (_path3688 = /*#__PURE__*/React.createElement("path", {
    d: "M45 89h-1v-1h1z",
    fill: "#cb8d9a"
  })), _path3689 || (_path3689 = /*#__PURE__*/React.createElement("path", {
    d: "M45 88h1v1h-1z",
    fill: "#db8498"
  })), _path3690 || (_path3690 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88v1h-1v-1z",
    fill: "#c72c52"
  })), _path3691 || (_path3691 = /*#__PURE__*/React.createElement("path", {
    d: "M47 88h1v1h-1z",
    fill: "#cc2a51"
  })), _path3692 || (_path3692 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v-1h1v1z",
    fill: "#7b466a"
  })), _path3693 || (_path3693 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89v-1h1v1z",
    fill: "#4c5879"
  })), _path3694 || (_path3694 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88v1h-1v-1z",
    fill: "#4d587b"
  })), _path3695 || (_path3695 = /*#__PURE__*/React.createElement("path", {
    d: "M51 88h1v1h-1z",
    fill: "#4d5778"
  })), _path3696 || (_path3696 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v-1h1v1z",
    fill: "#c4cccd"
  })), _path3697 || (_path3697 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89h-1v-1h1z",
    fill: "#dce7e5"
  })), _path3698 || (_path3698 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h-1v-1h1z",
    fill: "#85aa9a"
  })), _path3699 || (_path3699 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89v-1h1v1z",
    fill: "#82b36e"
  })), _path3700 || (_path3700 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89h-1v-1h1z",
    fill: "#b7d4a8"
  })), _path3701 || (_path3701 = /*#__PURE__*/React.createElement("path", {
    d: "M59 88v1h-1v-1z",
    fill: "#dde3d9"
  })), _path3702 || (_path3702 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v-1h1v1z",
    fill: "#e1e3e0"
  })), _path3703 || (_path3703 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v-1h1v1z",
    fill: "#e2e9e6"
  })), _path3704 || (_path3704 = /*#__PURE__*/React.createElement("path", {
    d: "M62 89h-1v-1h1z",
    fill: "#7e869b"
  })), _path3705 || (_path3705 = /*#__PURE__*/React.createElement("path", {
    d: "M63 89h-1v-1h1z",
    fill: "#4d587a"
  })), _path3706 || (_path3706 = /*#__PURE__*/React.createElement("path", {
    d: "M66 88v1h-1v-1z",
    fill: "#616a8a"
  })), _path3707 || (_path3707 = /*#__PURE__*/React.createElement("path", {
    d: "M67 89h-1v-1h1z",
    fill: "#bdc8c8"
  })), _path3708 || (_path3708 = /*#__PURE__*/React.createElement("path", {
    d: "M68 88v1h-1v-1z",
    fill: "#c4cfbf"
  })), _path3709 || (_path3709 = /*#__PURE__*/React.createElement("path", {
    d: "M69 89h-1v-1h1z",
    fill: "#c4cbcb"
  })), _path3710 || (_path3710 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h-1v-1h1z",
    fill: "#c7cbc7"
  })), _path3711 || (_path3711 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89v-1h1v1z",
    fill: "#c8c8bd"
  })), _path3712 || (_path3712 = /*#__PURE__*/React.createElement("path", {
    d: "M71 88h1v1h-1z",
    fill: "#d1d4c7"
  })), _path3713 || (_path3713 = /*#__PURE__*/React.createElement("path", {
    d: "M73 88v1h-1v-1z",
    fill: "#c9cfc5"
  })), _path3714 || (_path3714 = /*#__PURE__*/React.createElement("path", {
    d: "M74 89h-1v-1h1z",
    fill: "#cdd4d2"
  })), _path3715 || (_path3715 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88v1h-1v-1z",
    fill: "#656f8a"
  })), _path3716 || (_path3716 = /*#__PURE__*/React.createElement("path", {
    d: "M76 88h1v1h-1z",
    fill: "#66728c"
  })), _path3717 || (_path3717 = /*#__PURE__*/React.createElement("path", {
    d: "M77 89v-1h1v1z",
    fill: "#636d8b"
  })), _path3718 || (_path3718 = /*#__PURE__*/React.createElement("path", {
    d: "M78 89v-1h1v1z",
    fill: "#768091"
  })), _path3719 || (_path3719 = /*#__PURE__*/React.createElement("path", {
    d: "M79 88h1v1h-1z",
    fill: "#b7c3c8"
  })), _path3720 || (_path3720 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89v-1h1v1z",
    fill: "#91a1bd"
  })), _path3721 || (_path3721 = /*#__PURE__*/React.createElement("path", {
    d: "M81 88h1v1h-1z",
    fill: "#9baabe"
  })), _path3722 || (_path3722 = /*#__PURE__*/React.createElement("path", {
    d: "M82 88h1v1h-1z",
    fill: "#cdd6d3"
  })), _path3723 || (_path3723 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h-1v-1h1z",
    fill: "#cfd4d0"
  })), _path3724 || (_path3724 = /*#__PURE__*/React.createElement("path", {
    d: "M85 88v1h-1v-1z",
    fill: "#c7cfd2"
  })), _path3725 || (_path3725 = /*#__PURE__*/React.createElement("path", {
    d: "M86 89h-1v-1h1z",
    fill: "#afbfc9"
  })), _path3726 || (_path3726 = /*#__PURE__*/React.createElement("path", {
    d: "M89 89h-1v-1h1z",
    fill: "#6b758b"
  })), _path3727 || (_path3727 = /*#__PURE__*/React.createElement("path", {
    d: "M89 88h1v1h-1z",
    fill: "#6f788e"
  })), _path3728 || (_path3728 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89h-1v-1h1z",
    fill: "#747b94"
  })), _path3729 || (_path3729 = /*#__PURE__*/React.createElement("path", {
    d: "M91 88h1v1h-1z",
    fill: "#444857"
  })), _path3730 || (_path3730 = /*#__PURE__*/React.createElement("path", {
    d: "M94 89h-1v-1h1z",
    fill: "#a1a3a7",
    fillOpacity: 0.447
  })), _path3731 || (_path3731 = /*#__PURE__*/React.createElement("path", {
    d: "M36 89v1h-1v-1z",
    fill: "#1e2129"
  })), _path3732 || (_path3732 = /*#__PURE__*/React.createElement("path", {
    d: "M37 89v1h-1v-1z",
    fill: "#495571"
  })), _path3733 || (_path3733 = /*#__PURE__*/React.createElement("path", {
    d: "M38 89h1v1h-1z",
    fill: "#4b5672"
  })), _path3734 || (_path3734 = /*#__PURE__*/React.createElement("path", {
    d: "M40 89v1h-1v-1z",
    fill: "#5e4f69"
  })), _path3735 || (_path3735 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90v-1h1v1z",
    fill: "#b63057"
  })), _path3736 || (_path3736 = /*#__PURE__*/React.createElement("path", {
    d: "M41 89h1v1h-1z",
    fill: "#d05c77"
  })), _path3737 || (_path3737 = /*#__PURE__*/React.createElement("path", {
    d: "M43 90h-1v-1h1z",
    fill: "#e8cdd0"
  })), _path3738 || (_path3738 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89v1h-1v-1z",
    fill: "#e2d5d4"
  })), _path3739 || (_path3739 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h-1v-1h1z",
    fill: "#e0c2c3"
  })), _path3740 || (_path3740 = /*#__PURE__*/React.createElement("path", {
    d: "M46 89v1h-1v-1z",
    fill: "#e8dbd7"
  })), _path3741 || (_path3741 = /*#__PURE__*/React.createElement("path", {
    d: "M47 89v1h-1v-1z",
    fill: "#e4aab3"
  })), _path3742 || (_path3742 = /*#__PURE__*/React.createElement("path", {
    d: "M48 89v1h-1v-1z",
    fill: "#cb3753"
  })), _path3743 || (_path3743 = /*#__PURE__*/React.createElement("path", {
    d: "M48 90v-1h1v1z",
    fill: "#914163"
  })), _path3744 || (_path3744 = /*#__PURE__*/React.createElement("path", {
    d: "M49 89h1v1h-1z",
    fill: "#4c5673"
  })), _path3745 || (_path3745 = /*#__PURE__*/React.createElement("path", {
    d: "M50 89h1v1h-1z",
    fill: "#4c5778"
  })), _path3746 || (_path3746 = /*#__PURE__*/React.createElement("path", {
    d: "M52 90h-1v-1h1z",
    fill: "#4b5676"
  })), _path3747 || (_path3747 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89v1h-1v-1z",
    fill: "#5e6681"
  })), _path3748 || (_path3748 = /*#__PURE__*/React.createElement("path", {
    d: "M53 89h1v1h-1z",
    fill: "#d7dadb"
  })), _path3749 || (_path3749 = /*#__PURE__*/React.createElement("path", {
    d: "M55 89v1h-1v-1z",
    fill: "#dae4e6"
  })), _path3750 || (_path3750 = /*#__PURE__*/React.createElement("path", {
    d: "M55 90v-1h1v1z",
    fill: "#719cc9"
  })), _path3751 || (_path3751 = /*#__PURE__*/React.createElement("path", {
    d: "M56 89h1v1h-1z",
    fill: "#5a998f"
  })), _path3752 || (_path3752 = /*#__PURE__*/React.createElement("path", {
    d: "M58 89v1h-1v-1z",
    fill: "#7da94e"
  })), _path3753 || (_path3753 = /*#__PURE__*/React.createElement("path", {
    d: "M59 89v1h-1v-1z",
    fill: "#cac067"
  })), _path3754 || (_path3754 = /*#__PURE__*/React.createElement("path", {
    d: "M60 89v1h-1v-1z",
    fill: "#e2daad"
  })), _path3755 || (_path3755 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90v-1h1v1z",
    fill: "#e0ebe3"
  })), _path3756 || (_path3756 = /*#__PURE__*/React.createElement("path", {
    d: "M61 89h1v1h-1z",
    fill: "#9599aa"
  })), _path3757 || (_path3757 = /*#__PURE__*/React.createElement("path", {
    d: "M63 90h-1v-1h1z",
    fill: "#4b5576"
  })), _path3758 || (_path3758 = /*#__PURE__*/React.createElement("path", {
    d: "M65 89v1h-1v-1z",
    fill: "#4e5a7d"
  })), _path3759 || (_path3759 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89v1h-1v-1z",
    fill: "#6a778d"
  })), _path3760 || (_path3760 = /*#__PURE__*/React.createElement("path", {
    d: "M66 89h1v1h-1z",
    fill: "#c7cace"
  })), _path3761 || (_path3761 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90v-1h1v1z",
    fill: "#d1c6bf"
  })), _path3762 || (_path3762 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h-1v-1h1z",
    fill: "#cec7c2"
  })), _path3763 || (_path3763 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v-1h1v1z",
    fill: "#cfd4d2"
  })), _path3764 || (_path3764 = /*#__PURE__*/React.createElement("path", {
    d: "M70 89h1v1h-1z",
    fill: "#d0d6d1"
  })), _path3765 || (_path3765 = /*#__PURE__*/React.createElement("path", {
    d: "M71 89h1v1h-1z",
    fill: "#c9d0c9"
  })), _path3766 || (_path3766 = /*#__PURE__*/React.createElement("path", {
    d: "M72 90v-1h1v1z",
    fill: "#cad1cc"
  })), _path3767 || (_path3767 = /*#__PURE__*/React.createElement("path", {
    d: "M73 89h1v1h-1z",
    fill: "#cbd2d0"
  })), _path3768 || (_path3768 = /*#__PURE__*/React.createElement("path", {
    d: "M74 90v-1h1v1z",
    fill: "#999fab"
  })), _path3769 || (_path3769 = /*#__PURE__*/React.createElement("path", {
    d: "M76 89v1h-1v-1z",
    fill: "#636b86"
  })), _path3770 || (_path3770 = /*#__PURE__*/React.createElement("path", {
    d: "M77 90v-1h1v1z",
    fill: "#5e6984"
  })), _path3771 || (_path3771 = /*#__PURE__*/React.createElement("path", {
    d: "M79 89v1h-1v-1z",
    fill: "#7f8698"
  })), _path3772 || (_path3772 = /*#__PURE__*/React.createElement("path", {
    d: "M79 90v-1h1v1z",
    fill: "#cacfcd"
  })), _path3773 || (_path3773 = /*#__PURE__*/React.createElement("path", {
    d: "M80 89h1v1h-1z",
    fill: "#c6cdcf"
  })), _path3774 || (_path3774 = /*#__PURE__*/React.createElement("path", {
    d: "M82 90h-1v-1h1z",
    fill: "#c9cfd0"
  })), _path3775 || (_path3775 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90h-1v-1h1z",
    fill: "#c9ceca"
  })), _path3776 || (_path3776 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89v1h-1v-1z",
    fill: "#c9cfcc"
  })), _path3777 || (_path3777 = /*#__PURE__*/React.createElement("path", {
    d: "M84 89h1v1h-1z",
    fill: "#c9cfcb"
  })), _path3778 || (_path3778 = /*#__PURE__*/React.createElement("path", {
    d: "M85 89h1v1h-1z",
    fill: "#ccd3cc"
  })), _path3779 || (_path3779 = /*#__PURE__*/React.createElement("path", {
    d: "M86 90v-1h1v1z",
    fill: "#cad1ce"
  })), _path3780 || (_path3780 = /*#__PURE__*/React.createElement("path", {
    d: "M88 89h1v1h-1z",
    fill: "#686f88"
  })), _path3781 || (_path3781 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90v-1h1v1z",
    fill: "#6d748d"
  })), _path3782 || (_path3782 = /*#__PURE__*/React.createElement("path", {
    d: "M91 89v1h-1v-1z",
    fill: "#717891"
  })), _path3783 || (_path3783 = /*#__PURE__*/React.createElement("path", {
    d: "M92 89v1h-1v-1z",
    fill: "#424655"
  })), _path3784 || (_path3784 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90v-1h1v1z",
    fill: "#a1a1a5",
    fillOpacity: 0.447
  })), _path3785 || (_path3785 = /*#__PURE__*/React.createElement("path", {
    d: "M35 90v1h-1v-1z",
    fill: "#707275",
    fillOpacity: 0.894
  })), _path3786 || (_path3786 = /*#__PURE__*/React.createElement("path", {
    d: "M38 90v1h-1v-1z",
    fill: "#495673"
  })), _path3787 || (_path3787 = /*#__PURE__*/React.createElement("path", {
    d: "M39 90h1v1h-1z",
    fill: "#614c68"
  })), _path3788 || (_path3788 = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h1v1h-1z",
    fill: "#b73757"
  })), _path3789 || (_path3789 = /*#__PURE__*/React.createElement("path", {
    d: "M42 91h-1v-1h1z",
    fill: "#cd6579"
  })), _path3790 || (_path3790 = /*#__PURE__*/React.createElement("path", {
    d: "M42 90h1v1h-1z",
    fill: "#eae4e1"
  })), _path3791 || (_path3791 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v-1h1v1z",
    fill: "#e0e6dc"
  })), _path3792 || (_path3792 = /*#__PURE__*/React.createElement("path", {
    d: "M44 90h1v1h-1z",
    fill: "#e0e7e1"
  })), _path3793 || (_path3793 = /*#__PURE__*/React.createElement("path", {
    d: "M45 90h1v1h-1z",
    fill: "#e4e9e4"
  })), _path3794 || (_path3794 = /*#__PURE__*/React.createElement("path", {
    d: "M47 90v1h-1v-1z",
    fill: "#e5b9b9"
  })), _path3795 || (_path3795 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91h-1v-1h1z",
    fill: "#c43f4b"
  })), _path3796 || (_path3796 = /*#__PURE__*/React.createElement("path", {
    d: "M49 90v1h-1v-1z",
    fill: "#94455f"
  })), _path3797 || (_path3797 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v-1h1v1z",
    fill: "#4e5473"
  })), _path3798 || (_path3798 = /*#__PURE__*/React.createElement("path", {
    d: "M50 91v-1h1v1z",
    fill: "#4c5675"
  })), _path3799 || (_path3799 = /*#__PURE__*/React.createElement("path", {
    d: "M53 90v1h-1v-1z",
    fill: "#5f6a82"
  })), _path3800 || (_path3800 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90v1h-1v-1z",
    fill: "#d6dfdc"
  })), _path3801 || (_path3801 = /*#__PURE__*/React.createElement("path", {
    d: "M54 90h1v1h-1z",
    fill: "#d9e5e1"
  })), _path3802 || (_path3802 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91h-1v-1h1z",
    fill: "#6f9dda"
  })), _path3803 || (_path3803 = /*#__PURE__*/React.createElement("path", {
    d: "M57 90v1h-1v-1z",
    fill: "#6180ba"
  })), _path3804 || (_path3804 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91h-1v-1h1z",
    fill: "#ab8654"
  })), _path3805 || (_path3805 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v-1h1v1z",
    fill: "#ddad32"
  })), _path3806 || (_path3806 = /*#__PURE__*/React.createElement("path", {
    d: "M59 90h1v1h-1z",
    fill: "#d5c66b"
  })), _path3807 || (_path3807 = /*#__PURE__*/React.createElement("path", {
    d: "M60 90h1v1h-1z",
    fill: "#e5ebdd"
  })), _path3808 || (_path3808 = /*#__PURE__*/React.createElement("path", {
    d: "M62 90v1h-1v-1z",
    fill: "#979eb1"
  })), _path3809 || (_path3809 = /*#__PURE__*/React.createElement("path", {
    d: "M64 91h-1v-1h1z",
    fill: "#50587e"
  })), _path3810 || (_path3810 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91h-1v-1h1z",
    fill: "#4d567b"
  })), _path3811 || (_path3811 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v-1h1v1z",
    fill: "#6c778e"
  })), _path3812 || (_path3812 = /*#__PURE__*/React.createElement("path", {
    d: "M66 90h1v1h-1z",
    fill: "#ceccce"
  })), _path3813 || (_path3813 = /*#__PURE__*/React.createElement("path", {
    d: "M67 90h1v1h-1z",
    fill: "#c19694"
  })), _path3814 || (_path3814 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90v1h-1v-1z",
    fill: "#cda9a9"
  })), _path3815 || (_path3815 = /*#__PURE__*/React.createElement("path", {
    d: "M69 90h1v1h-1z",
    fill: "#d0d7d1"
  })), _path3816 || (_path3816 = /*#__PURE__*/React.createElement("path", {
    d: "M71 90v1h-1v-1z",
    fill: "#d0d4d2"
  })), _path3817 || (_path3817 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v-1h1v1z",
    fill: "#ccd1cc"
  })), _path3818 || (_path3818 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v-1h1v1z",
    fill: "#b9bfb9"
  })), _path3819 || (_path3819 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91v-1h1v1z",
    fill: "#ced4ce"
  })), _path3820 || (_path3820 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91h-1v-1h1z",
    fill: "#99a1aa"
  })), _path3821 || (_path3821 = /*#__PURE__*/React.createElement("path", {
    d: "M75 90h1v1h-1z",
    fill: "#606884"
  })), _path3822 || (_path3822 = /*#__PURE__*/React.createElement("path", {
    d: "M77 91h-1v-1h1z",
    fill: "#606b87"
  })), _path3823 || (_path3823 = /*#__PURE__*/React.createElement("path", {
    d: "M80 90v1h-1v-1z",
    fill: "#ced0cf"
  })), _path3824 || (_path3824 = /*#__PURE__*/React.createElement("path", {
    d: "M80 91v-1h1v1z",
    fill: "#cacdc8"
  })), _path3825 || (_path3825 = /*#__PURE__*/React.createElement("path", {
    d: "M81 90h1v1h-1z",
    fill: "#cdd4ce"
  })), _path3826 || (_path3826 = /*#__PURE__*/React.createElement("path", {
    d: "M83 90v1h-1v-1z",
    fill: "#c7cec6"
  })), _path3827 || (_path3827 = /*#__PURE__*/React.createElement("path", {
    d: "M83 91v-1h1v1z",
    fill: "#c5ccc8"
  })), _path3828 || (_path3828 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h-1v-1h1z",
    fill: "#c7cdcc"
  })), _path3829 || (_path3829 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91v-1h1v1z",
    fill: "#c8cccc"
  })), _path3830 || (_path3830 = /*#__PURE__*/React.createElement("path", {
    d: "M87 91h-1v-1h1z",
    fill: "#cad1cf"
  })), _path3831 || (_path3831 = /*#__PURE__*/React.createElement("path", {
    d: "M88 91v-1h1v1z",
    fill: "#646d89"
  })), _path3832 || (_path3832 = /*#__PURE__*/React.createElement("path", {
    d: "M89 90h1v1h-1z",
    fill: "#67718a"
  })), _path3833 || (_path3833 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91v-1h1v1z",
    fill: "#6c758e"
  })), _path3834 || (_path3834 = /*#__PURE__*/React.createElement("path", {
    d: "M92 91h-1v-1h1z",
    fill: "#404554"
  })), _path3835 || (_path3835 = /*#__PURE__*/React.createElement("path", {
    d: "M93 90h1v1h-1z",
    fill: "#a3a1a7",
    fillOpacity: 0.447
  })), _path3836 || (_path3836 = /*#__PURE__*/React.createElement("path", {
    d: "M34 92v-1h1v1z",
    fill: "#727376",
    fillOpacity: 0.894
  })), _path3837 || (_path3837 = /*#__PURE__*/React.createElement("path", {
    d: "M37 91v1h-1v-1z",
    fill: "#49536d"
  })), _path3838 || (_path3838 = /*#__PURE__*/React.createElement("path", {
    d: "M38 92h-1v-1h1z",
    fill: "#4a5471"
  })), _path3839 || (_path3839 = /*#__PURE__*/React.createElement("path", {
    d: "M39 91h1v1h-1z",
    fill: "#554e67"
  })), _path3840 || (_path3840 = /*#__PURE__*/React.createElement("path", {
    d: "M40 91h1v1h-1z",
    fill: "#b63b54"
  })), _path3841 || (_path3841 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92v-1h1v1z",
    fill: "#c85768"
  })), _path3842 || (_path3842 = /*#__PURE__*/React.createElement("path", {
    d: "M43 91v1h-1v-1z",
    fill: "#e8dbda"
  })), _path3843 || (_path3843 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92h-1v-1h1z",
    fill: "#e1e5e1"
  })), _path3844 || (_path3844 = /*#__PURE__*/React.createElement("path", {
    d: "M44 92v-1h1v1z",
    fill: "#dbe7de"
  })), _path3845 || (_path3845 = /*#__PURE__*/React.createElement("path", {
    d: "M45 91h1v1h-1z",
    fill: "#e3eae2"
  })), _path3846 || (_path3846 = /*#__PURE__*/React.createElement("path", {
    d: "M46 92v-1h1v1z",
    fill: "#dda5a7"
  })), _path3847 || (_path3847 = /*#__PURE__*/React.createElement("path", {
    d: "M48 91v1h-1v-1z",
    fill: "#c63b3a"
  })), _path3848 || (_path3848 = /*#__PURE__*/React.createElement("path", {
    d: "M49 91v1h-1v-1z",
    fill: "#8b4956"
  })), _path3849 || (_path3849 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92h-1v-1h1z",
    fill: "#4b5372"
  })), _path3850 || (_path3850 = /*#__PURE__*/React.createElement("path", {
    d: "M53 91v1h-1v-1z",
    fill: "#58637b"
  })), _path3851 || (_path3851 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92v-1h1v1z",
    fill: "#d2dbd9"
  })), _path3852 || (_path3852 = /*#__PURE__*/React.createElement("path", {
    d: "M55 91v1h-1v-1z",
    fill: "#d9e7e8"
  })), _path3853 || (_path3853 = /*#__PURE__*/React.createElement("path", {
    d: "M56 91v1h-1v-1z",
    fill: "#8095b9"
  })), _path3854 || (_path3854 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92v-1h1v1z",
    fill: "#8e546a"
  })), _path3855 || (_path3855 = /*#__PURE__*/React.createElement("path", {
    d: "M58 91v1h-1v-1z",
    fill: "#b85345"
  })), _path3856 || (_path3856 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92v-1h1v1z",
    fill: "#d8b58b"
  })), _path3857 || (_path3857 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91v1h-1v-1z",
    fill: "#e2e1c4"
  })), _path3858 || (_path3858 = /*#__PURE__*/React.createElement("path", {
    d: "M60 91h1v1h-1z",
    fill: "#e6eae3"
  })), _path3859 || (_path3859 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92h-1v-1h1z",
    fill: "#4a5274"
  })), _path3860 || (_path3860 = /*#__PURE__*/React.createElement("path", {
    d: "M63 92v-1h1v1z",
    fill: "#50587c"
  })), _path3861 || (_path3861 = /*#__PURE__*/React.createElement("path", {
    d: "M65 91v1h-1v-1z",
    fill: "#4d557a"
  })), _path3862 || (_path3862 = /*#__PURE__*/React.createElement("path", {
    d: "M66 91v1h-1v-1z",
    fill: "#67708a"
  })), _path3863 || (_path3863 = /*#__PURE__*/React.createElement("path", {
    d: "M67 92h-1v-1h1z",
    fill: "#c4cacd"
  })), _path3864 || (_path3864 = /*#__PURE__*/React.createElement("path", {
    d: "M67 91h1v1h-1z",
    fill: "#d5d3ca"
  })), _path3865 || (_path3865 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h-1v-1h1z",
    fill: "#d2ceca"
  })), _path3866 || (_path3866 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h-1v-1h1z",
    fill: "#ced0ce"
  })), _path3867 || (_path3867 = /*#__PURE__*/React.createElement("path", {
    d: "M71 91v1h-1v-1z",
    fill: "#d1d3d1"
  })), _path3868 || (_path3868 = /*#__PURE__*/React.createElement("path", {
    d: "M72 91v1h-1v-1z",
    fill: "#cacfcb"
  })), _path3869 || (_path3869 = /*#__PURE__*/React.createElement("path", {
    d: "M72 92v-1h1v1z",
    fill: "#d0d5d0"
  })), _path3870 || (_path3870 = /*#__PURE__*/React.createElement("path", {
    d: "M73 91h1v1h-1z",
    fill: "#cbd1ce"
  })), _path3871 || (_path3871 = /*#__PURE__*/React.createElement("path", {
    d: "M75 91v1h-1v-1z",
    fill: "#939ca6"
  })), _path3872 || (_path3872 = /*#__PURE__*/React.createElement("path", {
    d: "M77 92h-1v-1h1z",
    fill: "#5e6885"
  })), _path3873 || (_path3873 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h-1v-1h1z",
    fill: "#5a6380"
  })), _path3874 || (_path3874 = /*#__PURE__*/React.createElement("path", {
    d: "M79 92v-1h1v1z",
    fill: "#cacecd"
  })), _path3875 || (_path3875 = /*#__PURE__*/React.createElement("path", {
    d: "M81 91v1h-1v-1z",
    fill: "#ced1cd"
  })), _path3876 || (_path3876 = /*#__PURE__*/React.createElement("path", {
    d: "M82 91v1h-1v-1z",
    fill: "#c8d0ca"
  })), _path3877 || (_path3877 = /*#__PURE__*/React.createElement("path", {
    d: "M85 91h1v1h-1z",
    fill: "#c5ccc7"
  })), _path3878 || (_path3878 = /*#__PURE__*/React.createElement("path", {
    d: "M88 92h-1v-1h1z",
    fill: "#909aa2"
  })), _path3879 || (_path3879 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92v-1h1v1z",
    fill: "#646e87"
  })), _path3880 || (_path3880 = /*#__PURE__*/React.createElement("path", {
    d: "M90 91h1v1h-1z",
    fill: "#69738d"
  })), _path3881 || (_path3881 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92h-1v-1h1z",
    fill: "#3f4453"
  })), _path3882 || (_path3882 = /*#__PURE__*/React.createElement("path", {
    d: "M94 91v1h-1v-1z",
    fill: "#a5a3aa",
    fillOpacity: 0.447
  })), _path3883 || (_path3883 = /*#__PURE__*/React.createElement("path", {
    d: "M35 92v1h-1v-1z",
    fill: "#727377",
    fillOpacity: 0.898
  })), _path3884 || (_path3884 = /*#__PURE__*/React.createElement("path", {
    d: "M36 93v-1h1v1z",
    fill: "#48526b"
  })), _path3885 || (_path3885 = /*#__PURE__*/React.createElement("path", {
    d: "M37 92h1v1h-1z",
    fill: "#4b536f"
  })), _path3886 || (_path3886 = /*#__PURE__*/React.createElement("path", {
    d: "M38 93v-1h1v1z",
    fill: "#495271"
  })), _path3887 || (_path3887 = /*#__PURE__*/React.createElement("path", {
    d: "M40 92v1h-1v-1z",
    fill: "#4b5069"
  })), _path3888 || (_path3888 = /*#__PURE__*/React.createElement("path", {
    d: "M40 93v-1h1v1z",
    fill: "#9d4459"
  })), _path3889 || (_path3889 = /*#__PURE__*/React.createElement("path", {
    d: "M41 92h1v1h-1z",
    fill: "#c74754"
  })), _path3890 || (_path3890 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h-1v-1h1z",
    fill: "#e0b6b0"
  })), _path3891 || (_path3891 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93v-1h1v1z",
    fill: "#e8dcd8"
  })), _path3892 || (_path3892 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92v1h-1v-1z",
    fill: "#e6dbd5"
  })), _path3893 || (_path3893 = /*#__PURE__*/React.createElement("path", {
    d: "M45 92h1v1h-1z",
    fill: "#e9d9d1"
  })), _path3894 || (_path3894 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93h-1v-1h1z",
    fill: "#d27b72"
  })), _path3895 || (_path3895 = /*#__PURE__*/React.createElement("path", {
    d: "M48 93h-1v-1h1z",
    fill: "#c23e34"
  })), _path3896 || (_path3896 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93h-1v-1h1z",
    fill: "#724a5c"
  })), _path3897 || (_path3897 = /*#__PURE__*/React.createElement("path", {
    d: "M50 92v1h-1v-1z",
    fill: "#495473"
  })), _path3898 || (_path3898 = /*#__PURE__*/React.createElement("path", {
    d: "M52 93h-1v-1h1z",
    fill: "#4a5374"
  })), _path3899 || (_path3899 = /*#__PURE__*/React.createElement("path", {
    d: "M54 93h-1v-1h1z",
    fill: "#b9c1c8"
  })), _path3900 || (_path3900 = /*#__PURE__*/React.createElement("path", {
    d: "M55 93h-1v-1h1z",
    fill: "#e5e9e5"
  })), _path3901 || (_path3901 = /*#__PURE__*/React.createElement("path", {
    d: "M56 93h-1v-1h1z",
    fill: "#a9898d"
  })), _path3902 || (_path3902 = /*#__PURE__*/React.createElement("path", {
    d: "M56 92h1v1h-1z",
    fill: "#c4817e"
  })), _path3903 || (_path3903 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93h-1v-1h1z",
    fill: "#e9cac4"
  })), _path3904 || (_path3904 = /*#__PURE__*/React.createElement("path", {
    d: "M58 92h1v1h-1z",
    fill: "#e3e4e3"
  })), _path3905 || (_path3905 = /*#__PURE__*/React.createElement("path", {
    d: "M59 92h1v1h-1z",
    fill: "#dee5df"
  })), _path3906 || (_path3906 = /*#__PURE__*/React.createElement("path", {
    d: "M61 92v1h-1v-1z",
    fill: "#e1e5e3"
  })), _path3907 || (_path3907 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h-1v-1h1z",
    fill: "#71798f"
  })), _path3908 || (_path3908 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93v-1h1v1z",
    fill: "#4a5375"
  })), _path3909 || (_path3909 = /*#__PURE__*/React.createElement("path", {
    d: "M64 92v1h-1v-1z",
    fill: "#4f577b"
  })), _path3910 || (_path3910 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93h-1v-1h1z",
    fill: "#4d5579"
  })), _path3911 || (_path3911 = /*#__PURE__*/React.createElement("path", {
    d: "M65 92h1v1h-1z",
    fill: "#56617a"
  })), _path3912 || (_path3912 = /*#__PURE__*/React.createElement("path", {
    d: "M66 92h1v1h-1z",
    fill: "#bcc0c6"
  })), _path3913 || (_path3913 = /*#__PURE__*/React.createElement("path", {
    d: "M67 93v-1h1v1z",
    fill: "#d7dbd5"
  })), _path3914 || (_path3914 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92v1h-1v-1z",
    fill: "#cdd6ce"
  })), _path3915 || (_path3915 = /*#__PURE__*/React.createElement("path", {
    d: "M69 92h1v1h-1z",
    fill: "#cccfc9"
  })), _path3916 || (_path3916 = /*#__PURE__*/React.createElement("path", {
    d: "M70 92h1v1h-1z",
    fill: "#cad0c8"
  })), _path3917 || (_path3917 = /*#__PURE__*/React.createElement("path", {
    d: "M71 92h1v1h-1z",
    fill: "#d2d9cf"
  })), _path3918 || (_path3918 = /*#__PURE__*/React.createElement("path", {
    d: "M73 92h1v1h-1z",
    fill: "#d0d6d6"
  })), _path3919 || (_path3919 = /*#__PURE__*/React.createElement("path", {
    d: "M74 92h1v1h-1z",
    fill: "#7d8494"
  })), _path3920 || (_path3920 = /*#__PURE__*/React.createElement("path", {
    d: "M76 93v-1h1v1z",
    fill: "#5c6581"
  })), _path3921 || (_path3921 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93h-1v-1h1z",
    fill: "#5a6382"
  })), _path3922 || (_path3922 = /*#__PURE__*/React.createElement("path", {
    d: "M78 92h1v1h-1z",
    fill: "#677085"
  })), _path3923 || (_path3923 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92v1h-1v-1z",
    fill: "#c8cdcb"
  })), _path3924 || (_path3924 = /*#__PURE__*/React.createElement("path", {
    d: "M81 92h1v1h-1z",
    fill: "#c5cdc7"
  })), _path3925 || (_path3925 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93v-1h1v1z",
    fill: "#c6cdc9"
  })), _path3926 || (_path3926 = /*#__PURE__*/React.createElement("path", {
    d: "M84 92v1h-1v-1z",
    fill: "#c6ccc8"
  })), _path3927 || (_path3927 = /*#__PURE__*/React.createElement("path", {
    d: "M86 92h1v1h-1z",
    fill: "#c7cecd"
  })), _path3928 || (_path3928 = /*#__PURE__*/React.createElement("path", {
    d: "M87 92h1v1h-1z",
    fill: "#7b8394"
  })), _path3929 || (_path3929 = /*#__PURE__*/React.createElement("path", {
    d: "M89 92h1v1h-1z",
    fill: "#616b87"
  })), _path3930 || (_path3930 = /*#__PURE__*/React.createElement("path", {
    d: "M90 92h1v1h-1z",
    fill: "#65708b"
  })), _path3931 || (_path3931 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93v-1h1v1z",
    fill: "#3d4252"
  })), _path3932 || (_path3932 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h-1v-1h1z",
    fill: "#3a3c3d"
  })), _path3933 || (_path3933 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94h-1v-1h1z",
    fill: "#717276",
    fillOpacity: 0.898
  })), _path3934 || (_path3934 = /*#__PURE__*/React.createElement("path", {
    d: "M35 93h1v1h-1z",
    fill: "#1e2128"
  })), _path3935 || (_path3935 = /*#__PURE__*/React.createElement("path", {
    d: "M39 93h1v1h-1z",
    fill: "#494f6d"
  })), _path3936 || (_path3936 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94h-1v-1h1z",
    fill: "#694b60"
  })), _path3937 || (_path3937 = /*#__PURE__*/React.createElement("path", {
    d: "M41 94v-1h1v1z",
    fill: "#b24450"
  })), _path3938 || (_path3938 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94v-1h1v1z",
    fill: "#c64b4b"
  })), _path3939 || (_path3939 = /*#__PURE__*/React.createElement("path", {
    d: "M43 93h1v1h-1z",
    fill: "#c95b56"
  })), _path3940 || (_path3940 = /*#__PURE__*/React.createElement("path", {
    d: "M45 94h-1v-1h1z",
    fill: "#cc5a53"
  })), _path3941 || (_path3941 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h-1v-1h1z",
    fill: "#c8564f"
  })), _path3942 || (_path3942 = /*#__PURE__*/React.createElement("path", {
    d: "M47 93v1h-1v-1z",
    fill: "#c5433b"
  })), _path3943 || (_path3943 = /*#__PURE__*/React.createElement("path", {
    d: "M48 94h-1v-1h1z",
    fill: "#99454c"
  })), _path3944 || (_path3944 = /*#__PURE__*/React.createElement("path", {
    d: "M49 93v1h-1v-1z",
    fill: "#524c67"
  })), _path3945 || (_path3945 = /*#__PURE__*/React.createElement("path", {
    d: "M50 94h-1v-1h1z",
    fill: "#48526f"
  })), _path3946 || (_path3946 = /*#__PURE__*/React.createElement("path", {
    d: "M51 93v1h-1v-1z",
    fill: "#49536f"
  })), _path3947 || (_path3947 = /*#__PURE__*/React.createElement("path", {
    d: "M54 94h-1v-1h1z",
    fill: "#717a8a"
  })), _path3948 || (_path3948 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h-1v-1h1z",
    fill: "#d6dedf"
  })), _path3949 || (_path3949 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h-1v-1h1z",
    fill: "#eae3dc"
  })), _path3950 || (_path3950 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94v-1h1v1z",
    fill: "#eaeae3"
  })), _path3951 || (_path3951 = /*#__PURE__*/React.createElement("path", {
    d: "M58 93v1h-1v-1z",
    fill: "#e7eae4"
  })), _path3952 || (_path3952 = /*#__PURE__*/React.createElement("path", {
    d: "M59 93v1h-1v-1z",
    fill: "#e9e8e4"
  })), _path3953 || (_path3953 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94h-1v-1h1z",
    fill: "#e6e8e4"
  })), _path3954 || (_path3954 = /*#__PURE__*/React.createElement("path", {
    d: "M60 93h1v1h-1z",
    fill: "#a6adb8"
  })), _path3955 || (_path3955 = /*#__PURE__*/React.createElement("path", {
    d: "M61 93h1v1h-1z",
    fill: "#4d5675"
  })), _path3956 || (_path3956 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h1v1h-1z",
    fill: "#4c5577"
  })), _path3957 || (_path3957 = /*#__PURE__*/React.createElement("path", {
    d: "M64 93v1h-1v-1z",
    fill: "#4d5677"
  })), _path3958 || (_path3958 = /*#__PURE__*/React.createElement("path", {
    d: "M65 93v1h-1v-1z",
    fill: "#4d5678"
  })), _path3959 || (_path3959 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94h-1v-1h1z",
    fill: "#838b98"
  })), _path3960 || (_path3960 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h-1v-1h1z",
    fill: "#d2d7d9"
  })), _path3961 || (_path3961 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94v-1h1v1z",
    fill: "#d1d6d2"
  })), _path3962 || (_path3962 = /*#__PURE__*/React.createElement("path", {
    d: "M70 93v1h-1v-1z",
    fill: "#cad1ca"
  })), _path3963 || (_path3963 = /*#__PURE__*/React.createElement("path", {
    d: "M71 93v1h-1v-1z",
    fill: "#ced3cd"
  })), _path3964 || (_path3964 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93v1h-1v-1z",
    fill: "#ced4cd"
  })), _path3965 || (_path3965 = /*#__PURE__*/React.createElement("path", {
    d: "M72 93h1v1h-1z",
    fill: "#d5dbd9"
  })), _path3966 || (_path3966 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94h-1v-1h1z",
    fill: "#a9afb8"
  })), _path3967 || (_path3967 = /*#__PURE__*/React.createElement("path", {
    d: "M75 94h-1v-1h1z",
    fill: "#5b617a"
  })), _path3968 || (_path3968 = /*#__PURE__*/React.createElement("path", {
    d: "M75 93h1v1h-1z",
    fill: "#59627e"
  })), _path3969 || (_path3969 = /*#__PURE__*/React.createElement("path", {
    d: "M78 93v1h-1v-1z",
    fill: "#596180"
  })), _path3970 || (_path3970 = /*#__PURE__*/React.createElement("path", {
    d: "M78 94v-1h1v1z",
    fill: "#575e79"
  })), _path3971 || (_path3971 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94v-1h1v1z",
    fill: "#cacfd2"
  })), _path3972 || (_path3972 = /*#__PURE__*/React.createElement("path", {
    d: "M82 93h1v1h-1z",
    fill: "#cad0c9"
  })), _path3973 || (_path3973 = /*#__PURE__*/React.createElement("path", {
    d: "M83 94v-1h1v1z",
    fill: "#c8cec9"
  })), _path3974 || (_path3974 = /*#__PURE__*/React.createElement("path", {
    d: "M84 93h1v1h-1z",
    fill: "#cad0cd"
  })), _path3975 || (_path3975 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94v-1h1v1z",
    fill: "#ccd2d0"
  })), _path3976 || (_path3976 = /*#__PURE__*/React.createElement("path", {
    d: "M86 93h1v1h-1z",
    fill: "#a5abb3"
  })), _path3977 || (_path3977 = /*#__PURE__*/React.createElement("path", {
    d: "M88 93v1h-1v-1z",
    fill: "#616781"
  })), _path3978 || (_path3978 = /*#__PURE__*/React.createElement("path", {
    d: "M90 93v1h-1v-1z",
    fill: "#606a84"
  })), _path3979 || (_path3979 = /*#__PURE__*/React.createElement("path", {
    d: "M91 93h1v1h-1z",
    fill: "#3c4150"
  })), _path3980 || (_path3980 = /*#__PURE__*/React.createElement("path", {
    d: "M93 94h-1v-1h1z",
    fill: "#3a3b3c"
  })), _path3981 || (_path3981 = /*#__PURE__*/React.createElement("path", {
    d: "M34 94v1h-1v-1z",
    fill: "#f3f3ff",
    fillOpacity: 0.09
  })), _path3982 || (_path3982 = /*#__PURE__*/React.createElement("path", {
    d: "M35 94v1h-1v-1z",
    fill: "#727477",
    fillOpacity: 0.902
  })), _path3983 || (_path3983 = /*#__PURE__*/React.createElement("path", {
    d: "M36 94v1h-1v-1z",
    fill: "#1f2127"
  })), _path3984 || (_path3984 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95v-1h1v1z",
    fill: "#484f68"
  })), _path3985 || (_path3985 = /*#__PURE__*/React.createElement("path", {
    d: "M37 94h1v1h-1z",
    fill: "#48506c"
  })), _path3986 || (_path3986 = /*#__PURE__*/React.createElement("path", {
    d: "M40 95v-1h1v1z",
    fill: "#494f66"
  })), _path3987 || (_path3987 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95v-1h1v1z",
    fill: "#5e495e"
  })), _path3988 || (_path3988 = /*#__PURE__*/React.createElement("path", {
    d: "M42 94h1v1h-1z",
    fill: "#824355"
  })), _path3989 || (_path3989 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95h-1v-1h1z",
    fill: "#93414b"
  })), _path3990 || (_path3990 = /*#__PURE__*/React.createElement("path", {
    d: "M44 94h1v1h-1z",
    fill: "#984346"
  })), _path3991 || (_path3991 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v-1h1v1z",
    fill: "#914347"
  })), _path3992 || (_path3992 = /*#__PURE__*/React.createElement("path", {
    d: "M46 94h1v1h-1z",
    fill: "#774751"
  })), _path3993 || (_path3993 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95h-1v-1h1z",
    fill: "#524e61"
  })), _path3994 || (_path3994 = /*#__PURE__*/React.createElement("path", {
    d: "M48 95v-1h1v1z",
    fill: "#425269"
  })), _path3995 || (_path3995 = /*#__PURE__*/React.createElement("path", {
    d: "M49 94h1v1h-1z",
    fill: "#46516b"
  })), _path3996 || (_path3996 = /*#__PURE__*/React.createElement("path", {
    d: "M53 95v-1h1v1z",
    fill: "#444d67"
  })), _path3997 || (_path3997 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94v1h-1v-1z",
    fill: "#60697f"
  })), _path3998 || (_path3998 = /*#__PURE__*/React.createElement("path", {
    d: "M55 94h1v1h-1z",
    fill: "#959dab"
  })), _path3999 || (_path3999 = /*#__PURE__*/React.createElement("path", {
    d: "M56 94h1v1h-1z",
    fill: "#a7b1b8"
  })), _path4000 || (_path4000 = /*#__PURE__*/React.createElement("path", {
    d: "M58 94v1h-1v-1z",
    fill: "#a7b2b6"
  })), _path4001 || (_path4001 = /*#__PURE__*/React.createElement("path", {
    d: "M59 95h-1v-1h1z",
    fill: "#9da8b0"
  })), _path4002 || (_path4002 = /*#__PURE__*/React.createElement("path", {
    d: "M60 94v1h-1v-1z",
    fill: "#7b8494"
  })), _path4003 || (_path4003 = /*#__PURE__*/React.createElement("path", {
    d: "M60 95v-1h1v1z",
    fill: "#4e566f"
  })), _path4004 || (_path4004 = /*#__PURE__*/React.createElement("path", {
    d: "M64 94h1v1h-1z",
    fill: "#4b5474"
  })), _path4005 || (_path4005 = /*#__PURE__*/React.createElement("path", {
    d: "M66 94v1h-1v-1z",
    fill: "#4e5576"
  })), _path4006 || (_path4006 = /*#__PURE__*/React.createElement("path", {
    d: "M67 94v1h-1v-1z",
    fill: "#4d5472"
  })), _path4007 || (_path4007 = /*#__PURE__*/React.createElement("path", {
    d: "M67 95v-1h1v1z",
    fill: "#6d7589"
  })), _path4008 || (_path4008 = /*#__PURE__*/React.createElement("path", {
    d: "M68 94h1v1h-1z",
    fill: "#969da9"
  })), _path4009 || (_path4009 = /*#__PURE__*/React.createElement("path", {
    d: "M69 94h1v1h-1z",
    fill: "#a4abb4"
  })), _path4010 || (_path4010 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95h-1v-1h1z",
    fill: "#a5acb5"
  })), _path4011 || (_path4011 = /*#__PURE__*/React.createElement("path", {
    d: "M71 94h1v1h-1z",
    fill: "#9ca4ab"
  })), _path4012 || (_path4012 = /*#__PURE__*/React.createElement("path", {
    d: "M72 94h1v1h-1z",
    fill: "#818797"
  })), _path4013 || (_path4013 = /*#__PURE__*/React.createElement("path", {
    d: "M74 94v1h-1v-1z",
    fill: "#595e78"
  })), _path4014 || (_path4014 = /*#__PURE__*/React.createElement("path", {
    d: "M74 95v-1h1v1z",
    fill: "#525a77"
  })), _path4015 || (_path4015 = /*#__PURE__*/React.createElement("path", {
    d: "M76 95v-1h1v1z",
    fill: "#555e7a"
  })), _path4016 || (_path4016 = /*#__PURE__*/React.createElement("path", {
    d: "M77 95v-1h1v1z",
    fill: "#535d7a"
  })), _path4017 || (_path4017 = /*#__PURE__*/React.createElement("path", {
    d: "M80 95h-1v-1h1z",
    fill: "#555d76"
  })), _path4018 || (_path4018 = /*#__PURE__*/React.createElement("path", {
    d: "M80 94h1v1h-1z",
    fill: "#788092"
  })), _path4019 || (_path4019 = /*#__PURE__*/React.createElement("path", {
    d: "M81 94h1v1h-1z",
    fill: "#9ba4ac"
  })), _path4020 || (_path4020 = /*#__PURE__*/React.createElement("path", {
    d: "M84 95v-1h1v1z",
    fill: "#a2a9b0"
  })), _path4021 || (_path4021 = /*#__PURE__*/React.createElement("path", {
    d: "M85 94h1v1h-1z",
    fill: "#868d9a"
  })), _path4022 || (_path4022 = /*#__PURE__*/React.createElement("path", {
    d: "M87 94v1h-1v-1z",
    fill: "#5e677d"
  })), _path4023 || (_path4023 = /*#__PURE__*/React.createElement("path", {
    d: "M87 95v-1h1v1z",
    fill: "#5b6481"
  })), _path4024 || (_path4024 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95v-1h1v1z",
    fill: "#5e6881"
  })), _path4025 || (_path4025 = /*#__PURE__*/React.createElement("path", {
    d: "M90 94h1v1h-1z",
    fill: "#626d87"
  })), _path4026 || (_path4026 = /*#__PURE__*/React.createElement("path", {
    d: "M92 94v1h-1v-1z",
    fill: "#3b414d"
  })), _path4027 || (_path4027 = /*#__PURE__*/React.createElement("path", {
    d: "M93 95v-1h1v1z",
    fill: "#a5a3ac",
    fillOpacity: 0.447
  })), _path4028 || (_path4028 = /*#__PURE__*/React.createElement("path", {
    d: "M36 95h1v1h-1z",
    fill: "#474d65"
  })), _path4029 || (_path4029 = /*#__PURE__*/React.createElement("path", {
    d: "M38 95v1h-1v-1z",
    fill: "#474e6b"
  })), _path4030 || (_path4030 = /*#__PURE__*/React.createElement("path", {
    d: "M38 96v-1h1v1z",
    fill: "#484e69"
  })), _path4031 || (_path4031 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h-1v-1h1z",
    fill: "#464e68"
  })), _path4032 || (_path4032 = /*#__PURE__*/React.createElement("path", {
    d: "M41 95h1v1h-1z",
    fill: "#464f68"
  })), _path4033 || (_path4033 = /*#__PURE__*/React.createElement("path", {
    d: "M43 96h-1v-1h1z",
    fill: "#5f647b"
  })), _path4034 || (_path4034 = /*#__PURE__*/React.createElement("path", {
    d: "M44 95v1h-1v-1z",
    fill: "#585c71"
  })), _path4035 || (_path4035 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95v1h-1v-1z",
    fill: "#4e5569"
  })), _path4036 || (_path4036 = /*#__PURE__*/React.createElement("path", {
    d: "M45 95h1v1h-1z",
    fill: "#4f576c"
  })), _path4037 || (_path4037 = /*#__PURE__*/React.createElement("path", {
    d: "M47 95v1h-1v-1z",
    fill: "#46536f"
  })), _path4038 || (_path4038 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v-1h1v1z",
    fill: "#414f6d"
  })), _path4039 || (_path4039 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95v1h-1v-1z",
    fill: "#636a84"
  })), _path4040 || (_path4040 = /*#__PURE__*/React.createElement("path", {
    d: "M54 95h1v1h-1z",
    fill: "#5a607c"
  })), _path4041 || (_path4041 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96h-1v-1h1z",
    fill: "#484e6d"
  })), _path4042 || (_path4042 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96v-1h1v1z",
    fill: "#4a506f"
  })), _path4043 || (_path4043 = /*#__PURE__*/React.createElement("path", {
    d: "M58 95h1v1h-1z",
    fill: "#505b73"
  })), _path4044 || (_path4044 = /*#__PURE__*/React.createElement("path", {
    d: "M62 95v1h-1v-1z",
    fill: "#4c5573"
  })), _path4045 || (_path4045 = /*#__PURE__*/React.createElement("path", {
    d: "M65 96h-1v-1h1z",
    fill: "#4a5372"
  })), _path4046 || (_path4046 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96v-1h1v1z",
    fill: "#4a5472"
  })), _path4047 || (_path4047 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96h-1v-1h1z",
    fill: "#5b6480"
  })), _path4048 || (_path4048 = /*#__PURE__*/React.createElement("path", {
    d: "M68 96v-1h1v1z",
    fill: "#555e78"
  })), _path4049 || (_path4049 = /*#__PURE__*/React.createElement("path", {
    d: "M71 95v1h-1v-1z",
    fill: "#515a74"
  })), _path4050 || (_path4050 = /*#__PURE__*/React.createElement("path", {
    d: "M71 96v-1h1v1z",
    fill: "#576176"
  })), _path4051 || (_path4051 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h-1v-1h1z",
    fill: "#565f76"
  })), _path4052 || (_path4052 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96h-1v-1h1z",
    fill: "#636b81"
  })), _path4053 || (_path4053 = /*#__PURE__*/React.createElement("path", {
    d: "M80 96v-1h1v1z",
    fill: "#646b82"
  })), _path4054 || (_path4054 = /*#__PURE__*/React.createElement("path", {
    d: "M81 95h1v1h-1z",
    fill: "#5c627b"
  })), _path4055 || (_path4055 = /*#__PURE__*/React.createElement("path", {
    d: "M85 95v1h-1v-1z",
    fill: "#596379"
  })), _path4056 || (_path4056 = /*#__PURE__*/React.createElement("path", {
    d: "M85 96v-1h1v1z",
    fill: "#5f6881"
  })), _path4057 || (_path4057 = /*#__PURE__*/React.createElement("path", {
    d: "M86 95h1v1h-1z",
    fill: "#6b768d"
  })), _path4058 || (_path4058 = /*#__PURE__*/React.createElement("path", {
    d: "M89 96h-1v-1h1z",
    fill: "#5a647f"
  })), _path4059 || (_path4059 = /*#__PURE__*/React.createElement("path", {
    d: "M89 95h1v1h-1z",
    fill: "#5b6680"
  })), _path4060 || (_path4060 = /*#__PURE__*/React.createElement("path", {
    d: "M91 95h1v1h-1z",
    fill: "#3a404b"
  })), _path4061 || (_path4061 = /*#__PURE__*/React.createElement("path", {
    d: "M36 96h1v1h-1z",
    fill: "#464c64"
  })), _path4062 || (_path4062 = /*#__PURE__*/React.createElement("path", {
    d: "M39 97h-1v-1h1z",
    fill: "#464d67"
  })), _path4063 || (_path4063 = /*#__PURE__*/React.createElement("path", {
    d: "M41 96h1v1h-1z",
    fill: "#474e69"
  })), _path4064 || (_path4064 = /*#__PURE__*/React.createElement("path", {
    d: "M42 97v-1h1v1z",
    fill: "#7d8699"
  })), _path4065 || (_path4065 = /*#__PURE__*/React.createElement("path", {
    d: "M43 97v-1h1v1z",
    fill: "#8c919f"
  })), _path4066 || (_path4066 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97h-1v-1h1z",
    fill: "#898a96"
  })), _path4067 || (_path4067 = /*#__PURE__*/React.createElement("path", {
    d: "M46 96v1h-1v-1z",
    fill: "#8d95a0"
  })), _path4068 || (_path4068 = /*#__PURE__*/React.createElement("path", {
    d: "M47 96v1h-1v-1z",
    fill: "#6e7689"
  })), _path4069 || (_path4069 = /*#__PURE__*/React.createElement("path", {
    d: "M48 97v-1h1v1z",
    fill: "#434f69"
  })), _path4070 || (_path4070 = /*#__PURE__*/React.createElement("path", {
    d: "M53 96v1h-1v-1z",
    fill: "#4a546b"
  })), _path4071 || (_path4071 = /*#__PURE__*/React.createElement("path", {
    d: "M54 96v1h-1v-1z",
    fill: "#80879a"
  })), _path4072 || (_path4072 = /*#__PURE__*/React.createElement("path", {
    d: "M55 96v1h-1v-1z",
    fill: "#8f95a6"
  })), _path4073 || (_path4073 = /*#__PURE__*/React.createElement("path", {
    d: "M57 96v1h-1v-1z",
    fill: "#677082"
  })), _path4074 || (_path4074 = /*#__PURE__*/React.createElement("path", {
    d: "M58 96v1h-1v-1z",
    fill: "#828a9a"
  })), _path4075 || (_path4075 = /*#__PURE__*/React.createElement("path", {
    d: "M60 96v1h-1v-1z",
    fill: "#868d9d"
  })), _path4076 || (_path4076 = /*#__PURE__*/React.createElement("path", {
    d: "M60 97v-1h1v1z",
    fill: "#8f96a6"
  })), _path4077 || (_path4077 = /*#__PURE__*/React.createElement("path", {
    d: "M61 96h1v1h-1z",
    fill: "#687087"
  })), _path4078 || (_path4078 = /*#__PURE__*/React.createElement("path", {
    d: "M63 96v1h-1v-1z",
    fill: "#464f6c"
  })), _path4079 || (_path4079 = /*#__PURE__*/React.createElement("path", {
    d: "M65 97v-1h1v1z",
    fill: "#4a5270"
  })), _path4080 || (_path4080 = /*#__PURE__*/React.createElement("path", {
    d: "M66 96h1v1h-1z",
    fill: "#4c546e"
  })), _path4081 || (_path4081 = /*#__PURE__*/React.createElement("path", {
    d: "M67 96h1v1h-1z",
    fill: "#7c8499"
  })), _path4082 || (_path4082 = /*#__PURE__*/React.createElement("path", {
    d: "M72 96h1v1h-1z",
    fill: "#969eaf"
  })), _path4083 || (_path4083 = /*#__PURE__*/React.createElement("path", {
    d: "M73 96h1v1h-1z",
    fill: "#59607a"
  })), _path4084 || (_path4084 = /*#__PURE__*/React.createElement("path", {
    d: "M78 96h1v1h-1z",
    fill: "#525975"
  })), _path4085 || (_path4085 = /*#__PURE__*/React.createElement("path", {
    d: "M79 97v-1h1v1z",
    fill: "#8890a0"
  })), _path4086 || (_path4086 = /*#__PURE__*/React.createElement("path", {
    d: "M80 97v-1h1v1z",
    fill: "#99a1ae"
  })), _path4087 || (_path4087 = /*#__PURE__*/React.createElement("path", {
    d: "M81 96h1v1h-1z",
    fill: "#8c92a4"
  })), _path4088 || (_path4088 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97v-1h1v1z",
    fill: "#959cad"
  })), _path4089 || (_path4089 = /*#__PURE__*/React.createElement("path", {
    d: "M86 96v1h-1v-1z",
    fill: "#929aaa"
  })), _path4090 || (_path4090 = /*#__PURE__*/React.createElement("path", {
    d: "M87 96v1h-1v-1z",
    fill: "#8c97aa"
  })), _path4091 || (_path4091 = /*#__PURE__*/React.createElement("path", {
    d: "M87 97v-1h1v1z",
    fill: "#5b667d"
  })), _path4092 || (_path4092 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96h1v1h-1z",
    fill: "#58627d"
  })), _path4093 || (_path4093 = /*#__PURE__*/React.createElement("path", {
    d: "M90 96h1v1h-1z",
    fill: "#5e6983"
  })), _path4094 || (_path4094 = /*#__PURE__*/React.createElement("path", {
    d: "M92 97h-1v-1h1z",
    fill: "#393f4b"
  })), _path4095 || (_path4095 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98h-1v-1h1z",
    fill: "#f4f4ff",
    fillOpacity: 0.098
  })), _path4096 || (_path4096 = /*#__PURE__*/React.createElement("path", {
    d: "M35 97v1h-1v-1z",
    fill: "#707376",
    fillOpacity: 0.91
  })), _path4097 || (_path4097 = /*#__PURE__*/React.createElement("path", {
    d: "M36 98v-1h1v1z",
    fill: "#454c63"
  })), _path4098 || (_path4098 = /*#__PURE__*/React.createElement("path", {
    d: "M39 98v-1h1v1z",
    fill: "#454c67"
  })), _path4099 || (_path4099 = /*#__PURE__*/React.createElement("path", {
    d: "M40 98v-1h1v1z",
    fill: "#454d68"
  })), _path4100 || (_path4100 = /*#__PURE__*/React.createElement("path", {
    d: "M41 98v-1h1v1z",
    fill: "#434d62"
  })), _path4101 || (_path4101 = /*#__PURE__*/React.createElement("path", {
    d: "M45 97v1h-1v-1z",
    fill: "#4e596f"
  })), _path4102 || (_path4102 = /*#__PURE__*/React.createElement("path", {
    d: "M46 98h-1v-1h1z",
    fill: "#4f5570"
  })), _path4103 || (_path4103 = /*#__PURE__*/React.createElement("path", {
    d: "M47 97v1h-1v-1z",
    fill: "#4b526e"
  })), _path4104 || (_path4104 = /*#__PURE__*/React.createElement("path", {
    d: "M49 97h1v1h-1z",
    fill: "#434e66"
  })), _path4105 || (_path4105 = /*#__PURE__*/React.createElement("path", {
    d: "M54 97h1v1h-1z",
    fill: "#4d566f"
  })), _path4106 || (_path4106 = /*#__PURE__*/React.createElement("path", {
    d: "M55 97h1v1h-1z",
    fill: "#5e667e"
  })), _path4107 || (_path4107 = /*#__PURE__*/React.createElement("path", {
    d: "M57 97v1h-1v-1z",
    fill: "#505871"
  })), _path4108 || (_path4108 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h-1v-1h1z",
    fill: "#4f5771"
  })), _path4109 || (_path4109 = /*#__PURE__*/React.createElement("path", {
    d: "M62 97v1h-1v-1z",
    fill: "#4c5570"
  })), _path4110 || (_path4110 = /*#__PURE__*/React.createElement("path", {
    d: "M63 98h-1v-1h1z",
    fill: "#45506b"
  })), _path4111 || (_path4111 = /*#__PURE__*/React.createElement("path", {
    d: "M66 97v1h-1v-1z",
    fill: "#48516f"
  })), _path4112 || (_path4112 = /*#__PURE__*/React.createElement("path", {
    d: "M67 97v1h-1v-1z",
    fill: "#4a5171"
  })), _path4113 || (_path4113 = /*#__PURE__*/React.createElement("path", {
    d: "M67 98v-1h1v1z",
    fill: "#535976"
  })), _path4114 || (_path4114 = /*#__PURE__*/React.createElement("path", {
    d: "M69 97v1h-1v-1z",
    fill: "#555b75"
  })), _path4115 || (_path4115 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h-1v-1h1z",
    fill: "#555c75"
  })), _path4116 || (_path4116 = /*#__PURE__*/React.createElement("path", {
    d: "M70 97h1v1h-1z",
    fill: "#5d657c"
  })), _path4117 || (_path4117 = /*#__PURE__*/React.createElement("path", {
    d: "M71 97h1v1h-1z",
    fill: "#697189"
  })), _path4118 || (_path4118 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98h-1v-1h1z",
    fill: "#555d78"
  })), _path4119 || (_path4119 = /*#__PURE__*/React.createElement("path", {
    d: "M74 97v1h-1v-1z",
    fill: "#4e5573"
  })), _path4120 || (_path4120 = /*#__PURE__*/React.createElement("path", {
    d: "M78 97v1h-1v-1z",
    fill: "#4d5674"
  })), _path4121 || (_path4121 = /*#__PURE__*/React.createElement("path", {
    d: "M80 98v-1h1v1z",
    fill: "#596077"
  })), _path4122 || (_path4122 = /*#__PURE__*/React.createElement("path", {
    d: "M81 98v-1h1v1z",
    fill: "#5c637a"
  })), _path4123 || (_path4123 = /*#__PURE__*/React.createElement("path", {
    d: "M82 97h1v1h-1z",
    fill: "#586179"
  })), _path4124 || (_path4124 = /*#__PURE__*/React.createElement("path", {
    d: "M83 98v-1h1v1z",
    fill: "#5c647e"
  })), _path4125 || (_path4125 = /*#__PURE__*/React.createElement("path", {
    d: "M84 97h1v1h-1z",
    fill: "#606680"
  })), _path4126 || (_path4126 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97v1h-1v-1z",
    fill: "#5f657d"
  })), _path4127 || (_path4127 = /*#__PURE__*/React.createElement("path", {
    d: "M86 97h1v1h-1z",
    fill: "#58627a"
  })), _path4128 || (_path4128 = /*#__PURE__*/React.createElement("path", {
    d: "M88 97v1h-1v-1z",
    fill: "#555f79"
  })), _path4129 || (_path4129 = /*#__PURE__*/React.createElement("path", {
    d: "M89 97v1h-1v-1z",
    fill: "#555f7a"
  })), _path4130 || (_path4130 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98h-1v-1h1z",
    fill: "#58627c"
  })), _path4131 || (_path4131 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v-1h1v1z",
    fill: "#5c6781"
  })), _path4132 || (_path4132 = /*#__PURE__*/React.createElement("path", {
    d: "M91 97h1v1h-1z",
    fill: "#393e4a"
  })), _path4133 || (_path4133 = /*#__PURE__*/React.createElement("path", {
    d: "M34 98v1h-1v-1z",
    fill: "#ebf5f5",
    fillOpacity: 0.102
  })), _path4134 || (_path4134 = /*#__PURE__*/React.createElement("path", {
    d: "M35 98v1h-1v-1z",
    fill: "#707276",
    fillOpacity: 0.914
  })), _path4135 || (_path4135 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h-1v-1h1z",
    fill: "#444a61"
  })), _path4136 || (_path4136 = /*#__PURE__*/React.createElement("path", {
    d: "M38 99h-1v-1h1z",
    fill: "#444c64"
  })), _path4137 || (_path4137 = /*#__PURE__*/React.createElement("path", {
    d: "M39 99h-1v-1h1z",
    fill: "#444b64"
  })), _path4138 || (_path4138 = /*#__PURE__*/React.createElement("path", {
    d: "M41 99v-1h1v1z",
    fill: "#434b68"
  })), _path4139 || (_path4139 = /*#__PURE__*/React.createElement("path", {
    d: "M45 98h1v1h-1z",
    fill: "#424d66"
  })), _path4140 || (_path4140 = /*#__PURE__*/React.createElement("path", {
    d: "M58 99h-1v-1h1z",
    fill: "#424d68"
  })), _path4141 || (_path4141 = /*#__PURE__*/React.createElement("path", {
    d: "M58 98h1v1h-1z",
    fill: "#424f69"
  })), _path4142 || (_path4142 = /*#__PURE__*/React.createElement("path", {
    d: "M70 98h1v1h-1z",
    fill: "#454f6b"
  })), _path4143 || (_path4143 = /*#__PURE__*/React.createElement("path", {
    d: "M73 98v1h-1v-1z",
    fill: "#48536c"
  })), _path4144 || (_path4144 = /*#__PURE__*/React.createElement("path", {
    d: "M80 99v-1h1v1z",
    fill: "#4b5471"
  })), _path4145 || (_path4145 = /*#__PURE__*/React.createElement("path", {
    d: "M86 98h1v1h-1z",
    fill: "#525b77"
  })), _path4146 || (_path4146 = /*#__PURE__*/React.createElement("path", {
    d: "M88 98v1h-1v-1z",
    fill: "#535c78"
  })), _path4147 || (_path4147 = /*#__PURE__*/React.createElement("path", {
    d: "M88 99v-1h1v1z",
    fill: "#545e79"
  })), _path4148 || (_path4148 = /*#__PURE__*/React.createElement("path", {
    d: "M90 98v1h-1v-1z",
    fill: "#556079"
  })), _path4149 || (_path4149 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h-1v-1h1z",
    fill: "#5a657f"
  })), _path4150 || (_path4150 = /*#__PURE__*/React.createElement("path", {
    d: "M91 98h1v1h-1z",
    fill: "#373d4a"
  })), _path4151 || (_path4151 = /*#__PURE__*/React.createElement("path", {
    d: "M34 99h1v1h-1z",
    fill: "#707477",
    fillOpacity: 0.914
  })), _path4152 || (_path4152 = /*#__PURE__*/React.createElement("path", {
    d: "M36 99h1v1h-1z",
    fill: "#424960"
  })), _path4153 || (_path4153 = /*#__PURE__*/React.createElement("path", {
    d: "M37 99h1v1h-1z",
    fill: "#424a62"
  })), _path4154 || (_path4154 = /*#__PURE__*/React.createElement("path", {
    d: "M39 100h-1v-1h1z",
    fill: "#424962"
  })), _path4155 || (_path4155 = /*#__PURE__*/React.createElement("path", {
    d: "M44 100h-1v-1h1z",
    fill: "#424a64"
  })), _path4156 || (_path4156 = /*#__PURE__*/React.createElement("path", {
    d: "M65 99v1h-1v-1z",
    fill: "#454e6a"
  })), _path4157 || (_path4157 = /*#__PURE__*/React.createElement("path", {
    d: "M86 99h1v1h-1z",
    fill: "#505976"
  })), _path4158 || (_path4158 = /*#__PURE__*/React.createElement("path", {
    d: "M89 99v1h-1v-1z",
    fill: "#535d78"
  })), _path4159 || (_path4159 = /*#__PURE__*/React.createElement("path", {
    d: "M90 100h-1v-1h1z",
    fill: "#545e78"
  })), _path4160 || (_path4160 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99v1h-1v-1z",
    fill: "#58637d"
  })), _path4161 || (_path4161 = /*#__PURE__*/React.createElement("path", {
    d: "M91 99h1v1h-1z",
    fill: "#363c49"
  })), _path4162 || (_path4162 = /*#__PURE__*/React.createElement("path", {
    d: "M33 101v-1h1v1z",
    fill: "#ececec",
    fillOpacity: 0.11
  })), _path4163 || (_path4163 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101h-1v-1h1z",
    fill: "#1b1d25"
  })), _path4164 || (_path4164 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h-1v-1h1z",
    fill: "#40465e"
  })), _path4165 || (_path4165 = /*#__PURE__*/React.createElement("path", {
    d: "M38 100v1h-1v-1z",
    fill: "#414860"
  })), _path4166 || (_path4166 = /*#__PURE__*/React.createElement("path", {
    d: "M44 101h-1v-1h1z",
    fill: "#414960"
  })), _path4167 || (_path4167 = /*#__PURE__*/React.createElement("path", {
    d: "M62 101v-1h1v1z",
    fill: "#48526e"
  })), _path4168 || (_path4168 = /*#__PURE__*/React.createElement("path", {
    d: "M64 101h-1v-1h1z",
    fill: "#444c6a"
  })), _path4169 || (_path4169 = /*#__PURE__*/React.createElement("path", {
    d: "M64 100h1v1h-1z",
    fill: "#484f6a"
  })), _path4170 || (_path4170 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h-1v-1h1z",
    fill: "#485068"
  })), _path4171 || (_path4171 = /*#__PURE__*/React.createElement("path", {
    d: "M79 100h1v1h-1z",
    fill: "#49516f"
  })), _path4172 || (_path4172 = /*#__PURE__*/React.createElement("path", {
    d: "M85 101v-1h1v1z",
    fill: "#4d5772"
  })), _path4173 || (_path4173 = /*#__PURE__*/React.createElement("path", {
    d: "M86 100h1v1h-1z",
    fill: "#4e5873"
  })), _path4174 || (_path4174 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100v1h-1v-1z",
    fill: "#4f5974"
  })), _path4175 || (_path4175 = /*#__PURE__*/React.createElement("path", {
    d: "M88 100h1v1h-1z",
    fill: "#505a75"
  })), _path4176 || (_path4176 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v-1h1v1z",
    fill: "#56617c"
  })), _path4177 || (_path4177 = /*#__PURE__*/React.createElement("path", {
    d: "M91 101v-1h1v1z",
    fill: "#343a47"
  })), _path4178 || (_path4178 = /*#__PURE__*/React.createElement("path", {
    d: "M36 101v1h-1v-1z",
    fill: "#1c1e25"
  })), _path4179 || (_path4179 = /*#__PURE__*/React.createElement("path", {
    d: "M36 102v-1h1v1z",
    fill: "#3f465d"
  })), _path4180 || (_path4180 = /*#__PURE__*/React.createElement("path", {
    d: "M37 101h1v1h-1z",
    fill: "#3f475e"
  })), _path4181 || (_path4181 = /*#__PURE__*/React.createElement("path", {
    d: "M58 102h-1v-1h1z",
    fill: "#424864"
  })), _path4182 || (_path4182 = /*#__PURE__*/React.createElement("path", {
    d: "M60 102v-1h1v1z",
    fill: "#404a65"
  })), _path4183 || (_path4183 = /*#__PURE__*/React.createElement("path", {
    d: "M61 101h1v1h-1z",
    fill: "#46526b"
  })), _path4184 || (_path4184 = /*#__PURE__*/React.createElement("path", {
    d: "M66 101h1v1h-1z",
    fill: "#3e4861"
  })), _path4185 || (_path4185 = /*#__PURE__*/React.createElement("path", {
    d: "M69 101h1v1h-1z",
    fill: "#444d6a"
  })), _path4186 || (_path4186 = /*#__PURE__*/React.createElement("path", {
    d: "M82 102h-1v-1h1z",
    fill: "#47516d"
  })), _path4187 || (_path4187 = /*#__PURE__*/React.createElement("path", {
    d: "M87 102h-1v-1h1z",
    fill: "#4b556f"
  })), _path4188 || (_path4188 = /*#__PURE__*/React.createElement("path", {
    d: "M90 101v1h-1v-1z",
    fill: "#4f5975"
  })), _path4189 || (_path4189 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h-1v-1h1z",
    fill: "#535d79"
  })), _path4190 || (_path4190 = /*#__PURE__*/React.createElement("path", {
    d: "M92 101v1h-1v-1z",
    fill: "#343946"
  })), _path4191 || (_path4191 = /*#__PURE__*/React.createElement("path", {
    d: "M92 102v-1h1v1z",
    fill: "#3a3a3e"
  })), _path4192 || (_path4192 = /*#__PURE__*/React.createElement("path", {
    d: "M34 102h1v1h-1z",
    fill: "#717477",
    fillOpacity: 0.922
  })), _path4193 || (_path4193 = /*#__PURE__*/React.createElement("path", {
    d: "M44 102v1h-1v-1z",
    fill: "#3f455e"
  })), _path4194 || (_path4194 = /*#__PURE__*/React.createElement("path", {
    d: "M45 102v1h-1v-1z",
    fill: "#3f4561"
  })), _path4195 || (_path4195 = /*#__PURE__*/React.createElement("path", {
    d: "M46 103h-1v-1h1z",
    fill: "#3f455f"
  })), _path4196 || (_path4196 = /*#__PURE__*/React.createElement("path", {
    d: "M57 103v-1h1v1z",
    fill: "#424861"
  })), _path4197 || (_path4197 = /*#__PURE__*/React.createElement("path", {
    d: "M59 103h-1v-1h1z",
    fill: "#424863"
  })), _path4198 || (_path4198 = /*#__PURE__*/React.createElement("path", {
    d: "M62 102v1h-1v-1z",
    fill: "#434a66"
  })), _path4199 || (_path4199 = /*#__PURE__*/React.createElement("path", {
    d: "M63 102v1h-1v-1z",
    fill: "#49526c"
  })), _path4200 || (_path4200 = /*#__PURE__*/React.createElement("path", {
    d: "M65 103h-1v-1h1z",
    fill: "#535a6f"
  })), _path4201 || (_path4201 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h-1v-1h1z",
    fill: "#525b71"
  })), _path4202 || (_path4202 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103v-1h1v1z",
    fill: "#404b65"
  })), _path4203 || (_path4203 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103h-1v-1h1z",
    fill: "#424c68"
  })), _path4204 || (_path4204 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102v1h-1v-1z",
    fill: "#424b68"
  })), _path4205 || (_path4205 = /*#__PURE__*/React.createElement("path", {
    d: "M69 102h1v1h-1z",
    fill: "#424b67"
  })), _path4206 || (_path4206 = /*#__PURE__*/React.createElement("path", {
    d: "M74 102v1h-1v-1z",
    fill: "#434d69"
  })), _path4207 || (_path4207 = /*#__PURE__*/React.createElement("path", {
    d: "M78 103v-1h1v1z",
    fill: "#464e6a"
  })), _path4208 || (_path4208 = /*#__PURE__*/React.createElement("path", {
    d: "M81 102h1v1h-1z",
    fill: "#465169"
  })), _path4209 || (_path4209 = /*#__PURE__*/React.createElement("path", {
    d: "M84 102v1h-1v-1z",
    fill: "#48506b"
  })), _path4210 || (_path4210 = /*#__PURE__*/React.createElement("path", {
    d: "M85 103h-1v-1h1z",
    fill: "#49516c"
  })), _path4211 || (_path4211 = /*#__PURE__*/React.createElement("path", {
    d: "M90 103h-1v-1h1z",
    fill: "#4f5572"
  })), _path4212 || (_path4212 = /*#__PURE__*/React.createElement("path", {
    d: "M90 102h1v1h-1z",
    fill: "#535b76"
  })), _path4213 || (_path4213 = /*#__PURE__*/React.createElement("path", {
    d: "M91 102h1v1h-1z",
    fill: "#333945"
  })), _path4214 || (_path4214 = /*#__PURE__*/React.createElement("path", {
    d: "M35 104h-1v-1h1z",
    fill: "#727376",
    fillOpacity: 0.925
  })), _path4215 || (_path4215 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h-1v-1h1z",
    fill: "#3d435c"
  })), _path4216 || (_path4216 = /*#__PURE__*/React.createElement("path", {
    d: "M40 104h-1v-1h1z",
    fill: "#3d435b"
  })), _path4217 || (_path4217 = /*#__PURE__*/React.createElement("path", {
    d: "M43 104h-1v-1h1z",
    fill: "#3e435d"
  })), _path4218 || (_path4218 = /*#__PURE__*/React.createElement("path", {
    d: "M48 103v1h-1v-1z",
    fill: "#3b4660"
  })), _path4219 || (_path4219 = /*#__PURE__*/React.createElement("path", {
    d: "M49 104h-1v-1h1z",
    fill: "#3d4661"
  })), _path4220 || (_path4220 = /*#__PURE__*/React.createElement("path", {
    d: "M59 104v-1h1v1z",
    fill: "#40495e"
  })), _path4221 || (_path4221 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104v-1h1v1z",
    fill: "#41485f"
  })), _path4222 || (_path4222 = /*#__PURE__*/React.createElement("path", {
    d: "M65 104v-1h1v1z",
    fill: "#404861"
  })), _path4223 || (_path4223 = /*#__PURE__*/React.createElement("path", {
    d: "M66 103h1v1h-1z",
    fill: "#424b63"
  })), _path4224 || (_path4224 = /*#__PURE__*/React.createElement("path", {
    d: "M68 103v1h-1v-1z",
    fill: "#434b65"
  })), _path4225 || (_path4225 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104h-1v-1h1z",
    fill: "#424d67"
  })), _path4226 || (_path4226 = /*#__PURE__*/React.createElement("path", {
    d: "M80 103v1h-1v-1z",
    fill: "#434b67"
  })), _path4227 || (_path4227 = /*#__PURE__*/React.createElement("path", {
    d: "M83 104h-1v-1h1z",
    fill: "#464d69"
  })), _path4228 || (_path4228 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104h-1v-1h1z",
    fill: "#485069"
  })), _path4229 || (_path4229 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104h-1v-1h1z",
    fill: "#47516b"
  })), _path4230 || (_path4230 = /*#__PURE__*/React.createElement("path", {
    d: "M87 104v-1h1v1z",
    fill: "#47536d"
  })), _path4231 || (_path4231 = /*#__PURE__*/React.createElement("path", {
    d: "M89 103v1h-1v-1z",
    fill: "#4a5570"
  })), _path4232 || (_path4232 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v-1h1v1z",
    fill: "#4d5471"
  })), _path4233 || (_path4233 = /*#__PURE__*/React.createElement("path", {
    d: "M91 104h-1v-1h1z",
    fill: "#525974"
  })), _path4234 || (_path4234 = /*#__PURE__*/React.createElement("path", {
    d: "M91 103h1v1h-1z",
    fill: "#323743"
  })), _path4235 || (_path4235 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104v1h-1v-1z",
    fill: "#edf6f6",
    fillOpacity: 0.114
  })), _path4236 || (_path4236 = /*#__PURE__*/React.createElement("path", {
    d: "M34 104h1v1h-1z",
    fill: "#737477",
    fillOpacity: 0.925
  })), _path4237 || (_path4237 = /*#__PURE__*/React.createElement("path", {
    d: "M35 105v-1h1v1z",
    fill: "#1b1e23"
  })), _path4238 || (_path4238 = /*#__PURE__*/React.createElement("path", {
    d: "M36 105v-1h1v1z",
    fill: "#3b4357"
  })), _path4239 || (_path4239 = /*#__PURE__*/React.createElement("path", {
    d: "M38 105h-1v-1h1z",
    fill: "#3c4259"
  })), _path4240 || (_path4240 = /*#__PURE__*/React.createElement("path", {
    d: "M38 104h1v1h-1z",
    fill: "#3b4157"
  })), _path4241 || (_path4241 = /*#__PURE__*/React.createElement("path", {
    d: "M39 104h1v1h-1z",
    fill: "#3b4158"
  })), _path4242 || (_path4242 = /*#__PURE__*/React.createElement("path", {
    d: "M41 104v1h-1v-1z",
    fill: "#3c4258"
  })), _path4243 || (_path4243 = /*#__PURE__*/React.createElement("path", {
    d: "M42 105h-1v-1h1z",
    fill: "#3c4458"
  })), _path4244 || (_path4244 = /*#__PURE__*/React.createElement("path", {
    d: "M43 105v-1h1v1z",
    fill: "#3d415d"
  })), _path4245 || (_path4245 = /*#__PURE__*/React.createElement("path", {
    d: "M45 105h-1v-1h1z",
    fill: "#3e415c"
  })), _path4246 || (_path4246 = /*#__PURE__*/React.createElement("path", {
    d: "M45 104h1v1h-1z",
    fill: "#3d435f"
  })), _path4247 || (_path4247 = /*#__PURE__*/React.createElement("path", {
    d: "M46 104h1v1h-1z",
    fill: "#3e455c"
  })), _path4248 || (_path4248 = /*#__PURE__*/React.createElement("path", {
    d: "M48 104v1h-1v-1z",
    fill: "#3d4659"
  })), _path4249 || (_path4249 = /*#__PURE__*/React.createElement("path", {
    d: "M49 105h-1v-1h1z",
    fill: "#3e465c"
  })), _path4250 || (_path4250 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105v-1h1v1z",
    fill: "#3e445f"
  })), _path4251 || (_path4251 = /*#__PURE__*/React.createElement("path", {
    d: "M57 104v1h-1v-1z",
    fill: "#3d4560"
  })), _path4252 || (_path4252 = /*#__PURE__*/React.createElement("path", {
    d: "M58 104v1h-1v-1z",
    fill: "#3d465f"
  })), _path4253 || (_path4253 = /*#__PURE__*/React.createElement("path", {
    d: "M60 104h1v1h-1z",
    fill: "#3d475e"
  })), _path4254 || (_path4254 = /*#__PURE__*/React.createElement("path", {
    d: "M70 104v1h-1v-1z",
    fill: "#404763"
  })), _path4255 || (_path4255 = /*#__PURE__*/React.createElement("path", {
    d: "M71 104h1v1h-1z",
    fill: "#414864"
  })), _path4256 || (_path4256 = /*#__PURE__*/React.createElement("path", {
    d: "M77 104h1v1h-1z",
    fill: "#424a63"
  })), _path4257 || (_path4257 = /*#__PURE__*/React.createElement("path", {
    d: "M79 104v1h-1v-1z",
    fill: "#434a61"
  })), _path4258 || (_path4258 = /*#__PURE__*/React.createElement("path", {
    d: "M81 104v1h-1v-1z",
    fill: "#414a66"
  })), _path4259 || (_path4259 = /*#__PURE__*/React.createElement("path", {
    d: "M82 104v1h-1v-1z",
    fill: "#414c66"
  })), _path4260 || (_path4260 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105v-1h1v1z",
    fill: "#414d69"
  })), _path4261 || (_path4261 = /*#__PURE__*/React.createElement("path", {
    d: "M84 104v1h-1v-1z",
    fill: "#414e68"
  })), _path4262 || (_path4262 = /*#__PURE__*/React.createElement("path", {
    d: "M86 104v1h-1v-1z",
    fill: "#474e6a"
  })), _path4263 || (_path4263 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105v-1h1v1z",
    fill: "#464f69"
  })), _path4264 || (_path4264 = /*#__PURE__*/React.createElement("path", {
    d: "M89 104v1h-1v-1z",
    fill: "#46526d"
  })), _path4265 || (_path4265 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v-1h1v1z",
    fill: "#505772"
  })), _path4266 || (_path4266 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106h-1v-1h1z",
    fill: "#eeeef6",
    fillOpacity: 0.118
  })), _path4267 || (_path4267 = /*#__PURE__*/React.createElement("path", {
    d: "M35 106h-1v-1h1z",
    fill: "#74757a",
    fillOpacity: 0.925
  })), _path4268 || (_path4268 = /*#__PURE__*/React.createElement("path", {
    d: "M36 106h-1v-1h1z",
    fill: "#1a1e22"
  })), _path4269 || (_path4269 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h-1v-1h1z",
    fill: "#394154"
  })), _path4270 || (_path4270 = /*#__PURE__*/React.createElement("path", {
    d: "M38 106h-1v-1h1z",
    fill: "#3a4156"
  })), _path4271 || (_path4271 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h-1v-1h1z",
    fill: "#3a4056"
  })), _path4272 || (_path4272 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106h-1v-1h1z",
    fill: "#373e57"
  })), _path4273 || (_path4273 = /*#__PURE__*/React.createElement("path", {
    d: "M42 106v-1h1v1z",
    fill: "#344151"
  })), _path4274 || (_path4274 = /*#__PURE__*/React.createElement("path", {
    d: "M44 105v1h-1v-1z",
    fill: "#36474f"
  })), _path4275 || (_path4275 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v-1h1v1z",
    fill: "#384951"
  })), _path4276 || (_path4276 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h-1v-1h1z",
    fill: "#374650"
  })), _path4277 || (_path4277 = /*#__PURE__*/React.createElement("path", {
    d: "M47 106v-1h1v1z",
    fill: "#3c405d"
  })), _path4278 || (_path4278 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h-1v-1h1z",
    fill: "#3e435e"
  })), _path4279 || (_path4279 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106v-1h1v1z",
    fill: "#3d445d"
  })), _path4280 || (_path4280 = /*#__PURE__*/React.createElement("path", {
    d: "M50 105h1v1h-1z",
    fill: "#3c445c"
  })), _path4281 || (_path4281 = /*#__PURE__*/React.createElement("path", {
    d: "M54 106v-1h1v1z",
    fill: "#3a4059"
  })), _path4282 || (_path4282 = /*#__PURE__*/React.createElement("path", {
    d: "M57 105v1h-1v-1z",
    fill: "#444b60"
  })), _path4283 || (_path4283 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106h-1v-1h1z",
    fill: "#464d61"
  })), _path4284 || (_path4284 = /*#__PURE__*/React.createElement("path", {
    d: "M59 105v1h-1v-1z",
    fill: "#42495e"
  })), _path4285 || (_path4285 = /*#__PURE__*/React.createElement("path", {
    d: "M59 106v-1h1v1z",
    fill: "#3a4158"
  })), _path4286 || (_path4286 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105v1h-1v-1z",
    fill: "#404661"
  })), _path4287 || (_path4287 = /*#__PURE__*/React.createElement("path", {
    d: "M67 105h1v1h-1z",
    fill: "#3c435a"
  })), _path4288 || (_path4288 = /*#__PURE__*/React.createElement("path", {
    d: "M69 105v1h-1v-1z",
    fill: "#3f475b"
  })), _path4289 || (_path4289 = /*#__PURE__*/React.createElement("path", {
    d: "M70 106h-1v-1h1z",
    fill: "#464f61"
  })), _path4290 || (_path4290 = /*#__PURE__*/React.createElement("path", {
    d: "M70 105h1v1h-1z",
    fill: "#474f62"
  })), _path4291 || (_path4291 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106v-1h1v1z",
    fill: "#42495f"
  })), _path4292 || (_path4292 = /*#__PURE__*/React.createElement("path", {
    d: "M72 105h1v1h-1z",
    fill: "#3c425a"
  })), _path4293 || (_path4293 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106h-1v-1h1z",
    fill: "#414762"
  })), _path4294 || (_path4294 = /*#__PURE__*/React.createElement("path", {
    d: "M77 106v-1h1v1z",
    fill: "#424862"
  })), _path4295 || (_path4295 = /*#__PURE__*/React.createElement("path", {
    d: "M78 105h1v1h-1z",
    fill: "#434761"
  })), _path4296 || (_path4296 = /*#__PURE__*/React.createElement("path", {
    d: "M80 105v1h-1v-1z",
    fill: "#3d4a62"
  })), _path4297 || (_path4297 = /*#__PURE__*/React.createElement("path", {
    d: "M81 106h-1v-1h1z",
    fill: "#41485d"
  })), _path4298 || (_path4298 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106h-1v-1h1z",
    fill: "#4d4459"
  })), _path4299 || (_path4299 = /*#__PURE__*/React.createElement("path", {
    d: "M82 105h1v1h-1z",
    fill: "#56435d"
  })), _path4300 || (_path4300 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106v-1h1v1z",
    fill: "#58445b"
  })), _path4301 || (_path4301 = /*#__PURE__*/React.createElement("path", {
    d: "M85 105v1h-1v-1z",
    fill: "#51465d"
  })), _path4302 || (_path4302 = /*#__PURE__*/React.createElement("path", {
    d: "M86 106h-1v-1h1z",
    fill: "#464b63"
  })), _path4303 || (_path4303 = /*#__PURE__*/React.createElement("path", {
    d: "M86 105h1v1h-1z",
    fill: "#464d66"
  })), _path4304 || (_path4304 = /*#__PURE__*/React.createElement("path", {
    d: "M88 105v1h-1v-1z",
    fill: "#464e67"
  })), _path4305 || (_path4305 = /*#__PURE__*/React.createElement("path", {
    d: "M88 106v-1h1v1z",
    fill: "#474f6a"
  })), _path4306 || (_path4306 = /*#__PURE__*/React.createElement("path", {
    d: "M90 105v1h-1v-1z",
    fill: "#49506c"
  })), _path4307 || (_path4307 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106h-1v-1h1z",
    fill: "#4e546f"
  })), _path4308 || (_path4308 = /*#__PURE__*/React.createElement("path", {
    d: "M91 105h1v1h-1z",
    fill: "#303541"
  })), _path4309 || (_path4309 = /*#__PURE__*/React.createElement("path", {
    d: "M92 105h1v1h-1z",
    fill: "#3a3c3f"
  })), _path4310 || (_path4310 = /*#__PURE__*/React.createElement("path", {
    d: "M94 106h-1v-1h1z",
    fill: "#a3a3ad",
    fillOpacity: 0.439
  })), _path4311 || (_path4311 = /*#__PURE__*/React.createElement("path", {
    d: "M34 106v1h-1v-1z",
    fill: "#f6f6ff",
    fillOpacity: 0.118
  })), _path4312 || (_path4312 = /*#__PURE__*/React.createElement("path", {
    d: "M35 107h-1v-1h1z",
    fill: "#74767a",
    fillOpacity: 0.929
  })), _path4313 || (_path4313 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106v1h-1v-1z",
    fill: "#383f51"
  })), _path4314 || (_path4314 = /*#__PURE__*/React.createElement("path", {
    d: "M37 106h1v1h-1z",
    fill: "#394056"
  })), _path4315 || (_path4315 = /*#__PURE__*/React.createElement("path", {
    d: "M39 107h-1v-1h1z",
    fill: "#3a3f54"
  })), _path4316 || (_path4316 = /*#__PURE__*/React.createElement("path", {
    d: "M40 107h-1v-1h1z",
    fill: "#3b3f55"
  })), _path4317 || (_path4317 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106v1h-1v-1z",
    fill: "#363f4d"
  })), _path4318 || (_path4318 = /*#__PURE__*/React.createElement("path", {
    d: "M41 106h1v1h-1z",
    fill: "#4b6651"
  })), _path4319 || (_path4319 = /*#__PURE__*/React.createElement("path", {
    d: "M43 106v1h-1v-1z",
    fill: "#62915b"
  })), _path4320 || (_path4320 = /*#__PURE__*/React.createElement("path", {
    d: "M44 106v1h-1v-1z",
    fill: "#61a057"
  })), _path4321 || (_path4321 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107h-1v-1h1z",
    fill: "#5fa055"
  })), _path4322 || (_path4322 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106v1h-1v-1z",
    fill: "#629b59"
  })), _path4323 || (_path4323 = /*#__PURE__*/React.createElement("path", {
    d: "M46 106h1v1h-1z",
    fill: "#588359"
  })), _path4324 || (_path4324 = /*#__PURE__*/React.createElement("path", {
    d: "M48 106v1h-1v-1z",
    fill: "#3a504e"
  })), _path4325 || (_path4325 = /*#__PURE__*/React.createElement("path", {
    d: "M48 107v-1h1v1z",
    fill: "#394058"
  })), _path4326 || (_path4326 = /*#__PURE__*/React.createElement("path", {
    d: "M49 106h1v1h-1z",
    fill: "#3d455a"
  })), _path4327 || (_path4327 = /*#__PURE__*/React.createElement("path", {
    d: "M51 107v-1h1v1z",
    fill: "#3d445c"
  })), _path4328 || (_path4328 = /*#__PURE__*/React.createElement("path", {
    d: "M53 106h1v1h-1z",
    fill: "#3d4259"
  })), _path4329 || (_path4329 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v-1h1v1z",
    fill: "#7c808a"
  })), _path4330 || (_path4330 = /*#__PURE__*/React.createElement("path", {
    d: "M55 107v-1h1v1z",
    fill: "#b8bec1"
  })), _path4331 || (_path4331 = /*#__PURE__*/React.createElement("path", {
    d: "M57 107h-1v-1h1z",
    fill: "#c9cfce"
  })), _path4332 || (_path4332 = /*#__PURE__*/React.createElement("path", {
    d: "M58 106v1h-1v-1z",
    fill: "#cbced3"
  })), _path4333 || (_path4333 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h-1v-1h1z",
    fill: "#c3c7c9"
  })), _path4334 || (_path4334 = /*#__PURE__*/React.createElement("path", {
    d: "M60 106v1h-1v-1z",
    fill: "#9ea2a9"
  })), _path4335 || (_path4335 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107v-1h1v1z",
    fill: "#50556a"
  })), _path4336 || (_path4336 = /*#__PURE__*/React.createElement("path", {
    d: "M61 106h1v1h-1z",
    fill: "#3c425b"
  })), _path4337 || (_path4337 = /*#__PURE__*/React.createElement("path", {
    d: "M66 106h1v1h-1z",
    fill: "#40475c"
  })), _path4338 || (_path4338 = /*#__PURE__*/React.createElement("path", {
    d: "M68 106v1h-1v-1z",
    fill: "#818792"
  })), _path4339 || (_path4339 = /*#__PURE__*/React.createElement("path", {
    d: "M68 107v-1h1v1z",
    fill: "#bac2c5"
  })), _path4340 || (_path4340 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v-1h1v1z",
    fill: "#cdcfd1"
  })), _path4341 || (_path4341 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107v-1h1v1z",
    fill: "#ced0d0"
  })), _path4342 || (_path4342 = /*#__PURE__*/React.createElement("path", {
    d: "M71 106h1v1h-1z",
    fill: "#c4c8cf"
  })), _path4343 || (_path4343 = /*#__PURE__*/React.createElement("path", {
    d: "M73 106v1h-1v-1z",
    fill: "#9aa0aa"
  })), _path4344 || (_path4344 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h-1v-1h1z",
    fill: "#4e5564"
  })), _path4345 || (_path4345 = /*#__PURE__*/React.createElement("path", {
    d: "M75 107v-1h1v1z",
    fill: "#3e4761"
  })), _path4346 || (_path4346 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h-1v-1h1z",
    fill: "#3c4862"
  })), _path4347 || (_path4347 = /*#__PURE__*/React.createElement("path", {
    d: "M79 106h1v1h-1z",
    fill: "#4d425b"
  })), _path4348 || (_path4348 = /*#__PURE__*/React.createElement("path", {
    d: "M80 106h1v1h-1z",
    fill: "#843256"
  })), _path4349 || (_path4349 = /*#__PURE__*/React.createElement("path", {
    d: "M82 106v1h-1v-1z",
    fill: "#a52853"
  })), _path4350 || (_path4350 = /*#__PURE__*/React.createElement("path", {
    d: "M82 107v-1h1v1z",
    fill: "#b02653"
  })), _path4351 || (_path4351 = /*#__PURE__*/React.createElement("path", {
    d: "M83 106h1v1h-1z",
    fill: "#ae2752"
  })), _path4352 || (_path4352 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106v1h-1v-1z",
    fill: "#a62a51"
  })), _path4353 || (_path4353 = /*#__PURE__*/React.createElement("path", {
    d: "M85 106h1v1h-1z",
    fill: "#8f3054"
  })), _path4354 || (_path4354 = /*#__PURE__*/React.createElement("path", {
    d: "M87 106v1h-1v-1z",
    fill: "#5c405c"
  })), _path4355 || (_path4355 = /*#__PURE__*/React.createElement("path", {
    d: "M87 107v-1h1v1z",
    fill: "#454d65"
  })), _path4356 || (_path4356 = /*#__PURE__*/React.createElement("path", {
    d: "M89 106v1h-1v-1z",
    fill: "#484c69"
  })), _path4357 || (_path4357 = /*#__PURE__*/React.createElement("path", {
    d: "M91 106v1h-1v-1z",
    fill: "#4b536d"
  })), _path4358 || (_path4358 = /*#__PURE__*/React.createElement("path", {
    d: "M92 107h-1v-1h1z",
    fill: "#2f3440"
  })), _path4359 || (_path4359 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108h-1v-1h1z",
    fill: "#373e4f"
  })), _path4360 || (_path4360 = /*#__PURE__*/React.createElement("path", {
    d: "M38 107v1h-1v-1z",
    fill: "#383e56"
  })), _path4361 || (_path4361 = /*#__PURE__*/React.createElement("path", {
    d: "M38 108v-1h1v1z",
    fill: "#3a3d54"
  })), _path4362 || (_path4362 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v-1h1v1z",
    fill: "#353b4f"
  })), _path4363 || (_path4363 = /*#__PURE__*/React.createElement("path", {
    d: "M40 108v-1h1v1z",
    fill: "#4a6653"
  })), _path4364 || (_path4364 = /*#__PURE__*/React.createElement("path", {
    d: "M42 108h-1v-1h1z",
    fill: "#6cb35f"
  })), _path4365 || (_path4365 = /*#__PURE__*/React.createElement("path", {
    d: "M42 107h1v1h-1z",
    fill: "#66ba51"
  })), _path4366 || (_path4366 = /*#__PURE__*/React.createElement("path", {
    d: "M43 107h1v1h-1z",
    fill: "#70ba5f"
  })), _path4367 || (_path4367 = /*#__PURE__*/React.createElement("path", {
    d: "M45 107v1h-1v-1z",
    fill: "#88c57a"
  })), _path4368 || (_path4368 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108h-1v-1h1z",
    fill: "#78bb66"
  })), _path4369 || (_path4369 = /*#__PURE__*/React.createElement("path", {
    d: "M47 107v1h-1v-1z",
    fill: "#6db952"
  })), _path4370 || (_path4370 = /*#__PURE__*/React.createElement("path", {
    d: "M47 108v-1h1v1z",
    fill: "#669b59"
  })), _path4371 || (_path4371 = /*#__PURE__*/React.createElement("path", {
    d: "M49 107v1h-1v-1z",
    fill: "#3a494d"
  })), _path4372 || (_path4372 = /*#__PURE__*/React.createElement("path", {
    d: "M50 108v-1h1v1z",
    fill: "#3a4259"
  })), _path4373 || (_path4373 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108v-1h1v1z",
    fill: "#3b415b"
  })), _path4374 || (_path4374 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108h-1v-1h1z",
    fill: "#363c54"
  })), _path4375 || (_path4375 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107v1h-1v-1z",
    fill: "#7e8694"
  })), _path4376 || (_path4376 = /*#__PURE__*/React.createElement("path", {
    d: "M54 107h1v1h-1z",
    fill: "#e4ebec"
  })), _path4377 || (_path4377 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108h-1v-1h1z",
    fill: "#d6e2e7"
  })), _path4378 || (_path4378 = /*#__PURE__*/React.createElement("path", {
    d: "M56 108v-1h1v1z",
    fill: "#cfdde4"
  })), _path4379 || (_path4379 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108v-1h1v1z",
    fill: "#d0dce6"
  })), _path4380 || (_path4380 = /*#__PURE__*/React.createElement("path", {
    d: "M59 108h-1v-1h1z",
    fill: "#d8e2e7"
  })), _path4381 || (_path4381 = /*#__PURE__*/React.createElement("path", {
    d: "M59 107h1v1h-1z",
    fill: "#e9eeea"
  })), _path4382 || (_path4382 = /*#__PURE__*/React.createElement("path", {
    d: "M60 107h1v1h-1z",
    fill: "#bdc1c5"
  })), _path4383 || (_path4383 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107v1h-1v-1z",
    fill: "#444a60"
  })), _path4384 || (_path4384 = /*#__PURE__*/React.createElement("path", {
    d: "M62 107h1v1h-1z",
    fill: "#3c435d"
  })), _path4385 || (_path4385 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108v-1h1v1z",
    fill: "#3d455c"
  })), _path4386 || (_path4386 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h-1v-1h1z",
    fill: "#374057"
  })), _path4387 || (_path4387 = /*#__PURE__*/React.createElement("path", {
    d: "M66 107h1v1h-1z",
    fill: "#898e9b"
  })), _path4388 || (_path4388 = /*#__PURE__*/React.createElement("path", {
    d: "M67 107h1v1h-1z",
    fill: "#eeeae9"
  })), _path4389 || (_path4389 = /*#__PURE__*/React.createElement("path", {
    d: "M69 107v1h-1v-1z",
    fill: "#e2bcb6"
  })), _path4390 || (_path4390 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108v-1h1v1z",
    fill: "#cb7a75"
  })), _path4391 || (_path4391 = /*#__PURE__*/React.createElement("path", {
    d: "M70 107h1v1h-1z",
    fill: "#c6726a"
  })), _path4392 || (_path4392 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v-1h1v1z",
    fill: "#d6a196"
  })), _path4393 || (_path4393 = /*#__PURE__*/React.createElement("path", {
    d: "M72 108v-1h1v1z",
    fill: "#f0e4dc"
  })), _path4394 || (_path4394 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107v1h-1v-1z",
    fill: "#b8bbc2"
  })), _path4395 || (_path4395 = /*#__PURE__*/React.createElement("path", {
    d: "M74 107h1v1h-1z",
    fill: "#41475f"
  })), _path4396 || (_path4396 = /*#__PURE__*/React.createElement("path", {
    d: "M77 108h-1v-1h1z",
    fill: "#3d465c"
  })), _path4397 || (_path4397 = /*#__PURE__*/React.createElement("path", {
    d: "M78 107v1h-1v-1z",
    fill: "#3c4760"
  })), _path4398 || (_path4398 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107v1h-1v-1z",
    fill: "#43425c"
  })), _path4399 || (_path4399 = /*#__PURE__*/React.createElement("path", {
    d: "M79 107h1v1h-1z",
    fill: "#8a2853"
  })), _path4400 || (_path4400 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107v1h-1v-1z",
    fill: "#c0144c"
  })), _path4401 || (_path4401 = /*#__PURE__*/React.createElement("path", {
    d: "M81 107h1v1h-1z",
    fill: "#ba1747"
  })), _path4402 || (_path4402 = /*#__PURE__*/React.createElement("path", {
    d: "M83 107v1h-1v-1z",
    fill: "#b91948"
  })), _path4403 || (_path4403 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108v-1h1v1z",
    fill: "#bc1a4a"
  })), _path4404 || (_path4404 = /*#__PURE__*/React.createElement("path", {
    d: "M84 107h1v1h-1z",
    fill: "#bd1b48"
  })), _path4405 || (_path4405 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v-1h1v1z",
    fill: "#c0144a"
  })), _path4406 || (_path4406 = /*#__PURE__*/React.createElement("path", {
    d: "M86 107h1v1h-1z",
    fill: "#982050"
  })), _path4407 || (_path4407 = /*#__PURE__*/React.createElement("path", {
    d: "M88 107v1h-1v-1z",
    fill: "#4f445e"
  })), _path4408 || (_path4408 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h-1v-1h1z",
    fill: "#464d65"
  })), _path4409 || (_path4409 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108v-1h1v1z",
    fill: "#4b526b"
  })), _path4410 || (_path4410 = /*#__PURE__*/React.createElement("path", {
    d: "M91 107h1v1h-1z",
    fill: "#2e343f"
  })), _path4411 || (_path4411 = /*#__PURE__*/React.createElement("path", {
    d: "M37 108v1h-1v-1z",
    fill: "#363d4d"
  })), _path4412 || (_path4412 = /*#__PURE__*/React.createElement("path", {
    d: "M38 109h-1v-1h1z",
    fill: "#373e53"
  })), _path4413 || (_path4413 = /*#__PURE__*/React.createElement("path", {
    d: "M39 108v1h-1v-1z",
    fill: "#373c54"
  })), _path4414 || (_path4414 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109v-1h1v1z",
    fill: "#313f48"
  })), _path4415 || (_path4415 = /*#__PURE__*/React.createElement("path", {
    d: "M41 108v1h-1v-1z",
    fill: "#60955a"
  })), _path4416 || (_path4416 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v-1h1v1z",
    fill: "#69b853"
  })), _path4417 || (_path4417 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v-1h1v1z",
    fill: "#6fb45c"
  })), _path4418 || (_path4418 = /*#__PURE__*/React.createElement("path", {
    d: "M44 108v1h-1v-1z",
    fill: "#bfddba"
  })), _path4419 || (_path4419 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v-1h1v1z",
    fill: "#e3f0e1"
  })), _path4420 || (_path4420 = /*#__PURE__*/React.createElement("path", {
    d: "M46 108v1h-1v-1z",
    fill: "#9ece93"
  })), _path4421 || (_path4421 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v-1h1v1z",
    fill: "#63b44e"
  })), _path4422 || (_path4422 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h-1v-1h1z",
    fill: "#6bb85a"
  })), _path4423 || (_path4423 = /*#__PURE__*/React.createElement("path", {
    d: "M49 108v1h-1v-1z",
    fill: "#496750"
  })), _path4424 || (_path4424 = /*#__PURE__*/React.createElement("path", {
    d: "M50 109h-1v-1h1z",
    fill: "#373b54"
  })), _path4425 || (_path4425 = /*#__PURE__*/React.createElement("path", {
    d: "M51 108h1v1h-1z",
    fill: "#3a3f56"
  })), _path4426 || (_path4426 = /*#__PURE__*/React.createElement("path", {
    d: "M53 108v1h-1v-1z",
    fill: "#3e4457"
  })), _path4427 || (_path4427 = /*#__PURE__*/React.createElement("path", {
    d: "M53 109v-1h1v1z",
    fill: "#c1c8cb"
  })), _path4428 || (_path4428 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h-1v-1h1z",
    fill: "#c9d9e7"
  })), _path4429 || (_path4429 = /*#__PURE__*/React.createElement("path", {
    d: "M55 108h1v1h-1z",
    fill: "#80a6db"
  })), _path4430 || (_path4430 = /*#__PURE__*/React.createElement("path", {
    d: "M57 109h-1v-1h1z",
    fill: "#568dce"
  })), _path4431 || (_path4431 = /*#__PURE__*/React.createElement("path", {
    d: "M57 108h1v1h-1z",
    fill: "#528dcf"
  })), _path4432 || (_path4432 = /*#__PURE__*/React.createElement("path", {
    d: "M58 109v-1h1v1z",
    fill: "#5c91d0"
  })), _path4433 || (_path4433 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v-1h1v1z",
    fill: "#b2cbe7"
  })), _path4434 || (_path4434 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109v-1h1v1z",
    fill: "#e5ebe5"
  })), _path4435 || (_path4435 = /*#__PURE__*/React.createElement("path", {
    d: "M62 109h-1v-1h1z",
    fill: "#6d7284"
  })), _path4436 || (_path4436 = /*#__PURE__*/React.createElement("path", {
    d: "M63 108v1h-1v-1z",
    fill: "#373f56"
  })), _path4437 || (_path4437 = /*#__PURE__*/React.createElement("path", {
    d: "M64 108h1v1h-1z",
    fill: "#3b435a"
  })), _path4438 || (_path4438 = /*#__PURE__*/React.createElement("path", {
    d: "M65 108h1v1h-1z",
    fill: "#434c60"
  })), _path4439 || (_path4439 = /*#__PURE__*/React.createElement("path", {
    d: "M66 108h1v1h-1z",
    fill: "#cdd2d3"
  })), _path4440 || (_path4440 = /*#__PURE__*/React.createElement("path", {
    d: "M68 108v1h-1v-1z",
    fill: "#d3b9aa"
  })), _path4441 || (_path4441 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h-1v-1h1z",
    fill: "#b04343"
  })), _path4442 || (_path4442 = /*#__PURE__*/React.createElement("path", {
    d: "M69 108h1v1h-1z",
    fill: "#ba534d"
  })), _path4443 || (_path4443 = /*#__PURE__*/React.createElement("path", {
    d: "M71 108v1h-1v-1z",
    fill: "#c16357"
  })), _path4444 || (_path4444 = /*#__PURE__*/React.createElement("path", {
    d: "M71 109v-1h1v1z",
    fill: "#b85a34"
  })), _path4445 || (_path4445 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109v-1h1v1z",
    fill: "#cf9f75"
  })), _path4446 || (_path4446 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109v-1h1v1z",
    fill: "#eae5e3"
  })), _path4447 || (_path4447 = /*#__PURE__*/React.createElement("path", {
    d: "M74 108h1v1h-1z",
    fill: "#686e7f"
  })), _path4448 || (_path4448 = /*#__PURE__*/React.createElement("path", {
    d: "M76 109h-1v-1h1z",
    fill: "#39405a"
  })), _path4449 || (_path4449 = /*#__PURE__*/React.createElement("path", {
    d: "M78 108h1v1h-1z",
    fill: "#583754"
  })), _path4450 || (_path4450 = /*#__PURE__*/React.createElement("path", {
    d: "M80 108v1h-1v-1z",
    fill: "#a60c46"
  })), _path4451 || (_path4451 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h-1v-1h1z",
    fill: "#c7466f"
  })), _path4452 || (_path4452 = /*#__PURE__*/React.createElement("path", {
    d: "M81 108h1v1h-1z",
    fill: "#dba4b1"
  })), _path4453 || (_path4453 = /*#__PURE__*/React.createElement("path", {
    d: "M82 109v-1h1v1z",
    fill: "#dda9b4"
  })), _path4454 || (_path4454 = /*#__PURE__*/React.createElement("path", {
    d: "M83 108h1v1h-1z",
    fill: "#e5a8b6"
  })), _path4455 || (_path4455 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108v1h-1v-1z",
    fill: "#d991a1"
  })), _path4456 || (_path4456 = /*#__PURE__*/React.createElement("path", {
    d: "M85 108h1v1h-1z",
    fill: "#cc587c"
  })), _path4457 || (_path4457 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h-1v-1h1z",
    fill: "#b40744"
  })), _path4458 || (_path4458 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v-1h1v1z",
    fill: "#693356"
  })), _path4459 || (_path4459 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109h-1v-1h1z",
    fill: "#3e4a62"
  })), _path4460 || (_path4460 = /*#__PURE__*/React.createElement("path", {
    d: "M89 108h1v1h-1z",
    fill: "#414c64"
  })), _path4461 || (_path4461 = /*#__PURE__*/React.createElement("path", {
    d: "M90 108h1v1h-1z",
    fill: "#4a4f69"
  })), _path4462 || (_path4462 = /*#__PURE__*/React.createElement("path", {
    d: "M92 109h-1v-1h1z",
    fill: "#2d323d"
  })), _path4463 || (_path4463 = /*#__PURE__*/React.createElement("path", {
    d: "M33 110v-1h1v1z",
    fill: "#eef6ff",
    fillOpacity: 0.122
  })), _path4464 || (_path4464 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110v-1h1v1z",
    fill: "#75787c",
    fillOpacity: 0.929
  })), _path4465 || (_path4465 = /*#__PURE__*/React.createElement("path", {
    d: "M36 109h1v1h-1z",
    fill: "#353c4c"
  })), _path4466 || (_path4466 = /*#__PURE__*/React.createElement("path", {
    d: "M37 109h1v1h-1z",
    fill: "#363e52"
  })), _path4467 || (_path4467 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h-1v-1h1z",
    fill: "#353b51"
  })), _path4468 || (_path4468 = /*#__PURE__*/React.createElement("path", {
    d: "M39 109h1v1h-1z",
    fill: "#37464a"
  })), _path4469 || (_path4469 = /*#__PURE__*/React.createElement("path", {
    d: "M41 109v1h-1v-1z",
    fill: "#63a857"
  })), _path4470 || (_path4470 = /*#__PURE__*/React.createElement("path", {
    d: "M42 109v1h-1v-1z",
    fill: "#62b84c"
  })), _path4471 || (_path4471 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h-1v-1h1z",
    fill: "#83bf74"
  })), _path4472 || (_path4472 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109v1h-1v-1z",
    fill: "#d1e7cf"
  })), _path4473 || (_path4473 = /*#__PURE__*/React.createElement("path", {
    d: "M44 109h1v1h-1z",
    fill: "#9dc293"
  })), _path4474 || (_path4474 = /*#__PURE__*/React.createElement("path", {
    d: "M46 109v1h-1v-1z",
    fill: "#76b962"
  })), _path4475 || (_path4475 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h-1v-1h1z",
    fill: "#64b551"
  })), _path4476 || (_path4476 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110v-1h1v1z",
    fill: "#69bb53"
  })), _path4477 || (_path4477 = /*#__PURE__*/React.createElement("path", {
    d: "M48 109h1v1h-1z",
    fill: "#527b50"
  })), _path4478 || (_path4478 = /*#__PURE__*/React.createElement("path", {
    d: "M49 109h1v1h-1z",
    fill: "#363a4f"
  })), _path4479 || (_path4479 = /*#__PURE__*/React.createElement("path", {
    d: "M50 110v-1h1v1z",
    fill: "#383e54"
  })), _path4480 || (_path4480 = /*#__PURE__*/React.createElement("path", {
    d: "M52 110v-1h1v1z",
    fill: "#4d5263"
  })), _path4481 || (_path4481 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110h-1v-1h1z",
    fill: "#d9dcdb"
  })), _path4482 || (_path4482 = /*#__PURE__*/React.createElement("path", {
    d: "M54 109h1v1h-1z",
    fill: "#9fbedb"
  })), _path4483 || (_path4483 = /*#__PURE__*/React.createElement("path", {
    d: "M55 109h1v1h-1z",
    fill: "#1c65bf"
  })), _path4484 || (_path4484 = /*#__PURE__*/React.createElement("path", {
    d: "M56 109h1v1h-1z",
    fill: "#0059bf"
  })), _path4485 || (_path4485 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110v-1h1v1z",
    fill: "#005ac2"
  })), _path4486 || (_path4486 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109v1h-1v-1z",
    fill: "#0058ba"
  })), _path4487 || (_path4487 = /*#__PURE__*/React.createElement("path", {
    d: "M59 109h1v1h-1z",
    fill: "#4c82c7"
  })), _path4488 || (_path4488 = /*#__PURE__*/React.createElement("path", {
    d: "M60 109h1v1h-1z",
    fill: "#dde9ed"
  })), _path4489 || (_path4489 = /*#__PURE__*/React.createElement("path", {
    d: "M62 110h-1v-1h1z",
    fill: "#888d9c"
  })), _path4490 || (_path4490 = /*#__PURE__*/React.createElement("path", {
    d: "M65 110h-1v-1h1z",
    fill: "#384058"
  })), _path4491 || (_path4491 = /*#__PURE__*/React.createElement("path", {
    d: "M65 109h1v1h-1z",
    fill: "#545b6e"
  })), _path4492 || (_path4492 = /*#__PURE__*/React.createElement("path", {
    d: "M66 109h1v1h-1z",
    fill: "#d5e1d7"
  })), _path4493 || (_path4493 = /*#__PURE__*/React.createElement("path", {
    d: "M67 110v-1h1v1z",
    fill: "#9c9b67"
  })), _path4494 || (_path4494 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109v1h-1v-1z",
    fill: "#ae655a"
  })), _path4495 || (_path4495 = /*#__PURE__*/React.createElement("path", {
    d: "M69 109h1v1h-1z",
    fill: "#8c96bd"
  })), _path4496 || (_path4496 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110h-1v-1h1z",
    fill: "#7195c4"
  })), _path4497 || (_path4497 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h-1v-1h1z",
    fill: "#cdb980"
  })), _path4498 || (_path4498 = /*#__PURE__*/React.createElement("path", {
    d: "M72 109h1v1h-1z",
    fill: "#deb340"
  })), _path4499 || (_path4499 = /*#__PURE__*/React.createElement("path", {
    d: "M73 109h1v1h-1z",
    fill: "#e5e1c0"
  })), _path4500 || (_path4500 = /*#__PURE__*/React.createElement("path", {
    d: "M74 110v-1h1v1z",
    fill: "#848994"
  })), _path4501 || (_path4501 = /*#__PURE__*/React.createElement("path", {
    d: "M75 110v-1h1v1z",
    fill: "#363c55"
  })), _path4502 || (_path4502 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110v-1h1v1z",
    fill: "#3a425a"
  })), _path4503 || (_path4503 = /*#__PURE__*/React.createElement("path", {
    d: "M77 109h1v1h-1z",
    fill: "#3a4458"
  })), _path4504 || (_path4504 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109v1h-1v-1z",
    fill: "#633152"
  })), _path4505 || (_path4505 = /*#__PURE__*/React.createElement("path", {
    d: "M79 109h1v1h-1z",
    fill: "#aa0442"
  })), _path4506 || (_path4506 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109v1h-1v-1z",
    fill: "#d78ca2"
  })), _path4507 || (_path4507 = /*#__PURE__*/React.createElement("path", {
    d: "M81 109h1v1h-1z",
    fill: "#f1eeeb"
  })), _path4508 || (_path4508 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h-1v-1h1z",
    fill: "#ce8ca0"
  })), _path4509 || (_path4509 = /*#__PURE__*/React.createElement("path", {
    d: "M84 109v1h-1v-1z",
    fill: "#c3798f"
  })), _path4510 || (_path4510 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110h-1v-1h1z",
    fill: "#d0a7aa"
  })), _path4511 || (_path4511 = /*#__PURE__*/React.createElement("path", {
    d: "M85 109h1v1h-1z",
    fill: "#d995a7"
  })), _path4512 || (_path4512 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109v1h-1v-1z",
    fill: "#b50a48"
  })), _path4513 || (_path4513 = /*#__PURE__*/React.createElement("path", {
    d: "M87 109h1v1h-1z",
    fill: "#7c2854"
  })), _path4514 || (_path4514 = /*#__PURE__*/React.createElement("path", {
    d: "M89 109v1h-1v-1z",
    fill: "#41485e"
  })), _path4515 || (_path4515 = /*#__PURE__*/React.createElement("path", {
    d: "M89 110v-1h1v1z",
    fill: "#404a63"
  })), _path4516 || (_path4516 = /*#__PURE__*/React.createElement("path", {
    d: "M90 110v-1h1v1z",
    fill: "#474e67"
  })), _path4517 || (_path4517 = /*#__PURE__*/React.createElement("path", {
    d: "M91 109h1v1h-1z",
    fill: "#2c313c"
  })), _path4518 || (_path4518 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111h-1v-1h1z",
    fill: "#efeff7",
    fillOpacity: 0.125
  })), _path4519 || (_path4519 = /*#__PURE__*/React.createElement("path", {
    d: "M34 110h1v1h-1z",
    fill: "#76797d",
    fillOpacity: 0.933
  })), _path4520 || (_path4520 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v-1h1v1z",
    fill: "#343a4c"
  })), _path4521 || (_path4521 = /*#__PURE__*/React.createElement("path", {
    d: "M37 110h1v1h-1z",
    fill: "#343b52"
  })), _path4522 || (_path4522 = /*#__PURE__*/React.createElement("path", {
    d: "M39 110h1v1h-1z",
    fill: "#38464c"
  })), _path4523 || (_path4523 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111h-1v-1h1z",
    fill: "#63a859"
  })), _path4524 || (_path4524 = /*#__PURE__*/React.createElement("path", {
    d: "M41 111v-1h1v1z",
    fill: "#63b451"
  })), _path4525 || (_path4525 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110v1h-1v-1z",
    fill: "#8bbf7f"
  })), _path4526 || (_path4526 = /*#__PURE__*/React.createElement("path", {
    d: "M43 110h1v1h-1z",
    fill: "#c8e1c3"
  })), _path4527 || (_path4527 = /*#__PURE__*/React.createElement("path", {
    d: "M45 110v1h-1v-1z",
    fill: "#6aab5d"
  })), _path4528 || (_path4528 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h-1v-1h1z",
    fill: "#5eb34f"
  })), _path4529 || (_path4529 = /*#__PURE__*/React.createElement("path", {
    d: "M47 111h-1v-1h1z",
    fill: "#64b455"
  })), _path4530 || (_path4530 = /*#__PURE__*/React.createElement("path", {
    d: "M47 110h1v1h-1z",
    fill: "#6cb855"
  })), _path4531 || (_path4531 = /*#__PURE__*/React.createElement("path", {
    d: "M49 111h-1v-1h1z",
    fill: "#517c55"
  })), _path4532 || (_path4532 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111h-1v-1h1z",
    fill: "#505665"
  })), _path4533 || (_path4533 = /*#__PURE__*/React.createElement("path", {
    d: "M54 110v1h-1v-1z",
    fill: "#dce1e1"
  })), _path4534 || (_path4534 = /*#__PURE__*/React.createElement("path", {
    d: "M54 111v-1h1v1z",
    fill: "#aacbe2"
  })), _path4535 || (_path4535 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h-1v-1h1z",
    fill: "#105fb3"
  })), _path4536 || (_path4536 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111v-1h1v1z",
    fill: "#015dc0"
  })), _path4537 || (_path4537 = /*#__PURE__*/React.createElement("path", {
    d: "M57 110h1v1h-1z",
    fill: "#085bbc"
  })), _path4538 || (_path4538 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111h-1v-1h1z",
    fill: "#075fbe"
  })), _path4539 || (_path4539 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v-1h1v1z",
    fill: "#4b83ca"
  })), _path4540 || (_path4540 = /*#__PURE__*/React.createElement("path", {
    d: "M60 110h1v1h-1z",
    fill: "#d4e1ec"
  })), _path4541 || (_path4541 = /*#__PURE__*/React.createElement("path", {
    d: "M62 111h-1v-1h1z",
    fill: "#8f949f"
  })), _path4542 || (_path4542 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110v1h-1v-1z",
    fill: "#323a4f"
  })), _path4543 || (_path4543 = /*#__PURE__*/React.createElement("path", {
    d: "M63 110h1v1h-1z",
    fill: "#394156"
  })), _path4544 || (_path4544 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111h-1v-1h1z",
    fill: "#363e54"
  })), _path4545 || (_path4545 = /*#__PURE__*/React.createElement("path", {
    d: "M65 111v-1h1v1z",
    fill: "#575d6e"
  })), _path4546 || (_path4546 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111v-1h1v1z",
    fill: "#d4dfd4"
  })), _path4547 || (_path4547 = /*#__PURE__*/React.createElement("path", {
    d: "M68 110v1h-1v-1z",
    fill: "#78ad55"
  })), _path4548 || (_path4548 = /*#__PURE__*/React.createElement("path", {
    d: "M69 111h-1v-1h1z",
    fill: "#92a980"
  })), _path4549 || (_path4549 = /*#__PURE__*/React.createElement("path", {
    d: "M70 110v1h-1v-1z",
    fill: "#4b87cc"
  })), _path4550 || (_path4550 = /*#__PURE__*/React.createElement("path", {
    d: "M71 110v1h-1v-1z",
    fill: "#2d74d0"
  })), _path4551 || (_path4551 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111v-1h1v1z",
    fill: "#a9b79b"
  })), _path4552 || (_path4552 = /*#__PURE__*/React.createElement("path", {
    d: "M72 110h1v1h-1z",
    fill: "#e0b638"
  })), _path4553 || (_path4553 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111h-1v-1h1z",
    fill: "#e8dbae"
  })), _path4554 || (_path4554 = /*#__PURE__*/React.createElement("path", {
    d: "M74 111v-1h1v1z",
    fill: "#8a8f97"
  })), _path4555 || (_path4555 = /*#__PURE__*/React.createElement("path", {
    d: "M76 110h1v1h-1z",
    fill: "#3a4258"
  })), _path4556 || (_path4556 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h-1v-1h1z",
    fill: "#374355"
  })), _path4557 || (_path4557 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h-1v-1h1z",
    fill: "#652e52"
  })), _path4558 || (_path4558 = /*#__PURE__*/React.createElement("path", {
    d: "M80 110v1h-1v-1z",
    fill: "#b40144"
  })), _path4559 || (_path4559 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111v-1h1v1z",
    fill: "#d389a0"
  })), _path4560 || (_path4560 = /*#__PURE__*/React.createElement("path", {
    d: "M82 111h-1v-1h1z",
    fill: "#e9e3e1"
  })), _path4561 || (_path4561 = /*#__PURE__*/React.createElement("path", {
    d: "M82 110h1v1h-1z",
    fill: "#a62656"
  })), _path4562 || (_path4562 = /*#__PURE__*/React.createElement("path", {
    d: "M83 110h1v1h-1z",
    fill: "#9a063b"
  })), _path4563 || (_path4563 = /*#__PURE__*/React.createElement("path", {
    d: "M85 110v1h-1v-1z",
    fill: "#e4c7cb"
  })), _path4564 || (_path4564 = /*#__PURE__*/React.createElement("path", {
    d: "M86 111h-1v-1h1z",
    fill: "#e4b2c1"
  })), _path4565 || (_path4565 = /*#__PURE__*/React.createElement("path", {
    d: "M86 110h1v1h-1z",
    fill: "#b60648"
  })), _path4566 || (_path4566 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110v1h-1v-1z",
    fill: "#7e2554"
  })), _path4567 || (_path4567 = /*#__PURE__*/React.createElement("path", {
    d: "M88 110h1v1h-1z",
    fill: "#3d465d"
  })), _path4568 || (_path4568 = /*#__PURE__*/React.createElement("path", {
    d: "M90 111v-1h1v1z",
    fill: "#434963"
  })), _path4569 || (_path4569 = /*#__PURE__*/React.createElement("path", {
    d: "M92 111h-1v-1h1z",
    fill: "#2b303b"
  })), _path4570 || (_path4570 = /*#__PURE__*/React.createElement("path", {
    d: "M34 111v1h-1v-1z",
    fill: "#eff7ff",
    fillOpacity: 0.125
  })), _path4571 || (_path4571 = /*#__PURE__*/React.createElement("path", {
    d: "M34 112v-1h1v1z",
    fill: "#767a7e",
    fillOpacity: 0.933
  })), _path4572 || (_path4572 = /*#__PURE__*/React.createElement("path", {
    d: "M36 111v1h-1v-1z",
    fill: "#191c20"
  })), _path4573 || (_path4573 = /*#__PURE__*/React.createElement("path", {
    d: "M37 111h1v1h-1z",
    fill: "#343a50"
  })), _path4574 || (_path4574 = /*#__PURE__*/React.createElement("path", {
    d: "M39 112h-1v-1h1z",
    fill: "#31384d"
  })), _path4575 || (_path4575 = /*#__PURE__*/React.createElement("path", {
    d: "M40 112h-1v-1h1z",
    fill: "#343f48"
  })), _path4576 || (_path4576 = /*#__PURE__*/React.createElement("path", {
    d: "M40 111h1v1h-1z",
    fill: "#62a059"
  })), _path4577 || (_path4577 = /*#__PURE__*/React.createElement("path", {
    d: "M42 112h-1v-1h1z",
    fill: "#64b34f"
  })), _path4578 || (_path4578 = /*#__PURE__*/React.createElement("path", {
    d: "M42 111h1v1h-1z",
    fill: "#80b970"
  })), _path4579 || (_path4579 = /*#__PURE__*/React.createElement("path", {
    d: "M44 111v1h-1v-1z",
    fill: "#d5e8cd"
  })), _path4580 || (_path4580 = /*#__PURE__*/React.createElement("path", {
    d: "M44 112v-1h1v1z",
    fill: "#b4d3ac"
  })), _path4581 || (_path4581 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v-1h1v1z",
    fill: "#81be74"
  })), _path4582 || (_path4582 = /*#__PURE__*/React.createElement("path", {
    d: "M46 111h1v1h-1z",
    fill: "#64af54"
  })), _path4583 || (_path4583 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111v1h-1v-1z",
    fill: "#6ab556"
  })), _path4584 || (_path4584 = /*#__PURE__*/React.createElement("path", {
    d: "M48 111h1v1h-1z",
    fill: "#4e754e"
  })), _path4585 || (_path4585 = /*#__PURE__*/React.createElement("path", {
    d: "M50 111h1v1h-1z",
    fill: "#363d52"
  })), _path4586 || (_path4586 = /*#__PURE__*/React.createElement("path", {
    d: "M52 112h-1v-1h1z",
    fill: "#363a52"
  })), _path4587 || (_path4587 = /*#__PURE__*/React.createElement("path", {
    d: "M52 111h1v1h-1z",
    fill: "#474d5d"
  })), _path4588 || (_path4588 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111v1h-1v-1z",
    fill: "#dbe7e7"
  })), _path4589 || (_path4589 = /*#__PURE__*/React.createElement("path", {
    d: "M55 111h1v1h-1z",
    fill: "#7fabd8"
  })), _path4590 || (_path4590 = /*#__PURE__*/React.createElement("path", {
    d: "M56 111h1v1h-1z",
    fill: "#3f83cf"
  })), _path4591 || (_path4591 = /*#__PURE__*/React.createElement("path", {
    d: "M58 112h-1v-1h1z",
    fill: "#4c89d3"
  })), _path4592 || (_path4592 = /*#__PURE__*/React.createElement("path", {
    d: "M59 111v1h-1v-1z",
    fill: "#5d92d3"
  })), _path4593 || (_path4593 = /*#__PURE__*/React.createElement("path", {
    d: "M60 111v1h-1v-1z",
    fill: "#9cbcdb"
  })), _path4594 || (_path4594 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111v1h-1v-1z",
    fill: "#e3ebed"
  })), _path4595 || (_path4595 = /*#__PURE__*/React.createElement("path", {
    d: "M61 111h1v1h-1z",
    fill: "#848a95"
  })), _path4596 || (_path4596 = /*#__PURE__*/React.createElement("path", {
    d: "M63 111v1h-1v-1z",
    fill: "#31394f"
  })), _path4597 || (_path4597 = /*#__PURE__*/React.createElement("path", {
    d: "M63 112v-1h1v1z",
    fill: "#373f54"
  })), _path4598 || (_path4598 = /*#__PURE__*/React.createElement("path", {
    d: "M66 112h-1v-1h1z",
    fill: "#4e5664"
  })), _path4599 || (_path4599 = /*#__PURE__*/React.createElement("path", {
    d: "M66 111h1v1h-1z",
    fill: "#d8e0d9"
  })), _path4600 || (_path4600 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111v1h-1v-1z",
    fill: "#89b96f"
  })), _path4601 || (_path4601 = /*#__PURE__*/React.createElement("path", {
    d: "M68 111h1v1h-1z",
    fill: "#69a452"
  })), _path4602 || (_path4602 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h-1v-1h1z",
    fill: "#77b2a8"
  })), _path4603 || (_path4603 = /*#__PURE__*/React.createElement("path", {
    d: "M71 112h-1v-1h1z",
    fill: "#7da7ae"
  })), _path4604 || (_path4604 = /*#__PURE__*/React.createElement("path", {
    d: "M71 111h1v1h-1z",
    fill: "#cfbd6c"
  })), _path4605 || (_path4605 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111v1h-1v-1z",
    fill: "#dbb845"
  })), _path4606 || (_path4606 = /*#__PURE__*/React.createElement("path", {
    d: "M73 111h1v1h-1z",
    fill: "#e6e4c5"
  })), _path4607 || (_path4607 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v-1h1v1z",
    fill: "#7d838d"
  })), _path4608 || (_path4608 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111v1h-1v-1z",
    fill: "#354153"
  })), _path4609 || (_path4609 = /*#__PURE__*/React.createElement("path", {
    d: "M78 111h1v1h-1z",
    fill: "#602e4f"
  })), _path4610 || (_path4610 = /*#__PURE__*/React.createElement("path", {
    d: "M79 111h1v1h-1z",
    fill: "#ae0243"
  })), _path4611 || (_path4611 = /*#__PURE__*/React.createElement("path", {
    d: "M80 111h1v1h-1z",
    fill: "#d3809c"
  })), _path4612 || (_path4612 = /*#__PURE__*/React.createElement("path", {
    d: "M81 112v-1h1v1z",
    fill: "#eef1ed"
  })), _path4613 || (_path4613 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112h-1v-1h1z",
    fill: "#deb1c0"
  })), _path4614 || (_path4614 = /*#__PURE__*/React.createElement("path", {
    d: "M84 111v1h-1v-1z",
    fill: "#dba2b5"
  })), _path4615 || (_path4615 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112v-1h1v1z",
    fill: "#f2eae7"
  })), _path4616 || (_path4616 = /*#__PURE__*/React.createElement("path", {
    d: "M85 111h1v1h-1z",
    fill: "#e3acbd"
  })), _path4617 || (_path4617 = /*#__PURE__*/React.createElement("path", {
    d: "M86 112v-1h1v1z",
    fill: "#b00845"
  })), _path4618 || (_path4618 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112v-1h1v1z",
    fill: "#752651"
  })), _path4619 || (_path4619 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112h-1v-1h1z",
    fill: "#3c455d"
  })), _path4620 || (_path4620 = /*#__PURE__*/React.createElement("path", {
    d: "M91 112v-1h1v1z",
    fill: "#2a2d39"
  })), _path4621 || (_path4621 = /*#__PURE__*/React.createElement("path", {
    d: "M93 111v1h-1v-1z",
    fill: "#3b3c3f"
  })), _path4622 || (_path4622 = /*#__PURE__*/React.createElement("path", {
    d: "M35 112v1h-1v-1z",
    fill: "#777a7e",
    fillOpacity: 0.937
  })), _path4623 || (_path4623 = /*#__PURE__*/React.createElement("path", {
    d: "M37 112v1h-1v-1z",
    fill: "#323849"
  })), _path4624 || (_path4624 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h-1v-1h1z",
    fill: "#2f3844"
  })), _path4625 || (_path4625 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113v-1h1v1z",
    fill: "#5b8758"
  })), _path4626 || (_path4626 = /*#__PURE__*/React.createElement("path", {
    d: "M42 113h-1v-1h1z",
    fill: "#68b159"
  })), _path4627 || (_path4627 = /*#__PURE__*/React.createElement("path", {
    d: "M43 113h-1v-1h1z",
    fill: "#64ae58"
  })), _path4628 || (_path4628 = /*#__PURE__*/React.createElement("path", {
    d: "M43 112h1v1h-1z",
    fill: "#a8cfa3"
  })), _path4629 || (_path4629 = /*#__PURE__*/React.createElement("path", {
    d: "M45 112v1h-1v-1z",
    fill: "#d7ebd5"
  })), _path4630 || (_path4630 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113h-1v-1h1z",
    fill: "#99c993"
  })), _path4631 || (_path4631 = /*#__PURE__*/React.createElement("path", {
    d: "M46 112h1v1h-1z",
    fill: "#5fae52"
  })), _path4632 || (_path4632 = /*#__PURE__*/React.createElement("path", {
    d: "M48 113h-1v-1h1z",
    fill: "#68af5e"
  })), _path4633 || (_path4633 = /*#__PURE__*/React.createElement("path", {
    d: "M49 112v1h-1v-1z",
    fill: "#3d594d"
  })), _path4634 || (_path4634 = /*#__PURE__*/React.createElement("path", {
    d: "M50 112v1h-1v-1z",
    fill: "#33374f"
  })), _path4635 || (_path4635 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113v-1h1v1z",
    fill: "#353a51"
  })), _path4636 || (_path4636 = /*#__PURE__*/React.createElement("path", {
    d: "M53 113h-1v-1h1z",
    fill: "#373d4f"
  })), _path4637 || (_path4637 = /*#__PURE__*/React.createElement("path", {
    d: "M54 112v1h-1v-1z",
    fill: "#b5bdbd"
  })), _path4638 || (_path4638 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v-1h1v1z",
    fill: "#e9e7e8"
  })), _path4639 || (_path4639 = /*#__PURE__*/React.createElement("path", {
    d: "M55 112h1v1h-1z",
    fill: "#dae1e9"
  })), _path4640 || (_path4640 = /*#__PURE__*/React.createElement("path", {
    d: "M57 112v1h-1v-1z",
    fill: "#8faed1"
  })), _path4641 || (_path4641 = /*#__PURE__*/React.createElement("path", {
    d: "M57 113v-1h1v1z",
    fill: "#a9c2e3"
  })), _path4642 || (_path4642 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113h-1v-1h1z",
    fill: "#d3e0ea"
  })), _path4643 || (_path4643 = /*#__PURE__*/React.createElement("path", {
    d: "M59 113v-1h1v1z",
    fill: "#dfe6df"
  })), _path4644 || (_path4644 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h-1v-1h1z",
    fill: "#e0e7e3"
  })), _path4645 || (_path4645 = /*#__PURE__*/React.createElement("path", {
    d: "M62 112v1h-1v-1z",
    fill: "#5f6675"
  })), _path4646 || (_path4646 = /*#__PURE__*/React.createElement("path", {
    d: "M65 113h-1v-1h1z",
    fill: "#353c52"
  })), _path4647 || (_path4647 = /*#__PURE__*/React.createElement("path", {
    d: "M65 112h1v1h-1z",
    fill: "#3c3f54"
  })), _path4648 || (_path4648 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112v1h-1v-1z",
    fill: "#bfc7cb"
  })), _path4649 || (_path4649 = /*#__PURE__*/React.createElement("path", {
    d: "M67 112h1v1h-1z",
    fill: "#cde1bc"
  })), _path4650 || (_path4650 = /*#__PURE__*/React.createElement("path", {
    d: "M69 112v1h-1v-1z",
    fill: "#71a553"
  })), _path4651 || (_path4651 = /*#__PURE__*/React.createElement("path", {
    d: "M69 113v-1h1v1z",
    fill: "#62993d"
  })), _path4652 || (_path4652 = /*#__PURE__*/React.createElement("path", {
    d: "M70 112h1v1h-1z",
    fill: "#93a640"
  })), _path4653 || (_path4653 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v-1h1v1z",
    fill: "#d4b94a"
  })), _path4654 || (_path4654 = /*#__PURE__*/React.createElement("path", {
    d: "M73 112v1h-1v-1z",
    fill: "#e4d293"
  })), _path4655 || (_path4655 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112v1h-1v-1z",
    fill: "#dfe4dc"
  })), _path4656 || (_path4656 = /*#__PURE__*/React.createElement("path", {
    d: "M74 112h1v1h-1z",
    fill: "#585e6f"
  })), _path4657 || (_path4657 = /*#__PURE__*/React.createElement("path", {
    d: "M75 112h1v1h-1z",
    fill: "#323950"
  })), _path4658 || (_path4658 = /*#__PURE__*/React.createElement("path", {
    d: "M79 112v1h-1v-1z",
    fill: "#4c3550"
  })), _path4659 || (_path4659 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113h-1v-1h1z",
    fill: "#a10e4a"
  })), _path4660 || (_path4660 = /*#__PURE__*/React.createElement("path", {
    d: "M80 112h1v1h-1z",
    fill: "#bd245c"
  })), _path4661 || (_path4661 = /*#__PURE__*/React.createElement("path", {
    d: "M82 113h-1v-1h1z",
    fill: "#cc6a8e"
  })), _path4662 || (_path4662 = /*#__PURE__*/React.createElement("path", {
    d: "M83 112v1h-1v-1z",
    fill: "#ce6e92"
  })), _path4663 || (_path4663 = /*#__PURE__*/React.createElement("path", {
    d: "M83 113v-1h1v1z",
    fill: "#cc7293"
  })), _path4664 || (_path4664 = /*#__PURE__*/React.createElement("path", {
    d: "M84 112h1v1h-1z",
    fill: "#ca6f8d"
  })), _path4665 || (_path4665 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113v-1h1v1z",
    fill: "#c23b6b"
  })), _path4666 || (_path4666 = /*#__PURE__*/React.createElement("path", {
    d: "M86 113v-1h1v1z",
    fill: "#ae0946"
  })), _path4667 || (_path4667 = /*#__PURE__*/React.createElement("path", {
    d: "M87 112h1v1h-1z",
    fill: "#5d314f"
  })), _path4668 || (_path4668 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v-1h1v1z",
    fill: "#384056"
  })), _path4669 || (_path4669 = /*#__PURE__*/React.createElement("path", {
    d: "M90 112v1h-1v-1z",
    fill: "#3b4159"
  })), _path4670 || (_path4670 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113v-1h1v1z",
    fill: "#3d435a"
  })), _path4671 || (_path4671 = /*#__PURE__*/React.createElement("path", {
    d: "M91 113v-1h1v1z",
    fill: "#272a36"
  })), _path4672 || (_path4672 = /*#__PURE__*/React.createElement("path", {
    d: "M33 113h1v1h-1z",
    fill: "#f0f7ff",
    fillOpacity: 0.133
  })), _path4673 || (_path4673 = /*#__PURE__*/React.createElement("path", {
    d: "M34 114v-1h1v1z",
    fill: "#777a7e",
    fillOpacity: 0.941
  })), _path4674 || (_path4674 = /*#__PURE__*/React.createElement("path", {
    d: "M36 114v-1h1v1z",
    fill: "#313848"
  })), _path4675 || (_path4675 = /*#__PURE__*/React.createElement("path", {
    d: "M40 113h1v1h-1z",
    fill: "#3a5145"
  })), _path4676 || (_path4676 = /*#__PURE__*/React.createElement("path", {
    d: "M41 113h1v1h-1z",
    fill: "#689f5f"
  })), _path4677 || (_path4677 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114v-1h1v1z",
    fill: "#68b058"
  })), _path4678 || (_path4678 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114h-1v-1h1z",
    fill: "#67ae57"
  })), _path4679 || (_path4679 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114h-1v-1h1z",
    fill: "#73b266"
  })), _path4680 || (_path4680 = /*#__PURE__*/React.createElement("path", {
    d: "M46 113v1h-1v-1z",
    fill: "#6db060"
  })), _path4681 || (_path4681 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114v-1h1v1z",
    fill: "#66af5a"
  })), _path4682 || (_path4682 = /*#__PURE__*/React.createElement("path", {
    d: "M47 113h1v1h-1z",
    fill: "#547f56"
  })), _path4683 || (_path4683 = /*#__PURE__*/React.createElement("path", {
    d: "M49 113v1h-1v-1z",
    fill: "#2e3d44"
  })), _path4684 || (_path4684 = /*#__PURE__*/React.createElement("path", {
    d: "M49 114v-1h1v1z",
    fill: "#35384d"
  })), _path4685 || (_path4685 = /*#__PURE__*/React.createElement("path", {
    d: "M51 114h-1v-1h1z",
    fill: "#34394b"
  })), _path4686 || (_path4686 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113v1h-1v-1z",
    fill: "#636c74"
  })), _path4687 || (_path4687 = /*#__PURE__*/React.createElement("path", {
    d: "M54 113h1v1h-1z",
    fill: "#d8dddc"
  })), _path4688 || (_path4688 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114v-1h1v1z",
    fill: "#e8ebe2"
  })), _path4689 || (_path4689 = /*#__PURE__*/React.createElement("path", {
    d: "M56 114v-1h1v1z",
    fill: "#dbe7e6"
  })), _path4690 || (_path4690 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114h-1v-1h1z",
    fill: "#d8e3e4"
  })), _path4691 || (_path4691 = /*#__PURE__*/React.createElement("path", {
    d: "M58 114v-1h1v1z",
    fill: "#e9ebe3"
  })), _path4692 || (_path4692 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v-1h1v1z",
    fill: "#e6ece5"
  })), _path4693 || (_path4693 = /*#__PURE__*/React.createElement("path", {
    d: "M60 114v-1h1v1z",
    fill: "#9ea6ae"
  })), _path4694 || (_path4694 = /*#__PURE__*/React.createElement("path", {
    d: "M61 113h1v1h-1z",
    fill: "#373c50"
  })), _path4695 || (_path4695 = /*#__PURE__*/React.createElement("path", {
    d: "M63 113v1h-1v-1z",
    fill: "#343a51"
  })), _path4696 || (_path4696 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114v-1h1v1z",
    fill: "#313750"
  })), _path4697 || (_path4697 = /*#__PURE__*/React.createElement("path", {
    d: "M67 114h-1v-1h1z",
    fill: "#6a7082"
  })), _path4698 || (_path4698 = /*#__PURE__*/React.createElement("path", {
    d: "M68 113v1h-1v-1z",
    fill: "#dde3de"
  })), _path4699 || (_path4699 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114h-1v-1h1z",
    fill: "#d0ebcd"
  })), _path4700 || (_path4700 = /*#__PURE__*/React.createElement("path", {
    d: "M70 113v1h-1v-1z",
    fill: "#b3cd9c"
  })), _path4701 || (_path4701 = /*#__PURE__*/React.createElement("path", {
    d: "M71 113v1h-1v-1z",
    fill: "#c7d595"
  })), _path4702 || (_path4702 = /*#__PURE__*/React.createElement("path", {
    d: "M71 114v-1h1v1z",
    fill: "#e5e4ba"
  })), _path4703 || (_path4703 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114h-1v-1h1z",
    fill: "#e8ebe4"
  })), _path4704 || (_path4704 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114h-1v-1h1z",
    fill: "#999ca6"
  })), _path4705 || (_path4705 = /*#__PURE__*/React.createElement("path", {
    d: "M76 114h-1v-1h1z",
    fill: "#333b51"
  })), _path4706 || (_path4706 = /*#__PURE__*/React.createElement("path", {
    d: "M78 114v-1h1v1z",
    fill: "#393a4f"
  })), _path4707 || (_path4707 = /*#__PURE__*/React.createElement("path", {
    d: "M80 113v1h-1v-1z",
    fill: "#70264e"
  })), _path4708 || (_path4708 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114v-1h1v1z",
    fill: "#af0748"
  })), _path4709 || (_path4709 = /*#__PURE__*/React.createElement("path", {
    d: "M82 114h-1v-1h1z",
    fill: "#b90042"
  })), _path4710 || (_path4710 = /*#__PURE__*/React.createElement("path", {
    d: "M83 114h-1v-1h1z",
    fill: "#b04"
  })), _path4711 || (_path4711 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114h-1v-1h1z",
    fill: "#ba0045"
  })), _path4712 || (_path4712 = /*#__PURE__*/React.createElement("path", {
    d: "M85 114h-1v-1h1z",
    fill: "#b70042"
  })), _path4713 || (_path4713 = /*#__PURE__*/React.createElement("path", {
    d: "M85 113h1v1h-1z",
    fill: "#b30349"
  })), _path4714 || (_path4714 = /*#__PURE__*/React.createElement("path", {
    d: "M87 113v1h-1v-1z",
    fill: "#871e4f"
  })), _path4715 || (_path4715 = /*#__PURE__*/React.createElement("path", {
    d: "M88 113v1h-1v-1z",
    fill: "#3e3d50"
  })), _path4716 || (_path4716 = /*#__PURE__*/React.createElement("path", {
    d: "M89 114h-1v-1h1z",
    fill: "#383c52"
  })), _path4717 || (_path4717 = /*#__PURE__*/React.createElement("path", {
    d: "M90 114h-1v-1h1z",
    fill: "#383e53"
  })), _path4718 || (_path4718 = /*#__PURE__*/React.createElement("path", {
    d: "M90 113h1v1h-1z",
    fill: "#3b4057"
  })), _path4719 || (_path4719 = /*#__PURE__*/React.createElement("path", {
    d: "M92 113v1h-1v-1z",
    fill: "#262935"
  })), _path4720 || (_path4720 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115h-1v-1h1z",
    fill: "#76797c",
    fillOpacity: 0.937
  })), _path4721 || (_path4721 = /*#__PURE__*/React.createElement("path", {
    d: "M37 114v1h-1v-1z",
    fill: "#303747"
  })), _path4722 || (_path4722 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v-1h1v1z",
    fill: "#313649"
  })), _path4723 || (_path4723 = /*#__PURE__*/React.createElement("path", {
    d: "M40 114v1h-1v-1z",
    fill: "#32364d"
  })), _path4724 || (_path4724 = /*#__PURE__*/React.createElement("path", {
    d: "M41 115h-1v-1h1z",
    fill: "#2d3646"
  })), _path4725 || (_path4725 = /*#__PURE__*/React.createElement("path", {
    d: "M41 114h1v1h-1z",
    fill: "#334b42"
  })), _path4726 || (_path4726 = /*#__PURE__*/React.createElement("path", {
    d: "M42 114h1v1h-1z",
    fill: "#4d6d53"
  })), _path4727 || (_path4727 = /*#__PURE__*/React.createElement("path", {
    d: "M44 114v1h-1v-1z",
    fill: "#537d54"
  })), _path4728 || (_path4728 = /*#__PURE__*/React.createElement("path", {
    d: "M45 114v1h-1v-1z",
    fill: "#518152"
  })), _path4729 || (_path4729 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115v-1h1v1z",
    fill: "#507953"
  })), _path4730 || (_path4730 = /*#__PURE__*/React.createElement("path", {
    d: "M46 114h1v1h-1z",
    fill: "#416049"
  })), _path4731 || (_path4731 = /*#__PURE__*/React.createElement("path", {
    d: "M47 115v-1h1v1z",
    fill: "#323947"
  })), _path4732 || (_path4732 = /*#__PURE__*/React.createElement("path", {
    d: "M48 114h1v1h-1z",
    fill: "#31374e"
  })), _path4733 || (_path4733 = /*#__PURE__*/React.createElement("path", {
    d: "M50 115v-1h1v1z",
    fill: "#33394a"
  })), _path4734 || (_path4734 = /*#__PURE__*/React.createElement("path", {
    d: "M53 114h1v1h-1z",
    fill: "#32364c"
  })), _path4735 || (_path4735 = /*#__PURE__*/React.createElement("path", {
    d: "M55 115h-1v-1h1z",
    fill: "#525a68"
  })), _path4736 || (_path4736 = /*#__PURE__*/React.createElement("path", {
    d: "M55 114h1v1h-1z",
    fill: "#8c929c"
  })), _path4737 || (_path4737 = /*#__PURE__*/React.createElement("path", {
    d: "M57 114v1h-1v-1z",
    fill: "#a5a8af"
  })), _path4738 || (_path4738 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115v-1h1v1z",
    fill: "#a6adaf"
  })), _path4739 || (_path4739 = /*#__PURE__*/React.createElement("path", {
    d: "M59 114v1h-1v-1z",
    fill: "#9ca0a5"
  })), _path4740 || (_path4740 = /*#__PURE__*/React.createElement("path", {
    d: "M60 115h-1v-1h1z",
    fill: "#6e7681"
  })), _path4741 || (_path4741 = /*#__PURE__*/React.createElement("path", {
    d: "M61 115h-1v-1h1z",
    fill: "#393e50"
  })), _path4742 || (_path4742 = /*#__PURE__*/React.createElement("path", {
    d: "M61 114h1v1h-1z",
    fill: "#35384c"
  })), _path4743 || (_path4743 = /*#__PURE__*/React.createElement("path", {
    d: "M65 114h1v1h-1z",
    fill: "#343c4d"
  })), _path4744 || (_path4744 = /*#__PURE__*/React.createElement("path", {
    d: "M67 115v-1h1v1z",
    fill: "#585d6c"
  })), _path4745 || (_path4745 = /*#__PURE__*/React.createElement("path", {
    d: "M69 114v1h-1v-1z",
    fill: "#90989e"
  })), _path4746 || (_path4746 = /*#__PURE__*/React.createElement("path", {
    d: "M71 115h-1v-1h1z",
    fill: "#a9adb4"
  })), _path4747 || (_path4747 = /*#__PURE__*/React.createElement("path", {
    d: "M71 115v-1h1v1z",
    fill: "#9ca0aa"
  })), _path4748 || (_path4748 = /*#__PURE__*/React.createElement("path", {
    d: "M73 114v1h-1v-1z",
    fill: "#6c737f"
  })), _path4749 || (_path4749 = /*#__PURE__*/React.createElement("path", {
    d: "M74 114v1h-1v-1z",
    fill: "#363d4f"
  })), _path4750 || (_path4750 = /*#__PURE__*/React.createElement("path", {
    d: "M79 114h1v1h-1z",
    fill: "#3a374a"
  })), _path4751 || (_path4751 = /*#__PURE__*/React.createElement("path", {
    d: "M80 114h1v1h-1z",
    fill: "#5e2a4a"
  })), _path4752 || (_path4752 = /*#__PURE__*/React.createElement("path", {
    d: "M81 115v-1h1v1z",
    fill: "#801e4c"
  })), _path4753 || (_path4753 = /*#__PURE__*/React.createElement("path", {
    d: "M83 115h-1v-1h1z",
    fill: "#8f194b"
  })), _path4754 || (_path4754 = /*#__PURE__*/React.createElement("path", {
    d: "M84 114v1h-1v-1z",
    fill: "#90194c"
  })), _path4755 || (_path4755 = /*#__PURE__*/React.createElement("path", {
    d: "M85 115h-1v-1h1z",
    fill: "#891b49"
  })), _path4756 || (_path4756 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114v1h-1v-1z",
    fill: "#6a274c"
  })), _path4757 || (_path4757 = /*#__PURE__*/React.createElement("path", {
    d: "M86 114h1v1h-1z",
    fill: "#40384f"
  })), _path4758 || (_path4758 = /*#__PURE__*/React.createElement("path", {
    d: "M88 114v1h-1v-1z",
    fill: "#333a4e"
  })), _path4759 || (_path4759 = /*#__PURE__*/React.createElement("path", {
    d: "M89 115h-1v-1h1z",
    fill: "#373a50"
  })), _path4760 || (_path4760 = /*#__PURE__*/React.createElement("path", {
    d: "M92 114v1h-1v-1z",
    fill: "#242833"
  })), _path4761 || (_path4761 = /*#__PURE__*/React.createElement("path", {
    d: "M94 115h-1v-1h1z",
    fill: "#a5a5ae",
    fillOpacity: 0.447
  })), _path4762 || (_path4762 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h-1v-1h1z",
    fill: "#f1f1f8",
    fillOpacity: 0.153
  })), _path4763 || (_path4763 = /*#__PURE__*/React.createElement("path", {
    d: "M35 115v1h-1v-1z",
    fill: "#7b7c7e",
    fillOpacity: 0.953
  })), _path4764 || (_path4764 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h-1v-1h1z",
    fill: "#181a1d"
  })), _path4765 || (_path4765 = /*#__PURE__*/React.createElement("path", {
    d: "M38 115v1h-1v-1z",
    fill: "#2f364a"
  })), _path4766 || (_path4766 = /*#__PURE__*/React.createElement("path", {
    d: "M38 116v-1h1v1z",
    fill: "#30374b"
  })), _path4767 || (_path4767 = /*#__PURE__*/React.createElement("path", {
    d: "M39 115h1v1h-1z",
    fill: "#30374a"
  })), _path4768 || (_path4768 = /*#__PURE__*/React.createElement("path", {
    d: "M44 116h-1v-1h1z",
    fill: "#2c3343"
  })), _path4769 || (_path4769 = /*#__PURE__*/React.createElement("path", {
    d: "M45 116h-1v-1h1z",
    fill: "#2d3443"
  })), _path4770 || (_path4770 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115h1v1h-1z",
    fill: "#2d3445"
  })), _path4771 || (_path4771 = /*#__PURE__*/React.createElement("path", {
    d: "M57 115h1v1h-1z",
    fill: "#303449"
  })), _path4772 || (_path4772 = /*#__PURE__*/React.createElement("path", {
    d: "M66 115h1v1h-1z",
    fill: "#343a4d"
  })), _path4773 || (_path4773 = /*#__PURE__*/React.createElement("path", {
    d: "M70 115h1v1h-1z",
    fill: "#30354a"
  })), _path4774 || (_path4774 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116h-1v-1h1z",
    fill: "#33374c"
  })), _path4775 || (_path4775 = /*#__PURE__*/React.createElement("path", {
    d: "M81 116v-1h1v1z",
    fill: "#36374c"
  })), _path4776 || (_path4776 = /*#__PURE__*/React.createElement("path", {
    d: "M83 116v-1h1v1z",
    fill: "#38364d"
  })), _path4777 || (_path4777 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116v-1h1v1z",
    fill: "#31394c"
  })), _path4778 || (_path4778 = /*#__PURE__*/React.createElement("path", {
    d: "M90 115v1h-1v-1z",
    fill: "#353a4e"
  })), _path4779 || (_path4779 = /*#__PURE__*/React.createElement("path", {
    d: "M92 116h-1v-1h1z",
    fill: "#232731"
  })), _path4780 || (_path4780 = /*#__PURE__*/React.createElement("path", {
    d: "M94 116h-1v-1h1z",
    fill: "#a6a4b0",
    fillOpacity: 0.443
  })), _path4781 || (_path4781 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116v1h-1v-1z",
    fill: "#f7f7ff",
    fillOpacity: 0.141
  })), _path4782 || (_path4782 = /*#__PURE__*/React.createElement("path", {
    d: "M34 116h1v1h-1z",
    fill: "#7c7d81",
    fillOpacity: 0.945
  })), _path4783 || (_path4783 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116v1h-1v-1z",
    fill: "#191a1e"
  })), _path4784 || (_path4784 = /*#__PURE__*/React.createElement("path", {
    d: "M36 116h1v1h-1z",
    fill: "#2f3548"
  })), _path4785 || (_path4785 = /*#__PURE__*/React.createElement("path", {
    d: "M49 117h-1v-1h1z",
    fill: "#2f364b"
  })), _path4786 || (_path4786 = /*#__PURE__*/React.createElement("path", {
    d: "M60 116v1h-1v-1z",
    fill: "#32384b"
  })), _path4787 || (_path4787 = /*#__PURE__*/React.createElement("path", {
    d: "M82 117v-1h1v1z",
    fill: "#2e374d"
  })), _path4788 || (_path4788 = /*#__PURE__*/React.createElement("path", {
    d: "M84 117v-1h1v1z",
    fill: "#32354d"
  })), _path4789 || (_path4789 = /*#__PURE__*/React.createElement("path", {
    d: "M85 116h1v1h-1z",
    fill: "#31364d"
  })), _path4790 || (_path4790 = /*#__PURE__*/React.createElement("path", {
    d: "M90 116h1v1h-1z",
    fill: "#343a4e"
  })), _path4791 || (_path4791 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117v-1h1v1z",
    fill: "#232630"
  })), _path4792 || (_path4792 = /*#__PURE__*/React.createElement("path", {
    d: "M92 117v-1h1v1z",
    fill: "#3d3e41"
  })), _path4793 || (_path4793 = /*#__PURE__*/React.createElement("path", {
    d: "M93 116h1v1h-1z",
    fill: "#aaa7b3",
    fillOpacity: 0.424
  })), _path4794 || (_path4794 = /*#__PURE__*/React.createElement("path", {
    d: "M33 117h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.114
  })), _path4795 || (_path4795 = /*#__PURE__*/React.createElement("path", {
    d: "M35 117v1h-1v-1z",
    fill: "#7a7b7e",
    fillOpacity: 0.925
  })), _path4796 || (_path4796 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118h-1v-1h1z",
    fill: "#1a1b20"
  })), _path4797 || (_path4797 = /*#__PURE__*/React.createElement("path", {
    d: "M41 117h1v1h-1z",
    fill: "#2e3547"
  })), _path4798 || (_path4798 = /*#__PURE__*/React.createElement("path", {
    d: "M61 118v-1h1v1z",
    fill: "#30354b"
  })), _path4799 || (_path4799 = /*#__PURE__*/React.createElement("path", {
    d: "M78 118v-1h1v1z",
    fill: "#2e364b"
  })), _path4800 || (_path4800 = /*#__PURE__*/React.createElement("path", {
    d: "M85 117v1h-1v-1z",
    fill: "#2d354b"
  })), _path4801 || (_path4801 = /*#__PURE__*/React.createElement("path", {
    d: "M85 118v-1h1v1z",
    fill: "#2c374b"
  })), _path4802 || (_path4802 = /*#__PURE__*/React.createElement("path", {
    d: "M91 117h1v1h-1z",
    fill: "#22252f"
  })), _path4803 || (_path4803 = /*#__PURE__*/React.createElement("path", {
    d: "M93 118h-1v-1h1z",
    fill: "#3d3d41"
  })), _path4804 || (_path4804 = /*#__PURE__*/React.createElement("path", {
    d: "M93 117h1v1h-1z",
    fill: "#acaab6",
    fillOpacity: 0.412
  })), _path4805 || (_path4805 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119v-1h1v1z",
    fill: "#7a7b80",
    fillOpacity: 0.89
  })), _path4806 || (_path4806 = /*#__PURE__*/React.createElement("path", {
    d: "M36 118v1h-1v-1z",
    fill: "#191b1f"
  })), _path4807 || (_path4807 = /*#__PURE__*/React.createElement("path", {
    d: "M47 118v1h-1v-1z",
    fill: "#2d3346"
  })), _path4808 || (_path4808 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119h-1v-1h1z",
    fill: "#2d3249"
  })), _path4809 || (_path4809 = /*#__PURE__*/React.createElement("path", {
    d: "M63 118v1h-1v-1z",
    fill: "#2f344a"
  })), _path4810 || (_path4810 = /*#__PURE__*/React.createElement("path", {
    d: "M65 118v1h-1v-1z",
    fill: "#2d3248"
  })), _path4811 || (_path4811 = /*#__PURE__*/React.createElement("path", {
    d: "M80 118v1h-1v-1z",
    fill: "#2c3247"
  })), _path4812 || (_path4812 = /*#__PURE__*/React.createElement("path", {
    d: "M91 119v-1h1v1z",
    fill: "#22252e"
  })), _path4813 || (_path4813 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119h-1v-1h1z",
    fill: "#3e3f42"
  })), _path4814 || (_path4814 = /*#__PURE__*/React.createElement("path", {
    d: "M93 118h1v1h-1z",
    fill: "#adaab5",
    fillOpacity: 0.38
  })), _path4815 || (_path4815 = /*#__PURE__*/React.createElement("path", {
    d: "M34 119h1v1h-1z",
    fill: "#818186",
    fillOpacity: 0.827
  })), _path4816 || (_path4816 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119v1h-1v-1z",
    fill: "#1c1d20"
  })), _path4817 || (_path4817 = /*#__PURE__*/React.createElement("path", {
    d: "M36 119h1v1h-1z",
    fill: "#303043"
  })), _path4818 || (_path4818 = /*#__PURE__*/React.createElement("path", {
    d: "M46 119v1h-1v-1z",
    fill: "#2d3146"
  })), _path4819 || (_path4819 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120h-1v-1h1z",
    fill: "#32364b"
  })), _path4820 || (_path4820 = /*#__PURE__*/React.createElement("path", {
    d: "M47 120v-1h1v1z",
    fill: "#464b5b"
  })), _path4821 || (_path4821 = /*#__PURE__*/React.createElement("path", {
    d: "M49 119v1h-1v-1z",
    fill: "#444a5c"
  })), _path4822 || (_path4822 = /*#__PURE__*/React.createElement("path", {
    d: "M50 119v1h-1v-1z",
    fill: "#3b4255"
  })), _path4823 || (_path4823 = /*#__PURE__*/React.createElement("path", {
    d: "M50 120v-1h1v1z",
    fill: "#2a3145"
  })), _path4824 || (_path4824 = /*#__PURE__*/React.createElement("path", {
    d: "M58 119h1v1h-1z",
    fill: "#2e3548"
  })), _path4825 || (_path4825 = /*#__PURE__*/React.createElement("path", {
    d: "M62 119h1v1h-1z",
    fill: "#3d4355"
  })), _path4826 || (_path4826 = /*#__PURE__*/React.createElement("path", {
    d: "M63 119h1v1h-1z",
    fill: "#5f6574"
  })), _path4827 || (_path4827 = /*#__PURE__*/React.createElement("path", {
    d: "M64 120v-1h1v1z",
    fill: "#585d6f"
  })), _path4828 || (_path4828 = /*#__PURE__*/React.createElement("path", {
    d: "M79 119h1v1h-1z",
    fill: "#464d5e"
  })), _path4829 || (_path4829 = /*#__PURE__*/React.createElement("path", {
    d: "M81 119v1h-1v-1z",
    fill: "#393f54"
  })), _path4830 || (_path4830 = /*#__PURE__*/React.createElement("path", {
    d: "M90 119h1v1h-1z",
    fill: "#31344a"
  })), _path4831 || (_path4831 = /*#__PURE__*/React.createElement("path", {
    d: "M93 119v1h-1v-1z",
    fill: "#434649"
  })), _path4832 || (_path4832 = /*#__PURE__*/React.createElement("path", {
    d: "M94 119v1h-1v-1z",
    fill: "#b6b6ba",
    fillOpacity: 0.29
  })), _path4833 || (_path4833 = /*#__PURE__*/React.createElement("path", {
    d: "M35 120v1h-1v-1z",
    fill: "#929396",
    fillOpacity: 0.718
  })), _path4834 || (_path4834 = /*#__PURE__*/React.createElement("path", {
    d: "M36 121h-1v-1h1z",
    fill: "#232428"
  })), _path4835 || (_path4835 = /*#__PURE__*/React.createElement("path", {
    d: "M37 120v1h-1v-1z",
    fill: "#2c2c3b"
  })), _path4836 || (_path4836 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121v-1h1v1z",
    fill: "#373c4f"
  })), _path4837 || (_path4837 = /*#__PURE__*/React.createElement("path", {
    d: "M48 120v1h-1v-1z",
    fill: "#69707c"
  })), _path4838 || (_path4838 = /*#__PURE__*/React.createElement("path", {
    d: "M49 120v1h-1v-1z",
    fill: "#676d7c"
  })), _path4839 || (_path4839 = /*#__PURE__*/React.createElement("path", {
    d: "M49 121v-1h1v1z",
    fill: "#53596a"
  })), _path4840 || (_path4840 = /*#__PURE__*/React.createElement("path", {
    d: "M51 120v1h-1v-1z",
    fill: "#282f40"
  })), _path4841 || (_path4841 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121h-1v-1h1z",
    fill: "#292f43"
  })), _path4842 || (_path4842 = /*#__PURE__*/React.createElement("path", {
    d: "M62 121v-1h1v1z",
    fill: "#5d6373"
  })), _path4843 || (_path4843 = /*#__PURE__*/React.createElement("path", {
    d: "M64 121h-1v-1h1z",
    fill: "#3c434d"
  })), _path4844 || (_path4844 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h-1v-1h1z",
    fill: "#575e68"
  })), _path4845 || (_path4845 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121v-1h1v1z",
    fill: "#444a5a"
  })), _path4846 || (_path4846 = /*#__PURE__*/React.createElement("path", {
    d: "M66 121v-1h1v1z",
    fill: "#2b3247"
  })), _path4847 || (_path4847 = /*#__PURE__*/React.createElement("path", {
    d: "M70 121h-1v-1h1z",
    fill: "#2e3448"
  })), _path4848 || (_path4848 = /*#__PURE__*/React.createElement("path", {
    d: "M78 120v1h-1v-1z",
    fill: "#2a3144"
  })), _path4849 || (_path4849 = /*#__PURE__*/React.createElement("path", {
    d: "M78 121v-1h1v1z",
    fill: "#424957"
  })), _path4850 || (_path4850 = /*#__PURE__*/React.createElement("path", {
    d: "M80 120v1h-1v-1z",
    fill: "#676f7b"
  })), _path4851 || (_path4851 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121h-1v-1h1z",
    fill: "#2f3248"
  })), _path4852 || (_path4852 = /*#__PURE__*/React.createElement("path", {
    d: "M92 121h-1v-1h1z",
    fill: "#171b25"
  })), _path4853 || (_path4853 = /*#__PURE__*/React.createElement("path", {
    d: "M93 121h-1v-1h1z",
    fill: "#55575b",
    fillOpacity: 0.965
  })), _path4854 || (_path4854 = /*#__PURE__*/React.createElement("path", {
    d: "M93 121v-1h1v1z",
    fill: "#c5c5c5",
    fillOpacity: 0.173
  })), _path4855 || (_path4855 = /*#__PURE__*/React.createElement("path", {
    d: "M34 122v-1h1v1z",
    fill: "#b4b4b6",
    fillOpacity: 0.455
  })), _path4856 || (_path4856 = /*#__PURE__*/React.createElement("path", {
    d: "M36 121v1h-1v-1z",
    fill: "#434448"
  })), _path4857 || (_path4857 = /*#__PURE__*/React.createElement("path", {
    d: "M37 121v1h-1v-1z",
    fill: "#20212b"
  })), _path4858 || (_path4858 = /*#__PURE__*/React.createElement("path", {
    d: "M39 121h1v1h-1z",
    fill: "#2d3342"
  })), _path4859 || (_path4859 = /*#__PURE__*/React.createElement("path", {
    d: "M41 121v1h-1v-1z",
    fill: "#2c3243"
  })), _path4860 || (_path4860 = /*#__PURE__*/React.createElement("path", {
    d: "M46 121h1v1h-1z",
    fill: "#353b4c"
  })), _path4861 || (_path4861 = /*#__PURE__*/React.createElement("path", {
    d: "M48 121h1v1h-1z",
    fill: "#5b6170"
  })), _path4862 || (_path4862 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122h-1v-1h1z",
    fill: "#4b5263"
  })), _path4863 || (_path4863 = /*#__PURE__*/React.createElement("path", {
    d: "M51 122h-1v-1h1z",
    fill: "#283040"
  })), _path4864 || (_path4864 = /*#__PURE__*/React.createElement("path", {
    d: "M61 121h1v1h-1z",
    fill: "#2a3045"
  })), _path4865 || (_path4865 = /*#__PURE__*/React.createElement("path", {
    d: "M62 122v-1h1v1z",
    fill: "#515667"
  })), _path4866 || (_path4866 = /*#__PURE__*/React.createElement("path", {
    d: "M63 122v-1h1v1z",
    fill: "#5c636e"
  })), _path4867 || (_path4867 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122v-1h1v1z",
    fill: "#646a77"
  })), _path4868 || (_path4868 = /*#__PURE__*/React.createElement("path", {
    d: "M65 121h1v1h-1z",
    fill: "#393f50"
  })), _path4869 || (_path4869 = /*#__PURE__*/React.createElement("path", {
    d: "M67 122h-1v-1h1z",
    fill: "#2b3145"
  })), _path4870 || (_path4870 = /*#__PURE__*/React.createElement("path", {
    d: "M79 121v1h-1v-1z",
    fill: "#323846"
  })), _path4871 || (_path4871 = /*#__PURE__*/React.createElement("path", {
    d: "M80 121h1v1h-1z",
    fill: "#353b4d"
  })), _path4872 || (_path4872 = /*#__PURE__*/React.createElement("path", {
    d: "M81 122v-1h1v1z",
    fill: "#2b3144"
  })), _path4873 || (_path4873 = /*#__PURE__*/React.createElement("path", {
    d: "M91 121v1h-1v-1z",
    fill: "#292c3c"
  })), _path4874 || (_path4874 = /*#__PURE__*/React.createElement("path", {
    d: "M91 122v-1h1v1z",
    fill: "#191b22"
  })), _path4875 || (_path4875 = /*#__PURE__*/React.createElement("path", {
    d: "M92 122v-1h1v1z",
    fill: "#75777b",
    fillOpacity: 0.831
  })), _path4876 || (_path4876 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h-1v-1h1z",
    fill: "#e4e4e4",
    fillOpacity: 0.114
  })), _path4877 || (_path4877 = /*#__PURE__*/React.createElement("path", {
    d: "M35 122h1v1h-1z",
    fill: "#78797e",
    fillOpacity: 0.902
  })), _path4878 || (_path4878 = /*#__PURE__*/React.createElement("path", {
    d: "M36 122h1v1h-1z",
    fill: "#1c1e23"
  })), _path4879 || (_path4879 = /*#__PURE__*/React.createElement("path", {
    d: "M38 122v1h-1v-1z",
    fill: "#262c38"
  })), _path4880 || (_path4880 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123h-1v-1h1z",
    fill: "#2c3145"
  })), _path4881 || (_path4881 = /*#__PURE__*/React.createElement("path", {
    d: "M48 123v-1h1v1z",
    fill: "#2f3545"
  })), _path4882 || (_path4882 = /*#__PURE__*/React.createElement("path", {
    d: "M50 122v1h-1v-1z",
    fill: "#2f3447"
  })), _path4883 || (_path4883 = /*#__PURE__*/React.createElement("path", {
    d: "M63 122h1v1h-1z",
    fill: "#3d4353"
  })), _path4884 || (_path4884 = /*#__PURE__*/React.createElement("path", {
    d: "M64 122h1v1h-1z",
    fill: "#363b4e"
  })), _path4885 || (_path4885 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123h-1v-1h1z",
    fill: "#2c3147"
  })), _path4886 || (_path4886 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123v-1h1v1z",
    fill: "#2e3247"
  })), _path4887 || (_path4887 = /*#__PURE__*/React.createElement("path", {
    d: "M80 123h-1v-1h1z",
    fill: "#2e3443"
  })), _path4888 || (_path4888 = /*#__PURE__*/React.createElement("path", {
    d: "M90 122v1h-1v-1z",
    fill: "#2c3040"
  })), _path4889 || (_path4889 = /*#__PURE__*/React.createElement("path", {
    d: "M90 123v-1h1v1z",
    fill: "#171a22"
  })), _path4890 || (_path4890 = /*#__PURE__*/React.createElement("path", {
    d: "M92 123h-1v-1h1z",
    fill: "#424446"
  })), _path4891 || (_path4891 = /*#__PURE__*/React.createElement("path", {
    d: "M92 123v-1h1v1z",
    fill: "#9f9fa1",
    fillOpacity: 0.459
  })), _path4892 || (_path4892 = /*#__PURE__*/React.createElement("path", {
    d: "M35 123h1v1h-1z",
    fill: "#b6b6bb",
    fillOpacity: 0.384
  })), _path4893 || (_path4893 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124v-1h1v1z",
    fill: "#5a595e",
    fillOpacity: 0.996
  })), _path4894 || (_path4894 = /*#__PURE__*/React.createElement("path", {
    d: "M37 124v-1h1v1z",
    fill: "#1a1b21"
  })), _path4895 || (_path4895 = /*#__PURE__*/React.createElement("path", {
    d: "M39 123h1v1h-1z",
    fill: "#2d2f3c"
  })), _path4896 || (_path4896 = /*#__PURE__*/React.createElement("path", {
    d: "M41 123v1h-1v-1z",
    fill: "#2e3141"
  })), _path4897 || (_path4897 = /*#__PURE__*/React.createElement("path", {
    d: "M48 124h-1v-1h1z",
    fill: "#2f3144"
  })), _path4898 || (_path4898 = /*#__PURE__*/React.createElement("path", {
    d: "M53 124v-1h1v1z",
    fill: "#2e3145"
  })), _path4899 || (_path4899 = /*#__PURE__*/React.createElement("path", {
    d: "M55 124v-1h1v1z",
    fill: "#2f3247"
  })), _path4900 || (_path4900 = /*#__PURE__*/React.createElement("path", {
    d: "M56 124v-1h1v1z",
    fill: "#2e3146"
  })), _path4901 || (_path4901 = /*#__PURE__*/React.createElement("path", {
    d: "M60 123h1v1h-1z",
    fill: "#303347"
  })), _path4902 || (_path4902 = /*#__PURE__*/React.createElement("path", {
    d: "M63 123h1v1h-1z",
    fill: "#2d3044"
  })), _path4903 || (_path4903 = /*#__PURE__*/React.createElement("path", {
    d: "M65 124h-1v-1h1z",
    fill: "#2d3045"
  })), _path4904 || (_path4904 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124h-1v-1h1z",
    fill: "#2f3347"
  })), _path4905 || (_path4905 = /*#__PURE__*/React.createElement("path", {
    d: "M66 123h1v1h-1z",
    fill: "#2f3445"
  })), _path4906 || (_path4906 = /*#__PURE__*/React.createElement("path", {
    d: "M71 124h-1v-1h1z",
    fill: "#2f3344"
  })), _path4907 || (_path4907 = /*#__PURE__*/React.createElement("path", {
    d: "M74 123h1v1h-1z",
    fill: "#2e3246"
  })), _path4908 || (_path4908 = /*#__PURE__*/React.createElement("path", {
    d: "M81 124h-1v-1h1z",
    fill: "#2e3143"
  })), _path4909 || (_path4909 = /*#__PURE__*/React.createElement("path", {
    d: "M82 124v-1h1v1z",
    fill: "#2f3243"
  })), _path4910 || (_path4910 = /*#__PURE__*/React.createElement("path", {
    d: "M87 124v-1h1v1z",
    fill: "#2c2f40"
  })), _path4911 || (_path4911 = /*#__PURE__*/React.createElement("path", {
    d: "M89 123v1h-1v-1z",
    fill: "#262a34"
  })), _path4912 || (_path4912 = /*#__PURE__*/React.createElement("path", {
    d: "M89 124v-1h1v1z",
    fill: "#161a1f"
  })), _path4913 || (_path4913 = /*#__PURE__*/React.createElement("path", {
    d: "M91 123v1h-1v-1z",
    fill: "#313035"
  })), _path4914 || (_path4914 = /*#__PURE__*/React.createElement("path", {
    d: "M91 124v-1h1v1z",
    fill: "#868488",
    fillOpacity: 0.761
  })), _path4915 || (_path4915 = /*#__PURE__*/React.createElement("path", {
    d: "M92 124v-1h1v1z",
    fill: "#d7d7d7",
    fillOpacity: 0.051
  })), _path4916 || (_path4916 = /*#__PURE__*/React.createElement("path", {
    d: "M36 124h1v1h-1z",
    fill: "#aba9b0",
    fillOpacity: 0.431
  })), _path4917 || (_path4917 = /*#__PURE__*/React.createElement("path", {
    d: "M38 124v1h-1v-1z",
    fill: "#64626a",
    fillOpacity: 0.937
  })), _path4918 || (_path4918 = /*#__PURE__*/React.createElement("path", {
    d: "M38 125v-1h1v1z",
    fill: "#2e2d34"
  })), _path4919 || (_path4919 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h-1v-1h1z",
    fill: "#1d1e23"
  })), _path4920 || (_path4920 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125v-1h1v1z",
    fill: "#1d1f23"
  })), _path4921 || (_path4921 = /*#__PURE__*/React.createElement("path", {
    d: "M41 124h1v1h-1z",
    fill: "#1e1f26"
  })), _path4922 || (_path4922 = /*#__PURE__*/React.createElement("path", {
    d: "M42 124h1v1h-1z",
    fill: "#1d1e26"
  })), _path4923 || (_path4923 = /*#__PURE__*/React.createElement("path", {
    d: "M44 125h-1v-1h1z",
    fill: "#1f2027"
  })), _path4924 || (_path4924 = /*#__PURE__*/React.createElement("path", {
    d: "M66 124v1h-1v-1z",
    fill: "#1f2229"
  })), _path4925 || (_path4925 = /*#__PURE__*/React.createElement("path", {
    d: "M67 124v1h-1v-1z",
    fill: "#1e2229"
  })), _path4926 || (_path4926 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125h-1v-1h1z",
    fill: "#1f2128"
  })), _path4927 || (_path4927 = /*#__PURE__*/React.createElement("path", {
    d: "M71 125v-1h1v1z",
    fill: "#1e2027"
  })), _path4928 || (_path4928 = /*#__PURE__*/React.createElement("path", {
    d: "M78 125h-1v-1h1z",
    fill: "#1d2228"
  })), _path4929 || (_path4929 = /*#__PURE__*/React.createElement("path", {
    d: "M81 124v1h-1v-1z",
    fill: "#1b2025"
  })), _path4930 || (_path4930 = /*#__PURE__*/React.createElement("path", {
    d: "M82 124v1h-1v-1z",
    fill: "#1b1f25"
  })), _path4931 || (_path4931 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125h-1v-1h1z",
    fill: "#1a1e24"
  })), _path4932 || (_path4932 = /*#__PURE__*/React.createElement("path", {
    d: "M83 124h1v1h-1z",
    fill: "#1a1e25"
  })), _path4933 || (_path4933 = /*#__PURE__*/React.createElement("path", {
    d: "M86 124h1v1h-1z",
    fill: "#1b1f24"
  })), _path4934 || (_path4934 = /*#__PURE__*/React.createElement("path", {
    d: "M88 125h-1v-1h1z",
    fill: "#181c21"
  })), _path4935 || (_path4935 = /*#__PURE__*/React.createElement("path", {
    d: "M88 124h1v1h-1z",
    fill: "#1c1f23"
  })), _path4936 || (_path4936 = /*#__PURE__*/React.createElement("path", {
    d: "M89 124h1v1h-1z",
    fill: "#3c3e40"
  })), _path4937 || (_path4937 = /*#__PURE__*/React.createElement("path", {
    d: "M90 124h1v1h-1z",
    fill: "#7e7e80",
    fillOpacity: 0.737
  })), _path4938 || (_path4938 = /*#__PURE__*/React.createElement("path", {
    d: "M91 124h1v1h-1z",
    fill: "#bfbfc7",
    fillOpacity: 0.125
  })), _path4939 || (_path4939 = /*#__PURE__*/React.createElement("path", {
    d: "M37 126v-1h1v1z",
    fill: "#ceced3",
    fillOpacity: 0.184
  })), _path4940 || (_path4940 = /*#__PURE__*/React.createElement("path", {
    d: "M39 125v1h-1v-1z",
    fill: "#8f9296",
    fillOpacity: 0.62
  })), _path4941 || (_path4941 = /*#__PURE__*/React.createElement("path", {
    d: "M39 126v-1h1v1z",
    fill: "#686d74",
    fillOpacity: 0.871
  })), _path4942 || (_path4942 = /*#__PURE__*/React.createElement("path", {
    d: "M40 125h1v1h-1z",
    fill: "#52555e",
    fillOpacity: 0.961
  })), _path4943 || (_path4943 = /*#__PURE__*/React.createElement("path", {
    d: "M41 126v-1h1v1z",
    fill: "#525358",
    fillOpacity: 0.984
  })), _path4944 || (_path4944 = /*#__PURE__*/React.createElement("path", {
    d: "M42 126v-1h1v1z",
    fill: "#57585c",
    fillOpacity: 0.984
  })), _path4945 || (_path4945 = /*#__PURE__*/React.createElement("path", {
    d: "M43 125h1v1h-1z",
    fill: "#45464a"
  })), _path4946 || (_path4946 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126v-1h1v1z",
    fill: "#46474c"
  })), _path4947 || (_path4947 = /*#__PURE__*/React.createElement("path", {
    d: "M46 125v1h-1v-1z",
    fill: "#44464c"
  })), _path4948 || (_path4948 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v-1h1v1z",
    fill: "#44454c"
  })), _path4949 || (_path4949 = /*#__PURE__*/React.createElement("path", {
    d: "M47 125h1v1h-1z",
    fill: "#42444b"
  })), _path4950 || (_path4950 = /*#__PURE__*/React.createElement("path", {
    d: "M49 126v-1h1v1z",
    fill: "#41424a",
    fillOpacity: 0.996
  })), _path4951 || (_path4951 = /*#__PURE__*/React.createElement("path", {
    d: "M50 125h1v1h-1z",
    fill: "#41434a"
  })), _path4952 || (_path4952 = /*#__PURE__*/React.createElement("path", {
    d: "M52 125v1h-1v-1z",
    fill: "#3f4048",
    fillOpacity: 0.996
  })), _path4953 || (_path4953 = /*#__PURE__*/React.createElement("path", {
    d: "M53 125v1h-1v-1z",
    fill: "#404149",
    fillOpacity: 0.996
  })), _path4954 || (_path4954 = /*#__PURE__*/React.createElement("path", {
    d: "M54 125v1h-1v-1z",
    fill: "#424249",
    fillOpacity: 0.996
  })), _path4955 || (_path4955 = /*#__PURE__*/React.createElement("path", {
    d: "M54 126v-1h1v1z",
    fill: "#414148",
    fillOpacity: 0.996
  })), _path4956 || (_path4956 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126v-1h1v1z",
    fill: "#3f4047",
    fillOpacity: 0.996
  })), _path4957 || (_path4957 = /*#__PURE__*/React.createElement("path", {
    d: "M57 126h-1v-1h1z",
    fill: "#404047",
    fillOpacity: 0.996
  })), _path4958 || (_path4958 = /*#__PURE__*/React.createElement("path", {
    d: "M57 125h1v1h-1z",
    fill: "#3e4046",
    fillOpacity: 0.996
  })), _path4959 || (_path4959 = /*#__PURE__*/React.createElement("path", {
    d: "M58 125h1v1h-1z",
    fill: "#3e4046",
    fillOpacity: 0.992
  })), _path4960 || (_path4960 = /*#__PURE__*/React.createElement("path", {
    d: "M59 126v-1h1v1z",
    fill: "#3f4147",
    fillOpacity: 0.992
  })), _path4961 || (_path4961 = /*#__PURE__*/React.createElement("path", {
    d: "M60 125h1v1h-1z",
    fill: "#3e4047",
    fillOpacity: 0.992
  })), _path4962 || (_path4962 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126h-1v-1h1z",
    fill: "#3e3f46",
    fillOpacity: 0.992
  })), _path4963 || (_path4963 = /*#__PURE__*/React.createElement("path", {
    d: "M62 126v-1h1v1z",
    fill: "#3e3f45",
    fillOpacity: 0.992
  })), _path4964 || (_path4964 = /*#__PURE__*/React.createElement("path", {
    d: "M63 126v-1h1v1z",
    fill: "#3e3f45",
    fillOpacity: 0.988
  })), _path4965 || (_path4965 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h-1v-1h1z",
    fill: "#3f3f46",
    fillOpacity: 0.988
  })), _path4966 || (_path4966 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h-1v-1h1z",
    fill: "#404046",
    fillOpacity: 0.992
  })), _path4967 || (_path4967 = /*#__PURE__*/React.createElement("path", {
    d: "M69 126v-1h1v1z",
    fill: "#424347",
    fillOpacity: 0.992
  })), _path4968 || (_path4968 = /*#__PURE__*/React.createElement("path", {
    d: "M73 126v-1h1v1z",
    fill: "#434449",
    fillOpacity: 0.996
  })), _path4969 || (_path4969 = /*#__PURE__*/React.createElement("path", {
    d: "M75 125h1v1h-1z",
    fill: "#404248",
    fillOpacity: 0.996
  })), _path4970 || (_path4970 = /*#__PURE__*/React.createElement("path", {
    d: "M78 126h-1v-1h1z",
    fill: "#404148"
  })), _path4971 || (_path4971 = /*#__PURE__*/React.createElement("path", {
    d: "M83 125v1h-1v-1z",
    fill: "#505257",
    fillOpacity: 0.992
  })), _path4972 || (_path4972 = /*#__PURE__*/React.createElement("path", {
    d: "M84 126h-1v-1h1z",
    fill: "#46484d",
    fillOpacity: 0.996
  })), _path4973 || (_path4973 = /*#__PURE__*/React.createElement("path", {
    d: "M85 125v1h-1v-1z",
    fill: "#3b3d42",
    fillOpacity: 0.996
  })), _path4974 || (_path4974 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126v-1h1v1z",
    fill: "#3c3e43",
    fillOpacity: 0.992
  })), _path4975 || (_path4975 = /*#__PURE__*/React.createElement("path", {
    d: "M87 126h-1v-1h1z",
    fill: "#3f4145",
    fillOpacity: 0.973
  })), _path4976 || (_path4976 = /*#__PURE__*/React.createElement("path", {
    d: "M88 125v1h-1v-1z",
    fill: "#4f5255",
    fillOpacity: 0.914
  })), _path4977 || (_path4977 = /*#__PURE__*/React.createElement("path", {
    d: "M88 126v-1h1v1z",
    fill: "#6c6c70",
    fillOpacity: 0.749
  })), _path4978 || (_path4978 = /*#__PURE__*/React.createElement("path", {
    d: "M90 125v1h-1v-1z",
    fill: "#919193",
    fillOpacity: 0.4
  })), _path4979 || (_path4979 = /*#__PURE__*/React.createElement("path", {
    d: "M90 125h1v1h-1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path4980 || (_path4980 = /*#__PURE__*/React.createElement("path", {
    d: "M41 127h-1v-1h1z",
    fill: "#c9c9cf",
    fillOpacity: 0.169
  })), _path4981 || (_path4981 = /*#__PURE__*/React.createElement("path", {
    d: "M41 126h1v1h-1z",
    fill: "#cbcbd4",
    fillOpacity: 0.212
  })), _path4982 || (_path4982 = /*#__PURE__*/React.createElement("path", {
    d: "M43 127h-1v-1h1z",
    fill: "#d9d9de",
    fillOpacity: 0.216
  })), _path4983 || (_path4983 = /*#__PURE__*/React.createElement("path", {
    d: "M43 127v-1h1v1z",
    fill: "#a8a8ac",
    fillOpacity: 0.243
  })), _path4984 || (_path4984 = /*#__PURE__*/React.createElement("path", {
    d: "M44 126h1v1h-1z",
    fill: "#acacb0",
    fillOpacity: 0.243
  })), _path4985 || (_path4985 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126v1h-1v-1z",
    fill: "#a8a8b4",
    fillOpacity: 0.243
  })), _path4986 || (_path4986 = /*#__PURE__*/React.createElement("path", {
    d: "M46 126h1v1h-1z",
    fill: "#aaa5b2",
    fillOpacity: 0.247
  })), _path4987 || (_path4987 = /*#__PURE__*/React.createElement("path", {
    d: "M53 126h1v1h-1z",
    fill: "#a3a3af",
    fillOpacity: 0.239
  })), _path4988 || (_path4988 = /*#__PURE__*/React.createElement("path", {
    d: "M55 126h1v1h-1z",
    fill: "#9d9daa",
    fillOpacity: 0.235
  })), _path4989 || (_path4989 = /*#__PURE__*/React.createElement("path", {
    d: "M57 127v-1h1v1z",
    fill: "#9d9da5",
    fillOpacity: 0.235
  })), _path4990 || (_path4990 = /*#__PURE__*/React.createElement("path", {
    d: "M61 126v1h-1v-1z",
    fill: "#9b9ba8",
    fillOpacity: 0.231
  })), _path4991 || (_path4991 = /*#__PURE__*/React.createElement("path", {
    d: "M62 127v-1h1v1z",
    fill: "#9999a7",
    fillOpacity: 0.227
  })), _path4992 || (_path4992 = /*#__PURE__*/React.createElement("path", {
    d: "M64 126v1h-1v-1z",
    fill: "#9c9ca5",
    fillOpacity: 0.224
  })), _path4993 || (_path4993 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126v1h-1v-1z",
    fill: "#9c9caa",
    fillOpacity: 0.224
  })), _path4994 || (_path4994 = /*#__PURE__*/React.createElement("path", {
    d: "M65 126h1v1h-1z",
    fill: "#999ea2",
    fillOpacity: 0.227
  })), _path4995 || (_path4995 = /*#__PURE__*/React.createElement("path", {
    d: "M66 126h1v1h-1z",
    fill: "#9e9ea2",
    fillOpacity: 0.227
  })), _path4996 || (_path4996 = /*#__PURE__*/React.createElement("path", {
    d: "M67 127v-1h1v1z",
    fill: "#9b9b9f",
    fillOpacity: 0.231
  })), _path4997 || (_path4997 = /*#__PURE__*/React.createElement("path", {
    d: "M75 127h-1v-1h1z",
    fill: "#a1a1ae",
    fillOpacity: 0.235
  })), _path4998 || (_path4998 = /*#__PURE__*/React.createElement("path", {
    d: "M76 127v-1h1v1z",
    fill: "#a0a0a8",
    fillOpacity: 0.243
  })), _path4999 || (_path4999 = /*#__PURE__*/React.createElement("path", {
    d: "M78 127h-1v-1h1z",
    fill: "#9c9ca8",
    fillOpacity: 0.243
  })), _path5000 || (_path5000 = /*#__PURE__*/React.createElement("path", {
    d: "M83 127h-1v-1h1z",
    fill: "#cdd2d6",
    fillOpacity: 0.224
  })), _path5001 || (_path5001 = /*#__PURE__*/React.createElement("path", {
    d: "M84 126v1h-1v-1z",
    fill: "#bbbbbf",
    fillOpacity: 0.235
  })), _path5002 || (_path5002 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126v1h-1v-1z",
    fill: "#9a9a9e",
    fillOpacity: 0.239
  })), _path5003 || (_path5003 = /*#__PURE__*/React.createElement("path", {
    d: "M85 126h1v1h-1z",
    fill: "#9ea2a7",
    fillOpacity: 0.227
  })), _path5004 || (_path5004 = /*#__PURE__*/React.createElement("path", {
    d: "M87 126v1h-1v-1z",
    fill: "#adadad",
    fillOpacity: 0.184
  })), _path5005 || (_path5005 = /*#__PURE__*/React.createElement("path", {
    d: "M88 127h-1v-1h1z",
    fill: "#c8c8d1",
    fillOpacity: 0.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.e6fa0ea7d89dadae69464baf45fc71ce.svg";
export { ForwardRef as ReactComponent };